export const ph: { [key: string]: { [key: string]: string } } = {
  pctransferP: {
    OR: "O kaya",
    Help: "Pakitingnan ang seksyon ng tulong",
    Quiz: "Walang wallet? Gustong bumili ng digital currency?",
    TransferLimit: "Paliwanag ng Limitasyon sa Paglipat",
    invalid: "Di-wastong halaga",
    TransferNet: "Maglipat ng Network",
  },
  otcAdLog: {
    transQuantity: "Dami ng Transaksyon",
    operate: "Operasyon",
    quantity: "Dami",
    adId: "Ad ID",
    transType: "Uri ng Transaksyon",
    state: "Katayuan",
    time: "Naganap ang Oras",
  },
  withUpdate: {
    inputCpf: "Mangyaring maglagay ng CPF (000.000.000-00)",
    phoneNumPhp: "Ilagay ang Numero ng Telepono",
    inputEmail: "Mangyaring mag-input ng email",
    inputCnpj: "Mangyaring ipasok ang CNPJ",
    phoneNum: "Mangyaring ipasok ang numero ng telepono (+55) 99999-9999",
    inputName: "Paki-input ang pangalan",
  },
  about: {
    contentThree:
      "A BMM Testlabs é um laboratório independente de testes de jogos fundado em 27 de novembro de 1981. A empresa é acreditada como um organismo de inspeção IOS 17025 IT e 17020, reconhecido em mais de 400 jurisdições e possui 14 escritórios em 13 países.",
    allreserved:
      "Todos os direitos reservados ©2024 Site oficial de loteria AR",
    contentTwo:
      "A Gambling Commission é uma comissão independente que trabalha com as autoridades de licenciamento para autorizar e regular o jogo comercial no Reino Unido. A Gambling Commission (DCMS) é um órgão público patrocinado pelo Departamento de Cultura, Mídia e Esporte e é responsável por definir requisitos para os licenciados e realizar avaliações para garantir a conformidade.",
    contentFour:
      "A Gaming Associates é uma Instalação de Testes Acreditada (ATF) independente e reconhecida internacionalmente. A empresa é certificada pela IOS 9001, IOS/IEC17025 e PCI QSA, sendo reconhecida por autoridades globais.",
    contentOne:
      "A MGA é um órgão regulador independente responsável por regular todas as atividades de jogos em Malta, garantindo uma estrutura corporativa e um quadro jurídico eficaz, abrangente e legal para a indústria.",
    certified: "Obter certificação",
    email: "Email :",
    bottomText:
      "Este site fornece apenas serviços relacionados à consulta de dados de loteria, não oferecendo serviços de compra de loteria. Não há menção a atividades ilegais, publicidade comercial, cooperação de ponte, etc.",
    licensing: "Licenciamento",
  },
  fileUpload: {
    imageCannotExceed: "Larawan* Ang laki ay hindi maaaring lumampas",
    quickBetsizeResolutionNote:
      "Larawan* (Hindi maaaring lumagpas ang laki sa 500KB, ang resolusyon ay dapat na 150 x 150)",
    quickBetresolutionError: "Ang resolusyon ay dapat na 150×150",
    resolutionMustBe: "resolution ay dapat na",
  },
  lotteryList: {
    min: "min",
    Popular: "Lahat",
    loginFail:
      "Upang maglagay ng taya sa lottery, kailangan mong mag-log in at mag-recharge. Nag-expire na ang iyong token o hindi ka naka-log in. Mangyaring mag-log in!",
    Title: "Lottery - Platform Recharge Betting",
  },
  quotes: {
    latestPrice: "Pinakabagong Presyo",
    turnoverHeader: "Dami",
    gainList: "Mga Top Gainers",
    optional: "Mga paborito",
    title: "palengke",
    turnOver: "Halaga ng Transaksyon",
    upDown: "Bumangon at Bumagsak",
    quotes: "palengke",
    speedList: "Pinakamabilis Tumataas na Listahan",
    turnOverRate: "Rate ng Turnover",
    fastestfallling: "Pinakamabilis na Bumagsak na Listahan",
    nameCode: "Pangalan/Code",
    dropList: "Top Losers",
  },
  merchantOTC: {
    readAgreeTxt:
      "Nabasa ko at sumasang-ayon ako sa Merchant Certification Agreement",
    agreeText: "Sumang-ayon na i-freeze ang 10,000 USDT bilang deposito",
    balance: "Balanse",
    agreeTextTwo: "USDT bilang trading margin",
    agreeTextOne: "USDT bilang merchant margin",
    Title: "Mag-apply para maging Merchant",
    applyBtn: "Mag-apply Ngayon",
    lowBalance:
      "Hindi sapat ang iyong available na balanse. Pakibili/recharge/transfer muna.",
  },
  otcchat: {
    takerSelf: "Ako",
    total: "Halaga ng Transaksyon",
    takerSystem: "Sistema",
    sendMsgFail: "Nabigong magpadala ng mensahe, pakisubukang muli",
    sendMsg: "Ipadala",
    placeholder: "Ilagay ang iyong mensahe dito",
    takerOpposite: "Counterparty",
  },
  withdrawPop: {
    placeHolderEmail: "Pakilagay ang Email ID...",
    note: "Ang pagbibigay ng tumpak na email at telepono ay nakakatulong na mapabilis ang pagproseso ng pagbabayad sa bangko.",
    taxIDtype: "Uri ng Tax ID",
    noteIdentityNo: "Hindi maaaring walang laman ang bank code",
    bankNamePlaceholder: "Ilagay ang Account",
    bankName: "Account （Gcash/Maya/Bank)",
    identityNumberWithEx: "Mga Paraan ng Pag-withdraw (GCash/Maya/Bank)",
    noteCPFId: "Mangyaring magpasok ng 11 digit para sa CPF",
    brazilId: "ID ng Brazil",
    notePhone:
      "Mangyaring maglagay ng 11 digit na walang +55 para sa iyong mobile number.",
    bank: "Pangalan ng Bangko",
    withdrawalAmount: "Halaga ng Pag-withdraw",
    identityNumber: "Kodigo ng Bangko",
    beneficiaryName: "Pangalan ng Benepisyaryo",
    noteBankNameEmpty: "Hindi maaaring blangko ang pangalan ng bangko",
    selectType: "Mangyaring Piliin ang Uri ng Pagbabayad",
    placeHolderCNPJ: "Pakilagay ang CNPJ ID...",
    value: "Halaga",
    email: "I-email",
    noteCNPJ: "Mangyaring maglagay ng purong 14-digit na numero ng CNPJ",
    noteEVP: "Hindi maaaring walang laman ang EVP",
    amountNote: "Halaga > 0",
    identityNumberPlaceholder: "Ilagay ang code ng bangko",
    phoneNumberPlaceholder: "Ilagay ang Numero ng Telepono",
    cpfPlaceholder: "Pakilagay ang CPF...",
    userNamePlaceholder: "Ilagay ang Pangalan ng Gumagamit",
    userName: "Pangalan ng Gumagamit",
    walletOrBank: "Uri ng Bayad",
    beneficiaryNamePlaceholder: "Pakilagay ang pangalan ng benepisyaryo...",
    noteCPF: "Mangyaring magpasok ng 11 digit para sa CPF",
    Sake: "Mag-withdraw",
    bankPlaceholder: "Ilagay ang pangalan ng bangko",
    placeHolderCPF: "Pakilagay ang CPF ID...",
    phoneNumber: "Numero ng Telepono",
    emailPlaceholder: "Maglagay ng Email",
    placeHolderEVP: "Ilagay ang EVP number",
    brazilIdPlaceholder: "Ilagay ang Brazil identity number",
    placeHolderPhone: "Pakilagay ang PHONE ID...",
    notephoPhone: "Maglagay ng wastong numero ng telepono",
    pleaseSelect: "Mangyaring piliin",
    withdrawTo: "Mag-withdraw sa",
    noteEmail:
      "Mangyaring magpasok ng email address na hanggang 36 na character",
  },
  state: {
    off: "NAKA-OFF",
    on: "NAKA-ON",
  },
  commissionFlow: {
    GameAll: "Lahat",
    Project: "item",
    Amount: "Halaga",
    FilterTime: "Oras",
    Time: "Oras",
    type: "Uri",
    Topic: "Mga Detalye ng Bill",
    Balance: "Balanse",
  },
  announcement: {
    back: "Bumalik",
    title: "Anunsyo ng Platform",
  },
  aboutus: {
    title: "Tungkol sa Amin",
  },
  popupone: {
    set: "Itakda",
    ignore: "Huwag pansinin",
    content:
      "Para sa seguridad ng iyong account at pagbawi ng password, inirerekomendang magtakda ng kahit isang paraan ng pag-verify ng seguridad.",
  },
  qr: {
    Copy: "Kopyahin Link",
    Scan: "I-scan upang ibahagi, magrekomenda ng mga kaibigan",
    Save: "I-save",
    Share: "Ibahagi",
  },
  agentFlowLog: {
    type5: "Converter conta de comissão em conta corrente",
    type4: "Conta de comissão para conta total (TRX)",
    type3: "Transferir conta de comissão para conta geral",
    type2: "Comissão TRX",
    type6: "Conta de comissão para conta corrente (TRX)",
    type1: "Comissão USDT",
  },
  rechargeInfo: {
    cardName: "Mag-recharge",
    rechargeNotice: "Paunawa sa Pag-recharge",
    currentBalance: "Kasalukuyang Balanse",
    bankName: "Pangalan ng Bangko",
    payPlease: "Mangyaring magbayad",
    payCountdown: "Countdown ng pagbabayad",
    branch: "Pangalan ng Sangay",
    transferredMoney: "Nagtransfer ako ng pera. Humiling ng recharge",
    contactCustService:
      "Kung walang natanggap na deposito sa loob ng 10 minuto, mangyaring makipag-ugnayan sa online customer service o sa iyong dedikadong ahente.",
    cancelAddress: "Kanselahin ang paglipat",
    yuan: "yuan",
    recharge: "Mag-recharge",
    rechargeAddress: "Recharge Address",
    copy: "Kopyahin",
    recieptAmount: "Halaga ng Natanggap",
    cardNumber: "Numero ng Recipient Card",
    rechargeQrCode: "I-recharge ang QR Code",
  },
  lotteryFast3Game: {
    notice3: "Logro 191.16",
    notice2: "Logro 31.86",
    notice1: "Logro 1.970-191.16",
    notice7: "Logro 63.72",
    notice6: "Logro 12.74",
    notice5: "Logro 7.96",
    notice4: "Logro 31.86",
    notice8: "Logro 6.37",
  },
  operatevip: {
    allocate: "Mga Pondo sa Margin Trading",
  },
  friendCouponTerms: {
    friendCash: "Friend Cash Voucher",
    back: "Bumalik",
  },
  lotteries: {
    name39: "5 min",
    name38: "3 min",
    name37: "Mark Six",
    name36: "1 hora",
    name35: "5 min",
    name34: "3 min",
    name33: "1 min",
    name32: "1 hora",
    name31: "5 min",
    name30: "3 min",
    name29: "1 min",
    name28: "1 hora",
    name27: "5 min",
    name6: "5/11",
    name26: "3 min",
    name5: "PK10",
    name25: "1 min",
    name4: "3 dados",
    name24: "1 horas",
    name3: "5D",
    name23: "5 min",
    name22: "3 min",
    name9: "1 min",
    name21: "1 min",
    name8: "1D",
    name20: "1 hora",
    name7: "60 min",
    name2: "PC28",
    name1: "3D",
    name19: "5 min",
    name18: "3 min",
    name17: "1 min",
    name16: "1 hora",
    name15: "5 min",
    name14: "3 min",
    name13: "1 min",
    name12: "1 hora",
    name56: "5 min",
    name11: "5 min",
    name55: "3 min",
    name10: "3 min",
    name54: "1 min",
    name53: "30s",
    name52: "PK5",
    name51: "5 min",
    name50: "3 min",
    name49: "1 min",
    name48: "30s",
    name47: "PK3",
    name46: "5 min",
    name45: "3 min",
    name44: "1 min",
    name43: "30s",
    name42: "PK2",
    name41: "999",
    name40: "999",
  },
  benefit: {
    finManagement: "Pamamahala sa pananalapi",
    recharge: "Mga Aktibidad sa Pag-recharge",
    signinReward: "Mga Gantimpala sa Pag-login",
    downloadBonus: "I-download ang Kliyente (Bonus)",
    promoteFriend: "I-promote ang Mga Kaibigan (Mga Gantimpala)",
  },
  agentDepot: {
    membershipAward: "Gantimpala sa Pamamahala ng Miyembro",
    commisionBalance: "Balanse ng Komisyon",
    totalDeferred: "Kabuuang Deferred na Bayarin",
    managementFee: "Bayad sa Pamamahala",
    profitSharing: "Pagbabahagi ng Kita",
    back: "Bumalik",
    commision: "Komisyon",
    withdraw: "Mag-withdraw",
  },
  otcmerchant: {
    statusysormal: "Normal",
    statusReview: "Sa ilalim ng Pagsusuri",
    statusRejected: "Ako",
  },
  tronexchange: {
    convertBtn:
      "Halaga ng Palitan = (Natanggap na Halaga × Presyo sa Market) - Bayarin sa Transaksyon",
    limitation: "I-scan ang QR code para maglipat at makipagpalitan",
    amount: "Halaga ng Palitan",
    usdttrx: "Palitan ng Pera",
    address: "Limitasyon: 10-5,000 USDT (TRC20)",
    missingAddr: "Pakibigkis ang iyong wallet address",
    trxusdt: "Palitan ang USDT sa TRX",
    exchangeRecord: "Exchange Records",
    nodata: "Walang available na data",
    noticeHeading: "Kopyahin",
    AmountValue: "Halaga",
    title: "Tulong",
    search: "Maghanap",
    scantoexchange: "Quote",
    exchangefomular: "Palitan ang TRX sa USDT",
    time: "Oras ng Palitan",
    copy: "Address ng Wallet",
    walletSearch:
      "Pakilagay ang iyong wallet address upang tingnan ang mga resulta ng palitan",
    notice:
      "1. Magbukas ng third-party na digital wallet, i-scan o kopyahin ang address para ilipat.\n\n2. Tanging TRON TRC20 USDT at TRX ang sinusuportahan. Huwag lumampas sa limitasyon. Ang mas mababa sa minimum ay hindi mare-refund, higit sa limitasyon ay ibabawas ng 10% na bayad at refund.\n\n3. Ang platform ay magbabalik ng katumbas na TRX o USDT sa loob ng 10 segundo nang libre.",
  },
  moreTrend: {
    fourthTrend: "Ikaapat na Regular na Numero",
    champian: "Unang Regular na Numero",
    tenthTrend: "Ikasampung Lugar Trend",
    TenThousands: "Sampung Libo Trend",
    Ones: "Mga Uso",
    fifthTrend: "Ikalimang Regular na Numero",
    NumTrends: "Uso sa Numero",
    Tens: "Tens Trend",
    ninthTrend: "Uso sa Ika-siyam na Lugar",
    thirdTrend: "Ikatlong Regular na Numero",
    runnerup: "Pangalawang Regular na Numero",
    sixthTrend: "Ika-anim na Lugar Trend",
    Hundreds: "Daan-daang Trend",
    HistoryTab: "Kumuha ng Mga Tala",
    eightTrend: "Uso sa Ikawalong Lugar",
    trends: "Trend Chart",
    seventhTrend: "Ikapitong Lugar Uso",
    Thousands: "Hulaan ang Numero",
  },
  mystery: {
    completeTask:
      "Kumpletuhin ang mga gawain upang makatanggap ng mga gantimpala.",
  },
  trc20: {
    sameAddress: "Parehong address ng pagpapadala at pagtanggap",
    collectWalletNotSetting: "Hindi nakatakda ang collection wallet",
    lessThanMinAmount: "Balanse sa ibaba ng minimum na halaga ng recharge",
    privateKeyError: "Pribadong key configuration error",
  },
  bettingData: {
    FromAddress: "Mula sa Address",
    CreateTime: "Oras ng Paglikha",
    Amount: "Halaga",
    BetDetails: "Mga Detalye ng Taya",
    WinAmount: "Halaga ng Panalo",
  },
  phonePass: {
    incorrect: "Di-wastong SMS code",
  },
  deposit: {
    bank: "Bangko",
    payType: "Uri ng bayad",
  },
  modifyBank: {
    sure: "Kumpirmahin",
    chooseBank: "Piliin ang Bangko",
    name: "Pangalan ng May-ari ng Account",
    bankName: "Pangalan ng Bangko",
    userName: "Username",
    bankAddress: "Address ng Bangko (opsyonal)",
    cardNo: "Numero ng Card",
  },
  pcExchange: {
    btnName: "Palitan ng TRX/USDT",
  },
  popuptwo: {
    set: "Itakda",
    setBankCard: "Kinakailangan ang pag-setup ng bank card",
    ignore: "Huwag pansinin",
    content: "Kinakailangan ang desentralisadong wallet setup",
  },
  detail: {
    estPayout: "Est. Payout",
    singleBets: "Single Bet",
    overTime: "Kabuuan (kabilang ang overtime)",
    errMsg:
      "Ang mga logro ay nagbago. Upang maglagay ng taya, kailangan mo munang suriin at aprubahan ang mga pagbabago.",
    addMore: "Magdagdag pa",
    clearList: "I-clear ang Listahan",
    bet: "Taya",
    times: "Mga oras",
    total: "Kabuuan",
    totStake: "Kabuuang Stake",
    totOdds: "Kabuuang Logro",
    reset: "I-reset",
    singleBtn: "Single Bet",
  },
  agencyLink: {
    copyPromo: "Kopyahin ang promo code",
    enterPromotion: "Ilagay ang promo code sa pahina ng pagpaparehistro",
    scan: "I-scan ang QR code",
    copy: "Kopyahin ang link",
    register: "I-click ang link para magparehistro",
  },
  activity: {
    inActive: "Natapos na",
    back: "Bumalik",
    active: "Patuloy",
    title: "Sona ng Aktibidad",
  },
  donwload: {
    rated: "Na-rate para sa 18+",
    ratingAndReview: "Mga Rating at Review",
    whatsNew: "Ano ang bago",
    appName: "PK737",
    review: "46K review",
    subtitle: "Na-verify ng Play Protect",
    donwload: "Mga download",
    vefied: "Na-verify ang mga rating at review",
    updatedOn: "Na-update noong",
    title: "Opisyal na Brand",
    rapidDonwload: "Mabilis na Pag-install",
  },
  appStore: {
    action: "Get",
    inAppPurchases: "In-App Purchases",
    less: "Less",
    learnMore: "Learn More",
    yes: "Yes",
    ad: "Ad",
    languageSwitch: "中文",
    statsYears: "Years",
    statsAgeRating: "Age Rating",
    statsDeveloper: "Developer",
    developerName: "Yousician Ltd",
    developerRole: "Developer",
    ratingsMostHelpful: "Most Helpful Reviews",
    ratingsSeeAll: "See All Reviews",
    reviewR1Title: "About my experience",
    reviewR1Date: "26 Mar",
    reviewR1Author: "Gataonly",
    reviewR2Title: "So enjoyable and easy to use",
    reviewR2Date: "12 Mar",
    reviewR2Author: "MusicLover92",
    whatsNewVersion: "Version 7.97.0",
    whatsNewUpdatedAt: "1d ago",
    whatsNewBody: "This update includes small improvements and bug fixes. Love the app? Rate us!",
    privacyTitle: "App Privacy",
    privacyIntroPrefix: "The developer,",
    privacyIntroMiddle: ", indicated that the app's privacy practices may include handling of data as described below. For more information, see the",
    privacyIntroSuffix: ".",
    privacyPolicyLink: "developer's privacy policy",
    privacyTrackTitle: "Data Used to Track You",
    privacyTrackDescription: "The following data may be used to track you across apps and websites owned by other companies:",
    privacyLinkedTitle: "Data Linked to You",
    privacyLinkedDescription: "The following data may be collected and linked to your identity:",
    privacyNotLinkedTitle: "Data Not Linked to You",
    privacyNotLinkedDescription: "The following data may be collected but it is not linked to your identity:",
    privacyDisclaimer: "Privacy practices may vary based, for example, on the features you use or your age.",
    privacyItemLocation: "Location",
    privacyItemIdentifiers: "Identifiers",
    privacyItemUsageData: "Usage Data",
    privacyItemDiagnostics: "Diagnostics",
    privacyItemPurchases: "Purchases",
    accessibilityTitle: "Accessibility",
    accessibilityBody: "The developer has not yet indicated which accessibility features this app supports.",
    informationTitle: "Information",
    informationProvider: "Provider",
    informationSize: "Size",
    informationCategory: "Category",
    informationCompatibility: "Compatibility",
    informationCompatibilityValue: "Works on this iPhone",
    informationLanguages: "Languages",
    informationLanguagesValue: "English and 10 more",
    informationAgeRating: "Age Rating",
    informationAgeRatingValue: "4+ Infrequent/Mild Sexual Content",
    informationInAppPurchases: "In-App Purchases",
    informationCopyright: "Copyright",
    informationCopyrightValue: "© Yousician Ltd",
    informationLinkDeveloperWebsite: "Developer Website",
    informationLinkPrivacyPolicy: "Privacy Policy",
    informationLinkLicenceAgreement: "Licence Agreement",
    relatedMoreByDeveloper: "More by Yousician Ltd",
    relatedYouMightAlsoLike: "You Might Also Like",
    relatedYousicianName: "Yousician: Learn & Play Guitar",
    relatedYousicianSubtitle: "Guitar, Bass & Singing Lessons",
    relatedPianoName: "Piano by Yousician",
    relatedPianoSubtitle: "Lessons & Songs for Piano",
    relatedTcgName: "TCG Card Collection Scanner",
    relatedTcgSubtitle: "Card Scanner: Price & Organize",
    relatedDoubletuneName: "Guitar Tuner - Ukulele & Bass",
    relatedDoubletuneSubtitle: "DoubleTune: Tune Bajo, Cello...",
    relatedGuitarTunerEasyName: "Guitar Tuner Easy tune chords",
    relatedGuitarTunerEasySubtitle: "Acoustic ukulele, electric bass",
    footerDisclaimer: "GuitarTuna is a trademark of Yousician Ltd. This page is a UI replica for demonstration purposes only.",
    tabBarToday: "Today",
    tabBarGames: "Games",
    tabBarApps: "Apps",
    tabBarArcade: "Arcade",
    tabBarSearch: "Search",
    tabBarLabel: "App store navigation",
    casino: "Casino",
  },
  lotteryResultDetail: {
    oddGreen: "Kakaibang Berde",
    small: "Maliit",
    smallGreen: "Maliit na Berde",
    big: "Malaki",
    smallOrEven: "Maliit/Pantay",
    bigRed: "Malaking Pula",
    tigerDetail: "tigre",
    smallTail: "Maliit na Buntot",
    feras: "Hayop",
    greenBall: "Berdeng Bola",
    dragon: "Malaki",
    aves: "ibon",
    notPrime: "Sum",
    blueBall: "Asul na Bola",
    smallRed: "Maliit na Pula",
    bigTail: "Malaking Buntot",
    redEvenGreen: "Green Even Sum",
    sumBig: "Malaking Sum",
    redEvenSum: "Red Even Sum",
    and: "Gumuhit",
    sumSmall: "Maliit na Sum",
    bigBlue: "Malaking Asul",
    redEvenBlue: "Blue Even Sum",
    bigGreen: "Malaking Berde",
    redOddBlue: "Asul na Kakaibang Sum",
    evenRed: "Pula Kahit",
    bigEven: "Big Even",
    double: "Kahit Sum",
    evenBlue: "Blue Even",
    tiger: "Maliit",
    odd: "Kakaiba",
    oddBlue: "Blue Odd",
    redBall: "Pulang Bola",
    smallOdd: "Maliit na Odd",
    single: "Kakaibang Sum",
    extremeLarge: "Extreme Big",
    dragonDetail: "Dragon",
    redOddSum: "Pulang Kakaibang Sum",
    fiveEquals: "5 Katumbas",
    even: "Kahit na",
    smallBlue: "Maliit na Asul",
    smallEven: "Maliit Kahit",
    evenGreen: "Green Kahit",
    oddRed: "Pulang Kakaiba",
    isPrime: "Prime",
    extremeSmall: "Napakaliit",
    bigOdd: "Malaking Odd",
    redOddGreen: "Green Odd Sum",
  },
  promote: {
    DirectPromotions: "Mga Direktang Referral",
    FriendsList: "Mga Miyembro ng Koponan",
    PolicyTwo:
      "Tangkilikin ang 0.6% na komisyon sa offline na turnover sa pagtaya para sa mga miyembro ng pangalawang antas",
    InviteFriends:
      "Mag-imbita ng mga kaibigan <br/> Magbahagi ng kaligayahan at makakuha ng mga reward",
    PolicyOne:
      "Tangkilikin ang 0.4% na komisyon sa offline na turnover sa pagtaya para sa mga miyembro ng ikatlong antas",
    PromotePolicy: "Patakaran ng Komisyon sa Pag-promote",
    ViewDetails: "Tingnan ang mga Detalye",
    CopySuccess: "Magtagumpay ang Kopya",
    PolicyThree:
      "Mag-enjoy ng 1% na komisyon sa turnover ng offline na pagtaya para sa mga miyembro sa unang antas",
    InviteLink: "Link ng Promosyon",
    StartEarning:
      "Ibahagi ang iyong referral link at magsimulang kumita ng pera",
    CopyShareLink: "Kopyahin ang Link ng Pagbabahagi",
    ReferRewarded: "Sumangguni at Makakuha ng Gantimpala",
    PolicyFour:
      "Ang di-tuwirang pangalawang antas ay tumutukoy sa mga miyembrong direktang binuo mula sa unang antas",
    PolicyIntro:
      "Tangkilikin ang mga bonus ng komisyon ng turnover ng pagtaya sa tatlong antas",
  },
  " donwload": {
    people: "mga tao",
  },
  trendFooter: {
    trend: "TENDÊNCIA",
    prediction: "PREVISÃO",
    roadMap: "MAPA",
    strategy: "ESTRATÉGIA",
    homefooter: "INÍCIO",
  },
  barChart: {
    Month: "buwan",
    Week: "Linggo",
    Day: "Araw",
  },
  profitsReports: {
    Topic: "Mga Detalye ng Kita",
  },
  commission: {
    PopupTitle: "Kumpirmahin ang Paglipat",
    CommissionLog: "Mga Detalye ng Komisyon",
    Heading: "Humiling ng Withdrawal",
    Cancel: "Kanselahin",
    AmountText: "Mangyaring maglagay ng halaga",
    Amount: "Halaga",
    Confirm: "Kumpirmahin",
    MessageTwo: "Sigurado ka bang gusto mong lumipat",
    TransAmountText: "Halaga ng Paglipat",
    MessageOne: "Sigurado ka bang gusto mong lumipat",
    Ok: "Kumpirmahin",
    AmountError: "Ang halaga ng paglipat na iyong inilagay ay hindi tama",
    Balance: "Balanse ng Account",
  },
  otcTrade: {
    cancel: "Kanselahin",
    existingTrade: "Mayroong umiiral na transaksyon",
    done: "Nakumpleto",
    unconfirm: "Hindi nakumpirma",
    nonPay: "Walang rekord ng pagbabayad",
  },
  email: {
    Required: "Kinakailangan ang verification code",
    incorrect: "Error sa pag-verify ng email",
    Invalid: "Di-wastong email",
    Existing: "Nakarehistro na ang email",
  },
  validate: {
    Amount_not_set: "Mangyaring magpasok ng wastong halaga",
    EnterValidPhoneNumber:
      "Maglagay ng wastong 6-12 character na string (hindi pinapayagan ang mga simbolo)",
    EmptyPhoneNumber: "Walang laman ang numero ng telepono",
    phoneRegistered:
      "Ginagamit na ang numero ng telepono, mangyaring pumili ng isa pa",
    bankAlreadyBind: "Nakatali na ang bank account",
    dateFormat: "Ang petsa ay dapat nasa YYYY-MM-DD na format.",
    emailFormatError: "Maling format ng email",
    CustomerService_offline:
      "Pansamantalang offline ang serbisyo sa customer, mangyaring makipag-ugnayan sa ibang pagkakataon",
    pleaseInputCorrect: "Pakipasok ang tamang {title}",
    required: "Kinakailangan",
    invalidRefCode: "Pakilagay nang tama ang referral code",
    EnterValidReferral: "Maglagay ng wastong referral",
    formatError: "Di-wastong {title} format",
    nameCannotbeEmpty: "Hindi maaaring walang laman ang pangalan",
    refRequired: "Ang pagpaparehistro ay nangangailangan ng referral code",
    EnterValidPassword:
      "Maglagay ng wastong 6-12 character na password (hindi pinapayagan ang mga simbolo)",
    setBankCard: "I-set up ang bank card",
    PhoneRegistered:
      "Nakarehistro na ang numero ng telepono, mangyaring sumubok ng isa pa",
    notBlank: "Hindi maaaring walang laman ang {title}.",
    safetyPasswordNotSet: "Hindi nakatakda ang password sa seguridad",
    emptyEmail: "Hindi maaaring walang laman ang email",
    emailRegistered: "Ginagamit na ang email, mangyaring gumamit ng iba",
    PasswordAndConfirmPasswordNotMatching:
      "Hindi tugma ang password at confirmation password",
    verifyCodeError: "Maling verification code",
    walletAlreadyBind: "Ang pitaka na sinusubukan mong itali ay natali na",
    verifyCodeExpire: "Nag-expire na ang verification code",
    passwordNotBlank: "Hindi maaaring walang laman ang password",
    reentryError: "Ang dalawang entry sa {title} ay hindi magkatugma",
    passwordNoMatch: "Maling password",
    EmptyPassword: "Walang laman ang password",
    cannotBeEmpty: "Hindi maaaring walang laman ang field",
    phoneNotTheSameUser:
      "Pakikumpirma na ang numero ng telepono ay tumutugma sa numero ng telepono ng user sa pag-login",
    EnterRecommendCode: "Ilagay ang referral code",
    nameIsExisted: "Umiiral na ang palayaw",
    walletAddressFormatError: "Di-wastong format ng address ng wallet",
    pleaseSelect: "Mangyaring Piliin ang {title}",
    inCrorrectEmail: "Maling email",
    phoneIsExisted: "Nakarehistro na ang numero ng teleponong ito",
    NameRegistered: "Ginagamit na ang pangalan, mangyaring gumamit ng iba",
  },
  address: {
    duplicateError:
      "Ang wallet na iyong inilagay ay nakarehistro na, mangyaring ipasok muli",
  },
  betDetail: {
    RangeThree: "500-1000",
    All: "Lahat",
    RangeTwo: "100-500",
    Time: "Oras",
    result: "Kasalukuyang Hash",
    Month: "Ngayong Buwan",
    Currency: "Pera",
    Peace: "tugma",
    win: "Halaga ng Panalo",
    Invalid: "Di-wasto",
    GameAll: "Lahat",
    RangeOne: "0-100",
    Loss: "Talo",
    Amount: "Halaga",
    RangeAll: "Lahat",
    nextBlock: "Susunod na Hash",
    AllState: "Lahat",
    RangeFive: "Higit sa 5,000",
    Game: "item",
    State: "Katayuan",
    RangeFour: "1000-5000",
    Win: "manalo",
    Week: "Ngayong Linggo",
    Day: "Ngayong araw",
    return: "Ibalik ang Halaga",
  },
  lottery: {
    cancel: "Kanselahin",
    noteTitle: "Friendly na Paalala",
    specialHashMarkSix: "Espesyal na code na may huling tatlong digit",
    guessedCorrectly: "Hulaan",
    myBets: "Mga Pusta ko",
    secondPlace: "2nd Place",
    Recharge: "Mag-recharge",
    basicTrends: "Mga Pangunahing Trend",
    loss: "Hindi Panalo",
    Sure: "Kumpirmahin",
    specialCodeLastdigits: "Huling 3 Character",
    odds: "Odds",
    highestPossible: "Pinakamataas na posibleng hit",
    BetConfirmation: "Pagkumpirma ng Taya",
    addtoCart: "Idagdag sa Cart",
    CurrentIssue: "Kasalukuyang Numero ng Isyu",
    sure: "Kumpirmahin",
    maxbonusRate: "Pinakamataas na bonus para sa solong taya",
    drawSourceInfoTitle: "Pinagmulan ng Lottery Draw",
    lastThreePurpose: "Function ng huling tatlong digit",
    profitLoss: "Pagkawala",
    quickBetsEmpty: "Walang mahabang sequence",
    BetContent: "Nilalaman ng taya",
    quickBetTitle: "Taya sa Mahabang Pagkakasunod-sunod",
    LotteryNum: "Gumuhit ng Numero",
    betMinimumAmount: "Naabot ang pinakamababang halaga ng taya",
    guess: "Nahulaan ng tama",
    Note: "Tandaan",
    showMore: "Mga Detalye",
    minimumAmount: "Lampas sa limitasyon sa halaga ng taya",
    NumBasket: "Basket ng Numero",
    selectFast: "Mabilis na Pagpili",
    ConfirmPt: "Mga Pusta ko",
    Cancel: "Kanselahin",
    amountExceed: "Hindi sapat na balanse, mangyaring mag-recharge",
    Confirm: "Kumpirmahin",
    maximumWin: "Pinakamataas na Panalo",
    showAll: "(Ipakita lahat)",
    blockHashPopup:
      "Paki-click ang numero ng isyu upang suriin ang halaga ng block hash",
    nonRepeat: "Hindi nauulit",
    betPlace: "Ipasok ang halaga",
    singleAmount: "Isang Halaga",
    noteTitlePt: "Matagumpay na nailagay ang taya",
    CheckMore: "Tingnan ang Higit pang Mga Trend",
    clickFold: "(I-collapse)",
    confirm: "Kumpirmahin",
    Play: "Maglaro",
    notSelected: "Hindi pinili",
    resultsMap: "Mapa ng Resulta",
    IssueNum: "Numero ng Isyu",
    clickVerify: "I-click para i-verify",
    TimePopupCont: "ay isinasagawa",
    return: "Bumalik",
    All: "Lahat",
    NormalBet: "Normal na taya",
    toRecharge: "Mag-recharge",
    Law: "Pamamaraan",
    selectABettingOption: "Mangyaring pumili ng pagpipilian sa pagtaya!",
    lotterySource:
      "Pinagmulan ng pagguhit - harangan ang halaga ng hash (ganap na pagiging patas/hindi makontrol/napapatunayan ng publiko)",
    amountPerBet: "Halaga sa bawat taya",
    betAmountPlaceholder: "Pakilagay ang halagang gusto mong taya",
    currentSelection: "Kasalukuyang Pinili",
    rules: "Mga tuntunin",
    thunder: "Pindutin ang target",
    currentTenValidation:
      "Ang kasalukuyang taya ay hindi maaaring lumampas sa 10 numero",
    bomb: "Bomba",
    lotteyNumbers: "Gumuhit ng Numero",
    mode: "Mode",
    OpenTime: "Draw Time",
    harmonyValue: "Kabuuang halaga",
    AddBets: "Magpatuloy sa Pagdaragdag",
    betItems: "Mga Item sa Taya",
    specialHash: "Huling tatlong digit",
    betMaximumAmount: "Ang halaga ng taya ay umabot sa limitasyon",
    maxBetAmountis: "Ang pinakamataas na halaga ng taya ay",
    Program: "Plano",
    maxBonus: "Pinakamataas na bonus para sa solong taya",
    contest: "Mahabang Pagkakasunod-sunod",
    firstPlace: "1st Place",
    Deadline: "Deadline ng Taya",
    Trend: "Uso",
    Common: "Kabuuan",
    totalAmount: "Nakapirming Halaga",
    moreDetails: "Higit pang mga Detalye",
    BetSuccess: "Matagumpay na nailagay ang taya",
    pleaseFillBetAmount: "Mangyaring punan ang halaga na gusto mong taya",
    TopContent:
      "Hindi bababa sa 1 numero ang dapat mapili sa daan-daan, sampu o unit. Ang pagtutugma ng napiling numero sa kaukulang posisyon sa panalong numero ay nagreresulta sa isang panalo. Gantimpala ng pera",
    Balance: "Balanse",
    specialCode: "Espesyal na code",
    BetNow: "Tumaya Ngayon",
    PageTopTitlte: "Binubuo ng positional courage ng isang bituin",
    BetAmount: "Halaga ng taya",
    PopupContent: "One star, positional courage, composed",
    pending: "Naghihintay ng Draw",
    lastThree: "Huling tatlong digit",
    Source: "Opisyal na Pinagmulan ng Premyo",
    Clear: "Maaliwalas",
    yesterday: "Kahapon",
    NoticePopContent:
      "Matagumpay na nailagay ang taya, i-click ang arrow sa kanang sulok sa itaas ng slip ng taya upang tingnan ang mga makasaysayang tala ng taya",
    Empty: "Maaliwalas",
    previousPeriod: "Kasaysayan",
    PeriodExpired: "ay natapos na",
    thirdPlace: "3rd Place",
    repeat: "Nauulit",
    win: "Panalo",
    profit: "Kita",
    deadlineIsUp: "Naabot na ang huling araw ng pagtaya",
    specialCodeLastdigitsMarkSix: "Espesyal na code, hindi tatlong digit",
    fifthPlace: "5th Place",
    fourthPlace: "4th Place",
    clear: "Maaliwalas",
    betting: "pagtaya",
    Expect: "Isyu",
    Times: "Mga oras",
    betQuantity: "Dami",
    showLess: "I-collapse",
    betTimes: "Numero ng tala",
  },
  entrust: {
    daysOfStrategy: "Mga araw ng diskarte:",
    policyDetails: "Mga detalye ng diskarte",
  },
  stockData: {
    enterCode: "Pakilagay ang stock code o abbreviation",
  },
  betType: {
    name6: "PK10",
    name5: "tamanho",
    name4: "Zhuang Xian",
    name3: "Niu Niu",
    name2: "Sortudo",
    name1: "ímpar mesmo ímpar mesmo",
  },
  agentLog: {
    Type: "Uri",
    CreateTime: "Oras ng Paglikha",
    Amount: "Halaga",
    Balance: "Balanse",
    Records: "Data ng Promosyon",
  },
  withdrawDetail: {
    RangeThree: "500-1000",
    All: "Lahat",
    RangeTwo: "100-500",
    Time: "Oras",
    Rejected: "Tinanggihan ang withdrawal",
    AllClass: "Lahat",
    Month: "Ngayong buwan",
    Currency: "Pera",
    Topic: "Mga Detalye ng Pag-withdraw",
    GameAll: "Lahat",
    AllStatus: "Lahat",
    RangeOne: "0-100",
    FirstClass: "Unang antas",
    Amount: "Halaga",
    Approved: "nakapasa",
    RangeAll: "Lahat",
    SecondClass: "Ikalawang antas",
    TotalWithdraw: "Kabuuang halaga ng withdrawal",
    Successful: "Tagumpay",
    typeStr: "Uri",
    RangeFive: "Higit sa 5000",
    Game: "item",
    Canceled: "Kinansela",
    RangeFour: "1000-5000",
    Week: "Ngayong linggo",
    Day: "Ngayong araw",
    Pending: "Pinoproseso",
    ThirdClass: "Ikatlong antas",
  },
  betSlip: {
    single: "Walang asawa",
    betnow: "Simulan ang Pagpusta Ngayon!",
    multiple: "Maramihan",
    empty: "Walang laman ang Bet Slip",
  },
  chart: {
    winText: "Panalong laro",
    betsText: "Ang halaga ng taya",
    betsCountText: "Bilang ng taya",
  },
  appdownload: {
    footer: "Propesyonal na pag-encrypt, secure at walang pag-aalala",
    androidpro: "Android Professional Edition",
    title: "Paki-download ang Hash App para sa mga operasyon",
    applepro: "iOS Professional Edition",
    chooseMethod: "I-install ang app",
  },
  register: {
    getVerificationCode: "Kunin ang Verification Code",
    Account: "Username",
    phoneNoPlaceHolder: "Numero ng Mobile",
    emailValidation: "Mangyaring magpasok ng email",
    emailReg: "I-email",
    smsCode: "SMS Verification",
    required: "Hindi tugma ang mga password",
    verificationCodePlaceholder: "Pakipasok ang verification code",
    RegisterAnAccount: "Pagpaparehistro ng Account",
    password: "Itakda ang Password",
    Trc20Address: "TRC20 Address",
    smsVerificationCode: "SMS Verification Code",
    nameError: "Error sa pagpaparehistro ng account",
    noRequired: "Pakipasok ang code ng imbitasyon (opsyonal)",
    CreateAccount: "Gumawa ng Bagong Account",
    AccountRegister: "Account",
    Login: "Mag-login",
    deviceLimitFiveHour:
      "Naabot ng device na ito ang 5 oras na limitasyon sa pagpaparehistro.",
    phoneCodeValidation: "Pakipasok ang SMS verification code",
    ExistingNumberError: "Umiiral na ang Wallet address",
    phone: "Numero ng mobile",
    RePasswordPlaceHolder: "Kumpirmahin ang password",
    phoneValidation: "Mangyaring ipasok ang numero ng telepono",
    newUserVoucherNotice:
      "Magrehistro para makatanggap ng {voucher} yuan + unang recharge makakuha ng {initialAmount} yuan",
    UserNamePatternError:
      "Ang username ay dapat na 6-20 character at naglalaman lamang ng mga titik at numero",
    EmailPatternError: "Error sa pattern ng email",
    passwordPlaceholder: "Mangyaring ipasok ang password",
    ipLimitOneHour:
      "Ang IP na ito ay umabot sa oras-oras na limitasyon sa pagpaparehistro.",
    CaptchaPlaceHolder: "CAPTCHA",
    UserNameError: "Mangyaring ipasok ang palayaw ng gumagamit",
    deviceLimitToday:
      "Naabot na ng device na ito ang pang-araw-araw na limitasyon sa pagpaparehistro.",
    ExistingUserNameError: "Umiiral na ang account na ito",
    email: "I-email",
    PasswordPlaceHolder: "Password (8 hanggang 20 character)",
    phoneNoRequired: "Mangyaring ipasok ang iyong numero ng telepono",
    verifyCode: "Verification Code",
    codeDoesNotMatch: "Hindi tugma ang code",
    recommenderPlaceholder: "Mangyaring ipasok ang tagarekomenda",
    smsVerificationCodePlaceholder: "Pakipasok ang SMS verification code",
    phoneFormatError: "Maling format ng numero ng telepono",
    verifiCode: "Kodigo ng SMS",
    WalletPlaceHolder: "Desentralisadong wallet (TRC20 USDT)",
    Captcha: "Verification Code",
    invalidPhilippinePhoneNo: "Hindi wastong numero ng telepono sa Pilipinas",
    Register: "Magrehistro",
    ipLimitMonth:
      "Ang IP na ito ay umabot sa buwanang limitasyon sa pagpaparehistro.",
    SignIn: "Mag-sign In",
    deviceLimitMonth:
      "Naabot ng device na ito ang buwanang limitasyon sa pagpaparehistro.",
    ipLimitDay:
      "Ang IP na ito ay umabot sa pang-araw-araw na limitasyon sa pagpaparehistro.",
    addrPattrnErr: "Error sa pagbubuklod ng address ng wallet",
    phoneNumberError: "Mangyaring ipasok ang numero ng telepono",
    AddressError: "Mangyaring ipasok ang address",
    haveAccount: "Mayroon ka nang account?",
    highestExclusive: "Eksklusibong Regalo para sa mga Bagong Miyembro",
    Notice: "Mayroon ka nang account?",
    toSend: "Magrehistro para makakuha",
    PasswordError: "Hindi tugma ang mga password!",
    onlineService: "Online Customer Service",
    SendCode: "Ipadala ang Code",
    RecomPlaceHolder: "Mangyaring ipasok ang code ng imbitasyon",
    CaptchaError: "Mali ang nailagay na verification code, pakisubukang muli",
    AccountPlaceHolder: "Account",
    UsernameShouldContain9AtThirdCharacter:
      "Ang username ay dapat may digit 9 bilang pangatlong character",
    RecomendedCode: "Code ng Imbitasyon",
    ipLimitWeek:
      "Naabot na ng IP na ito ang lingguhang limitasyon sa pagpaparehistro.",
    phoneNumber: "Mobile",
    phonePlaceholder: "Mangyaring ipasok ang iyong numero ng telepono",
    invalidBrazilPhoneNo:
      "Ang mga numero ng telepono ay dapat magsimula sa digit 9, na sinusundan ng kaukulang area code",
    deviceLimitHour:
      "Naabot ng device na ito ang 1 oras na limitasyon sa pagpaparehistro.",
    PhonePatternError: "Di-wastong numero ng telepono",
    back: "Bumalik",
    emailCodeValidation: "Pakipasok ang email verification code",
    title: "Magrehistro",
    Continue: "Magrehistro ngayon",
    nameWalletAdrError: "Mali ang username o wallet address, pakisubukang muli",
    PasswordMatchErr:
      "Ang dalawang password na ipinasok ay hindi tugma, mangyaring muling ipasok",
    PasswordPatternError: "Ang password ay dapat na 8-20 character",
    deviceLimitWeek:
      "Naabot na ng device na ito ang lingguhang limitasyon sa pagpaparehistro.",
    recommender: "Tagapagrekomenda",
    ExistingPhoneError: "Umiiral na ang numero ng teleponong ito",
    invalidInviteCode:
      "Ang code ng imbitasyon ay hindi umiiral, mangyaring muling ipasok",
    Password: "Password",
    submitButton: "Magrehistro",
    UserName: "Magrehistro",
    invalidBrazilAreaCode:
      "Ang mga numero ng telepono ay dapat may area code 11-99; anumang area code sa labas ng saklaw na ito ay hindi tinatanggap",
    RePassword: "Kumpirmahin ang password",
    Paste: "Idikit",
    firstCharge: "Unang recharge makuha",
    TouristLogin: "Maglaro nang walang pagpaparehistro",
    verificationCode: "Verification Code",
    inviteCodeError: "Mangyaring ipasok ang code ng imbitasyon",
    emailCode: "Pagpapatunay ng Email",
    ipLimitFiveHour:
      "Naabot ng IP na ito ang limitasyon sa pagpaparehistro sa loob ng limang oras.",
    emailPlaceholder: "I-email",
    phoneReg: "Mobile",
    WalletRegister: "Wallet",
    captchaNotMatch: "Maling captcha",
  },
  agent: {
    FilterAll: "Lahat",
    FilterFirst: "Antas 1",
    CommissionPlaceHold: "Pakipasok ang account o ID",
    teamWinLoss: "Panalo/talo ng Koponan",
    MemTableCommission: "Komisyon",
    FilterLevel: "Antas",
    teamWithdraw: "Pag-atras ng Koponan",
    allCommissionStat: "Lahat ng komisyon",
    MemberTab: "Koponan Ko",
    BetHistory: "Mga Makasaysayang Taya",
    CommTableTime: "Oras",
    MemberThirdPeople: "Ika-3 Antas na Downline",
    CommTableAccount: "Account",
    FilterThird: "Antas 3",
    CommissionTab: "Komisyon ko",
    CommissionTransaction: "Account",
    balance: "Balanse",
    FilterMonth: "Ngayong Linggo",
    Search: "Maghanap",
    recomCode: "Referral code",
    CommissionText1: "Patakaran sa pag-alis ng komisyon ng promosyon",
    CommissionText2:
      "Tangkilikin ang tatlong-antas na turnover commission bonus",
    CommTableBet: "Halaga ng taya",
    CommTableCommission: "Komisyon",
    earnProfit: "Kumita (1 taong tubo 32.28%)",
    cumulativeBettingCommission: "Pinagsama-samang komisyon sa pagtaya",
    CommissionTransfer: "Paglipat",
    history: "Kasaysayan",
    CommissionToday: "Komisyon ngayon",
    levelOne: "Antas 1",
    MemTableAgent: "Pag-unlad ng Ahente",
    CommissionBalance: "Balanse ng Komisyon",
    agentComission: "Komisyon ng Ahente",
    FilterSecond: "Antas 2",
    cumulativeRechargeCommission: "Pinagsama-samang komisyon sa recharge",
    deposit: "Deposito",
    FilterTime: "Petsa ng Komisyon",
    Save: "I-save nang lokal",
    teamBet: "Halaga ng taya ng koponan",
    FilterToday: "Antas",
    MemberSecondPeople: "Ika-2 Antas na Downline",
    teamCommission: "Komisyon ng koponan",
    levelThree: "Antas 3",
    MemTableAccount: "Account",
    CommTableLevel: "Antas",
    MemberMember: "Bilang ng Koponan",
    CommissionHistory: "Komisyon Log",
    rechargeCommission: "Recharge Commission",
    MemTableProfit: "panalo/talo",
    todaysCommissionStat: "Komisyon ngayon",
    bettingCommission: "Komisyon sa pagtaya",
    teamBalance: "Balanse ng Koponan",
    CopynShare: "Kopyahin ang link",
    today: "Ngayon",
    MemberTodayPeople: "Bago Ngayon",
    MemTableBet: "Halaga ng taya",
    teamRecharge: "Deposito ng Koponan",
    levelTwo: "Antas 2",
    PromotionTab: "Aking Promosyon",
    commission: "Komisyon",
    QRNotDownloaded: "Hindi na-download",
    MemberFirstPeople: "Unang Antas ng Downline",
    commissionDetails: "Mga Detalye ng Komisyon",
    inviteFriendNow: "Convide amigos",
    NoCommissionPrompt:
      "Hindi ka pa nakakuha ng anumang komisyon. Anyayahan ang mga kaibigan na magsimulang kumita.",
    FilterWeek: "Ngayong Linggo",
    BetToday: "Mga taya ngayon",
    QRDownloaded: "Na-download",
    MemTableActive: "Antas",
    PromotionNotice:
      "Mag-enjoy ng 1% na komisyon sa 1st level offline na turnover sa pagtaya\n\nTangkilikin ang 0.6% na komisyon sa 2nd level offline na turnover sa pagtaya\n\nTangkilikin ang 0.4% na komisyon sa ika-3 antas ng offline na turnover sa pagtaya\n\nAng hindi direktang 2nd level ay tumutukoy sa mga miyembro na direktang binuo mula sa 1st level",
    Share: "Ibahagi ang QR code",
    withdraw: "Labas",
  },
  pcNotification: {
    BAddCopied: "Nakopya ang address ng pagtaya",
  },
  sysmsg: {
    placeholder: "Mangyaring ipasok",
    send: "Ipadala",
  },
  rules: {
    TransferTron: "Mangyaring ilipat sa TRON",
    Odds: "Odds",
    GameRules: "Mga Panuntunan sa Laro",
    nothavecoin:
      "Limitasyon sa paglipat: {min_amount} - {max_amount} USDT, di-wasto kung lumampas",
    bettingSubIntro:
      '<p><span style="color: #ffffff;">Pakigamit ang iyong</span><span style="color: #3598db;"> desentralisadong wallet</span><span style="color: #ffffff;"> upang ilipat sa tinukoy na wallet address sa ibaba</span></p>',
    bettingIntro: "Maglipat at tumaya, instant payment",
    ErrorGame: "Di-wastong ID ng laro",
    transferNet:
      "Transfer Network: USDT (TRC20) - Transfer Network: USDT (TRC20)",
    CopySuccess: "Matagumpay ang pagkopya",
    Betting: "Taya",
    nothavecoinlink:
      "Walang wallet? Gustong bumili ng digital currency, pakisuri",
    BettingAddress: "Address ng Pagtaya",
    OnlyAccept: "Tumatanggap lang",
    CopyAddress: "Recharge Address",
    limitations: "Transfer network: USDT (TRC20)",
  },
  otcLogRecords: {
    volume: "Dami",
    typeStatus: "Uri ng Data",
    currency: "Pera",
    user: "Gumagamit",
    status: "Data",
  },
  quoteDetails: {
    latestPrice: "Pinakabagong Presyo",
    code: "Code/Pangalan",
    gainListTitle: "Mga Top Gainers",
    quoteChange: "Rate ng Pagbabago",
    turnOverRateTitle: "Rate ng Turnover",
    timedSpeed: "5 minutong acceleration",
    back: "Bumalik",
    lowest: "Mababa",
    speedList: "Mabilis na tumataas na listahan",
    highest: "Mataas",
    dropListTitle: "Top Losers",
    turnoverTitle: "Halaga ng Transaksyon",
    speedListAlt: "Bumagsak na listahan",
    turnoverPerValue: "Turnover / 10,000",
  },
  modifyWith: {
    cnpjID: "CPF ID",
    notVerified: "Hindi Na-verify",
    phoneNumber: "Numero ng Telepono",
    accName: "Pangalan",
    cpf: "CPF",
    verified: "Na-verify",
    cnpj: "CNPJ",
    email: "Email",
  },
  modifyLoginPassword: {
    getVerficationCode: "Kunin ang verification code",
  },
  forceRegister: {
    contactCustomerService: "Makipag-ugnayan sa Serbisyo sa Kustomer",
    content:
      "Magrehistro ngayon at makatanggap ng 100₱ bilang bonus, kasama ang dagdag na 50% sa anumang halaga ng recharge. Makipag-ugnayan sa customer service para makatanggap ng libreng programa ng propesyonal na mentorship.",
  },
  otcOrder: {
    wrongAmount: "Hindi tamang dami",
    wrongOrderId: "Maling order ID",
    otherMerchatAdd: "Hindi maisara ang iba pang mga merchant ad",
    invalidTrade: "Hindi maaaring makipagkalakalan sa iyong sarili",
  },
  languagePopup: {
    Cancel: "Kanselahin",
    SelectLanguage: "Piliin ang operating language",
    Save: "I-save",
  },
  newsDetails: {
    back: "Bumalik",
    title: "Balita",
    announcement: "Editor",
  },
  verifyState: {
    set: "Itakda",
    unVerified: "Hindi Na-verify",
    notSet: "Hindi Nakatakda",
    verify: "Na-verify",
  },
  opeatemonth: {
    managementFee: "Bayad sa Pamamahala",
  },
  withdrawInquiry: {
    CommissionPrice: "Presyo ng Order",
    unsoldQuantity: "Hindi Napunong Dami",
    commissionStatus: "Katayuan ng Order",
    commissionTime: "Oras ng Order",
    nameCode: "Code ng Pangalan",
    back: "Bumalik",
    end: "Wala na",
    title: "Kanselahin ang Inquiry",
    CommissionDirection: "Direksyon ng Order",
    OrderQuantity: "Dami ng Order",
  },
  " field": {
    "HomeConfig_Customer_service_label ": "Label ng Customer Service",
    "Home_Withdrawal_amount_of_the_day ": "Araw-araw na Halaga ng Pag-withdraw",
    "Home_total_number_of_users ": "Kabuuang mga User",
    AgentAccount_phone: "Telepono",
  },
  kyc: {
    notVerified: "Complete a verificação de identidade antes de sacar",
    alreadyPending: "Verificação em análise, não reenvie",
    realNameAlreadyUsed: "Este nome real já está em uso",
    idCardBackRequired: "Foto traseira do documento é obrigatória",
    realNameRequired: "Nome real é obrigatório",
    facePhotoRequired: "Foto de verificação facial é obrigatória",
    invalidUrl: "URL da imagem inválida",
    idCardFrontRequired: "Foto frontal do documento é obrigatória",
    alreadyApproved: "Verificação já aprovada",
    submitSuccess: "Verificação enviada, aguarde análise",
  },
  randomWin: {
    title:
      "Ang mga nanalong manlalaro ay nakumpirma na at ang mga gantimpala ay ipinamamahagi!",
    win: "manalo",
  },
  LotteryTask: {
    setLotteryResultMax: "Pinakamataas na Resulta ng Lottery",
    createLottery: "Lumikha ng Lottery",
  },
  foundWinners: {
    highestPrice: "Pinakamataas na Presyo",
    registerToReadThree:
      "¥3,456/taon, inirerekomenda ng mga analyst ng gintong medalya ang mga pangunahing stock araw-araw, magparehistro para sa libreng pagbabasa",
    more: "Higit pa",
    registerToReadFour:
      "¥7,188/taon, mga pang-araw-araw na seleksyon na nakatuon sa end-of-day trading, magparehistro para sa libreng pagbabasa",
    historyRanking: "Last 15 Days Ranking",
    biggestIncrease: "Pinakamataas na Pagtaas",
    latestStockPool: "Pinakabagong Stock Pool",
    stockName: "Pangalan ng Stock",
    loginToAccess: "Magrehistro at mag-log in para magbasa",
    registerToReadTwo:
      "¥3,600/taon, malaking pagpili ng stock ng data, real-time na pagsubaybay ng eksperto, magparehistro para sa libreng pagbabasa",
    promptLogin: "Hindi ka pa naka-log in, pumunta sa pag-login",
    attention: "Presyo ng Panoorin",
    registerToReadOne:
      "¥2,796/taon, pumili ng 3-5 potensyal na stock araw-araw, magparehistro para sa libreng pagbabasa",
  },
  otcLog: {
    all: "Lahat",
    canceled: "Kinansela",
    completed: "Nakumpleto",
    complain: "Sa ilalim ng Apela",
    open: "Patuloy",
    unconfirm: "Hindi Nakumpirma",
  },
  agentCommTrans: {
    FilterAll: "Lahat",
    TableAmount: "Halaga ng taya",
    TopName: "Mga Detalye ng Komisyon",
    TableLevel: "Antas",
    TableGame: "Proyekto",
    FilterToday: "Ngayong araw",
    TableBalance: "Balanse",
    FilterProj: "Proyekto",
    FilterWeek: "Ngayong Linggo",
    TableUserName: "Account",
    TableTime: "Oras",
    FilterTrans: "Mag-withdraw",
    FilterCommi: "Komisyon",
    FilterMonth: "Ngayong Buwan",
    TableCommission: "Komisyon",
    FilterTime: "Oras",
  },
  stockcard: {
    optional: "Mga paborito",
  },
  veriy: {
    addUsername: "username",
    enterUserName: "Ipasok ang username",
  },
  safetyPassword: {
    NewPassword: "Bagong password",
    RePassword: "Ipasok muli ang password",
    PasswordEmpty: "Mangyaring magtakda ng password",
    passwordEmpty: "Walang laman ang password",
    captchaError: "Pakipasok ang verification code",
    error: "Hindi kilalang error",
    empty: "Walang laman ang password sa seguridad",
    wrong: "Mali ang password ng seguridad",
    Captcha: "Resulta ng pagkalkula",
    emptyError: "Walang laman ang password",
    PasswrdMatchErr: "Hindi tugma ang mga password",
    PasswordError: "Mali ang input ng iyong password",
    captchaNotMatch: "Maling verification code",
    PasswordInfo: "I-update ang password ng seguridad",
    Save: "I-save",
    CurrentPassword: "Lumang password",
    Safety: "Password ng seguridad",
    placeholder: "Security Code",
  },
  rule: {
    CopyText: "Kopyahin ang Address",
    Settlement: "Halaga ng Settlement",
    Game: "Pangalan ng Laro",
    Introduction: "Panimula ng Mga Panuntunan sa Laro",
    Amount: "Halaga ng taya",
    ScanText: "I-scan sa Taya",
    ViewDetail: "Tingnan ang lahat ng mga tala",
    GameRecord: "Mga Rekord ng Laro",
    Result: "Kasalukuyang Hash",
  },
  verifySms: {
    next: "Susunod",
    SmsCodeTwoLabel1: "Mangyaring ipasok ang iyong mobile",
    EmailCode: "SMS Code",
    SmsCodeTwoLabel2: "Natanggap ang verification code",
    Confirm: "Kumpirmahin",
    SmsCodeOneLabel: "Pakilagay ang iyong mobile verification code",
    EmailCodeLabel2: "6 na digit na verification code ang natanggap",
    SmsCodeTwo: "Mobile verification code",
    EmailCodeLabel1: "Mangyaring magpasok ng email",
    ContactService:
      "Walang code? Mangyaring makipag-ugnayan sa customer service",
    SmsCodeOne: "Mobile verification code",
    Phone: "Mangyaring ipasok ang iyong numero ng telepono",
    Next: "SMS Verification",
    SendCode: "Magpadala ng verification code",
    Topic: "Pagpapatunay ng Seguridad",
  },
  setemail: {
    Intro:
      "Ang pag-verify sa email ay nagdaragdag ng karagdagang layer ng seguridad sa iyong mga withdrawal at account",
    ChangeEmail: "Baguhin ang pag-verify ng email",
    ActiveEmail: "Email",
    Topic: "Email",
  },
  title: {
    evaluation: "Pagsusuri",
    recharge: "Mag-recharge",
    shopJoin: "Trabaho sa tindahan",
    betSlip: "Bet Slip",
    serviceDetail: "Mga Detalye ng Serbisyo",
    myTeam: "Aking Team",
    personalJoin: "Personal na Trabaho",
    capitalFlow: "Daloy ng Pondo",
    myAccount: "Aking Mga Asset",
    serviceTechnician: "Service Technician",
    withdraw: "Mag-withdraw",
  },
  verifyEmail: {
    EmailCodeTwo: "Email verification code",
    Email: "Pakilagay ang iyong email",
    EmailCodeTwoLabel1: "Mangyaring magpasok ng email",
    EmailCodeTwoLabel2: "6 na digit na verification code ang natanggap",
    emailIsIncorrect: "Ilagay ang verification code",
    EmailCodeOneLabel: "Pakilagay ang iyong email verification code",
    Confirm: "Kumpirmahin",
    MobileCode: "Mobile verification code",
    enterCaptcha: "Kinakailangan ang captcha",
    MobileCodeLabel1: "Mangyaring ipasok ang telepono",
    ContactService:
      "Walang code? Mangyaring makipag-ugnayan sa customer service",
    MobileCodeLabel2: "Natanggap ang verification code",
    SendCode: "Ipadala ang code",
    Topic: "Pagpapatunay ng seguridad",
    EmailCodeOne: "Email verification code",
    existingEmail: "Umiiral na ang email",
  },
  common: {
    noMoreData:
      "Sa kasalukuyan ay walang mga talaan ng komisyon. Anyayahan ang iyong mga kaibigan at magsimulang kumita ng mga komisyon ngayon.",
    Cancel: "Kanselahin",
    Profile: "Aking",
    EndtDateTitle: "Petsa ng Pagtatapos",
    PCLanguageTopic: "Pinasimpleng Chinese",
    StartDate: "Petsa ng Pagsisimula",
    quote: "Opsyonal na Merkado",
    Loading: "Naglo-load",
    Inquire: "Maghanap",
    share:
      "Pansamantalang offline ang serbisyo sa customer, mangyaring makipag-ugnayan sa ibang pagkakataon",
    totPrice: "Kabuuang Presyo",
    StartDateTitle: "Petsa ng Pagsisimula",
    ok: "OK",
    Loose: "Palayain",
    Whatsapp: "Whatsapp",
    Finished: "Wala na",
    funding: "Margin Trading",
    Telegram: "Telegram",
    Pulling: "Hilahin",
    more: "Higit pa",
    userTerms: "Mga Tuntunin at Kasunduan",
    Join: "Sumali",
    less: "Mas kaunti",
    customerCare: "Serbisyo sa Customer",
    EndDate: "Petsa ng Pagtatapos",
    remaining: "natitira:",
    home: "Home",
    backToHome: "Sumali sa laro",
    allOrders: "Lahat ng Order",
    marqueeText: "Tekstong Marquee",
    chat: "Serbisyo sa Customer",
    LanguageTopic: "Sinabi ni En",
    orders: "Mga order",
    noData:
      "Kasalukuyang walang mga tala sa lottery, mangyaring pumili ng isang hanay ng oras o lumahok sa laro upang tingnan ang iyong mga tala",
    Ok: "Kumpirmahin",
    account: "Account",
  },
  otcAccount: {
    noPaymentType: "Hindi naitakda ng user ang uri ng pagbabayad",
    noMatchPayType: "Walang katugmang uri ng pagbabayad ang user",
    insuffFrozenBal: "Hindi sapat ang frozen na balanse",
    noOposieAccount: "Walang setting ng order account",
  },
  tabpage: {
    cashManager: "Tagapamahala ng pera",
    upload: "Pag-upload ng Configuration",
    sms: "SMS Configuration",
    company: "Impormasyon ng Kumpanya",
    payment: "Pagbabayad",
    email: "Mga Setting ng Email",
    others: "Iba",
    otcBasicConfig: "Pangunahing Configuration ng OTC",
    riskManagement: "Pamamahala ng Panganib",
    image: "Pamamahala ng Larawan",
    ClassicTasks: "Mga Klasikong Gawain",
    en: "Ingles",
    otp: "OTP",
    zh: "Pinasimpleng Chinese",
    home: "Home Menu",
    uploadConfig: "Pag-upload ng Configuration",
    extend: "Karagdagang Impormasyon",
    system: "System Configuration",
    trade: "Configuration ng Trading",
    trc20: "TRC20 Configuration",
    pragmatic: "Pragmatic na Laro",
    ja: "Hapon",
    appManagemnt: "Pamamahala ng App",
    redpacket: "Mga Setting ng Red Packet",
    detail: "Detalyadong Paglalarawan",
    basic: "Pangunahing Impormasyon",
  },
  placeAdd: {
    transMsg: "Mensahe ng Transaksyon",
    Title: "Mag-post ng Ad",
    wantToBe: "Bansa at uri ng transaksyon",
    noOfTrans: "Dami ng Transaksyon",
    minLimit: "Isang minimum na limitasyon ng transaksyon",
    meansTrans: "Paraan ng Transaksyon",
    yourOffer: "Iyong Alok",
    transLimit: "Limitasyon sa Transaksyon (kinakailangan)",
    availableBalance: "Magagamit na Balanse ng C2C",
    refPrice: "Presyo ng Sanggunian",
    failTime: "Petsa ng Pag-expire",
    availableBal: "Balanse ng C2C Account:",
    priceSetting: "Pagtatakda ng Presyo",
    maxLimit: "Isang maximum na limitasyon ng transaksyon",
    addReminder: "Impormasyon ng Ad",
    epxOfPay: "Deadline ng Pagbabayad",
    fundPassword: "Password ng Pondo",
    publishAdd: "I-publish Ngayon",
  },
  noticeDetail: {
    back: "Bumalik",
    announcement: "Mga Detalye ng Anunsyo",
  },
  recomInfo: {
    QRDownloaded: "Na-download",
    QRNotDownloaded: "Hindi na-download",
  },
  mngPayment: {
    confirm: "Kumpirmahin",
    qr: "Mangyaring i-upload ang iyong imahe ng QR code",
    password: "Password",
    heading: "Paraan ng Pagbabayad",
    name: "Pangalan",
    bankName: "Pangalan ng Bangko",
    account: "Account Number",
  },
  downloadPlatform: {
    pwaNotSupported: "Hindi suportado ang pag-install sa browser na ito",
    footer: "Piliin kung paano mo gustong i-install ang app",
    pwa: "I-install bilang PWA",
    title: "Pumili ng paraan ng pag-install",
    apk: "I-download ang APK",
  },
  appStoreInstall: {
    title: "Pumili ng paraan ng pag-install",
    pwa: "I-install bilang PWA",
    iosProfile: "I-install ang iOS Profile",
    pwaNotSupported: "Hindi suportado ang pag-install sa browser na ito",
    iosProfileFailed: "Hindi makuha ang iOS profile download link",
    iosProfileInstructions: "Sundin ang mga hakbang sa ibaba upang i-install ang iOS profile",
  },
  notice: {
    noticeHead: "Update Notification",
    upgradeContent: "Mahal na gumagamit, ang sistema ay ina-update.",
  },
  otcorderstatus: {
    trading: "Sa transaksyon",
    cancel: "Kinansela",
    waiting: "Pinoproseso",
    done: "Nakumpleto",
    partialCancel: "Bahagyang nakansela",
  },
  lotDetailsPop: {
    BetTime: "Oras ng Taya",
    No: "Hindi.",
    Odds: "Odds",
    betQty: "taya",
    rebate: "Ibalik ang Halaga",
    BetSerNo: "Numero ng taya",
    LotteryName: "Gumuhit ng Pangalan",
    Title: "Mga Detalye ng Taya",
    ReturnAmount: "Bonus",
    LotteryHashChars: "Huling tatlong digit",
    BetData: "Pangalan ng taya",
    ReturnAmt: "Ibinalik ang halaga",
    LotteryNum: "Iginuhit na Numero",
    BetQuentity: "Ang dami ng taya",
    viewHash: "Tingnan ang Source Hash Source",
    SingleBet: "Isang halaga ng taya",
    PlayMethod: "gameplay",
    BetTotal: "Ang halaga ng taya",
    MyBetDet: "Mga taya ko",
  },
  technician: {
    imageOver3: "Higit sa 3 mga larawan",
    storeRequired:
      "Ang pagdaragdag ng technician ay nangangailangan ng isang tindahan",
    personStoreNoAdd:
      "Ang personal na tindahan ay hindi maaaring magdagdag ng technician",
    earliestReserve: "Pinakamaagang magagamit na appointment",
    distanceNear: "Pinakamalapit na distansya",
    orderCounts: "Bilang ng mga order",
    female: "Babaeng technician",
    male: "Lalaking technician",
  },
  home: {
    cancel: "Kanselahin",
    TimeBao: "Kasalukuyang pamamahala sa pananalapi",
    Customer: "Serbisyo sa Customer",
    QuestionTwo: "Ano ang desentralisadong wallet? Bakit ito ligtas?",
    upload: "Mag-recharge",
    trend: "Tendência",
    walletPopupcancel: "Huwag mo nang ipaalala muli",
    nextDraw: "Próximo Sorteio",
    Activity: "Aktibidad",
    walletPopuptitle: "Friendly na paalala",
    History: "História",
    userBenefits: "Mga benepisyo ng gumagamit",
    walletPopupcontent:
      "Ang iyong kasalukuyang account ay hindi nakatali sa isang desentralisadong pitaka, kaya lahat ng mga ulat ng laro ay hindi bubuo ng data.",
    ScanCode: "I-scan para makipagpalitan (minimum exchange 1U o 10T)",
    Calculation:
      "Halaga ng Palitan = (Natanggap na Halaga × Kasalukuyang Presyo sa Market) - Bayarin sa Gas",
    appdownsubtitle: "Larong Lottery",
    otc: "C2C",
    QuestionSix: "Anong uri ng opsyon sa USDT ang dapat kong piliin?",
    GameIntro:
      "Ang block hash value ay ang DNA ng isang set ng data; bawat block hash value ay natatangi, random at hindi nababasag.",
    all: "TODOS",
    aboutus: "Tungkol sa amin",
    reacharge: "Mag-recharge",
    liveSports: "Matagumpay na Nabago ang Password",
    DigitalExchange: "Digital Currency Exchange",
    SubHeading: "Patas, Tapat, Transparent",
    QuestionThree: "Ano ang desentralisadong wallet? Bakit ito ligtas?",
    customerCare: "Pangangalaga sa Customer",
    viewAll: "Lahat",
    goToUrl: "Kumpirmahin",
    MinimumBet: "Pinakamababang Taya",
    reachrge: "Mag-recharge",
    HashFun: "Ang mga sorpresa ng hash ay sagana, walang katapusang kasiyahan!",
    versionPopLatest: "Pinakabagong Bersyon:",
    Heading: "Global TRON Blockchain Betting Platform",
    Help: "Tulong",
    NewTestMenu: "Subukan ang menu zh",
    SighIn: "Check-in",
    AnswerSix:
      "Ang platform na ito ay batay sa teknolohiyang TRON TRC20. Samakatuwid, ang Lucky Hash transfer address ay kabilang sa USDT-TRC20. Dapat mong piliin ang USDT-TRC20. Kung pipili ka ng ibang uri, hindi matatanggap ng Lucky Hash ang iyong USDT, na magreresulta sa mga pagkalugi para sa iyo at sa Lucky Hash",
    AnswerFive: "Anong uri ng opsyon sa USDT ang dapat kong piliin?",
    AnswerOne:
      "Sa panimula, ang blockchain ay isang nakabahaging database na nag-iimbak ng data o impormasyon. Mayroon itong mga feature tulad ng tamper-proof, ganap na masusubaybayan, transparent sa publiko, sama-samang pinapanatili, atbp.",
    ViewRules: "Tingnan ang Mga Panuntunan",
    officialChannel: "Opisyal na Channel",
    TestMenu: "Menu ng pagsubok",
    QuestionFour: "Bakit ako may magkakasunod na panalo o pagkatalo?",
    CopySuccess: "Matagumpay ang pagkopya",
    versionPopCurr: "Kasalukuyang Bersyon:",
    PlatformRedemption: "Opisyal na Platform Exchange",
    appdownbtn: "I-download ang App",
    AnswerThree:
      "Kung ikukumpara sa mga sentralisadong wallet (exchanges), kung saan ang mga pribadong key ay hawak ng mga third-party na service provider, ang mga desentralisadong wallet ay may mga user na namamahala ng kanilang sariling mga pribadong key, na may mga asset na nakaimbak sa blockchain. Ang mga user ang tunay na may hawak ng mga digital na asset, at ang mga wallet ay nagsisilbi lamang na mga tool upang tumulong na pamahalaan ang mga on-chain na asset at basahin ang data ng blockchain, kaya hindi nila makontrol, nakawin o mailipat ang iyong mga asset",
    QuestionFive: "Bakit may pagkaantala sa pagtanggap ng mga pondo?",
    OnlineService: "Online Customer Service",
    walletPopupconfirm: "Pumunta upang magbigkis",
    Expalination:
      "Kung kailangan mong palitan ang USDT para sa TRX o TRX para sa USDT, mangyaring ilipat sa address sa ibaba. Ang platform ay agad na magbabalik ng katumbas na halaga ng TRX o USDT sa iyo sa loob ng 10 segundo, nang libre",
    appdowntitle: "Pinakasikat",
    AnswerFour:
      "Ang mga random na kaganapan ay sumusunod sa batas ng malalaking numero (sa ilalim ng hindi nagbabagong mga kundisyong pang-eksperimento, ang dalas ng mga random na kaganapan ay lumalapit sa posibilidad nito gaya ng tinukoy ng batas ng malalaking numero). Habang tumataas ang dalas ng mga paglilipat, ang posibilidad na manalo o matalo ay patungo sa isang matatag na halaga. Samakatuwid, magpatuloy sa paglilipat; ang pangkalahatang posibilidad na manalo ay tumataas sa mas madalas na paglilipat",
    Odds: "Odds",
    Telegram: "Telegram:",
    QuestionOne: "Ano ang blockchain?",
    channelContent:
      '<div style="color: #333; font-family: \'Microsoft YaHei\', Arial, sans-serif; line-height: 1.6;">\n<div style="max-width: 650px; margin: 0 auto;">\n<div style="text-align: left;">\n<div style="margin-bottom: 12px;">\n<div class="flex flex-col text-sm">\n<section class="text-token-text-primary w-full focus:outline-none [--shadow-height:45px] has-data-writing-block:pointer-events-none has-data-writing-block:-mt-(--shadow-height) has-data-writing-block:pt-(--shadow-height) [&amp;:has([data-writing-block])&gt;*]:pointer-events-auto scroll-mt-[calc(var(--header-height)+min(200px,max(70px,20svh)))]" dir="auto" data-turn-id="request-69c9f2c1-c2ec-8323-bb90-c3c1177f9a36-4" data-testid="conversation-turn-16" data-scroll-anchor="true" data-turn="assistant">\n<div class="text-base my-auto mx-auto pb-10 [--thread-content-margin:var(--thread-content-margin-xs,calc(var(--spacing)*4))] @w-sm/main:[--thread-content-margin:var(--thread-content-margin-sm,calc(var(--spacing)*6))] @w-lg/main:[--thread-content-margin:var(--thread-content-margin-lg,calc(var(--spacing)*16))] px-(--thread-content-margin)">\n<div class="[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn">\n<div class="flex max-w-full flex-col gap-4 grow">\n<div class="min-h-8 text-message relative flex w-full flex-col items-end gap-2 text-start break-words whitespace-normal outline-none keyboard-focused:focus-ring [.text-message+&amp;]:mt-1" dir="auto" tabindex="0" data-message-author-role="assistant" data-message-id="9e5fafd1-3b3e-41ad-821d-0950bb40d374" data-message-model-slug="gpt-5-3" data-turn-start-message="true">\n<div class="flex w-full flex-col gap-1 empty:hidden">\n<div class="markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling">\n<p data-start="264" data-end="386"><span style="color: #a3abb4;">White Paper: Animal Racing &mdash;&mdash; Muling Binibigyang-Kahulugan ang Susunod na Hangganan ng Digital Competitive Entertainment</span></p>\n<p data-start="388" data-end="469"><span style="color: #a3abb4;">Publisher: Flutter Entertainment Innovation Lab</span><br data-start="435" data-end="438" /><span style="color: #a3abb4;">Bersyon: 1.0 | Petsa: Q3 2026</span></p>\n<ol data-start="471" data-end="493">\n<li data-section-id="1869b6x" data-start="471" data-end="493"><span style="color: #a3abb4;">Buod ng Ehekutibo</span></li>\n</ol>\n<p data-start="495" data-end="737"><span style="color: #a3abb4;">Habang ang pandaigdigang merkado ng online entertainment ay pumapasok sa yugto ng matinding kompetisyon, opisyal na inilunsad ng Flutter Entertainment ang <em data-start="650" data-end="678">Animal Racing: Wild Sprint</em>, gamit ang lakas ng mga brand na Paddy Power at Betfair.</span></p>\n<p data-start="739" data-end="1217"><span style="color: #a3abb4;">Hindi ito isang simpleng laro ng &ldquo;cyber animals&rdquo;, kundi isang bagong uri ng entertainment product na pinagsasama ang high-definition 3D rendering, physics engine collisions, at dynamic odds mechanisms. Layunin nitong punan ang puwang sa pagitan ng tradisyunal na horse racing at mga magagaan na casual games, gamit ang advanced data processing ng Flutter upang magbigay ng high-frequency (tuwing 90 segundo), transparent, at highly interactive na immersive betting experience.</span></p>\n<ol start="2" data-start="1219" data-end="1263">\n<li data-section-id="85xg20" data-start="1219" data-end="1263"><span style="color: #a3abb4;">Konteksto ng Merkado at mga Oportunidad</span></li>\n</ol>\n<p data-start="1265" data-end="1940"><span style="color: #a3abb4;">&middot; Pagbabago ng henerasyon: Ang mga user ng Gen Z ay nawawalan na ng pasensya sa tradisyunal na takbo ng karera at mas pinipili ang mabilis at visually impactful na karanasan.</span><br data-start="1439" data-end="1442" /><span style="color: #a3abb4;">&middot; Teknolohikal na pag-unlad: Ang pag-usbong ng generative AI at real-time physics engines ay nagbibigay-daan sa mga anthropomorphic na galaw ng hayop at random na mga kaganapan, na nagpapataas ng entertainment value.</span><br data-start="1658" data-end="1661" /><span style="color: #a3abb4;">&middot; Bentahe sa regulasyon: Sa ilalim ng mahigpit na global compliance framework ng Flutter, iniiwasan ng <em data-start="1764" data-end="1779">Animal Racing</em> ang mga isyung etikal tungkol sa totoong hayop sa pamamagitan ng digital na presentasyon, na naaayon sa ESG (Environmental, Social, and Governance) standards.</span></p>\n<ol start="3" data-start="1942" data-end="1978">\n<li data-section-id="fcnwr8" data-start="1942" data-end="1978"><span style="color: #a3abb4;">Pangunahing Disenyo ng Produkto</span></li>\n</ol>\n<p data-start="1980" data-end="2007"><span style="color: #a3abb4;">3.1 Mundo at mga Karakter</span></p>\n<p data-start="2009" data-end="2142"><span style="color: #a3abb4;">Ang laro ay nakatakda sa isang kathang-isip na &ldquo;Animal Racing Federation&rdquo;. Bawat karera ay may 8 kalahok mula sa 5 pangunahing uri:</span></p>\n<p data-start="2144" data-end="2496"><span style="color: #a3abb4;">&middot;🐉 Dragon (Bilis at pagsabog) napakabilis na sprint sa maikling oras</span><br data-start="2213" data-end="2216" /><span style="color: #a3abb4;">.🐅 Tigre (Lakas at katatagan) mataas ang resistensya sa abala</span><br data-start="2278" data-end="2281" /><span style="color: #a3abb4;">.🐇 Kuneho (Agility at pag-iwas) mataas ang tsansang umiwas sa hadlang</span><br data-start="2351" data-end="2354" /><span style="color: #a3abb4;">.🐖 Baboy (Tibay at comeback) malakas ang acceleration sa huli</span><br data-start="2416" data-end="2419" /><span style="color: #a3abb4;">.🐒 Unggoy (Random at strategy) nagti-trigger ng hindi inaasahang mga event</span></p>\n<p data-start="2498" data-end="2542"><span style="color: #a3abb4;">3.2 Teknikal na Arkitektura: Lampas sa RNG</span></p>\n<p data-start="2544" data-end="2635"><span style="color: #a3abb4;">Batay sa teknolohikal na platform ng Flutter, binuo ang isang &ldquo;Dynamic Narrative Engine&rdquo;:</span></p>\n<ol data-start="2637" data-end="3121">\n<li data-section-id="wsdtp5" data-start="2637" data-end="2907"><span style="color: #a3abb4;">Pisikal na determinismo: Ang resulta ng karera ay batay sa client-side physics simulation, hindi sa tradisyunal na random number generator. Ibig sabihin, ang galaw, banggaan, at posisyon ay sumusunod sa Newtonian mechanics, na nagbibigay ng realism at traceability.</span></li>\n<li data-section-id="ct4x6t" data-start="2908" data-end="3074"><span style="color: #a3abb4;">Real-time odds flow: Sa gitna ng karera, ang odds ay nagbabago base sa posisyon, natitirang stamina, at &ldquo;excitement level&rdquo;. Sinusuportahan ang &ldquo;in-race trading&rdquo;.</span></li>\n<li data-section-id="6tijx3" data-start="3076" data-end="3121"><span style="color: #a3abb4;">Responsableng Pagsusugal at Risk Control</span></li>\n</ol>\n<p data-start="3123" data-end="3226"><span style="color: #a3abb4;">Bilang lider sa industriya, ipinatutupad ng Flutter Entertainment ang &ldquo;Player Safety First&rdquo; protocol:</span></p>\n<p data-start="3228" data-end="3610"><span style="color: #a3abb4;">&middot; Mekanismo ng pahinga: Dahil sa mabilis na takbo ng laro (isang round kada 30 segundo), may sapilitang pahinga pagkatapos ng 10 sunod-sunod na round, kasama ang maikling cognitive test.</span><br data-start="3414" data-end="3417" /><span style="color: #a3abb4;">&middot; Transparency: Lahat ng &ldquo;hidden attributes&rdquo; ng hayop (tulad ng fatigue at morale) ay inilalabas gamit ang blockchain hash bago ang karera upang masigurong patas at maiwasan ang manipulasyon.</span></p>\n<ol start="5" data-start="3613" data-end="3628">\n<li data-section-id="f135zh" data-start="3613" data-end="3628"><span style="color: #a3abb4;">Konklusyon</span></li>\n</ol>\n<p data-start="3630" data-end="3777"><span style="color: #a3abb4;">Ang <em data-start="3634" data-end="3649">Animal Racing</em> ay hindi lamang isang laro, kundi isang estratehikong pahayag ng Flutter Entertainment para sa hinaharap ng gamified betting.</span></p>\n<p data-start="3779" data-end="4091"><span style="color: #a3abb4;">Pinagsasama nito ang excitement ng sports betting, control ng video games, at visual appeal ng animated films. Sa suporta ng global compliance at payment network ng Flutter, naniniwala kami na ang <em data-start="3976" data-end="3991">Animal Racing</em> ang magiging susunod na lider sa digital entertainment matapos ang traditional sports at eSports.</span></p>\n<hr data-start="4093" data-end="4098" />\n<p data-start="4100" data-end="4299" data-is-last-node="" data-is-only-node=""><span style="color: #a3abb4;">Paunawa: Ang produktong ito ay para lamang sa mga lugar kung saan legal ang pagsusugal. Ang Flutter Entertainment ay nakatuon sa pagprotekta sa mga manlalaro at pagsusulong ng responsableng libangan.</span></p>\n</div>\n</div>\n</div>\n</div>\n<div class="z-0 flex min-h-[46px] justify-start">&nbsp;</div>\n<div class="mt-3 w-full empty:hidden">\n<div class="text-center">&nbsp;</div>\n</div>\n</div>\n</div>\n</section>\n</div>\n<div class="pointer-events-none h-px w-px absolute bottom-0" aria-hidden="true" data-edge="true">&nbsp;</div>\n</div>\n</div>\n</div>\n</div>',
    GameDescription: "Panimula ng Laro",
    withdrawal: "Mag-withdraw",
    versionPopuptitle: "Nakahanap ng Bagong Bersyon",
    TelegramGroup: "@wonder_wallet",
    AnswerTwo:
      "Ang Blockchain ay mahalagang isang nakabahaging database na nag-iimbak ng data o impormasyon. Mayroon itong mga feature tulad ng tamper-proof, traceable, transparent at sama-samang pinapanatili.",
    uploads: "Mag-withdraw",
    versionPopSure: "Gusto mo bang i-download ang pinakabagong bersyon?",
    liveGames: "Lottery",
    liveGamesPK: "Lottery PG",
    Community: "Komunidad",
    CopyAddress: "Kopyahin ang exchange address",
    withdraw: "Mag-withdraw",
  },
  popup: {
    SignInText:
      "Tuloy-tuloy na mag-log in sa loob ng pitong araw para makatanggap ng mga pulang packet na regalo",
    Gift: "Tumanggap ng Red Packet",
    today: "Ngayong araw",
    SignIn: "Mag-login Ngayon",
    CheckDays1: "Tuloy-tuloy na naka-log in",
    CheckDays2: "Araw",
    CheckInText: "Araw-araw na Check-in",
  },
  verifyemail: {
    enterCaptcha: "Maling email",
  },
  buySellOTC: {
    cancel: "Mga segundo para awtomatikong magkansela",
    placeOrder: "Place Order",
    sellAll: "Ibenta Lahat",
    merchantApplication: "Aplikasyon ng Merchant",
    accApp: "Mag-apply para sa Account",
    buy: "Bumili",
    password: "Password",
    total: "Kabuuang Halaga",
    emptyFields: "Hindi ganap na napunan ang account o password",
    remainAmount: "Natitirang Halaga",
    exitPassword: "Password ng seguridad",
    price: "Presyo",
    enterAmount: "Maglagay ng halaga",
    limit: "Limitahan",
    buyAll: "Bilhin Lahat",
    merchRevTitle: "Aplikasyon ng Merchant",
    state: "Katayuan",
    myAds: "Aking Mga Ad",
    placeAnAd: "Mag-post ng Ad",
    orderRecord: "Kasaysayan ng Order",
    margin: "Margin",
    amount: "Dami",
    appTime: "Oras ng Application",
    exitReason: "Lumabas Dahilan",
    exitTitle: "Lumabas sa Merchant",
    merchName: "Pangalan",
    heading: "C2C Transaksyon",
    sell: "Ibenta",
    disclaim:
      '<p><span style="font-size: 10pt; font-family: Arial; color: #ffffff;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Pakikumpirma ang order sa pagbebenta sa loob ng isang oras pagkatapos matanggap ang mensahe ng pagbabayad.&quot;}">Pakikumpirma ang order sa pagbebenta sa loob ng isang oras pagkatapos matanggap ang mensahe ng pagbabayad.</span></p>',
    minMaxAmt: "Mas mababa o lampas sa limitasyon ng kalakalan",
    cancelMerch: "Aplikasyon ng Merchant",
    cancelExit: "Kanselahin",
    operate: "Operasyon",
    transfer: "Paglipat",
    buyByQty: "Bumili ayon sa dami",
    paymentMethod: "Paraan ng pagbabayad",
    confirmExit: "Kumpirmahin ang paglabas",
  },
  detailed: {
    moderated: "Naghihintay ng pagsusuri",
    rechargeSuccessfull: "Matagumpay na mag-recharge",
    rechargeFailed: "Nabigo ang pag-recharge",
  },
  myTeam: {
    allMembers: "Lahat ng Miyembro",
    noMore: "Wala na",
    rechargeMember: "Mga Recharged na Miyembro",
    myTeam: "Aking Team",
    back: "Bumalik",
    noRechargeMember: "Mga Non-recharged na Miyembro",
    totalRecharge: "Kabuuang Halaga ng Recharge:",
  },
  helpoffice: {
    officeEnvironment: "Kapaligiran sa Opisina",
  },
  betCountDetails: {
    Game: "item",
    Loss: "Pagkalugi",
    Time: "Oras",
    Win: "Panalo",
    Bets: "Bilang ng taya",
  },
  kycDetails: {
    livenessNoFace: "Walang nakitang mukha. Ilagay ang iyong mukha sa frame.",
    upload: "Mag-upload",
    livenessStepProgress: "Hakbang {current} ng {total}",
    stepIdVerification: "Pag-verify ng ID",
    captureFailed: "Failed to capture photo. Please try again.",
    stepFaceVerification: "Pag-verify ng Mukha",
    livenessTurnRight: "Dahan-dahang ikiling ang mukha sa kanan",
    livenessTurnLeft: "Dahan-dahang ikiling ang mukha sa kaliwa",
    livenessTurnUp: "Dahan-dahang tumingala",
    continue: "Magpatuloy",
    idAlignFrame: "Ilagay ang iyong ID sa loob ng frame.",
    faceDesc:
      "Position your face within the frame and take a live photo. Gallery upload is not available for this step.",
    addIdPhoto: "Magdagdag ng larawan ng ID",
    livenessFaceCenter: "Tumingin nang diretso sa camera",
    usePhoto: "Use Photo",
    livenessMultipleFaces: "Isang mukha lamang ang dapat makita.",
    submitSuccess: "KYC submitted successfully",
    livenessTurnDown: "Dahan-dahang yumuko",
    faceTitle: "Face Verification",
    idGuideExampleNoReflection: "Walang reflection",
    topic: "KYC Verification",
    uploadFailed: "Failed to upload image. Please try again.",
    invalidImageFile: "Please select an image file.",
    switchCamera: "Palitan ang camera",
    livenessIntro:
      "Sundin ang mga tagubilin sa screen: tumingin nang diretso, ikiling sa kaliwa, pagkatapos sa kanan.",
    idGuideDo1: "Inisyu ng gobyerno",
    idGuideDo2: "Orihinal na buong laki, hindi na-edit na dokumento",
    idGuideDo3: "Ilagay ang dokumento sa isang kulay na background",
    submit: "Submit",
    realNameTip1: "Gamitin ang parehong pangalan na nasa iyong ID",
    submitFailed: "Failed to submit KYC. Please try again.",
    livenessCapturing: "Kinukunan ang iyong larawan…",
    idGuideDo4: "Nababasa, maliwanag, at may kulay na larawan",
    idGuideDont2: "Hindi expired ang dokumento",
    cameraNotSupported: "Camera is not supported on this device.",
    uploadIdTitle: "Mag-upload ng ID Document",
    fullLegalName: "Buong Legal na Pangalan",
    idGuideExampleGood: "Mabuti",
    stepRealName: "Tunay na Pangalan",
    livenessFaceTooSmall:
      "Lumapit nang kaunti upang mapuno ng mukha ang frame.",
    idTip1:
      "Gumamit ng wastong government-issued ID (passport, national ID, o driver's license)",
    imageSizeExceeded: "Image size cannot exceed 5MB.",
    capturePhotoAria: "Capture photo",
    idTip3: "Dapat makita ang apat na sulok ng dokumento",
    idTip2: "Siguraduhing malinaw ang larawan at hindi malabo",
    faceTip1: "Face the camera directly with good lighting",
    livenessFailed: "Nabigo ang face verification. Pakisubukang muli.",
    realNameDesc:
      "Ilagay ang iyong buong legal na pangalan na eksaktong nakasaad sa iyong government-issued ID.",
    takePhoto: "Kumuha ng Larawan",
    livenessStepTimeout:
      "Hindi natukoy ang galaw sa tamang oras. Pakisundin ang mga tagubilin sa screen.",
    idFront: "Harap ng ID",
    faceTip3: "Keep a neutral expression",
    faceTip2: "Remove glasses, hats, or masks",
    idBack: "Likod ng ID",
    fullLegalNamePlaceholder: "Ilagay ang iyong buong legal na pangalan",
    idGuideDont1: "Walang itim at puting larawan",
    livenessFaceCenterFinal: "Tumingin nang diretso sa camera muli",
    idGuideExampleNotBlur: "Hindi malabo",
    uploadIdDesc:
      "Mag-upload ng malinaw na larawan ng harap at likod ng iyong government-issued ID. Siguraduhing kitang-kita ang lahat ng detalye.",
    idAligned: "Nakita ang ID. Pindutin ang shutter para kumuha ng larawan.",
    cameraPermissionRequired:
      "Camera access is required. Please allow camera permission in your browser settings.",
    retake: "Retake",
    realNameTip2: "Huwag gumamit ng palayaw o pagdadaglat",
    idGuideExampleNotCropped: "Hindi putol",
    realNameTitle: "Pag-verify ng Tunay na Pangalan",
  },
  operateweek: {
    managementFee: "Bayad sa Pamamahala",
  },
  withdraw: {
    cancel: "Kanselahin",
    statusPending: "Sinusuri",
    WithdrawAmount: "halaga ng withdrawal",
    addNewAddress: "Magdagdag ng bagong address",
    yzpay_wallet_address: "YZ Pay wallet address",
    selectNetwork: "Pumili ng network",
    withdrawalAmount: "Halaga ng withdrawal",
    enterAmount: "Mangyaring magpasok ng halagang higit sa 0",
    addressBook: "Listahan ng mga address",
    enterTheGoPayWalletAddress: "Ilagay ang address ng wallet ng GoPay",
    doWithdraw: "Mag-withdraw",
    all: "Lahat",
    rechargePrompt: "Paki-recharge ang balanse ng iyong account ay $R0,00",
    passwordText: "Ipasok ang withdrawal password",
    SelectWithdrawType: "Piliin ang uri ng pag-withdraw",
    confirmDeleteAddress: "Kumpirmahin ang pagtanggal ng address",
    minimumAmount: "Pinakamababang halaga",
    Save: "Isumite",
    MinimumAmount: "Ang pinakamababang halaga ng withdrawal ay",
    AmountError: "Mangyaring maglagay ng tamang halaga",
    Balance: "Nai-withdraw na balanse",
    coin: "Pera",
    AmountUSDT: "Baguhin ang halaga ng USDT na gusto mong bawiin",
    MaxExceed: "Lumampas sa maximum na halaga ng withdrawal",
    statusRejected: "Tinanggihan",
    enterGopayWalletAddress: "Ilagay ang address ng wallet ng GoPay",
    save: "I-save",
    network: "Network",
    availableBalance: "Magagamit na balanse",
    noNewWithdraw: "Hindi bagong withdrawal",
    enterTheYzPayWalletAddress: "Ilagay ang YZPay wallet address",
    gopay_wallet_address: "Address ng wallet ng GoPay",
    Topic: "Humiling ng Withdrawal",
    AmountTRX: "Baguhin ang halaga ng USDT na gusto mong bawiin",
    Password: "Mangyaring ipasok ang iyong password sa seguridad",
    MinExceed: "Mas mababa sa minimum na halaga ng withdrawal",
    address: "I-withdraw",
    contToWithdraw: "Hindi bagong withdrawal",
    GXPayId: "GX payment ID",
    recentlyUsed: "Kamakailan",
    Title: "Mag-withdraw",
    WithdrawPassword: "Pag-withdraw ng password",
    label: "Label ng Wallet (Opsyonal)",
    statusCancelled: "Kinansela",
    selectAddress: "Pumili ng address",
    confirm: "Kumpirmahin",
    statusSuccessful: "Matagumpay",
    statusApproved: "Naaprubahan",
    sameAmountReview:
      "Nagsumite ka ng withdrawal ng parehong halaga na kasalukuyang sinusuri. Mangyaring huwag muling isumite kung hindi isang bagong withdrawal.",
    noData: "Walang mga address",
  },
  promotion: {
    clickToOpenDocument: "I-click upang buksan ang dokumentasyon",
    interfaceDescription: "Paglalarawan ng Interface",
    interfaceDescriptionCotent:
      "<p>Ang interface ng AR Lottery API ay nagbibigay ng tumpak na impormasyon sa lottery, kabilang ang oras ng lottery, numero ng isyu, numero ng lottery, at higit pang data na nauugnay sa mga resulta ng lottery.</p>\n<p>&nbsp;</p>\n<p>Ang interface ng AR Lottery API ay nagbibigay ng dalawang paraan ng pag-access (web at h5), at sinusuportahan ang JSON na format. Sa hinaharap, ibibigay ang XML na format.</p>",
    latestResult: "Pinakabagong resulta",
    hashLottery: "Instant Hash Lottery",
    interfaceOverViewContent:
      "<p>Ang AR Lottery API ay ang opisyal na platform ng AR Lottery para sa pagbibigay ng data ng lottery sa mga customer sa industriya ng lottery, mga third-party na merchant ng lottery o mga institusyon ng pagsusuri sa web at h5 na format. Ito ay isang internasyonal na propesyonal na website ng impormasyon sa lottery.</p>",
    lotteryList: "Listahan ng lottery",
    lotteryDrawingTime: "Oras ng Pagguhit",
    userGuide: "Gabay sa Gumagamit",
    advantageTitle: "Mga Bentahe ng API Interface",
    countDownDraw: "Countdown sa Period Draw",
    lotteryRemainText1: "Kasalukuyan",
    downloadIOS: "Para sa iOS",
    interfaceOverView: "Pangkalahatang-ideya ng Interface",
    winningNumber: "Panalong Numero",
    customerService: "Serbisyo sa Customer",
    lotteryRemainText2: "Panahon, Natitira",
    lotteryRemainText3: "Panahon",
    disclaimerContent:
      '<p>Bago gamitin ang open interface ng AR Lottery API, pakitiyak na basahin at unawaing mabuti ang pahayag na ito. Maaari mong piliing huwag gamitin ang open platform ng AR Lottery API, ngunit kung gagamitin mo ang open interface ng AR Lottery API, ang iyong paggamit ay ituring na isang pag-endorso ng pahayag na ito.</p>\n<p>&nbsp;</p>\n<p>Maliban sa mga tuntunin ng serbisyong tinukoy sa open interface ng AR Lottery API, walang pananagutan ang AR Lottery para sa anumang iba pang aksidente, kapabayaan, paglabag at pagkalugi na dulot ng paggamit ng open platform ng AR Lottery API (kabilang ang mga virus sa computer na nahawahan ng pag-download ng content mula sa iba pang naka-link na third-party na website), at walang legal na pananagutan ang AR Lottery.</p>\n<p>&nbsp;</p>\n<p>Ang sinumang user, merchant o institusyon na kumokonekta sa nilalaman ng web ng third-party sa pamamagitan ng open interface ng AR Lottery API ay maaaring lumabag sa mga karapatan nito sa pagpapakalat ng network ng impormasyon at dapat kaagad na magsumite ng nakasulat na paunawa ng mga karapatan sa AR Lottery, at magbigay ng patunay ng pagkakakilanlan, pagmamay-ari, at detalyadong patunay ng paglabag. Pagkatapos matanggap ang mga legal na dokumento sa itaas, ididiskonekta ng AR Lottery ang nauugnay na content ng koneksyon sa lalong madaling panahon alinsunod sa batas. Ang mga gumagamit, mangangalakal o iba pang institusyon, atbp., ay malinaw at sumasang-ayon na ang mga panganib ng paggamit ng mga serbisyo ng network ng website na ito ay ganap na dinadala ng kanilang mga sarili; lahat ng mga kahihinatnan na nagmumula sa paggamit ng mga serbisyo ng network ng website na ito ay dinadala din ng kanilang mga sarili, at ang AR Lottery ay walang pananagutan sa mga user.</p>\n<p>&nbsp;</p>\n<p>Hindi inaako ng website na ito ang anumang responsibilidad sa mga sumusunod na sitwasyon:</p>\n<p>1. Anumang pagnanakaw o pakikialam na dulot ng force majeure na nakakaapekto sa normal na operasyon ng network, gaya ng pag-atake ng hacker, pagsalakay o pagsiklab ng virus sa computer, pansamantalang pagsasara dahil sa pamamahala ng gobyerno, atbp.</p>\n<p>2. Maliban sa nilalamang may markang "AR Lottery" sa bawat channel ng website na ito, ang natitirang nilalaman ay ibinibigay ng mga kooperatiba na mangangalakal (mga institusyon). Hindi inaako ng kumpanya ang anumang mga hindi pagkakaunawaan at legal na responsibilidad na dulot ng legalidad at kalusugan ng nilalaman. Kung mayroon kang anumang mga pagdududa, mangyaring makipag-ugnayan sa amin at haharapin namin ito sa lalong madaling panahon.</p>\n<p>3. Mayroong mga link sa iba pang mga website sa website na ito, kabilang ang mga banner ad. Ang website na ito ay hindi mananagot para sa nilalaman, patakaran sa privacy o pag-uugali ng mga kumpanyang nagpapatakbo ng mga website na ito sa anumang iba pang mga website. Bago magbigay ng personal na impormasyon sa mga website na ito na naka-link sa website na ito, pakitingnan ang kanilang mga patakaran sa privacy.</p>\n<p>4. Lahat ng API lottery interface sa website na ito ay ibinibigay ng AR Group.</p>',
    timeDescriptionText2: "Minuto bawat Panahon, Buong Araw",
    interfaceRestrictions: "Mga Paghihigpit sa Interface",
    aboutUs: "Tungkol sa amin",
    blockHash: "I-block ang Hash",
    timeDescriptionText3: "Panahon",
    timeDescriptionText1: "Lahat",
    trendChart: "Trend chart",
    copyrightReservedText: "Copyright © 2024 All Rights Reserved",
    helpCenter: "Help Center",
    lotteryHistory: "Makasaysayang mga resulta",
    disclaimerTitle: "Disclaimer",
    roadBeadAnalysis: "Road Bead Analysis",
    joinOurCommunity: "Sumali sa Aming Komunidad",
    lotteryRules: "Mga panuntunan sa lottery",
    apiInterface: "Interface ng Api",
    businessCooperation: "Pakikipagtulungan sa Negosyo",
    disclaimer: "Suporta/Legal",
    mobileWeb: "Direktang Pag-access",
    privacyPolicy: "Patakaran sa Privacy",
    interfaceRestrictionsContent:
      "<p>Nagbibigay kami ng interface ng AR Lottery API para sa mga user, merchant o institusyon nang walang bayad. Ang mga resulta ng lottery ng AR Lottery API ay ibinibigay sa real time na walang pagkaantala bilang default, ngunit dahil sa network o teknikal na mga kadahilanan, ang mga resulta ng lottery ay maaaring maantala paminsan-minsan.</p>",
    verified: "Na-verify",
    termsOfService: "Mga Tuntunin ng Serbisyo",
    advantageContet:
      '<p><span style="font-size: 14pt;"><strong>1. Mataas na sabay na pag-access:</strong></span></p>\n<p>Ang platform server ay gumagamit ng cluster architecture at parallel data processing engine, na nag-o-optimize sa diskarte ng mataas na concurrency at mataas na access para matiyak ang stable at tumpak na data.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>2. Mass data storage:</strong></span></p>\n<p>Gumagamit ang platform ng isang distributed database platform para i-accommodate ang napakalaking historical lottery data ng bawat phase.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>3. Propesyonal na platform ng data ng API:</strong></span></p>\n<p>Propesyonal na interface ng pag-develop ng data ng API ng serbisyo ng lottery para sa mga website ng industriya ng lottery at mga mahilig sa pag-unlad, na sumasaklaw sa aming impormasyon sa lottery.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>4. Makapangyarihang mapagkukunan ng impormasyon:</strong></span></p>\n<p>Ang data ng lottery ay may awtoridad, tumpak at napapanahon, na nagbibigay ng maraming impormasyon sa lottery, kabilang ang numero ng panahon ng lottery, numero ng lottery, atbp.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>5. Multi-platform na suporta sa tawag:</strong></span></p>\n<p>Magbigay ng format ng JSON, suportahan ang mga paraan ng pag-access sa web at h5, pati na rin ang mga paraan ng web call gaya ng browser ajax.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>6. Napakataas na karanasan ng user:</strong></span></p>\n<p>Ito ay may napakalinaw na user interface, alinsunod sa user-friendly na interactive na karanasan, at kumpleto ang pagpapakita ng data ng lottery.</p>',
    newsAnnouncement: "Anunsyo ng Balita:",
    announcementText:
      "Ang lahat ng data ng lottery sa platform na ito ay nagmula sa blockchain hash value conversion. Kahit sino ay maaaring i-query ito sa blockchain anumang oras, kahit saan, tinitiyak na ang platform ay hindi maaaring manipulahin ang data at ang mga tala ay transparent sa real time.",
    home: "Home",
    expect: "Panahon",
    downloadAndroid: "Para sa Android",
    supportLegal: "Suporta/Legal",
    FAQ: "FAQ",
    lotteryNumber: "Period draw number",
    register: "Magrehistro",
  },
  basket: {
    points: "Mga puntos",
  },
  systemMessage: {
    exception: "System exception",
    invalidWalletAdd: "Di-wastong address ng wallet",
    outsideTimeSlot: "Hindi available para sa kasalukuyang puwang ng oras",
    invalidTargetUsers: "Wala kang pahintulot na kunin ang kupon na ito",
    notMerchan: "Hindi isang mangangalakal",
    singleBetMaximum: "Ang numero ng taya ay lumampas sa maximum na limitasyon",
    noNetwork:
      "Nabigo ang koneksyon sa network, pakisubukang muli sa ibang pagkakataon",
    systemError: "Isara",
    couponNotAvailable: "Hindi available ang kupon!",
    passwordEmpty: "Mangyaring magtakda ng password sa seguridad",
    captchaError: "Mali ang input ng verification code, pakipasok muli",
    rechargeFailed:
      "May nangyaring mali sa pag-recharge. Pakisubukang muli mamaya.",
    pleaseRechargeToBeEligible: "Mag-recharge para maging kwalipikado",
    accountNotEmpty: "Pakilagay ang account number",
    enableVerificationMethod:
      "Mangyaring paganahin muna ang paraan ng pag-verify",
    notWithinValidPeriod: "Sa labas ng valid period",
    failedToClaimReward: "Nabigong i-claim ang reward",
    couponNotAvailableTryAgain: "Hindi available ang kupon! Subukan muli.",
    notApproveCancel: "Hindi pinapayagan o nakansela na",
    insufficientAmt: "Hindi sapat na balanse",
    userLimitExceeded: "Lumampas sa limitasyon ng user",
    claimedSuccessfully: "Inangkin",
    inputParamError: "Error sa parameter",
    codeCannotBeBlank: "Hindi maaaring walang laman ang code",
    fail: "Nabigo ang operasyon",
    userNotEligibleToRedeem: "Hindi karapat-dapat para sa pagtubos",
    invalidAmount: "Di-wastong account",
    success: "Matagumpay ang operasyon",
    OldPasswordError: "Maling lumang password",
    insuffiAccBal: "Hindi sapat na balanse sa account",
    claimedCountExceed: "Lumampas ang bilang ng claim sa kupon",
    somethingWrong: "Nabigong kumonekta at humiling ng data, pakisubukang muli",
    minAmount: "Hindi maaaring 0 ang halaga.",
    incorrectBetTime: "Maling halaga ng oras ng taya",
    incorrectBetNumber: "Maling numero ng taya",
    accountError: "Di-wastong paglilipat ng account",
    noRewardsAvailableForThisRechargeLimit:
      "Walang available na reward para sa limitasyon sa recharge na ito",
    noRangeToGetReward:
      "Ang bilang ng mga araw na hindi nagre-recharge ay hindi tumutugma sa anumang naka-configure na hanay",
    youHaveClaimedWithinThisTimeSlot: "Na-claim na sa loob ng time slot na ito",
    error: "Mali",
    MaxAmount: "Mangyaring magpasok ng halagang mas mababa sa 100",
    couponAlreadyClaimed: "Na-claim na ang kupon!",
    totalLimitExceeded: "Lumampas sa kabuuang limitasyon",
    youAreNotEligibleToClaimThisReward:
      "Hindi ka karapat-dapat na i-claim ang reward na ito",
    alreadyClaimed: "Na-claim na",
    invalidCoupon: "Di-wastong Kupon",
    insufficientBal:
      "Ang halaga ng iyong pag-withdraw ay lumampas sa magagamit na balanse, mangyaring muling ipasok",
    validateFailed: "Nabigo ang pagpapatunay ng parameter",
    forbidden: "Walang nauugnay na pahintulot",
    captchaRequired: "Hindi tugma ang verification code",
    configNotFound: "Walang config para sa reward na ito",
    allGiftsClaimedWithinSlot:
      "Na-claim ang lahat ng regalo sa loob ng panahong ito",
    unauthorized:
      "Hindi naka-log in o nag-expire ang token, mangyaring mag-log in!",
    captchaNotMatch: "Hindi tugma ang verification code",
    notFound: "Walang nakitang nauugnay na data",
    rechargeWithinTodayToBeEligible:
      "Mag-recharge ngayon para maging kwalipikado",
    singleBetMinimum:
      "Ang numero ng taya ay mas mababa sa minimum na limitasyon",
  },
  capitalFundDetails: {
    title: "Mga Detalye ng Pondo",
  },
  forgetPassword: {
    resetSuccess: "Live Match",
  },
  moreTrendMarkSix: {
    seventhTrend: "Anim na regular na numero",
  },
  financefund: {
    endDate: "Petsa ng Pagtatapos",
    to: "Upang",
    startDate: "Petsa ng Pagsisimula",
  },
  flowlog: {
    typeUsdtWithdraw: "Pag-withdraw ng USDT",
    typeTrxWithdraw: "Pag-withdraw ng USDT",
  },
  pcGamerules: {
    Rules4wingame: "Mga panuntunan upang manalo sa laro",
    acclimits: "Limitahan ang halaga",
  },
  changesms: {
    captcha: "CAPTCHA",
  },
  action: {
    cancel: "Magtakda ng tinukoy na halaga, gaya ng pagbabago ng katayuan",
    getAllBalance: "Isang-click na query sa balanse",
    certify: "Patunay",
    collectToWallet: "Pinagsama-sama sa platform wallet",
    Pay: "Pagbabayad",
    deductionOfStock: "Pagbawas ng Stock",
    sendCash: "Magpadala ng Pera",
    addUserControl: "User Risk Control",
    updateUniAppLanguage: "Bumuo ng UNIAPP File",
    SubUsers: "Sub-user",
    updateMaxNetRecharge: "I-update ang Maximum Net Recharge",
    dumpdata: "I-export",
    addVoucherManagement: "Magpadala ng Voucher",
    closeOperation: "Isara ang Operasyon",
    checkNewStocks: "Suriin ang Bagong Stocks",
    cash: "Mag-withdraw",
    buyStock: "Bumili ng Stock",
    forceCapitalClose: "Puwersang Isara ang Posisyon",
    add: "Bumuo ng Susi",
    rechargeFinish: "Nakumpleto ang pag-recharge",
    collectAll: "Isang-click na pagsasama-sama",
    userbank: "Bangko ng Gumagamit",
    add_sub_agent: "add_sub_agent",
    frozen: "Huwag paganahin",
    pay: "Kumpirmahin ang Pagbabayad",
    partialClose: "Bahagyang Pagbebenta",
    businessDetails: "mga detalye ng negosyo",
    jumpUserAccount: "User Account",
    updatePrivateKey: "Baguhin ang Pribadong Key",
    plus: "Backend Recharge",
    refreshTheStocks: "I-update ang Stock Pool",
    unforbidden: "Paganahin",
    selectAdd: "Piliin upang idagdag",
    setCategories: "Itakda ang Kategorya",
    getBalance: "Kumuha ng balanse",
    checkAccount: "Balanse na Query",
    redpacketDetail: "Mga Detalye ng Red Packet",
    orders: "Pamamahala ng Order",
    export_file: "I-export",
    detail: "Tingnan ang mga Detalye",
    agent_account: "agent_account",
    minus: "Backend Deduction",
    payExchange: "Pagbabayad ng Exchange",
    rejected: "Bawiin",
    turnDown: "Tanggihan",
    save: "I-save",
    update: "Baguhin ang susi",
    delete: "Tanggalin",
    runOnce: "Ipatupad nang isang beses",
    interestDetails: "interesDetails",
    addRobot: "Magdagdag ng Robot",
    reject: "Tanggihan",
    audit: "Itakda ang tinukoy na halaga, gaya ng pagbabago ng katayuan",
    changeCode: "Baguhin ang Pribadong Key",
    agentCommission: "Mga Detalye ng Komisyon",
    resetpassword: "I-reset ang Password",
    dividendReturn: "Pagbabalik ng Dibidendo",
    unFrozen: "Force Unfreeze",
    close: "Kanselahin",
    changeCostPrice: "Baguhin ang Presyo ng Gastos",
    address: "Pamamahala ng Address",
    updateRsa: "Baguhin ang susi",
    forbidden: "Hindi pinagana",
    clear: "Maaliwalas",
    addRsa: "Bumuo ng susi",
    flowLog: "Daloy ng Pondo",
    closeCapital: "Isara ang Capital",
    addFirstGift: "Bagong Regalo ng User",
    hide: "Magtago",
    approveAll: "Magdagdag ng Batch",
    resetPwd: "I-reset ang password",
    addFriendCoupon: "Magpadala ng Kupon sa Kaibigan",
    approve: "Aprubahan",
    selectOrAddUserBank: "Piliin o Magdagdag ng Account",
    clone: "Kopyahin ang Idagdag",
    updateStopStocks: "I-update ang Mga Natigil na Stock",
    updateAdminlanguage: "Bumuo ng ADMIN File",
  },
  otcComplain: {
    invalidStatus: "Di-wastong data ng apela",
    blockOtherparty:
      "Hindi makansela ang apela ng ibang partido, mangyaring makipag-ugnayan sa ibang partido upang malutas. Kung may pagtatalo, makipag-ugnayan sa customer service para sa tulong.",
  },
  contact_us_page: {
    contactUs: "Kontakin Kami",
    copyright:
      "Todos os direitos reservados ©2024 AR lottery site oficial da loteria",
    telegram_handle: "@GlobalGame365",
    contact_note:
      "Este site fornece apenas informações sobre consultas de dados de loteria, não se tratando de compra de loteria. Não há menção a atividades ilegais, publicidade, cooperação, etc.",
    telegram: "Telegrama",
    title: "Makipag-ugnayan sa Amin",
  },
  otcOrderDetail: {
    seller: "Nagtitinda",
    cancel: "Kumpirmahin",
    contactInfo: "Impormasyon sa Pakikipag-ugnayan",
    otherSide: "Counterparty",
    sellerPayment: "Paraan ng pagbabayad ng nagbebenta",
    cancelOrder: "Kanselahin ang order",
    cancelAppeal: "Kanselahin ang apela",
    appealDes: "Dahilan ng Apela",
    CancelOrder: "Kumpirmahin ang pagkansela",
    bank: "Bank card",
    orderTime: "Oras ng Order",
    notesTransfer:
      '<p style="text-align: justify;"><span style="font-size: 10pt; color: #ffffff;">1. Kapag naglilipat, iwasang isama ang USDT para maiwasan ang interception o mga isyu sa pagyeyelo ng bank card.</span></p> <p style="text-align: justify;"><span style="color: #ffffff; font size: 10pt;">2. Gamitin ang iyong real-name bank card, Alipay o WeChat para sa paglipat.</span></p> <p style="text-align: justify;"><span style="font-size: 10pt; color : #ffffff;">3. Kung ang bank transfer ay lumampas sa 50,000 RMB pagkatapos ng 17:00 sa mga holiday o araw ng trabaho, hatiin ang mga pagbabayad upang matiyak ang napapanahong pagproseso.</span></p>',
    price: "Presyo",
    transferHeading: "Pag-iingat sa paglipat",
    confirmTitle: "Kumpirmahin ang resibo at sumang-ayon na mag-order",
    selectAppeal: "Mangyaring pumili ng uri ng apela",
    order: "Numero ng order",
    sure: "Kumpirmahin",
    complain: "Nasa ilalim ng apela",
    transfer: "Paglipat",
    cancelNotice:
      "Kinansela ang order, hindi matingnan ang impormasyon sa pagbabayad",
    receipt: "Kumpirmahin ang pagtanggap at paglabas ng mga pondo",
    toBePaid: "Para mabayaran",
    otherName: "Pangalan",
    toPay: "Magpatuloy sa pagbabayad",
    orderAppeal: "Mag-order ng apela",
    party: "Nagbabayad ang counterparty",
    appealDisclaim:
      "Sa sandaling maihain ang apela, ang order ay agad na na-freeze; ang sistema ay mamagitan hanggang sa malutas. Mapi-freeze ang mga nakakahamak na account sa apela.",
    no: "Hindi",
    CancelReceipt: "Kanselahin",
    note: "Mangyaring gumamit ng tunay na pangalan na pagbabayad; kung hindi man ay maaaring tanggihan ng nagbebenta. Walang mga puna; mga personal na C2C certified account lang ang tinatanggap.",
    wait: "Naghihintay para sa nagbebenta na maglabas ng mga pondo",
    Confirm: "OK",
    cancelTitle: "Kinansela",
    title: "Mga Detalye ng Order",
    submitAppeal: "Magsumite ng apela",
    contentReceipt:
      "Mangyaring mag-log in sa iyong online banking, Alipay, WeChat o iba pang third-party na account sa pagbabayad upang i-verify at kumpirmahin ang resibo!",
    total: "Kabuuang halaga",
    actualPayment: "Aktwal na paraan ng pagbabayad",
    appealType: "Uri ng Apela",
    enterDes: "Ilagay ang Dahilan ng Apela",
    contentCancel:
      "Magiliw na paalala: Para sa mga transaksyon sa C2C, 3 pagkansela sa isang araw ang naghihigpit sa mga function ng pagbili sa araw na iyon. Ang mga nakakahamak na pagkansela at maraming reklamo ay nagreresulta sa permanenteng pagkawala ng mga pribilehiyo sa pangangalakal ng C2C.",
    amount: "Halaga (CNY)",
    notePaid: "Hindi pa binabayaran",
    ownSide: "Ang panig namin",
    ConfirmOrder: "Hayaan mo akong mag-isip muli",
    yes: "Oo",
    appealEmpty: "Piliin ang Uri ng Apela",
    confirmPayment: "Kumpirmahin ang pagbabayad",
    chat: "Makipag-ugnayan",
    paid: "Binayaran",
    subAppeal: "Magsumite ng apela",
    asset: "Tingnan ang mga asset",
    complete: "Nakumpleto",
    appealing: "Nasa ilalim ng apela",
  },
  pcNavItem: {
    APP: "APP",
    Help: "Tulong",
    AboutUs: "Tungkol sa Amin",
    GameRule: "Laro",
    Question: "FAQ",
    RuleInfo: "Mga Panuntunan sa Laro",
    ContactUs: "Online Customer Service",
    Community: "Chat sa Komunidad",
  },
  system: {
    cancel: "I-reset",
    exception: "System Exception",
    MobileNumberRegistered: "Nakarehistro na ang mobile number",
    wrongPurchasePrice: "Maling presyo ng pagbili",
    clearingCache:
      "Pag-clear ng configuration cache at pag-update, mangyaring maghintay...",
    upload: "Mag-upload",
    loadEnd: "-- Wala nang Data --",
    fundSettlementIsSuccessful: "Matagumpay ang margin trading settlement",
    otherOperation: "Iba pang mga Operasyon",
    userNotExist: "Walang gumagamit",
    closeOthers: "Isara ang Iba",
    EmptyRiskMargin: "Mangyaring ipasok ang margin ng panganib",
    MarginError: "Ang margin ay dapat na maramihan ng 100",
    minimumAdditionalAllocationAmountForOneTime:
      "Minimum na karagdagang halaga ng margin trading",
    ForgetPasswordPhoneCodeFail: "Di-wastong mobile verification code",
    itemName: "Pangalan ng Pagpipilian",
    UserAlreadyUsed: "Ginagamit na ang user na ito",
    confirmOperation: "Walang nakitang nauugnay na data",
    deductedFromGiftVoucher: "Ibinawas sa gift voucher",
    EnteringRiskMarginFailed: "Mangyaring ipasok ang margin ng panganib",
    loadSuccess: "Matagumpay na Na-load",
    invalidEmail: "Di-wastong email",
    parametererror: "Walang aktibong paraan ng pag-verify ang user",
    confirmSubmit: "Deposito",
    addressOverMax: "Naabot na ang limitasyon ng address",
    PositionInformationNotExist: "Ang impormasyon ng posisyon ay hindi umiiral",
    edit: "I-edit",
    additionalAmountCannotBeLessThanZero:
      "Ang karagdagang halaga ay hindi maaaring mas mababa sa 0",
    cancelFullScreen: "Lumabas sa Full Screen",
    optional: "(Opsyonal)",
    fullScreen: "Buong Screen",
    accountNameCannotBeEmpty:
      "Hindi maaaring walang laman ang pangalan ng may-ari ng account",
    dayStockLogSaveFailed:
      "Nabigong i-save ang kasalukuyang araw na log ng imbentaryo",
    maximumRiskMargin: "Lumampas sa maximum na margin ng panganib",
    ForgetPasswordUserNotExist:
      "Ang user na may ganitong numero ng telepono ay hindi umiiral",
    captchaExpired: "Nag-expire na ang verification code",
    cpfAlreadyUsed: "Ginagamit na ang CPF na ito",
    customerService: "Online Customer Service",
    emailAlreadyUsed: "Ginagamit na ang email na ito",
    additionalAllocationAmountLessThanZero:
      "Ang karagdagang halaga ng margin trading ay hindi maaaring mas mababa sa 0",
    TypeError: "Error sa pag-type",
    FundingInformationNotExist:
      "Ang impormasyon ng margin trading ay hindi umiiral",
    pressToClose: "Mag-click dito upang lumabas",
    redpacketPickedMessage:
      "Kumuha si {user_name} ng pulang pakete {amount}{currency}",
    male: "Lalaki",
    FriendCashCouponIssuedFailed: "Naibigay na ang Friend cash coupon",
    commissionedSuccessfully: "Matagumpay ang order",
    redPacketFinish: "Natapos ang Pulang Packet",
    statusError:
      "Hindi sinusuportahan ng kasalukuyang katayuan ang operasyong ito",
    enterAdditionalAllocationAmount:
      "Mangyaring magpasok ng karagdagang halaga ng margin trading",
    IdentifierFundNotExist:
      "Ang natatanging margin trading identifier ay hindi umiiral",
    withdrawAmountCannotExceedMinAmount:
      "Ang halaga ng withdrawal ay lumampas sa minimum",
    LoginSuccess: "Matagumpay ang pag-log in",
    pulldownRefresh: "Hilahin pababa para i-refresh",
    getCurrentDataFailed: "Hindi makuha ang kasalukuyang data",
    saveFail: "Nabigo ang pag-save",
    MarginCallFailed: "Nabigo ang margin call",
    additionalAllocationAmountMultipleOfHundred:
      "Ang karagdagang margin ay dapat na maramihan ng 100",
    search: "Maghanap",
    successfulPurchase: "Matagumpay ang pagbili",
    firstOfAllTheRealNameAuthenticationCanBindTheBankCard:
      "Dapat kumpletuhin ang tunay na pangalan na pagpapatotoo bago i-binding ang bank card",
    minimumAdditionalAmount: "Minimum na karagdagang halaga",
    savingToLocal: "Lokal na nagse-save, mangyaring maghintay...",
    submitOrder: "Isumite ang Order",
    noMembersInGroup: "Walang miyembro sa grupo",
    pleaseInput: "Pakipasok ang {title}",
    sendSuccess: "Matagumpay ang pagpapadala",
    insufficientFunds: "Hindi sapat na pondo ng account",
    EmptyAllocationMultiple: "Mangyaring pumili ng maramihang margin trading",
    close: "I-reset",
    siteService: "Serbisyo ng Site",
    accountLocked: "Naka-disable ang account na ito",
    accountAbnormalPleaseContactCustomerService:
      "Abnormal ang account, mangyaring makipag-ugnayan sa customer service",
    bomdMessage:
      "Binabati kita {user_name} na tumama sa isang minahan na nagpapadala ng pulang packet, nawala {loss_amount} {currency}",
    balanceNotEnough: "Hindi sapat na balanse sa account",
    ForgotPasswordInvalidVerificationCode: "Di-wastong verification code",
    LoginFailed: "Nabigo ang pag-login",
    closeDataFailed: "Nabigong isara ang function ng data",
    mobile_code_sent: "Ipinadala ang password ng seguridad sa telepono",
    salePriceFormatError: "Error sa format ng presyo ng pagbebenta",
    confirm: "I-reset",
    yuan: "Yuan",
    recordNotExist: "Hindi Nahanap ang Record",
    LoginUserNotExist: "Ang login user ay wala",
    fractionalSharesCannotSplitAndSold:
      "Ang odd lot (mas mababa sa 100 shares) ay hindi maaaring hatiin at ibenta",
    resendError:
      "Mangyaring maghintay ng 5 minuto bago ipadala muli ang verification code",
    redpacketMessage: "Nais ka ng kaunlaran at good luck",
    managementFee: "Bayad sa Pamamahala",
    phoneAlreadyUsed: "Ginagamit na ang numero ng teleponong ito",
    fundingApplicationFailed: "Nabigo ang application ng margin trading",
    WithdrawalApplicationSuccessful:
      "Matagumpay ang aplikasyon sa pag-withdraw",
    to: "Upang",
    CpfIdLimitExceeded: "Lumampas sa limitasyon ng CPF ID",
    operation: "Operasyon",
    understood: 'Nabasa ko ang "{title}"',
    WalletAddressRequired: "Kinakailangan ang address ng pitaka",
    enterTheStockCode: "Pakilagay ang stock code",
    language: "Wika",
    rechargeHasBeenSuccessful: "Naging matagumpay ang recharge na ito",
    additionalFundingSuccessful: "Matagumpay ang karagdagang margin",
    phoneoremailoraccountnamerequired:
      "Kinakailangan ang pangalan ng telepono o email o account",
    sendFail: "Nabigo ang pagpapadala",
    captcha: "Verification Code",
    Test: "Pagsubok",
    FailedCancellingCommissionOrder:
      "Nabigong kanselahin ang order ng komisyon",
    EntrustedOrderDoesNotExist: "Ang pagkakakilanlan ng order ay hindi umiiral",
    details: "Tingnan ang mga detalye",
    recharge_overMaxLimit:
      "Ang halaga ng recharge ay lumampas sa pinapayagang limitasyon: {max_amount}",
    female: "Babae",
    saveFailed: "Nabigo ang pag-save",
    pwdChangeSuccess: "Di-wastong Area Code",
    IncorrectAmount: "Mali ang halagang inilagay mo",
    FailedRevokeAnOrder: "Nabigong kanselahin ang order ng isang-click",
    bonusMessage:
      "Binabati kita {user_name} nakatanggap ng pulang packet reward {bonus_amount}",
    MobileNumberIncorrect: "Maling format ng numero ng mobile",
    insertError: "Nabigong ipasok ang tala",
    enterTheAdditionalAmount: "Mangyaring maglagay ng karagdagang halaga",
    insufficientTradableQuantityToday: "Hindi sapat na dami na nabibili ngayon",
    LoginPasswordFailed: "Walang laman ang password",
    yourfundbalanceisinsufficient: "Hindi sapat na balanse ng pondo",
    wrongChoiceOfAllocationMultiple:
      "Maling margin trading ang maramihang pagpili",
    repeatPickSamePacket: "Napili mo na itong pulang pakete",
    CancelledOrderNotExist: "Ang kinanselang order ay hindi umiiral",
    noRepeatSubmit: "Humiling na naproseso na",
    yourAccountHasInsufficientFunds: "Hindi sapat na pondo ng account",
    success: "Matagumpay ang operasyon",
    areacodeMissing: "Kinakailangan ang area code",
    selectDistributionOrder: "Mangyaring piliin ang margin trading order",
    deleteFailed: "Nabigo ang pagtanggal",
    MobileNumberNotRegistered: "Hindi nakarehistro ang mobile number",
    minimumRiskMargin10万: "Minimum na margin ng panganib 100,000",
    reentry: "Kumpirmahin",
    signSucessfully: "Matagumpay ang pag-log in, congrats sa pagkuha",
    AmountNotMultipleOf100:
      "Ang karagdagang halaga ng margin ay dapat na maramihan ng 100",
    SendVouchersInBatchFailed: "Nabigo ang pagpapadala ng batch voucher!",
    didNotPassTheUniqueIdOfTheFund:
      "Hindi naipasa ang natatanging margin trading ID",
    bankRequired: "Kinakailangan ang pangalan ng bangko",
    currencyDefaultError: "Isang default na pera lang ang pinapayagan",
    bankCardNumberFormatError: "Serbisyo sa Customer",
    redpacketPickedBombMessage:
      "Nakakuha si {user_name} ng {amount}{currency} pulang pakete, nakatanggap ka ng bomb bonus na {loss_amount}{currency}",
    updateFailed: "Nabigo ang pag-update",
    noBalance: "Walang balanse",
    FailedToModifyMobileNumber: "Nabigong baguhin ang numero ng mobile",
    failedToTransferFundsOut: "Nabigong maglipat ng mga pondo",
    passwordError: "Mali ang Account o Password",
    switchOn: "Paganahin",
    addLanguage: "Magdagdag ng Wika",
    getAddress: "Kunin ang address",
    updateError: "Nabigo ang pag-update",
    loadFail: "Nabigo ang pag-load",
    summary: "Kabuuan",
    selectLanguage: "Piliin ang Wika",
    shopService: "Uri ng Pagbabayad",
    betValueConfigNotFound: "Hindi Na-configure ang Halaga ng Taya",
    phoneError: "Maling format sa mobile",
    notRegistered: "Hindi nakarehistro ang account",
    agentDailyDepotSaveFailed: "Nabigong i-save ang ahente araw-araw na depot",
    fundingApplicationSuccessful:
      "Matagumpay ang application ng margin trading",
    appName: "Maligayang Buhay",
    toDate: "Petsa ng Pagtatapos",
    deleteConfirm: "Kumpirmahin ang Tanggalin?",
    thePurchaseQuantityIsMultipleOfHundred:
      "Ang dami ng binili ay dapat na maramihang 100",
    sellingQuantityMustBeMultipleHundred:
      "Ang dami ng pagbebenta ay dapat na maramihang 100 share",
    inputConfirm: "Pakikumpirma ang {title}",
    privacyProtocol: "Kasunduan sa Privacy",
    currentAgentOffline:
      "Kasalukuyang offline ang ahente, kumonekta muli sa ibang ahente?",
    home: "Home",
    recharge_overMinLimit: "Halaga ng recharge sa labas ng pinapayagang saklaw",
    incorrecemail: "Maling email",
    successfulWithVoucher:
      "Matagumpay ang pag-log in, congrats sa pagkuha ng coupon",
    NoPromotionCode:
      "Walang code na pang-promosyon, mangyaring makipag-ugnayan sa serbisyo sa customer",
    rechargeConfirmation: "Pagkumpirma ng recharge",
    LoginNameFailed: "Walang laman ang numero ng telepono",
    BatchProcessingSuccessful:
      "Matagumpay ang aktibidad sa pag-recharge ng unang batch",
    emailCodeSent: "Ipinadala ang password sa seguridad sa email",
    pleaseSelect: "Mangyaring Piliin",
    notFound: "Walang nakitang nauugnay na data",
    ForgetPasswordPhoneNumberEmpty: "Walang laman ang numero ng telepono",
    noData: "Walang data",
    tradingOfThisStockIsSuspended:
      "Pansamantalang sinuspinde ang stock mula sa pangangalakal",
    initializeEffectivePrincipal: "Paunang epektibong punong-guro",
    InsufficientFunds: "Hindi sapat na pondo ng account",
    withdrawalpasswordenteredincorrectly:
      "Mali ang nailagay na password sa pag-withdraw",
    rechargeConfirmationOperationFailed:
      "Naging matagumpay ang recharge na ito",
    select: "Pumili",
    noPermission: "Walang pahintulot",
    captchaError: "Maling verification code",
    successfulSell: "Matagumpay na naibenta ang stock",
    CreateUserAgentFailed: "Nabigong lumikha ng user agent",
    theAccountOpeningNameInconsistentWithVerificationName:
      "Ang pangalan ng may-ari ng account ay hindi tumutugma sa na-verify na pangalan",
    matchIsClosed: "Isinara ang laban",
    payType: "Uri ng Pagbabayad",
    userInterestCalculationHasCalculated:
      "Tapos na ang pagkalkula ng interes ng user",
    systemName: "Maghanap",
    orderSuccess: "Matagumpay ang order",
    newPWDCannotBeOld:
      "Mangyaring gumamit ng mas secure na password at iwasan ang muling paggamit ng mga lumang password",
    registerProtocol: "Kasunduan sa Pagpaparehistro",
    EntrustedOrderNotExist: "Ang pagkakakilanlan ng order ay hindi umiiral",
    SuccessfullyModified: "Matagumpay na nabago",
    releaseRefresh: "I-release para i-refresh",
    closeLeft: "Isara ang Kaliwa",
    multiBombBonusMessage:
      "Binabati kita {user_name} ay nakakuha ng maraming bonus na bomba {bonus_amount} {currency}",
    user_name_empty: "Ilagay ang iyong pangalan",
    pleaseEnterTheStockCode: "Pakilagay ang stock code",
    loading: "Naglo-load...",
    uniqueIdentifierFundDoesNotExist:
      "Ang natatanging margin trading identifier ay hindi umiiral",
    fail: "Nabigo ang operasyon",
    ProfitShareFailed: "Nabigo ang function ng pagbabahagi ng kita",
    partnerNotExist: "Wala ang partner",
    noRecord: "~ Walang laman ~",
    insertSuccess: "Matagumpay na naidagdag",
    enterCorrectAmount: "Mangyaring maglagay ng tamang halaga",
    reset: "I-reset",
    orderNow: "Order na",
    yourFundingAccountHasInsufficientFunds:
      "Hindi sapat na margin trading account na pondo",
    addLanguageFile: "Magdagdag ng mga File ng Wika",
    submitting: "Isinusumite...",
    deleteOptionalSuccess: "Matagumpay na naalis sa mga paborito",
    noUserFoundForThisIdAndGroupId:
      "Hindi nakita ang user na may ID at GroupId",
    mapDataError: "Maling pagkuha ng impormasyon ng address",
    cancelLanguage: "Kanselahin",
    balanceLow: "Mababang balanse",
    AdditionalAmountLessThan0:
      "Ang karagdagang halaga ay hindi maaaring mas mababa sa 0",
    purchaseQuantityMustBeGreaterThanOrEqualToHundred:
      "Ang dami ng binili ay dapat na ≥ 100",
    cnpjAlreadyUsed: "Ang CNPJ na ito ay ginagamit na",
    updateApp: "Available ang bagong bersyon, paki-update",
    Platform_android: "Bersyon ng Android",
    interestCalculatedSuccessfully: "Matagumpay ang pagkalkula ng interes",
    existingNameError: "Kumpirmahin ang Iyong Password",
    confirmLanguage: "Kumpirmahin",
    existingRecord: "May rekord",
    deleteSuccess: "Matagumpay na natanggal",
    parameterNameShouldBeUnique:
      "Umiiral na ang pangalan ng parameter. Dapat kakaiba",
    agentNotExist: "Ang numero ng account ng ahente ay hindi umiiral",
    signSuccessfully: "Matagumpay ang pag-log in, congrats sa pagkuha",
    yourAccountBalanceIsInsufficient: "Hindi sapat na balanse sa account!",
    fundTransferFailed: "Nabigo ang paglipat ng pondo",
    EnterAdditionalAmount: "Mangyaring maglagay ng karagdagang halaga",
    accountHasInsufficientFunds: "Hindi sapat na pondo ng account",
    bankIsNotOpenYet: "Hindi pa sinusuportahan ang bangko",
    closeRight: "Isara Kanan",
    privacyPolicy: "Patakaran sa Privacy",
    failedToAddFunds: "Nabigong magdagdag ng margin trading",
    enterTheSaleQuantity: "Mangyaring ipasok ang dami ng benta",
    SendCashInBatchFailed: "Nabigo ang batch na pagpapadala ng cash!",
    configKeyShouldBeUnique: "Umiiral na ang config key. Dapat kakaiba",
    appUseRule: "Mga Tuntunin sa Paggamit",
    updateSuccess: "Matagumpay ang pag-update",
    FundSettlementSuccessful: "Matagumpay ang margin trading settlement",
    OperationFailed: "Nabigo ang operasyon",
    Platform_ios: "Bersyon ng iOS",
    purchasesScienceTechnologyGreaterEqualTwoHundred:
      "Ang dami ng pagbili ng STAR Market ay dapat na ≥ 200",
    accountDisabled: "Mula sa {remark}",
    bankNameCannotBeEmpty: "Hindi maaaring walang laman ang pangalan ng bangko",
    timebaoAccountCreateFailed: "Nabigong gumawa ng Timebao account",
    purchaseQuantityFormatError: "Error sa format ng dami ng pagbili",
    InsufficientBalance: "Hindi sapat na balanse sa account",
    InvalidPhone:
      "Di-wastong format. Dapat magsimula sa 09 at 11 digit ang haba",
    failedPurchase: "Nabigo ang pagbili",
    alreadyAddedToThisGroup: "Home Configuration",
    clearCache: "Buong Screen",
    NoEntrustmentInformationFound: "Walang impormasyon ng order",
    uniqueIdentifierOfTheFundDoesNotExist:
      "Ang natatanging margin trading identifier ay hindi umiiral",
    rechargeHasBeenFailed: "Nabigo ang recharge na ito",
    download: "I-download",
    stockIsTemporarilyUnavailableForTrading:
      "Pansamantalang hindi available ang stock para sa pangangalakal",
    incorrectphone: "Maling telepono",
    marginCallFailed: "Nabigo ang margin call",
    cpfIdAlreadyUsed: "Ginagamit na ang CPF ID na ito",
    CreateUserCouponFailed: "Nabigong lumikha ng kupon ng user",
    from: "Mula sa",
    interestCalculationFailed: "Nabigo ang pagkalkula ng interes",
    App_download_title: "I-download ang app ngayon",
    AmountBelowMinimum:
      "Ang halaga ay hindi maaaring mas mababa sa minimum na halaga",
    readAndAgree: "Basahin at sumang-ayon",
    ThirdPartyUpdateFailed: "Pakikumpirma kung na-update na ang third party!",
    pendingBetsExist: "May mga nakabinbing taya na hindi pa naaayos.",
    minimumRiskMargin: "Mas mababa sa minimum na margin ng panganib",
    AlreadysubmittedOrderError: "Naisumite na ang order",
    additionalAmountFormatError: "Minimum na karagdagang halaga",
    withdrawNotice:
      "Pagkatapos ng matagumpay na pagbabayad, mag-a-update ang balanse ng laro sa loob ng 3 minuto. Kung mabigo ang pagbabayad, pumili ng ibang channel ng pagbabayad",
    closeAll: "Wika",
    failed: "Nabigo",
    noUsersToDeleteForThisGroupID:
      "Walang user na tatanggalin para sa group ID na ito",
    invalidCode: "Di-wastong redemption code",
    fromDate: "Petsa ng Pagsisimula",
    "bankCardNumberCannotBeEmpty ":
      "Hindi maaaring walang laman ang numero ng bank card",
    LoginUserFailed: "Na-block ang user sa pag-login",
    addLanguageImage: "Magdagdag ng mga Larawan ng Wika",
    invitation_link: "Link ng imbitasyon",
    accountIsAbnormalPleaseContactCustomerService:
      "Abnormal ang account, mangyaring makipag-ugnayan sa customer service",
    nonTradingDay: "Maligayang pagdating, ngayon ay hindi araw ng kalakalan",
    purchasePriceFormatError: "Error sa format ng presyo ng pagbili",
    accountExpiresProhibitBuying:
      "Nag-expire ang account, hindi pinapayagan ang pagbili ng mga order",
    parameterError: "Mga maling parameter",
    orderRule: "Order Notes",
    itemValue: "Halaga ng Opsyon",
    FundTransferSuccessful: "Matagumpay ang paglilipat ng pondo",
    withdrawAccountRequired:
      "Kinakailangan ang bangko o pitaka para sa pag-withdraw",
    incorrectaccountname: "Maling pangalan ng account",
    MinimumBillingCycle: "Ang minimum na yugto ng pagsingil ay dalawang araw",
    ok: "Mag-upload",
    SuccessfulMarginCall: "Nabigo ang margin call",
    changeLanguage: "Baguhin ang Wika",
    insertFailed: "Nabigo ang pagpasok",
    alreadyDeleted: "Tinanggal ang user",
    notExists: "Walang code",
    suspiciousBehaviorDetected:
      "May nakitang kahina-hinalang gawi, Mangyaring makipag-ugnayan sa isang administrator",
    AdditionalAmountFormatError: "Maling format ng karagdagang halaga",
    selectAddress: "Pumili ng address",
    flowLogRemark: "Mula sa {remark}",
    changePassword: "Baguhin ang Password",
    commissionFailed: "Nabigo ang komisyon",
    additionalFundsReceived: "Karagdagang margin trading fee",
    DistributionOrderNotSelecte: "Mangyaring piliin ang margin trading order",
    AddFundsError: "Nabigong magdagdag ng margin trading",
    successfulMarginCall: "Matagumpay ang margin call",
    FailedToPlaceAnOrder:
      "Nabigong mag-order, mangyaring makipag-ugnayan sa online customer service para sa malalaking paunang deposito",
    unauthorized: "Hindi awtorisado, Mangyaring Mag-login Muli",
    switchOff: "Huwag paganahin",
    marketClosed: "Sarado ang merkado, hindi makapagkalakal",
    WithdrawalRequestFailed: "Nabigo ang kahilingan sa pag-withdraw",
    deleteHint: "Tanggalin ang Kahilingan",
    OperationSuccess: "Matagumpay ang operasyon",
  },
  operate: {
    findByWeek: "Lingguhang Margin Trading",
    intrestFree: "Walang Interes na Margin Trading",
    findByDay: "Pang-araw-araw na Margin Trading",
    vipAllocation: "VIP Margin Trading",
    monthlyAllocation: "Buwanang Margin Trading",
  },
  field: {
    Job_cron_expression: "Cron Expression",
    CoinCurrency_can_internal_transfer:
      "Sinusuportahan ng Withdrawal ang Panloob na Paglilipat: 0=hindi, 1=oo",
    LotteryBetList_user_email: "Email",
    SysConfig_smsbao_url: "SMS Bao URL",
    Entrust_name: "Pangalan ng Stock",
    Activity_bond: "Bond",
    Parameter_partner_id: "Partner ID",
    RechargeType_message: "Remarks",
    Activity_balance: "Natitira",
    UserAccount_account: "Magagamit na Balanse",
    DepotSimulate_type: "Uri ng Posisyon 0: A 1: B",
    OtcAccountInfo_status: "Pinagana",
    User_token_time: "Oras ng Token",
    UserCoupon_user_real_name: "Pangalan",
    Entrust_order: "Numero ng Order",
    JobLog_invoke_target: "I-invoke ang Target",
    LotteryBetList_close_time: "Oras ng Isara",
    Withdraw_agent: "ID ng Ahente",
    LotteryType_bonus_rate_base: "Pinakamababang Logro",
    SysConfig_mail_username: "Email Username",
    Deal_com_cost: "Gastos ng Komisyon",
    Baseconfig_water_alpha: "Opacity ng Watermark",
    UserSimulate_encrypt_phone: "Naka-encrypt na Telepono",
    SysConfig_water_status: "Katayuan ng Watermark",
    TronExchange_from_amount: "Natanggap na Halaga",
    Baseconfig_app_ios: "Link sa Pag-download ng iOS",
    VoucherCash_remark: "Remarks",
    VoucherCash_user_real_name: "Pangalan",
    RsaKey_id: "ID",
    click: "Tingnan",
    Deal_number: "Dami",
    LotteryBetList_other1: "Reserve 1",
    LotteryBetList_other2: "Reserve 2",
    CapitalLog_capital: "Capital ID",
    OtcAccount_user_phone: "Telepono",
    LotteryBetList_other3: "Reserve 2",
    Baseconfig_withdraw_wake_sound: "Tunog ng Alerto sa Pag-alis",
    EntrustSimulate_entrust_time: "Oras ng Order",
    Entrust_mold: "Uri ng Operasyon 1: Bumili 2: Bumili sa Market",
    DealSimulate_deal_time: "Oras ng Deal",
    Entrust_version: "Bersyon",
    UserBank_is_default: "Ay_default",
    "Home_Register_today ": "Pagpaparehistro Ngayong Araw (Tunay na Pangalan)",
    BetType_winning_pc_zh: "Winning_pc_zh",
    Activity_name: "Pangalan ng Aktibidad",
    Baseconfig_popup_mobile_content: "Mobile Popup",
    ActivityLog_partner_refCode: "Referral Code ng Kasosyo",
    AgentDeferred_agent_phone: "Telepono ng Ahente",
    OtcAccountHistory_create_date: "Oras ng Paglikha",
    WalletCollectHistory_txid: "Hash ng Transaksyon",
    ActivityLog_remark: "Remarks",
    CoinAccount_user_real_name: "Tunay na Pangalan",
    GXBasketballJc_updateTime: "Oras ng Pag-update",
    Entrust_stamp_cost: "Halaga ng Stamp Duty",
    DepotSimulate_buy_total: "Kabuuang Halaga ng Pagbili",
    TimebaoLog_id: "ID",
    AgentManage_mother: "Ina Account",
    CoinRecharge_type: "Pinagmulan",
    TimebaoAccount_totalamount: "Kabuuang Mga Natanggap na Paglipat",
    Depot_surplus: "Nananatiling Available",
    UserCoupon_id: "ID",
    Community_update_time: "Oras ng Pag-update",
    UserLevel_create_time: "Oras ng Paglikha",
    Wallet_address: "Address ng Wallet",
    PowerInterest_jly_tb_zz: "% YoY Net na Paglago ng Kita",
    CapitalLog_create_time: "Oras ng Paglikha",
    adminuser_name: "Username",
    News_type: "Uri",
    CoinCurrency_addressCron: "Address",
    CoinAccountDetail_before_info:
      "Impormasyon ng Account Bago ang Transaksyon",
    Wallet_max_amount: "Max na Halaga",
    TimebaoAccount_capital_change: "Pagbabago ng Kapital",
    Baseconfig_chat_socket_domain: "SOCKET ng Customer Service",
    OtcOrder_type: "Uri ng Order",
    LotteryResult_close_end_time: "Oras ng Pagtatapos ng Settlement",
    UserAccount_first_trans_date: "Petsa ng Unang Transaksyon",
    ActivityLog_approve_time: "Oras ng Pag-apruba",
    DealSimulate_status: "Katayuan",
    HomeConfig_enter_menu_title: "Ipasok ang Pamagat ng Menu",
    BetType_create_time: "Oras ng Paglikha",
    Capital_total: "Available na Halaga",
    Agent_agent: "Superior na Ahente",
    UserCoupon_recharge_id: "Recharge Code",
    AgentCommission_bet_type: "Kategorya ng Laro",
    TronExchange_create_time: "Oras",
    HomeConfig_first_tab: "Unang Tab",
    CoinWithdraw_user_real_name: "Tunay na Pangalan",
    AgentReserve_data: "Data ng Modelo",
    Protocol_update_time: "Oras ng Pag-update",
    TronExchange_to_token: "TOKEN",
    User_agent: "Ahente",
    Activity_pc_image_jp: "Mga Larawan ng Japanese na PC",
    OtcOrder_account_id: "Account ID",
    User_agent_nick: "Superior Nickname",
    BetType_win_rate: "Manalo ng Return Multiple",
    Help_update_time: "Oras ng Pagbabago",
    WalletCollectHistory_amount: "Halaga",
    LotteryMaxResult_blocktimestamp: "I-block ang Timestamp",
    UserCoupon_coupon_type: "Uri ng Cash Coupon",
    LotteryResult_end_time: "Oras ng Pagtatapos ng Taya",
    LotteryBetList_win_amount: "Ibalik ang Halaga",
    GxBasketballJCResult_home: "Pangalan ng Home Team",
    Baseconfig_withdraw_refresh_interval:
      "Withdrawal Refresh Interval (segundo)",
    Entrust_plus_fee: "Karagdagang Bayarin",
    Approved: "Wastong code",
    lastMsgImage: "Imahe",
    AgentAccount_trx_commission_total: "Kabuuang TRX Commission",
    Withdraw_ref_code: "Referral Code",
    paymentChannel: "Channel ng Pagbabayad",
    GXBasketballJc_away: "Numero ng Isyu",
    FlowType_name: "Uri ng Transaksyon",
    Wallet_trx_total: "Kabuuang TRX",
    LotteryMaxResult_lottery_id: "Lottery ID",
    User_update_time: "Oras ng Pagbabago",
    Baseconfig_withdraw_fee_fixed: "Bayad sa Pag-withdraw",
    HomeConfig_sportgames_card_label_color: "Kulay ng Label ng Pindutan",
    AgentCommission_bet_amount: "Halaga ng taya",
    UserBank_status: "1 Normal 2 Tinanggal",
    Baseconfig_huhui_comment1: "Paliwanag na Walang Interes 1",
    Baseconfig_huhui_comment2: "Paliwanag na Walang Interes 2",
    Baseconfig_withdraw_fee_rate: "Default na SMS",
    AgentAccount_finance_total: "Pinansyal na Interes",
    AgentCommission_id: "ID",
    Lottery_image: "Imahe",
    ActivityLog_user_phone: "Telepono",
    Activity_title_ch: "Pamagat ng Tradisyonal na Tsino",
    LotteryBetList_version: "Pamamahala ng Bersyon",
    SysConfig_register_agent_type: "Uri ng Ahente",
    UserSimulate_core_set: "Modelo ng User Rate",
    Entrust_entrust_id: "Numero ng Order",
    UserAccount_user_name: "palayaw",
    MonthlyHistory_trx_bet_total: "Kabuuang TRX Bet",
    BetOrder_pay_amount: "Ibinalik na Halaga",
    GXBasketballJc_lqDxf: "LqDxf",
    UserSimulate_user_account_account: "Mga pondo",
    AgentFlowType_id: "ID",
    CoinAccount_total_balance: "Kabuuang Balanse",
    LotteryResult_ref_code: "Referral Code",
    VoucherManagement_create_time: "Oras ng Paglikha",
    RechargeType_status: "Katayuan",
    Baseconfig_trc20_refer_blockid: "Taas ng Reference Block",
    OtcTrade_modify_time: "Oras ng Pagbabago",
    CoinRecharge_certify_image: "Ilipat ang Patunay na Larawan",
    TimebaoAccount_partner_ref_code: "Referral Code ng Kasosyo",
    VoucherCash_create_time: "Oras ng Paglikha",
    HomeConfig_enter_content: "Ipasok ang Nilalaman",
    Deal_user_phone: "Telepono",
    CoinCurrency_pass: "Password ng RPC",
    InterestLog_type: "Uri",
    FriendCoupon_friend_uid: "Friend Used ID",
    UserSimulate_email: "Email ng User",
    DepotSimulate_cost_total: "Natitirang Halaga ng Gastos",
    OtcTrade_remark: "Remarks",
    Baseconfig_smsplannet_secretkey: "smsplannet_secretkey",
    CategoryList_category_image: "Larawan ng Kategorya",
    Baseconfig_time_interval: "Instant Treasure Interval",
    GxBeidanJC_issue: "Isyu",
    PowerInterest_net_assets_per_share: "Net Asset Value Per Share",
    AgentAccount_trade_fee: "Bayad sa pangangalakal",
    Baseconfig_company_name: "Pangalan ng Kumpanya",
    CoinAccountDetail_create_time: "Timestamp ng Transaksyon",
    mobileNumber: "numero ng mobile",
    CoinCurrency_withdraw_fee_max: "Max Withdrawal Fee",
    selectable: "opsyonal",
    MonthlyHistory_user_user_number: "Address ng Wallet",
    VoucherManagement_cid: "ID ng Diskarte",
    MonthlyHistory_id: "ID",
    LotteryMaxResult_estimate_time: "Tinatayang Oras",
    AgentDeferred_user_number: "Numero",
    Total_profit: "Kabuuang Kita/Pagkawala",
    FriendCouponLog_balance: "Kasalukuyang Balanse",
    AgentReserve_id: "ID",
    InterestLog_cost: "Halaga ng Gastos",
    Capital_frozen: "Mga Frozen na Pondo",
    CoinAccount_id: "Id",
    AgentAccount_trade_total: "Halaga ng Transaksyon",
    UserAccount_voucher_management: "Bayad sa Pamamahala na Gifted ng Platform",
    LotteryMax_bet_money: "Taya ng Pera",
    adminuser_user: "Username",
    UserLevel_name: "Paglalarawan",
    News_title: "Pamagat ng Balita",
    UserBank_name: "Pangalan ng Bangko",
    AgentCommission_remark: "Remarks",
    Parameter_config_value: "Halaga ng Parameter",
    LotteryType_partner_partner_name: "Pangalan ng Kasosyo",
    CoinCurrency_createNum: "Bilang ng Paglikha ng Isang Address",
    FlowType_language_1: "Ibang Wika 1",
    FlowType_language_3: "Ibang Wika 3",
    FlowType_language_2: "Ibang Wika 2",
    AgentFee_staff: "Staff ID",
    ExchangeRate_to_currency: "Palitan ng Pera",
    Baseconfig_copyright: "Copyright ng Site",
    WalletCollectHistory_status: "Katayuan ng Transaksyon",
    ExchangeRate_partner_id: "Partner ID",
    UserAccount_usdt_account: "Mga Pondo ng USDT",
    Minus_approved_by: "Approver",
    AgentFlowLog_voucher: "Voucher",
    Wallet_min_block_timestamp: "Min USDT Block Time",
    Depot_user_real_name: "Pangalan",
    AgentDivide_upagent: "Superior na Ahente",
    User_inter_standard: "International Mobile Code",
    Deal_stamp_cost: "Halaga ng Stamp Duty",
    Draw: "Gumuhit",
    TimebaoAccount_interestamount: "Kabuuang Interes",
    ActivityNotice_content: "Nilalaman",
    Baseconfig_app_download_popup_show: "Ipakita ang Pag-download ng APP",
    User_login_time: "Oras ng Pag-login",
    LanguageField_id: "ID",
    User_last_login_device: "Huling Login Device APP ANDROID IOS PC",
    adminuser_google_secret: "Secret Key ng Google",
    DepotSimulate_id: "ID",
    Minus_partner_name: "Pangalan ng Kasosyo",
    DealSimulate_mold: "Uri ng Operasyon 1: Bumili 2: Bumili sa Market",
    AgentFee_id: "ID",
    SysConfig_ucpass_appid: "ucpass App ID",
    Baseconfig_is_web_pc_coupon_popup: "is_coupon_popup",
    Withdraw_currency: "Withdrawal Currency",
    LotteryType_partner_id: "Partner ID",
    CategoryList_game_view_style: "Game View Style",
    UserSimulate_is_trade_channel_agree: "Channel ng Ahente",
    LotteryBetList_comment: "Magkomento",
    UserAccount_usdt_fee_total: "Bayad sa USDT",
    UserAccount_trx_bet_today: "Araw-araw na TRX Bets",
    EntrustSimulate_deal: "Presyo ng Order",
    DealSimulate_name: "Pangalan ng Stock",
    Recharge_to_address: "Pagtanggap ng Account/Address",
    TimebaoAccount_interest_year: "Interes Ngayong Taon",
    ascending: "Paakyat",
    OtcMerchant_is_deposit: "Deposito 0=hindi 1=oo",
    DepotStop_cost: "Gastos sa Posisyon",
    OtcTrade_complain_type: "Katayuan ng Apela",
    RechargeMethod_fee: "Bayad",
    Baseconfig_sms_format: "Format ng Pagpapadala ng SMS",
    CoinFlowType_status: "Katayuan",
    FoundWinners_focus_price: "Presyo ng Panoorin",
    MidokeMessage_status: "Posisyon",
    Activity_title_en: "Pamagat sa Ingles",
    Capital_depot: "Mga Pondo sa Gastos sa Posisyon",
    Baseconfig_home_profit_banner: "Banner ng Alerto sa Bahay",
    BetOrder_bet_type: "Kategorya ng Laro",
    HomeConfig_enter_button_text: "Ipasok ang Button Text",
    OtcAccount_create_time: "Oras ng Paglikha",
    SysConfig_transcan_block_url: "I-block ang Link ng Impormasyon",
    CoinAccountDetail_uid: "User ID",
    LotteryMax_start_time: "Oras ng Pagsisimula",
    TimebaoAccount_interestyear: "Taunang Interes",
    Lottery_partner_id: "Partner ID",
    EntrustSimulate_agent: "Numero ng Order",
    OtcTrade_phone: "Telepono",
    Baseconfig_ip_white: "IP Whitelist",
    OtcPaymentType_id: "ID",
    SysConfig_data: "Data",
    VoucherCash_admin: "Operator",
    PowerInterest_id: "ID",
    AgentFlowLog_type: "Uri",
    DepotSimulate_cost: "Gastos sa Posisyon",
    AgentAccount_superior_name: "Superior na Pangalan",
    CoinRechargeAddr_fee_total: "Kabuuang Bayad sa Paghawak",
    CoinAccount_user_name: "Palayaw ng User",
    Parameter_language: "Wika ng Paggamit",
    VoucherManagement_id: "ID",
    Trade_total: "Kabuuang Halaga ng Binili",
    Recharge_sure_time: "Oras ng Pagkumpirma ng User",
    UserSimulate_last_time: "Huling Oras ng Pag-log in",
    AgentDeferred_upagent: "Superior na Ahente",
    LotteryGroup_sort: "Pagbukud-bukurin",
    OtcOrder_unfrozen: "Unfrozen na Halaga",
    UserBank_card: "Bank Account Number",
    OtcPaymentType_icon: "Icon",
    CoinCurrency_guijiCron: "Koleksyon",
    RechargeMethod_app_version: "Bersyon ng App",
    Protocol_type: "Uri",
    Withdraw_transfer_time: "Oras ng Paglipat",
    DepotSimulate_cancel: "Kinanselang Halaga",
    Baseconfig_ucpass_token: "Yunxin Auth Token",
    Agent_number: "Numero ng Ahente",
    CoinCurrency_status:
      "Naka-iskedyul na Katayuan ng Gawain: 0=hindi tumatakbo, 1=tumatakbo",
    User_bank: "Nakatali sa Bangko",
    CoinRecharge_confirmations: "Mga kumpirmasyon",
    InterestLog_capital_capital_name: "Uri ng Produkto",
    ActivityLog_balance: "Natitira",
    PowerInterest_mg_gjj: "Naipong Pondo Bawat Bahagi",
    Deal_mother: "Inang Account ID",
    TimebaoAccount_version: "Bersyon",
    LotteryBetList_user_real_name: "Pangalan",
    Wallet_id: "ID",
    Community_partner_id: "Partner ID",
    Recharge_pay_time: "Oras ng Callback",
    "Home_Number_of_positions ": "Bilang ng mga Posisyon",
    FoundWinners_changepercent: "Max na Pagtaas",
    SysConfig_ios_download: "Apple Download",
    TimebaoLog_end_time: "Oras ng Pagtatapos ng Interes",
    MonthlyHistory_usdt_result: "Tala ng Panalo/Pagkakatalo ng USDT",
    User_real_name: "Tunay na Pangalan",
    OtcAccount_name: "palayaw",
    FoundWinners_focus_time: "Presyo at Oras ng Panoorin",
    AgentManage_number: "Bilang ng Transaksyon",
    Withdraw_oper_ip: "User Operation IP",
    DepotSimulate_user_real_name: "Pangalan",
    extra: "Dagdag",
    VoucherCash_agent: "ID ng Ahente",
    CoinCurrency_rechargeCron: "Reverse",
    Withdraw_to_amount: "Na-withdraw na Halaga",
    OtcAccount_real_name: "Tunay na Pangalan",
    OperatorInformation_action: "Pangalan ng Operasyon",
    AgentCommission_token: "Uri ng TOKEN 1=USDT 0=TRX",
    CoinCurrency_withdraw_rule:
      'Mga Panuntunan sa Withdrawal Address para sa Currency, na nakaimbak bilang key-value; minlen:5 = minimum na haba ng address 5, maxlen:18 = maximum na haba 18, pre:0x = dapat magsimula sa 0x; maramihang pinaghihiwalay ng ","',
    DealSimulate_create_time: "Oras ng Transaksyon",
    GxBeidanJcResult_homeId: "Home Team ID",
    FlowLog_user_caller: "Espesyalista sa Customer Service",
    Baseconfig_is_real_name_popup: "Walang Tunay na Pangalan na Popup Button",
    Activity_title_jp: "Pamagat ng Hapon",
    Entrust_remark: "Remarks",
    CoinCurrency_currency_name:
      "Pangalan ng currency, hal., Chinese Yuan, Bitcoin, Litecoin, atbp.",
    CoinCurrency_withdrawCron: "Auto Withdrawal Cron Expression",
    UserSimulate_card: "Numero ng ID Card",
    Lottery_image_zh: "Imahe ng Intsik",
    OtcTrade_taker: "Tagiliran",
    Withdraw_coin_addr: "Address ng Pagtanggap ng User",
    MonthlyHistory_trx_win_total: "Halaga ng Panalo ng TRX",
    Language_name: "Pangalan ng wika",
    ActivityLog_token: "Token",
    OtcOrder_modify_time: "Oras ng Pagbabago",
    AgentAccount_manage_total: "Bayad sa Pamamahala",
    FirstVoucher_status: "Katayuan",
    "Home_Unfinished_recharge_amount ": "Hindi Kumpletong Halaga ng Recharge",
    LotteryType_function1: "Nakareserbang Function 1",
    kycInReviewMessage:
      "Ang iyong KYC details ay nasa review. Hindi ka maaaring mag-withdraw hanggang makumpleto ang verification.",
    OtcOrder_phone: "Telepono",
    LotteryType_function2: "Nakareserbang Function 2",
    AgentAccount_user_real_name: "Pangalan",
    RechargeType_max_amount: "Pinakamataas na Halaga",
    EntrustSimulate_order: "Numero ng Order",
    Transaction_return_investment_ratio: "Trading Return on Investment",
    ActivityLog_number: "Dami",
    VoucherCash_type: "Uri",
    Baseconfig_ucpass_url: "URL ng Kahilingan ng Yunxin",
    CapitalLog_order: "Numero ng Order",
    PlusMinusType_name: "Uri",
    CoinCurrency_withdraw_fee_min: "Pinakamababang Bayad sa Pag-withdraw",
    Closed_explain: "Paliwanag",
    VoucherCash_activity_id: "Aktibidad",
    AgentFee_agent: "ID ng Ahente",
    Minus_type: "Uri ng Recharge",
    TimebaoRate_unit: "Mga araw",
    Closed_id: "ID",
    state: "Estado",
    AgentWithdraw_status: "Katayuan",
    CoinWithdraw_transfer_status: "Katayuan ng Paglipat 0: Default na Halaga",
    Community_sort: "Kategorya",
    TimebaoLog_starttime: "Oras ng Pagsisimula ng Interes",
    BetType_min_trx_block_timestamp: "Min TRX Block Time",
    OtcTrade_opposite_o_id: "Counterparty Order ID",
    CoinCurrency_withdraw_fee: "Bayad sa Pag-withdraw",
    EntrustSimulate_change_cost: "Gastos sa Bayarin sa Paglipat",
    Code: "Code",
    LotteryType_example_en: "Halimbawa ng Ingles",
    LotteryMax_bet_loss: "Pagkatalo sa taya",
    AgentAccount_version: "Bersyon",
    OtcMerchant_status: "Katayuan ng Merchant",
    Baseconfig_timebao_rate: "Instant Treasure Rate",
    CoinAccountDetail_number: "Dami ng Transaksyon",
    OtcMerchant_user_name: "palayaw",
    Home_frozen_total: "Total Frozen",
    DepotSimulate_update_time: "Oras ng Pagbabago",
    CoinChainType_coin_type: "Numero ng Kontrata/Address",
    LotteryResult_next_order_id: "Susunod na Numero ng Isyu",
    LotteryBetList_token: "TOKEN",
    GXBasketballJc_id: "Lottery JC ID",
    Language_remark: "Puna",
    UserAccount_trx_bet_month: "Buwanang TRX Bets",
    BetType_status: "Kung Gagamitin",
    Recharge_type: "Uri ng Interface",
    UserSimulate_reid: "Tagapagrekomenda",
    OtcAccountHistory_id: "ID",
    Minus_approve_by: "Approver",
    UserAccount_usdt_bet_year: "Mga Taunang USDT na Taya",
    OtcOrder_orig_price: "Orihinal na Presyo ng Order",
    UserSimulate_name: "palayaw",
    User_activity1: "Gawain 1",
    GxBeidanJcResult_comp: "Pangalan ng Tugma",
    User_alipay: "Alipay",
    AgentAccount_month_capital: "Buwanang Pagpopondo",
    Language_is_default: "Puna",
    Entrust_mother: "Ina Account",
    HomeConfig_notice: "Pansinin",
    VoucherCash_approved_time: "Oras ng Pag-apruba",
    LotteryCategory_name_zh: "Paglalarawan ng Tsino",
    FeeLog_capital_order: "Kontrata ng Diskarte",
    LotteryCategory_partner_name: "Pangalan ng Kasosyo",
    UserSimulate_token_time: "Oras ng Token",
    LotteryType_example_ch: "Halimbawa ng Tradisyunal na Tsino",
    DailyHistory_partner_name: "Pangalan sa Login ng Kasosyo",
    BetBalance_trx_paid_amount: "Halaga ng Pagbabalik ng TRX",
    AgentAccount_free_trade_total: "Halaga ng Trading na Walang Interes",
    FoundWinners_id: "ID",
    HomeConfig_sportgames_card_buttons: "Pindutan ng Card",
    pendingBets: "Mga Nakabinbing Taya",
    Normal: "Normal na Mode",
    Plus_exchange: "Exchange Rate",
    Depot_order: "Numero ng Order",
    "Home_Number_of_first_depositors_day ":
      "Bilang ng mga Unang Nagdeposito Ngayon",
    Baseconfig_upload_type: "Uri ng Pag-upload",
    UserVip_id: "ID",
    UserAccount_first_voucher: "Pinakamataas na Antas na Naabot",
    CapitalLog_balance: "Natitira",
    DepotSimulate_order: "Numero ng Order",
    DealSimulate_com_cost: "Gastos ng Komisyon",
    UserAccount_usdt_win_total: "Kabuuang Kita ng USDT",
    Capital_increase_bond: "Karagdagang Margin",
    Divide_total: "Dibidendo na Walang Interes",
    Baseconfig_chat_domain: "Domain ng Customer Service",
    Baseconfig_app_versionupdate: "Prompt sa Pag-update ng APP",
    GxBasketballJCResult_issueNum: "Numero ng Isyu",
    Baseconfig_smsbao_account: "Gumagamit ng SMS Bao",
    AgentDeferred_deferred: "Ipinagpaliban na Bayad",
    Baseconfig_banner4: "Larawan 4 ng APP Carousel",
    Baseconfig_banner5: "Larawan 5 ng APP Carousel",
    Baseconfig_banner6: "Larawan 6 ng APP Carousel",
    LotteryType_example_jp: "Halimbawa ng Hapon",
    Baseconfig_banner1: "Larawan 1 ng APP Carousel",
    Baseconfig_banner2: "Larawan 2 ng APP Carousel",
    Baseconfig_banner3: "Larawan 3 ng APP Carousel",
    TimebaoLog_create_time: "Oras",
    CoinChainType_partner_id: "Partner ID",
    TimebaoLog_partner_id: "Partner ID",
    GxBasketballJCResult_away: "Pangalan ng Away Team",
    LotteryGroup_name_2: "Iba pa 2",
    CapitalLog_user_phone: "Telepono",
    LotteryGroup_name_1: "Iba 1",
    CapitalLog_agent: "ID ng Ahente",
    UserAccount_trx_win_month: "Buwanang TRX na Kita",
    ActivityNotice_create_time: "Oras ng Paglikha",
    CoinChainType_main_coin_type: "Pangunahing Chain Coin Number",
    OtcPaymentType_status: "Katayuan",
    LotteryGroup_name_3: "Iba pa 3",
    FlowType_language_en: "Tradisyunal na Tsino",
    PowerInterest_total_equity: "Kabuuang Outstanding Shares",
    Agent_month: "Buwanang Pag-alis ng Pamamahagi",
    Recharge_our_addr: "Pagtanggap ng Address",
    Deal_agent_name: "Pangalan ng Stock",
    OtcTrade_transaction_id: "Numero ng Transaksyon",
    UserBank_withdraw_type: "0 Bank Card 1 Digital Currency",
    HomeConfig_sportgames_menu_title: "Pamagat ng Menu",
    Baseconfig_trongrid_url: "Tongrid_Url",
    Partners_name: "Pangalan",
    CoinChainType_main_unit: "Pangunahing Chain Currency",
    User_googele_secret: "Secret Key ng Google Authenticator",
    UserControl_id: "ID",
    OtcTrade_version: "Bersyon",
    UserAccount_friend_coupon: "Kabuuang Friend Cash Coupons",
    FeeLog_type: "Uri",
    Plus_approve_by: "Approver",
    TimebaoRate_create_time: "Oras",
    Activity_parameter: "Mga Parameter ng JSON",
    OtcTrade_complain_owner: "Apela sa May-ari",
    GXBasketballJc_home: "Away Team ID",
    LotteryMax_id: "ID",
    Lottery_image_2: "Larawan 2",
    Lottery_image_3: "Larawan 3",
    MonthlyHistory_usdt_net_loss: "USDT Netong Kita/Pagkawala",
    DepotStop_type: "Uri ng Posisyon 0: A 1: B",
    FriendCoupon_coupon_type: "Uri ng Cash Coupon",
    CoinFlowType_name: "Uri ng Transaksyon",
    UserAccount_partner_id: "Partner ID",
    DailyHistory_trx_win_total: "Halaga ng Panalo ng TRX",
    GxBasketballJCResult_status: "Katayuan",
    OtcAccountInfo_create_time: "Oras ng Paglikha",
    noLimit: "Walang limitasyon",
    Job_create_time: "Oras ng Paglikha",
    HomeConfig_save_all: "Magdagdag ng Carousel Image",
    Lottery_image_1: "Larawan 1",
    Wallet_exclude_address: "Ibinukod ang Address",
    LotteryMaxResult_status: "Katayuan",
    BetType_min_trx_amount: "Min TRX Recharge Halaga",
    RechargeType_notice1: "Tandaan 1",
    TimebaoRate_status: "1 = Naka-enable, 0 = Naka-disable",
    OtcAccountHistory_total_balance: "Kabuuang Balanse",
    RechargeType_notice2: "Tandaan 2",
    RechargeType_notice3: "Tandaan 3",
    Baseconfig_recharge_explain: "Paliwanag ng Pag-recharge sa Pagdating",
    TimebaoAccount_uid: "Account ID",
    DealSimulate_capital: "ID ng pagpopondo",
    Entrust_deal: "Presyo ng Order",
    CoinRecharge_currency: "Pera",
    ExchangeRate_create_time: "Timestamp",
    Wallet_max_trx_block_timestamp: "Max TRX Block Time",
    Activity_title_3: "Iba pang 3 Pamagat",
    GxBeidanJC_issue_num: "Inilabas na Dami",
    Entrust_source: "Source 0: Mobile Web 1: PC Web 2: Supplement",
    AgentFlowLog_order: "Numero ng Order",
    OtcAccountInfo_type: "Uri",
    LotteryType_rule_function: "Winning Rule Function",
    Activity_title_1: "Iba pang 1 Pamagat",
    FlowType_language_ch: "Tradisyunal na Tsino",
    SMS_phone: "Telepono",
    Plus_token: "Token",
    Activity_title_2: "Iba pang 2 Pamagat",
    User_md5_phone: "MD5 Encryption",
    News_aid: "Impormasyon ng Admin",
    OtcAccount_uid: "User ID",
    LotteryType_partner_ref_code: "Referral Code",
    EntrustSimulate_cancel: "Kinanselang Halaga",
    OtcTrade_fee_currency: "Pera ng Bayad",
    BetType_game_img: "Ipakita ang Larawan",
    AgentDivide_agent_real_name: "Pangalan ng Ahente",
    AgentWithdraw_balance: "Balanse",
    OtcChat_chat_content: "Record ng Chat",
    Wallet_trx_fee: "Bayarin sa Pagpalit ng TRX",
    CoinWithdraw_otc_price: "Presyo ng OTC",
    News_count: "Basahin ang Bilang",
    adminuser_update_time: "Oras ng Pag-update",
    LotteryMaxResult_start_time: "Oras ng Pagsisimula",
    CoinCurrency_c_limit_withdraw:
      "Max Araw-araw na Pagsubok sa Pag-withdraw; hindi pinapayagan ang mga withdrawal kung lumampas",
    VoucherManagement_activity_id: "Aktibidad",
    EntrustSimulate_mold: "Uri ng Operasyon 1: Bumili 2: Bumili sa Market",
    CoinRecharge_currency_id: "Currency ID",
    CoinAccount_recharge_total: "Kabuuang Halaga ng Deposito",
    BetType_rule_en: "Paglalarawan sa Ingles",
    FlowType_language_jp: "Hapon",
    DepotStop_code: "Stock Code",
    AgentManage_id: "ID",
    AgentReserve_remark: "Remarks",
    Capital_plus_fee: "Karagdagang Bayarin",
    Deal_user_number: "Dami ng Alok",
    Baseconfig_app_homegif: "APP Home GIF",
    FlowLog_mother: "Pangunahing Account ID",
    RechargeType_is_default: "Default",
    FlowLog_balance: "Natitira",
    Withdraw_staff: "Staff ID",
    LotteryType_lottery_id: "Lottery ID",
    SysConfig_otc_default_currency: "Default na Pera",
    DepotStop_delivery: "Dami ng Paghahatid",
    Depot_id: "ID",
    Withdraw_partner_name: "Pangalan sa Login ng Kasosyo",
    GXBasketballJc_createTime: "Oras ng Paglikha",
    EntrustSimulate_name: "Pangalan ng Stock",
    AgentReserve_level2: "Antas 2 na Rate ng Komisyon",
    AgentAccount_capital_total: "Halaga ng Pagpopondo",
    AgentReserve_level3: "Antas 3 na Rate ng Komisyon",
    UserSimulate_login_time: "Oras ng Pag-login",
    AgentDeferred_create_time: "Oras ng Transaksyon",
    AgentReserve_level1: "Antas 1 na Rate ng Komisyon",
    TronExchange_exchange_rate: "Exchange Rate",
    CoinWithdraw_audit_time: "Oras ng Pagproseso",
    Activity_pc_image_en: "English PC Images",
    FlowType_partner_id: "Ibang Wika 3",
    PowerInterest_ya_ggr_hsr_zf:
      "Pagtaas ng Presyo 10 Araw Pagkatapos ng Petsa ng Anunsyo (%)",
    LotteryResult_status: "Katayuan",
    AgentManage_customer_service: "Espesyalista sa Customer Service",
    Baseconfig_name: "Pangalan",
    WeekVoucherManagement_ref: "Referral",
    BetType_rule_ch: "Tradisyunal na Paglalarawan",
    BetBalance_usdt_bet_amount: "Halaga ng USDT Recharge",
    RechargeMethod_view_type: "Uri ng View",
    DealSimulate_profit_loss: "Kita at Pagkalugi",
    TimebaoBatchLog_partner_ref_code: "Referral Code ng Kasosyo",
    EMS_create_time: "Oras ng Paglikha",
    LotteryType_bet_maximum: "Pinakamataas na Halaga ng Taya",
    BetType_name: "Pangalan ng Laro",
    HomeConfig_gif_label: "Mga Ilustrasyon sa Tahanan",
    BetType_min_amount: "Pinakamababang Halaga ng Recharge",
    AgentFee_agent_fee: "Komisyon ng Ahente",
    Activity_ref_code: "Referral Code",
    DealSimulate_plus_fee: "Karagdagang Bayarin",
    AgentAccount_usdt_commission_total: "Kabuuang Komisyon ng USDT",
    VoucherManagement_capital_order: "ID ng Diskarte",
    Latest_withdraw: "Pinakabagong Pag-withdraw",
    SysConfig_sms_gateway: "SMS Gateway",
    OtcTrade_real_name: "Tunay na Pangalan",
    BetOrder_remark: "Puna",
    DepotSimulate_day_number: "Posisyon Ngayon",
    Wallet_min_trx_amount: "Min TRX Recharge Halaga",
    AgentFlowLog_agent_real_name: "Pangalan",
    UserBank_province: "Lalawigan",
    Activity_pc_image_ch: "Mga Tradisyunal na Intsik na Larawan ng PC",
    RiskControl_create_time: "Oras ng Pagkontrol sa Panganib",
    News_img: "Impormasyon ng Larawan",
    GxBasketballJCResult_halfAwayScore: "Half-time na Marka ng Away Team",
    UserAccount_first_gift: "Unang Recharge Gift Pack",
    Recharge_uid: "User ID",
    BetType_coin_key: "Naka-encrypt na Pribadong Key",
    JobLog_id: "ID",
    BetOrder_blockNumber: "Taas ng Block",
    Baseconfig_chat_link1: "Link ng Customer Service 1",
    MonthlyHistory_month: "Buwan - YYYYMM",
    CapitalLog_entrust: "Numero ng Komisyon",
    TimebaoLog_user_phone: "Telepono",
    Recharge_from_addr: "Address ng Gumagamit",
    UserAccount_trx_withdraw_fee: "Bayarin sa Pag-withdraw ng TRX",
    AgentDivide_divide: "Mutual Aid",
    UserSimulate_status: "Katayuan ng User",
    BetBalance_game_type: "Uri ng Laro",
    OtcPaymentType_name: "Pangalan",
    Lottery_name: "Paglalarawan",
    Baseconfig_app_android: "Link ng Android App",
    Common_category: "Karaniwang Kategorya",
    Baseconfig_smsplannet_url: "smsplannet_url",
    Depot_cost_total: "Natitirang Halaga",
    DepotSimulate_frozen: "Frozen na Halaga",
    UserControl_lastamount: "Turnover kahapon",
    GXBasketballJc_lotteryJCid: "Match ID",
    AgentDeferred_number: "Dami ng Transaksyon",
    UserSimulate_token: "Token",
    Withdraw_status_paymentFailed: "Matagumpay ang Withdrawal",
    GxBeidanJcResult_halfHomeScore: "Half-Time Home Team Score",
    LanguageField_content: "Nilalaman",
    OtcOrder_oper_ip: "Mag-order ng IP",
    User_staff: "Empleyado",
    WalletCollectHistory_to_address: "Collection Wallet",
    TimebaoLogType_language_zh: "Wika_zh",
    News_content: "Nilalaman",
    Capital_multiple: "Pagpopondo ng Maramihan",
    OtcOrder_lock_volume: "Naka-lock na Dami",
    DepotSimulate_code: "Stock Code",
    OtcOrder_frozen: "Nagyelo",
    UserAccount_trx_withdraw_total: "TRX Accumulated Withdrawals",
    LotteryBetList_lottery_id: "Lottery ID",
    Baseconfig_schedule_task: "Instant Treasure CRON",
    Manage_total: "Bayad sa Pamamahala",
    CoinCurrency_c_cannot_recharge_desc_cn:
      "Paglalarawan Kapag Hindi Available ang Deposit (Chinese)",
    UserSimulate_md5_phone: "MD5 Encryption",
    TronExchange_uid: "User ID",
    LotteryType_comment: "Tandaan",
    UserBank_city: "lungsod",
    FriendCouponLog_friend_uid: "Friend ID ang ginamit",
    FlowLog_remark: "Remarks",
    HomeConfig_title: "Configuration ng Homepage",
    Plus_create_time: "Oras ng Application",
    Partners_create_time: "Oras ng Paglikha",
    DepotSimulate_version: "Bersyon",
    UserAccount_user_phone: "Telepono",
    AgentManage_upagent: "Superior na Ahente",
    CapitalLog_user_real_name: "Pangalan",
    User_safety_password: "Password ng Seguridad",
    SysConfig_app_force: "App Forced Update",
    Baseconfig_third_party_sms_available: "Magagamit ang Third-Party na SMS",
    FlowLog_partner_ref_code: "Referral Code ng Kasosyo",
    Market_profit: "Profit/Los in Operation",
    Capital_code: "Code",
    JobLog_job_group: "Pangalan ng Pangkat ng Gawain",
    LotteryType_show_params: "Mga Opsyon sa Display ng JSON",
    FeeLog_mother: "ID ng Magulang na Account",
    Agent_id: "Numero",
    Baseconfig_stock_limit_volumn: "Limitahan ang Dami ng Trading",
    FlowLog_uid: "User ID",
    Baseconfig_android_app_link: "Link sa Pag-download ng Android",
    TimebaoAccount_real_name: "Remarks",
    AgentManage_create_time: "Oras ng Transaksyon",
    PowerInterest_zg_rate: "Ratio ng Conversion",
    Agent_update_time: "Oras ng Pagbabago",
    MidokeMessage_partner_ref_code: "Referral Code ng Kasosyo",
    Protocol_count: "Nilalaman",
    DepotStop_transfer: "Dami ng Paglipat",
    SysConfig_ucpass_template: "ucpass_template",
    User_agent_number: "Superior ID",
    OtcTrade_volume: "Dami ng Pagpapatupad",
    HomeConfig_route: "Daan",
    Deal_shareholder: "Impormasyon sa Shareholder",
    HomeConfig_sportgames_card_color: "Kulay ng Background ng Card",
    HomeConfig_click_upload: "I-click para mag-upload",
    OtcOrder_quote_currency: "Valuation Currency",
    CoinCurrency_c_cannot_recharge_desc_en:
      "Paglalarawan Kapag Hindi Available ang Deposit (Ingles)",
    Baseconfig_sms_url: "SMS_URL",
    Entrust_real_name: "Pangalan",
    FeeLog_uid: "User ID",
    AgentWithdraw_remark: "Remarks",
    FriendCoupon_uid: "User ID",
    HomeConfig_sportgames_card_font_color: "Kulay ng Font ng Card",
    Activity_rule_zh: "Pinasimpleng Mga Panuntunan sa Aktibidad ng Chinese",
    PowerInterest_time: "Oras ng Pag-update",
    OtcAccountHistory_uid: "ID ng Miyembro",
    TimebaoAccount_last_time: "Oras ng Pagkalkula ng Huling Interes",
    OtcChat_modify_time: "Order ID",
    EntrustSimulate_capital: "ID ng financing",
    AgentDivide_remark: "Remarks",
    InterestLog_agent_fee: "Komisyon ng Empleyado",
    Minus_user_caller: "Serbisyo sa Customer",
    ActivityLog_agent: "ID ng Ahente",
    Entrust_cancel: "Kinanselang Dami",
    Baseconfig_company_phone2: "Makipag-ugnayan sa Telepono 2",
    OtcTrade_user_real_name: "Tunay na Pangalan",
    Baseconfig_company_phone1: "Makipag-ugnayan sa Telepono 1",
    TimebaoRate_comment: "Remarks",
    UserBank_withdraw_exchange_id: "Withdraw_exchange_id",
    OtcChat_opposite_id: "ID ng Miyembro ng Counterparty",
    RechargeMethod_show_all: "Ipakita ang Lahat",
    LotteryResult_blockID: "I-block ang Hash",
    Depot_update_time: "Oras ng Pagbabago",
    TimebaoAccount_partner_id: "Partner ID",
    Baseconfig_app_home_bottom_image_1: "APP HOME BOTTOM 1",
    ActivityLog_refCode: "Reference Code",
    EntrustSimulate_source: "Source 0: Mobile Web 1: Web End 2: Supplement",
    Deal_change: "Ilipat ang Buwis",
    Lottery_status: "Katayuan",
    Language_afterfix: "Kaukulang field suffix",
    Plus_user_real_name: "Pangalan",
    Baseconfig_recharge_coupon_web_mobile:
      "I-prompt ang Mga Kaibigan na Makatanggap ng Cash Coupons (Mobile Web)",
    Baseconfig_app_home_bottom_image_6: "APP HOME BOTTOM 6",
    UserSimulate_alipay: "Alipay",
    FirstVoucher_voucher_management: "Halaga ng Bayad sa Pamamahala",
    CoinAccount_bonus_total: "Kabuuang Dami ng Gantimpala",
    DealSimulate_cost: "Presyo ng Pagbebenta",
    "Home_Unfinished_withdrawal_amount ":
      "Hindi Nakumpletong Dami ng Pag-withdraw",
    InterestLog_remark: "Remarks",
    Baseconfig_app_home_bottom_image_2: "APP HOME BOTTOM 2",
    HomeConfig_Customer_service_label: "Label ng Customer Service",
    FlowLog_user_name: "palayaw",
    Baseconfig_app_home_bottom_image_3: "APP HOME BOTTOM 3",
    Baseconfig_app_home_bottom_image_4: "APP HOME BOTTOM 4",
    Baseconfig_app_home_bottom_image_5: "APP HOME BOTTOM 5",
    UserAccount_trx_win_year: "TRX Taunang Kita",
    Plus_remark: "Recharge Remarks",
    DailyHistory_day: "Petsa",
    Recharge_exchange: "Exchange Rate",
    Capital_divided: "Ratio ng Pagbabahagi ng Kita",
    PowerInterest_notice_date: "Pinakabagong Petsa ng Anunsyo",
    AgentAccount_extra_2: "Nakareserbang Patlang 2",
    AgentAccount_extra_1: "Nakareserbang Patlang 1",
    GxBeidanJcResult_awayScore: "Score ng Koponan sa Layo",
    Minus_approve_time: "Oras ng Pag-apruba",
    Depot_day: "Mga Nasuspinde na Araw",
    OtcTrade_opposite_t_id: "Counterparty Transaction Record ID",
    Plus_partner_id: "Partner ID",
    SysConfig_tron_trx_amount: "Tron_trx_amount",
    FriendCouponLog_friend_coupon_log_type_id: "Uri ng Log",
    TimebaoLog_capital_amount: "Halaga ng Pagkalkula ng Interes",
    Agent_last_login_time: "Oras ng Pag-login",
    CoinWithdraw_create_time: "Oras ng Paggawa ng Order",
    CoinRecharge_status: "Katayuan",
    FlowLog_type: "Uri",
    FeeLog_plus_fee: "Karagdagang Bayarin",
    LotteryMax_order_id: "Numero ng Order",
    User_we_chat: "WeChat",
    FriendCoupon_status: "Katayuan",
    Baseconfig_email_smtp_host: "SMTP Server",
    Recharge_create_time: "Oras ng Pag-recharge",
    AgentWithdraw_fee: "Bayad sa Paghawak",
    SysConfig_trc20_refer_blocktime: "Oras ng Pag-block ng Sanggunian",
    RechargeMethod_sortid: "Numero ng Kategorya",
    DepotStop_sell_total: "Kabuuang Halaga ng Benta",
    PowerInterest_reporting_period: "Petsa ng Pag-uulat",
    FlowLog_partner_partner_name: "Pangalan ng Kasosyo",
    TimebaoAccount_comment: "Remarks",
    UserAccount_usdt_balance: "Kita/Pagkatalo ng USDT sa Pagtaya",
    CapitalLog_uid: "User ID",
    SysConfig_keyword: "Mga Keyword ng Site",
    UserBank_account: "May hawak ng Account",
    AgentFlowLog_upagent: "Superior Agent ID",
    Capital_profit: "Kabuuang Sub-account na Kita/Pagkawala",
    UserBank_create_time: "Oras",
    Wallet_code_key: "Susi",
    Baseconfig_smsbao_api_key: "SMS Package API_KEY",
    ActivityNotice_aid: "Impormasyon ng Administrator",
    Baseconfig_timebao_annualized_interest_rate:
      "Real-Time Treasure Taunang Rate ng Interes",
    CoinWithdrawAddr_id: "Numero",
    GxBeidanJC_bf: "Bf",
    OtcTrade_account_id: "Pagtanggap ng Account",
    FlowLog_id: "Numero",
    DepotStop_cq_cxr: "Petsa ng Ex-dividend",
    CoinCurrency_c_max_withdraw:
      "Pinakamataas na Halaga ng Pag-withdraw bawat Araw; hindi pinapayagan ang mga withdrawal kung lumampas",
    CoinWithdraw_uid: "ID ng Miyembro",
    Capital_buy_fee: "Komisyon para sa Pagbili ng Stocks",
    UserLevel_status: "Katayuan",
    UserControl_stocks: "Restricted Stock List para sa Pagbili",
    Depot_delivery: "Dami ng Pamamahagi",
    Withdraw_status_Successfully: "Tinanggihan",
    OtcOrder_version: "Bersyon",
    oldPhone: "Lumang mobile",
    UserSimulate_peizi_auth: "Awtorisasyon sa Margin Trading",
    Withdraw_audit_time: "Oras ng Pagproseso",
    CoinCurrency_auto_confirm:
      "Pinagana ang Auto Confirmation: 1 para sa pinagana, 0 para sa hindi pinagana, ang default ay 0",
    Deal_commission: "Komisyon sa pangangalakal",
    CoinWithdrawAddr_uid: "ID ng Miyembro",
    HomeConfig_header_prompt_content: "Nilalaman sa pag-download ng app",
    OtcTrade_user_phone: "Numero ng Transaksyon",
    CoinCurrency_id: "Numero",
    Baseconfig_pc_web_header_description:
      "Nilalaman ng Pangunahing Paglalarawan ng Website",
    Activity_id: "Numero",
    Parameter_content: "Data ng Diksyunaryo ng Parameter",
    Job_job_group: "Pangalan ng Pangkat ng Gawain",
    Capital_win: "Bilang ng mga Sub-account na may Kita",
    Baseconfig_is_withdraw_popup: "Paganahin ang Withdrawal Popup",
    Entrust_finish: "Nakumpletong Dami",
    EntrustSimulate_version: "Bersyon",
    AgentWithdraw_order: "Umorder",
    Withdrawal_risk_control: "Pagkontrol sa Panganib sa Pag-withdraw",
    Entrust_commission: "Komisyon",
    DealSimulate_short: "Maikling Code ng Stock",
    CoinChainType_currency: "Pangalan ng barya",
    UserAccount_voucher_cash: "Platform na Gifted Cash",
    Capital_version: "Bersyon",
    Partners_id: "Numero",
    PowerInterest_short: "Maikling Code ng Stock",
    AgentAccount_divide_total: "Mutual Commission",
    Capital_quantity: "Dami",
    CoinWithdrawAddr_partner_id: "Partner ID",
    BetType_rule_jp: "Paglalarawan ng Hapon",
    Parameter_module: "Module",
    Entrust_agent: "ID ng Ahente",
    UserCoupon_create_time: "Oras ng Pagkuha ng Cash Coupon",
    Help_create_time: "Oras ng Paglikha",
    CoinCurrency_ip: "IP ng Wallet Server",
    UserAccount_first_total: "Unang Halaga ng Recharge",
    CoinAccountDetail_partner_id: "Partner ID",
    DealSimulate_contract: "Numero ng Pagpopondo sa Kontrata",
    User_p_id: "Partner ID",
    DealSimulate_entrust: "Ipagkatiwala ang ID",
    AgentWithdraw_id: "Numero",
    Baseconfig_default_chat: "Default na Chat",
    User_status: "Katayuan ng User",
    AgentFlowLog_staff: "ID ng empleyado",
    LotteryResult_blocktimestamp: "I-block ang Timestamp",
    MonthlyHistory_user_user_name: "palayaw",
    Capital_close: "Linya ng Liquidation",
    DealSimulate_type: "Uri 0: Bumili 1: Ibenta",
    SMS_content: "Nilalaman",
    BetOrder_agent: "ID ng Ahente",
    Closure: "Bukas",
    testUserCannotWithdraw: "Hindi makumpleto ng mga test user ang KYC.",
    SysConfig_site_title: "Pangalan ng Site",
    OperatorInformation_create_time: "Oras ng Paglikha",
    UserAccount_agent: "ID ng Ahente",
    User_certified_synced: "Pag-sync ng Chat",
    Baseconfig_coupon: "User Cash Coupon (App)",
    OtcOrder_base_currency: "Base Currency",
    Entrust_depot_mold: "Mode ng Posisyon 0: A Posisyon 1: B Posisyon",
    GXBasketballJc_comp: "Home Team ID",
    Entrust_stamp: "Tungkulin ng Selyo",
    InterestLog_user_real_name: "Pangalan",
    SysConfig_filesize: "Pag-upload ng Configuration",
    MidokeMessage_create_time: "Oras ng Paglikha",
    AgentWithdraw_pay_time: "Petsa ng Pagbabayad",
    Parameter_config_extra: "Pinahabang Halaga ng Parameter",
    WeekVoucherManagement_create_time: "Oras ng Paglikha",
    AgentCommission_bet_result: "Resulta ng Laro",
    Deal_create_time: "Oras ng Transaksyon",
    DepotSimulate_interest: "Halaga ng Dibidendo Pagkatapos ng Buwis",
    Capital_sms_num: "Bilang ng Naipadalang SMS",
    LotteryMaxResult_max_result_id: "Kumpletuhin ang Resulta ID",
    Community_status: "Katayuan",
    HomeConfig_enter_notice_marquee: "Maglagay ng subtitle ng notification",
    Depot_capital_order: "Kontrata ng Diskarte",
    Minus_id: "ID",
    AgentFlowLog_from_address: "Address ng Withdrawal Wallet",
    BetOrder_recharge_time: "Oras ng Pag-recharge",
    InterestLog_mother: "ID ng Magulang na Account",
    OperatorInformation_operator_id: "Operator",
    LotteryMax_bet_win: "Panalo sa Pagsusugal",
    Entrust_change_cost: "Bayarin sa Paglipat, Gastos",
    AgentFlowLog_balance: "Natitira",
    TimebaoAccount_coin_currency_id: "Kabuuang Paglipat sa",
    GXBasketballJc_sellStatus: "SellStatus",
    Entrust_fee: "Kabuuang Bayarin",
    Activity_title: "Pamagat ng Larawan",
    CoinWithdraw_coin_addr_id: "Coin Address ID ng User",
    LotteryMax_ref_code: "Pangalan ng Kasosyo",
    Capital_create_time: "Oras ng Paglikha",
    Minus_user_name: "palayaw",
    OtcTrade_fee: "Bayad sa Pagpapatupad",
    Capital_fee: "Gastos",
    Community_id: "Numero",
    Deal_deal_time: "Oras ng Deal",
    SysConfig_trx_enabled: "Buksan ang TRX",
    BetOrder_uid: "ID ng Miyembro",
    DealSimulate_agent: "ID ng Ahente",
    Depot_status: "Katayuan",
    GxBeidanJcResult_bf: "Half-Time/Full-Time na Logro",
    AgentAccount_trx_withdraw_total: "TRX Withdrawal Halaga",
    Capital_trade_status: "Katayuan ng Transaksyon",
    OtcMerchant_user_phone: "Telepono",
    MidokeMessage_visitorid: "ID ng bisita",
    AgentAccount_usdt_commission_1: "USDT Iba Pang Komisyon",
    ActivityLog_id: "Numero",
    Current_total: "Kasalukuyang Kabuuang Asset",
    Depot_uid: "User ID",
    GxBeidanJC_id: "Numero",
    CoinAccount_transfer_total: "Kabuuang Dami ng Paglipat",
    enterAmount: "Pakilagay ang halaga",
    OtcAccountDetail_uid: "User ID",
    SysConfig_filetype: "Uri ng File",
    BetType_winning_pc_ch: "Winning_pc_ch",
    DealSimulate_uid: "User ID",
    UserAccount_usdt_win_year: "USDT Taunang Kita",
    TimebaoAccount_user_phone: "Telepono",
    FlowType_language_zh: "Pinasimpleng Chinese",
    EntrustSimulate_uid: "User ID",
    LotteryBetList_lottery_type_id: "Uri ng Lottery ID",
    Help_img: "Impormasyon sa Larawan",
    TronExchange_remark: "Puna",
    Deal_change_cost: "Bayarin sa Paglipat, Gastos",
    Capital_user_real_name: "Pangalan",
    Entrust_short: "Maikling Code ng Stock",
    FriendCoupon_amount: "Halaga",
    VoucherManagement_admin: "Operator",
    AgentCommission_bet_order_id: "Numero ng Order ng Transaksyon",
    Baseconfig_code_required: "Kailangan ng referral code",
    I118_name: "Pangalan",
    OtcOrder_name: "Palayaw ng User",
    LotteryGroup_partner_id: "Partner ID",
    UserAccount_usdt_bet_total: "Mga Buwanang Taya ng USDT",
    CoinWithdraw_coin_addr_label: "Paglalarawan ng Coin Address ng User",
    status: "Katayuan",
    RiskControl_type: "Uri ng Pagkontrol sa Panganib",
    HomeConfig_button_text: "Text ng button",
    UserAccount_usdt_recharge_fee: "Bayad sa Deposito ng USDT",
    Withdraw_pay_time: "Petsa ng Pagbabayad",
    User_card: "Numero ng ID Card",
    OtcAccount_currency: "Uri ng pera",
    Depot_buy_total: "Kabuuang Halaga ng Pagbili",
    OtcAccountDetail_create_time: "Oras ng Transaksyon",
    CoinRecharge_uid: "ID ng Miyembro",
    ExchangeRate_id: "Numero",
    Job_invoke_target: "Tawagan ang Target String",
    AgentAccount_user_server_total: "Bayad sa Serbisyo",
    CoinWithdraw_otc_ads_id: "OTC Advertisement ID",
    UserAccount_profit_multiple: "Multiplier ng Kita",
    LotteryBetList_win_number: "Bilang ng Mga Panalong Ticket",
    OtcAccountDetail_id: "Numero",
    AgentFee_times: "Mga oras",
    GxBeidanJC_comp_id: "Compound Number",
    PowerInterest_szz_rate: "Kabuuang Bonus at Transfer Shares Ratio",
    AgentDivide_mother: "Ina Account",
    Information_id: "Numero",
    UserSimulate_safety_password: "Password ng Seguridad",
    bonusRedeemAfter:
      "Mare-redeem ang bonus pagkatapos ng {turnOver}x rollover",
    Agent_user_team: "Bilang ng mga Gumagamit",
    AgentAccount_push_total: "Bayad sa Pag-promote",
    UserAccount_trx_bet_total: "TRX Kabuuang Taya",
    Baseconfig_app_tab1: "Menu ng APP 1",
    BetType_name_1: "Iba pa 1 Pangalan",
    Baseconfig_app_tab2: "Menu ng APP 2",
    BetType_name_3: "Iba pang 3 Pangalan",
    GxBeidanJC_jq: "Jq",
    UserSimulate_activity1: "Gawain 1",
    BetType_name_2: "Iba pang 2 Pangalan",
    SysConfig_ucpass_token: "ucpass token",
    Partners_status: "Katayuan",
    Baseconfig_app_tab3: "Menu ng APP 3",
    Baseconfig_register_create_agent: "Magrehistro ng Ahente",
    Withdraw_version: "Bersyon",
    SysConfig_password_attempt_time: "Oras ng Pagtatangka ng Password",
    GxBasketballJCResult_comp: "Pangalan ng Tugma",
    EntrustSimulate_change: "Ilipat ang Buwis",
    fullTurnoverRequirement: "Buong withdrawal rollover na kinakailangan",
    UserSimulate_certified_time: "Oras ng Pagpapatunay ng Tunay na Pangalan",
    OtcAccountInfo_account: "Account Number",
    BetType_rule_pc_zh: "Rule_pc_zh",
    BetType_amount_pc_en: "Halaga_pc_en",
    Capital_clear_time: "Oras ng Settlement",
    SysConfig_trongrid_url: "Mahabang URL",
    OtcMerchant_create_time: "Oras ng paglikha",
    Minus_caller: "Serbisyo sa Customer",
    VoucherManagement_uid: "User ID",
    OtcOrder_max_quote:
      "Pinakamataas na Halaga ng Transaksyon ng Currency ng Pagpapahalaga (Dami ng Currency ng Pagpapahalaga). Direktang itinakda kapag gumagawa ng limit order.",
    OtcOrder_uid: "User ID",
    UserAccount_mother: "ID ng Magulang na Account",
    Baseconfig_aboutus_banner: "Tungkol sa Amin Cover Image",
    TronExchange_partner_id: "Partner_id",
    FriendCouponLog_id: "Numero",
    FirstVoucher_amount: "Antas",
    AgentFlowLog_number: "Dami",
    OtcOrder_user_name: "Palayaw ng User",
    FriendCoupon_approve_time: "Oras ng Pag-isyu ng Platform",
    User_midoke_session_id: "Kumperensya ng Medoc",
    DealSimulate_finish: "Nakumpletong Dami",
    Baseconfig_app_version: "Numero ng Bersyon ng APP",
    FlowLog_number: "Dami",
    Job_job_name: "Pangalan ng Gawain",
    CoinCurrency_recharge_open_time: "Oras ng Pagbubukas ng Deposito",
    CoinRecharge_phone: "Telepono",
    SysConfig_register_agent_template: "Template ng Pagbabahagi ng Kita",
    DepotSimulate_profit_loss: "Kasalukuyang Kita at Pagkalugi",
    AgentDeferred_remark: "Remarks",
    Plus_total: "Aktwal na Halaga",
    OtcAccount_total_balance: "Kabuuang balanse",
    CoinChainType_status: "Katayuan",
    UserAccount_staff: "ID ng Magulang na Account",
    User_certified_time: "Oras ng Pagpapatunay ng Tunay na Pangalan",
    AgentFee_number: "Dami",
    CoinAccountDetail_coin_flow_type: "Uri ng Transaksyon",
    Depot_user_phone: "Numero ng Telepono",
    AgentAccount_mutual_capital: "Mutual Aid Financing",
    UserAccount_account_type: "Uri ng Account",
    Agent_domain: "Impormasyon ng Domain",
    EMS_event: "Kaganapan",
    CoinCurrency_lock_release_time: "Tagal ng Paglabas sa ilang minuto",
    AgentReserve_cumlRecharge_label: "Pinagsama-samang Recharge",
    TronExchange_operator: "nagbabayad",
    Baseconfig_ios_app_link: "Link sa Pag-download ng iOS",
    User_remark: "Remarks",
    UserSimulate_vip: "Antas ng VIP",
    LotteryMaxResult_blockID: "Block Number",
    PowerInterest_results_by_date: "Ibahagi ang Petsa ng Pagpaparehistro",
    EntrustSimulate_depot_mold: "Mode ng Posisyon 0: A Posisyon 1: B Posisyon",
    UserSimulate_push_team: "Direktang Referral Team",
    LotteryType_example_1: "Iba pang Halimbawa 1",
    SysConfig_ucpass_url: "ucpass URL",
    LotteryType_example_2: "Iba pang Halimbawa 2",
    LotteryType_example_3: "Iba pang Halimbawa 2",
    CoinRechargeAddr_chain_name: "Pangalan ng Public Chain",
    DealSimulate_surplus: "Natitirang Dami",
    RechargeType_sortid: "Pag-uuri",
    SysConfig_usdt_enabled: "Buksan ang USDT",
    DailyHistory_trx_result: "TRX Win/Los Record",
    AgentFlowLog_fee: "Bayad",
    User_reid: "Referrer",
    Depot_short: "Maikling Code ng Seguridad",
    Recharge_staff: "ID ng empleyado",
    availableAmount: "Magagamit na Balanse",
    Recharge_account: "I-recharge ang account.",
    Plus_type: "Uri ng Recharge",
    User_is_trade_channel_agree: "Kasunduan sa Trading Channel",
    AgentFlowLog_agent: "ID ng Ahente",
    Capital_increase_capital: "Karagdagang Margin Trading",
    GxBeidanJcResult_matchTime: "Oras ng Pagtutugma",
    GxBeidanJC_home_id: "Home ID",
    LanguageField_table_name: "Pangalan ng Talahanayan",
    Parameter_type: "Uri ng Parameter",
    BetOrder_blocktimestamp: "I-block ang Timestamp",
    FoundWinners_stock_status: "Katayuan ng Stock",
    AgentCommission_txid: "Transaksyon HASH",
    ActivityLog_user_real_name: "Pangalan",
    Activity_partner_id: "Partner ID",
    Wallet_max_trx_amount: "Maximum TRX Recharge Halaga",
    BetType_amount_pc_jp: "Halaga_pc_1",
    Depot_name: "Pangalan ng Seguridad",
    CoinWithdraw_otc_volume: "Dami ng OTC",
    DepotStop_capital: "ID ng financing",
    Withdraw_callback: "URL ng callback",
    User_name: "palayaw",
    OtcMerchant_vip:
      "VIP ranking, default sa 0 para sa non-VIP, mas mataas ang ranggo ng value sa mga order",
    OtcOrder_min_quote:
      "Pinakamababang Halaga ng Transaksyon ng Currency ng Pagpapahalaga (Dami ng Currency ng Pagpapahalaga). Direktang itinakda kapag gumagawa ng limit order.",
    Deal_staff: "ID ng empleyado",
    Help_id: "Numero",
    Baseconfig_company_address: "Address ng Kumpanya",
    Community_ref_code: "Reference Code",
    GxBeidanJcResult_id: "Numero",
    Withdraw_status_pending: "Naaprubahan",
    Entrust_price: "Presyo ng Deal",
    myBalance: "Ang balanse ko",
    Recharge_user_caller: "Serbisyo sa Customer",
    AgentAccount_trx_account: "Magagamit na Balanse ng TRX",
    MonthlyHistory_trx_extra_1: "TRX Reserve 1",
    Plus_status: "Katayuan: 0 - Aplikasyon, 1 - Naaprubahan, 2 - Tinanggihan",
    CoinWithdraw_transaction_id: "ID ng Transaksyon",
    TronExchange_from_address: "Address ng User Wallet",
    LotteryMaxResult_blocktime: "Oras ng Pag-block",
    RechargeMethod_name: "Pangalan",
    AgentAccount_usdt_withdraw_total: "Halaga ng Pag-withdraw ng USDT",
    "Home_Transaction_fee_income_day ": "Kita sa Trading Fee para sa Araw",
    OtcOrder_remain_volume: "Nai-tradable na Dami, katulad ng volume",
    TimebaoAccount_withdrawamount: "Kabuuang Withdrawal",
    DealSimulate_code: "Stock Code",
    Baseconfig_sys_agent_voucher: "Voucher ng Komisyon ng Ahente",
    HomeConfig_menu_text: "Teksto ng menu",
    HomeConfig_background_color: "Kulay ng background",
    AgentFlowLog_bet_type_id: "Uri ng Laro",
    Activity_rule_jp: "Mga Panuntunan sa Aktibidad ng Hapon",
    Finance_amount: "Regular na Kayamanan",
    DepotStop_give: "Dami ng Regalo",
    AgentFee_remark: "Remarks",
    SysConfig_mail_smtp_auth: "Email SMTP Verification",
    BetOrder_txid: "Transaksyon HASH",
    AgentFlowLog_txid: "HASH",
    DealSimulate_shareholder: "Impormasyon sa Shareholder",
    AgentFlowLog_mold: "Taasan/Bawasan",
    selecPayTypePlaceholder: "Pumili ng uri ng suweldo",
    Capital_price: "Presyo",
    HomeConfig_second_tab: "Pangalawang tab",
    HomeConfig_benefits_label: "Mga benepisyo sa pagpaparehistro",
    Minus_create_time: "Oras ng Application",
    UserSimulate_photo: "Larawan ng Authentication",
    LotteryBetList_blockNumber: "Taas ng Block",
    LanguageField_code: "Wika ng Paggamit",
    FlowType_id: "Numero",
    Depot_cancel: "Kinanselang Dami",
    FoundWinners_high_time: "Pinakamataas na Oras ng Presyo",
    CoinRecharge_guiji: "Kung Magsasama-sama",
    AgentAccount_wit_total: "Halaga ng Pag-withdraw",
    HomeConfig_marquee_label: "Text ng notification",
    EntrustSimulate_create_time: "Oras ng Order",
    Baseconfig_sys_agenturl: "URL ng Ahente ng System",
    Baseconfig_app_app: "Pag-download ng Apple/Android",
    GxBasketballJCResult_matchId: "Match ID",
    RechargeType_view_type: "Uri",
    OtcAccount_phone: "Telepono",
    Recharge_agent: "ID ng Ahente",
    TimebaoBatchLog_comment: "Remarks",
    SysConfig_water_position: "Posisyon ng Watermark",
    TimebaoAccount_isautoinout: "1 Awtomatikong Paglipat In/Out 0 Manual",
    Baseconfig_recharge_popup_image_pc:
      "Imahe ng PC para sa Mga Detalye ng Notification na Non-Recharge",
    PowerInterest_yag_gr: "Petsa ng Anunsyo",
    UserAccount_user_number: "Address ng Wallet",
    SysConfig_lottery_wait_second:
      "Mga Segundo ng Oras ng Pagpapanatili ng Taya",
    InterestLog_capital_order: "Kontrata ng Diskarte",
    FriendCouponLog_user_phone: "Telepono",
    CoinRecharge_currency_chain_type: "Uri ng Kadena ng Barya",
    Depot_cash: "Pamamahagi ng Dividend",
    GxBasketballJCResult_awayScore: "Score ng Koponan sa Layo",
    VoucherManagement_amount: "Halaga",
    LotteryCategory_id: "Numero",
    RechargeMethod_pay_provider_config:
      "Configuration ng Provider ng Pagbabayad",
    CoinChainType_generate_address: "Katayuan ng Paglalaan ng Address",
    Capital_buy_stock: "Bumili ng Stocks",
    FlowLog_partner_id: "Partner ID",
    DepotSimulate_agent: "ID ng Ahente",
    Baseconfig_tron_trx_amount: "TRC20 Transaksyon TRX Dami",
    Plus_from_amount: "Orihinal na Halaga",
    AgentFlowLog_order_id: "Numero ng Order",
    CoinRecharge_remark: "Remarks Paliwanag",
    User_mother: "ID ng Magulang na Account",
    News_status: "Katayuan ng Balita",
    Baseconfig_logo: "Logo ng Site",
    EntrustSimulate_type: "Uri 0: Bumili 1: Ibenta",
    TronExchange_agent: "ID ng Ahente",
    GXBasketballJc_status: "Katayuan",
    CapitalLog_id: "Numero",
    RechargeType_name: "Pangalan",
    OtcOrder_price: "Presyo",
    Baseconfig_otc_merchat_deposit_amount: "Halaga ng Deposito",
    DealSimulate_staff: "ID ng empleyado",
    Depot_give: "Dami ng Regalo",
    UserControl_stock_value_market: "Umiikot na Halaga sa Pamilihan",
    ActivityLog_status: "Katayuan: 1 Nabayaran, Aplikasyon | 0, 2 Tinanggihan",
    RiskControl_id: "Numero",
    Capital_update_time: "Oras ng Pag-update",
    HomeConfig_sportgames_card: "Match Information Card",
    UserCoupon_cashed_date: "Petsa ng Cash-out",
    OtcMerchant_phone: "Telepono",
    DepotStop_version: "Bersyon",
    LotteryMax_status: "Katayuan",
    BetType_winning_pc_jp: "Winning_pc_jp",
    Help_status: "Katayuan",
    Community_image: "Imahe",
    CoinAccount_user_phone: "Telepono",
    navUpdateWithdraw: "I-update ang Setting ng Withdraw",
    Lottery_sort: "Pag-uuri",
    LotteryResult_start_time: "Simulan ang Oras ng Pagtaya",
    Baseconfig_pay_ali_isactive: "Koleksyon ng Alipay",
    BetType_rule_zh: "Paglalarawan ng Tsino",
    Baseconfig_chat_token: "TOKEN ng Customer Service",
    UserControl_lastvolumn: "Dami ng Trading Kahapon",
    LotteryResult_bet_loss: "Halaga ng Pagkawala ng User",
    OtcOrder_remark: "Mensahe ng Order",
    AgentDivide_agent_phone: "Numero ng Telepono ng Ahente",
    UserSimulate_bank: "Nakatali sa Bangko",
    CoinRechargeAddr_address: "Kaugnay na Address ng Pera",
    Baseconfig_app_force: "Sapilitang Pag-update ng APP",
    LotteryGroup_partner_name: "Pangalan ng Kasosyo",
    UserSimulate_caller: "Espesyalista sa Customer Service",
    CoinCurrency_is_lock:
      "Pinagana ang Deposit Locking: 1 para sa oo, 0 para sa hindi",
    Language_simple_code: "Pagpapaikli ng wika",
    InterestLog_times: "Bilang ng Bayarin",
    AgentFlowLog_bet_amount: "Dami ng taya",
    SysConfig_app_version: "Numero ng Bersyon ng App",
    Community_create_time: "Nilikhang Oras",
    Information_status: "Katayuan",
    UserAccount_usdt_extra_2: "USDT Spare Field 2",
    RsaKey_partner_id: "palayaw",
    UserAccount_usdt_extra_1: "USDT Spare Field 1",
    LotteryResult_id: "Numero",
    LotteryBetList_uid: "User ID",
    Wallet_min_trx_block_timestamp: "Minimum na TRX Block Time",
    TronExchange_to_address: "Address ng Receipt Wallet",
    AgentFee_create_time: "Oras",
    FeeLog_number: "Dami ng pangangalakal",
    MonthlyHistory_usdt_win_total: "Halaga ng Panalo ng USDT",
    InterestLog_uid: "User ID",
    Recharge_time: "Oras ng Deposito",
    GxBeidanJcResult_away: "Pangalan ng Away Team",
    GXBasketballJc_matchTime: "Katayuan ng Benta",
    FriendCoupon_create_time: "Oras ng Paglikha",
    AgentWithdraw_number: "Halaga",
    Baseconfig_android_download: "Pag-download ng Android",
    Job_remark: "Mga Tala",
    Parameter_extend: "Mga Katangian ng Extension ng Parameter",
    LotteryBetList_bet_money: "Halaga ng taya",
    Baseconfig_sms_gateway: "Default na SMS",
    BetType_max_amount: "Pinakamataas na Halaga ng Recharge",
    HomeConfig_add_copyright_image: "Magdagdag ng copyright na larawan",
    BetType_rule_pc_ch: "Rule_pc_ch",
    Activity_pc_image_zh: "Pinasimpleng Chinese PC Images",
    UserAccount_usdt_extra_3: "Mga Resulta ng Panalo/Pagkakatalo ng USDT",
    DealSimulate_extra_fee2: "Mga Bayad sa Settlement",
    DealSimulate_extra_fee3: "Mga Bayarin sa Platform",
    DealSimulate_extra_fee1: "Bayarin sa Paghawak ng Produkto",
    User_sms_status: "Katayuan ng SMS",
    CoinRechargeAddr_update_time: "Oras ng Pag-update",
    UserAccount_usdt_payback_total: "Kabuuang Mga Refund ng USDT",
    AgentFlowLog_ref_code: "Referral Code",
    MidokeMessage_id: "Numero",
    Plus_number: "Halaga ng Recharge",
    DepotStop_cash: "Pamamahagi ng Dividend",
    BetType_winning_pc_en: "Winning_pc_en",
    UserBank_id: "ID",
    CoinWithdraw_remark: "Paglalarawan ng Coin Transfer ng Platform",
    AgentCommission_total_commission: "Kasalukuyang Komisyon",
    Deal_stamp: "Tungkulin ng Selyo",
    RiskControl_agent: "ID ng Ahente",
    AgentFlowLog_create_time: "Oras",
    TimebaoLog_endtime: "Oras ng Pagtatapos ng Interes",
    VoucherManagement_user_real_name: "Pangalan",
    availableToWithdraw: "Magagamit para mag-withdraw",
    DepotSimulate_short: "Pagpapaikli ng Stock",
    OtcOrder_is_ads: "Ay Advertisement",
    BetType_admin_sort: "Kategorya",
    FriendCoupon_user_user_friend_name: "Pangalan ng Kaibigan",
    SysConfig_tron_api_key: "Tron_api_key",
    AgentFlowLog_agent_number: "Account ng Ahente",
    WeekVoucherManagement_type: "Uri ng Voucher",
    TimebaoBatchLog_endtime: "Oras ng Pagtatapos ng Interes",
    AgentFlowLog_name: "palayaw",
    Depot_number: "Bilang ng mga Stock",
    Baseconfig_mail_username: "Email Username",
    UserCoupon_user_phone: "Telepono",
    AgentDeferred_mother: "Ina Account",
    LotteryType_id: "Numero",
    DepotStop_profit_loss: "Kasalukuyang Kita at Pagkalugi",
    UserSimulate_qq: "Impormasyon sa QQ",
    AgentFee_type: "Natitirang Uri",
    PowerInterest_gq_djr_qsr_zf:
      "Pagtaas ng Presyo 10 Araw bago ang Petsa ng Pagpaparehistro ng Bahagi (%)",
    User_agent_phone: "Superior na Numero ng Telepono",
    SysConfig_mail_password: "Email Password",
    UserControl_create_time: "Oras",
    HomeConfig_rates_label: "Mga presyo ng stock",
    gameRoomName: "Pangalan ng kwarto ng laro",
    PowerInterest_project_progress: "Planuhin ang Pag-unlad",
    DepotStop_interest: "Halaga ng Pamamahagi ng Dividend Pagkatapos ng Buwis",
    CoinWithdrawAddr_addr_label: "Label ng Address",
    CategoryList_main_category_id: "Pangunahing Kategorya ID",
    DailyHistory_usdt_bet_total: "USDT Kabuuang Halaga ng Taya",
    RsaKey_private_key: "Pribadong Susi",
    EMS_code: "Code",
    Agent_staff_team: "Koponan ng Empleyado",
    BetType_rule_pc_en: "Rule_pc_en",
    UserBank_wallet_address: "Wallet_address",
    Baseconfig_sys_aboutus: "Tungkol sa Amin",
    VoucherManagement_user_phone: "Numero ng Telepono",
    AgentManage_balance: "Balanse",
    LotteryMaxResult_result: "Resulta",
    Agent_encrypt_phone: "I-encrypt ang Mobile Number",
    Rejected: "Di-wasto ang duplicate na code.",
    OtcMerchant_user_real_name: "Tunay na Pangalan",
    FeeLog_contract: "Numero ng Kontrata",
    AgentFee_capital: "ID ng financing",
    UserSimulate_update_time: "Oras ng Pagbabago",
    LotteryBetList_id: "Numero",
    First_Trans_red_total: "Trading Red Envelope",
    InterestLog_create_time: "Oras ng Paglikha",
    RechargeMethod_id: "Numero",
    Deal_fee: "Komisyon sa pangangalakal",
    LotteryMax_end_time: "Oras ng Pagtatapos",
    MonthlyHistory_partner_name: "Pangalan sa Login ng Kasosyo",
    EntrustSimulate_finish: "Nakumpletong Dami",
    AgentFlowLog_mother: "Inang Account ID",
    DealSimulate_sell_total: "Kabuuang Halaga ng Benta",
    TimebaoLog_start_time: "Oras ng Pagsisimula ng Interes",
    Withdraw_bank_address: "Sangay",
    Wallet_usdt_min_amount: "Minimum na USDT",
    AgentManage_uid: "User ID",
    Partners_token: "Token",
    Wallet_total: "Lahat",
    FirstVoucher_peizi_amount: "Halaga ng Pananalapi",
    BetOrder_bet_amount: "Halaga ng taya",
    TimebaoLog_comment: "Remarks",
    Baseconfig_ucpass_template: "Yunxin Single Send Template",
    AgentFee_mother: "Inang Account ID",
    TronExchange_status:
      "Uri: 0 para sa Nakabinbing Exchange, 1 para sa Exchange na Matagumpay, 2 para sa Exchange Nabigo",
    GxBasketballJCResult_lqDxf: "Over/Under",
    Help_banner: "Banner",
    CoinRecharge_user_phone: "Telepono",
    News_banner: "Default na Mga Setting ng Bandar",
    TronExchange_from_txid: "Transaksyon ng Resibo HASH",
    AgentFlowLog_remake: "Remarks",
    FlowLog_user_phone: "Makipag-ugnayan sa Telepono",
    OtcMerchant_real_name: "Tunay na pangalan",
    OperatorInformation_json_text: "Baguhin ang Nilalaman",
    GxBeidanJcResult_awayId: "Away Team ID",
    DepotSimulate_staff: "ID ng empleyado",
    MidokeMessage_msgtype: "Uri ng Mensahe",
    Capital_sell_fee: "Komisyon para sa Pagbebenta ng mga Stock",
    VoucherManagement_remark: "Remarks",
    AgentAccount_trade_plus: "Trading Surcharge",
    MidokeMessage_content: "Nilalaman",
    DepotSimulate_mother: "ID ng Ina Warehouse",
    AgentManage_vouchers: "Voucher",
    User_checkin_count: "Bilang ng tseke",
    Withdraw_uid: "ID ng Miyembro",
    Depot_fee_total: "Kabuuang Bayarin",
    CoinRecharge_amount: "Halaga ng Deposito",
    TimebaoLog_amount: "Halaga",
    DealSimulate_stamp: "Tungkulin ng Selyo",
    DepotStop_user_real_name: "Pangalan",
    GxBeidanJC_away_id: "Mag-iwan ng ID",
    UserSimulate_phone: "Numero ng Telepono",
    TimebaoAccount_nextinitialcapital: "Susunod na Effective Capital",
    OtcAccountDetail_number: "Dami",
    Depot_agent: "ID ng Ahente",
    PowerInterest_gq_djr: "Ibahagi ang Petsa ng Pagpaparehistro",
    Agent_create_time: "Oras ng Pagpaparehistro",
    CoinCurrency_is_in_eth: "Inilabas man sa ilalim ng Ethereum Architecture",
    CoinRecharge_otc_owner_name: "Pangalan ng Counterparty sa OTC",
    CoinWithdraw_user_name: "palayaw",
    OperatorInformation_controller_name: "Pangalan ng Module",
    DealSimulate_change_cost: "Bayarin sa Paglipat, Gastos",
    OtcAccountInfo_update_time: "Oras ng Pagbabago",
    BetOrder_id: "Numero",
    LotteryCategory_name_2: "Iba pa 2",
    UserSimulate_app_version: "Bersyon ng App",
    LotteryCategory_name_3: "Iba pa 3",
    LotteryCategory_name_1: "Iba 1",
    LotteryCategory_name: "Paglalarawan",
    CoinWithdrawAddr_currency: "Pera",
    CoinChainType_partner_partner_name: "Pangalan ng Kasosyo",
    LotteryCategory_ref_code: "Referral Code",
    FlowType_partner_partner_id: "Partner ID",
    CoinAccount_uid: "User ID",
    CoinRecharge_otc_oppsite_currency: "Counterparty Coin Type sa OTC",
    SysConfig_ip_white: "IP Whitelist",
    LotteryBetList_blockID: "I-block ang Hash",
    "Home_First_deposit_amount_day ": "Unang Halaga ng Deposito para sa Araw",
    Wallet_bet_type_id: "Uri ng Laro",
    HomeConfig_enter_app_download_subtitle: "Maglagay ng subtitle",
    TimebaoBatchLog_create_time: "Oras",
    voice: "Boses",
    SMS_name: "Pangalan ng SMS",
    OtcAccountInfo_name: "Pangalan",
    HomeConfig_app_download_logo: "Logo ng pag-download ng app",
    LotteryBetList_bet_data_show: "Mga Pagpipilian sa Pagtaya",
    Depot_profit_loss: "Kasalukuyang Kita at Pagkalugi",
    BetOrder_paid_txid: "Ibalik ang Transaksyon HASH",
    CoinAccount_partner_id: "Partner_id",
    RiskControl_staff: "ID ng empleyado",
    descending: "Pababa",
    AgentDivide_vouchers: "Voucher",
    SysConfig_logo: "Logo ng Site",
    LotteryMaxResult_partner_id: "Katayuan",
    Parameter_create_time: "Oras ng Paglikha",
    MidokeMessage_contenttype: "Uri ng Nilalaman",
    Help_aid: "Tulong",
    DealSimulate_deal: "Bilhin ang Presyo",
    OtcTrade_payment_time: "Deadline ng Pagbabayad",
    TimebaoRate_rate1: "Rate 1",
    TimebaoRate_rate3: "Rate 3",
    Activity_type: "Uri ng Aktibidad",
    Deal_Turnover: "Turnover",
    TimebaoRate_rate2: "Rate 2",
    Capital_ratio: "Rate ng Bayad sa Rollover",
    BetType_rule_pc_jp: "Rule_pc_jp",
    Deal_short: "Maikling Code ng Stock",
    OtcOrder_status: "Katayuan ng Order",
    OtcOrder_remain: "Natitirang Tradable Volume",
    User_bindwechat: "Nakatali sa Public Account",
    TronExchange_to_txid: "Transaksyon ng Pagbabayad HASH",
    Baseconfig_sms_merchant: "Tagabigay ng SMS",
    DepotStop_name: "Pangalan ng Stock",
    DepotSimulate_sell_total: "Kabuuang Halaga ng Pagbebenta",
    LotteryType_lottery_category_id:
      "Lottery Gameplay Classification ID - Direktang Pagpili, Iisang Pinili, Kumbinasyon, Pagpoposisyon, Hindi Pagpoposisyon, Pagpoposisyon ng Tapang",
    I118_language_03: "Iba pa 3",
    I118_language_04: "Iba pa 4",
    UserBank_refer_to: "Sumangguni_sa",
    I118_language_01: "Iba 1",
    I118_language_02: "Iba pa 2",
    Depot_staff: "ID ng empleyado",
    Entrust_staff: "ID ng empleyado",
    Withdraw_type: "Uri",
    OtcTrade_done_time: "Oras ng Pagkumpleto",
    GXBasketballJc_updateAt: "Lokal na Oras ng Pag-update",
    I118_language_05: "Iba pa 5",
    I118_language_06: "Iba pa 6",
    AgentAccount_activity_capital: "Pagpopondo ng Aktibidad",
    Deal_finish: "Nakumpletong Dami",
    TimebaoLogType_partner_ref_code: "Reference Code ng Kasosyo",
    CoinAccountDetail_user_phone: "Numero ng Telepono",
    Lottery_game_type: "Uri ng Laro",
    TimebaoAccount_partner_partner_name: "Pangalan ng Kasosyo",
    Lottery_time_interval: "Larawan 3",
    Wallet_partner_name: "Pangalan ng Kasosyo",
    GxBeidanJcResult_deleteStatus: "Tanggalin ang Katayuan",
    CoinCurrency_sendamount: "Minimum na Halaga para sa Pagsasama-sama",
    TimebaoLog_capitalamount: "Halaga ng Interes",
    LotteryCategory_partner_id: "Partner ID",
    LotteryType_lottery_group_id: "Maglaro ng Grupo",
    DealSimulate_change: "Ilipat ang Buwis",
    OtcAccount_version: "Bersyon",
    FriendCoupon_register_date: "Petsa ng Paggamit ng Kaibigan",
    Deal_agent_real_name: "Pangalan",
    FeeLog_total: "Halaga ng kalakalan",
    AgentFlowLog_remark: "Remarks",
    InterestLog_balance: "Balanse ng Account",
    Net_recharge: "Net Recharge",
    Entrust_number: "Dami ng Order",
    UserSimulate_password: "Password",
    Baseconfig_keyword: "Mga Keyword ng Site",
    UserVip_amount: "Halaga ng Recharge",
    Capital_interest: "Halaga ng Rollover Fee",
    GxBeidanJC_match_id: "Numero ng Tugma",
    GxBasketballJCResult_compId: "Itugma ang Group ID",
    CoinCurrency_can_withdraw: "Availability ng Withdrawal",
    Lottery_comment: "Tandaan",
    UserSimulate_ip: "IP ng pagpaparehistro",
    EntrustSimulate_code: "Stock Code",
    LotteryBetList_blocktime: "Block Time",
    DepotStop_cost_total: "Natitirang Halaga ng Gastos",
    OtcTrade_old_status: "Katayuan ng Lumang Transaksyon",
    OtcTrade_status: "Katayuan ng Transaksyon",
    Parameter_config_name: "Pangalan ng Parameter",
    DailyHistory_uid: "Pagkakakilanlan ng Gumagamit",
    BetType_tie_rate: "Tie Return Multiple",
    Baseconfig_timebao_time_point: "Real-Time na Treasure Execution Time",
    LotteryBetList_ref_code: "Referral Code",
    User_user_account_rec_total: "Kabuuang Halaga ng Recharge",
    ActivityLog_partner_id: "Partner ID",
    CoinWithdraw_status: "Katayuan",
    BetType_amount_pc_zh: "Halaga_pc_zh",
    Agent_name: "Login Password",
    DepotSimulate_status: "Katayuan ng Stock",
    User_user_account_account: "Balanse ng Account",
    OtcAccountDetail_otc_flow_type: "Uri ng Transaksyon",
    GxBeidanJcResult_issueNum: "Numero ng Isyu",
    UserSimulate_id: "Numero",
    Help_content: "Nilalaman",
    Activity_time: "Petsa ng Paglikha",
    FriendCouponLog_uid: "User ID",
    Parameter_config_type: "Uri ng Parameter",
    UserAccount_recharge_total: "Mga Naipon na Deposito",
    LotteryType_sample_rule_en: "Simple English Rule",
    UserVip_average: "Buwanang Average na Halaga",
    RechargeMethod_isdefault: "Ay Default",
    Job_job_id: "Numero",
    WalletCollectHistory_create_time: "Timestamp",
    CoinChainType_partner_ref_code: "Referral Code ng Kasosyo",
    OtcChat_is_read: "Basahin ang Katayuan",
    CoinAccount_available_balance: "Magagamit na Balanse para sa Trading",
    VoucherManagement_type: "Uri",
    WeekVoucherManagement_approved_by: "Approver",
    OtcAccountDetail_balance: "Balanse Pagkatapos ng Transaksyon",
    Agent_agent_team: "Koponan ng Ahente",
    TimebaoLog_partner_ref_code: "Referral Code ng Kasosyo",
    AgentManage_agent_agent_name: "Pangalan ng Ahente",
    Baseconfig_stock_image: "Stock Image",
    target_rolloverMin: "Mag-scroll pababa",
    AgentDivide_id: "Numero",
    Baseconfig_password_attempt_time: "Oras ng Pagtatangka ng Password",
    HomeConfig_copyright: "Copyright",
    ActivityLog_user_name: "palayaw",
    OtcOrder_user_phone: "Telepono",
    OtcMerchant_remark: "Remarks",
    RiskControl_mother: "Inang Account ID",
    TimebaoAccount_total_amount: "Kabuuang Paglipat sa",
    WeekVoucherManagement_balance: "Balanse",
    UserAccount_usdt_loss_total: "Kabuuang Pagkalugi ng USDT",
    WeekVoucherManagement_status: "Katayuan",
    DepotStop_uid: "User ID",
    SysConfig_id: "Numero",
    GxBasketballJCResult_halfHomeScore: "Half-Time Home Team Score",
    CapitalLog_mother: "Impormasyon ng Inang Account",
    LotteryBetList_user_name: "palayaw",
    HomeConfig_sportgames_card_bg_color: "Kulay ng Background ng Card",
    Agent_password: "Login Password",
    TimebaoLogType_id: "Numero",
    Baseconfig_tron_api_key: "Tron_Api_key",
    OtcOrder_effective_time: "Panahon ng Bisa ng Order, sa mga araw",
    Capital_change: "Bayarin sa Paglipat",
    Baseconfig_recharge_popup_image_mob:
      "Larawan ng APP para sa Mga Detalye ng Notification na Non-Recharge",
    Baseconfig_email_smtp_auth_starttls_enable: "Suportahan ang STARTTLS",
    CoinAccount_interest_total: "Kita sa Interes",
    Partners_password: "Password",
    EntrustSimulate_stamp_cost: "Halaga ng Stamp Duty",
    KYCDetailsNeedToUpdate:
      "Kailangan ang KYC verification bago ka makapag-withdraw.",
    UserAccount_sms_time: "Oras ng Pagpapadala ng SMS",
    Withdraw_user_real_name: "Pangalan",
    User_caller: "Espesyalista sa Customer Service",
    UserAccount_my_coupon: "Kabuuang Aking Mga Kupon sa Cash",
    Agent_bank_address: "Sangay ng Pagbubukas ng Account",
    OtcAccount_id: "Numero",
    Depot_price: "Presyo ng Gastos",
    ExchangeRate_status: "Exchange Rate",
    Wallet_max_block_timestamp: "Pinakamataas na USDT Block Time",
    Withdraw_wallet_address: "Address ng Wallet",
    Depot_mother: "ID ng Magulang Warehouse",
    Recharge_status_Moderated: "Matagumpay na Mag-recharge",
    WeekVoucherManagement_approved_time: "Petsa ng Pag-apruba",
    BetType_max_trx_amount: "Maximum TRX Recharge Halaga",
    LotteryType_sample_rule_ch: "Simpleng Tradisyonal na Panuntunang Tsino",
    BetType_remark: "Tandaan",
    ActivityNotice_id: "Numero",
    Baseconfig_timebao_status: "Gumamit ng Real-Time na Kayamanan?",
    LotteryGroup_id: "Numero",
    UserAccount_reid: "Referrer ID",
    SysConfig_smsplannet_url: "URL ng Network ng Short Message Planning",
    LotteryGroup_status: "Katayuan",
    close: "Isara",
    TimebaoAccount_interestthis: "Interes sa Kasalukuyang Buwan",
    Capital_status: "Katayuan ng Pananalapi",
    Admin_recharge: "Backend Recharge",
    FlowLog_partner_name: "Pangalan ng Kasosyo",
    RechargeMethod_currency: "Pera",
    HomeConfig_enter_menu_name: "Ipasok ang pangalan ng menu",
    GxBeidanJcResult_matchId: "Match ID",
    WalletCollectHistory_token: "TOKEN",
    LotteryType_create_time: "Oras ng Paglikha",
    Information_name: "Pamagat",
    GxBeidanJC_spf: "Spf",
    I118_message_id: "ID ng Mensahe",
    Capital_sms_time: "SMS",
    Capital_market: "Halaga ng Market ng mga Posisyon",
    TimebaoAccount_user_real_name: "Pangalan",
    AgentDivide_staff: "ID ng empleyado",
    LotteryType_sample_rule_2: "Simple Iba Pang Panuntunan 2",
    LotteryType_sample_rule_3: "Simple Iba Pang Panuntunan 3",
    LotteryType_bonus_json_rate: "JSON Odds Table",
    LotteryType_sample_rule_1: "Simple Iba Pang Panuntunan 1",
    MonthlyHistory_partner_id: "Partner ID",
    SubUser_trx_commission_total: "TRX Kabuuang Komisyon",
    LotteryBetList_agent: "ID ng Ahente",
    DepotSimulate_price: "Presyo ng Gastos",
    GXBasketballJc_lqRf: "LqRf",
    GxBasketballJCResult_deleteStatus: "Tanggalin ang Katayuan",
    BetType_chain_type: "Uri ng Public Chain",
    AgentManage_agent: "ID ng Ahente",
    ActivityLog_approve_by: "Approver",
    GxBasketballJCResult_awayId: "Away Team ID",
    Capital_serve: "Bayarin sa Serbisyo (Kabuuang Bayarin sa pangangalakal)",
    Agent_bank_name: "Pangalan ng Bangko",
    "newPhone ": "Bagong mobile",
    UserAccount_version: "Bersyon",
    FriendCoupon_coupon: "Cash Coupon Code - 9-digit na natatanging numero",
    AgentDivide_uid: "User ID",
    SubUser_nick_name: "palayaw",
    OtcAccountInfo_uid: "User ID",
    RiskControl_capital: "ID ng financing",
    EntrustSimulate_plus_fee: "Mga Karagdagang Singil",
    SysConfig_trc20_task: "TRC20 Gawain",
    SysConfig_email_smtp_port: "Email smtp Port",
    TimebaoAccount_amount: "Mga Kasalukuyang Asset",
    Activity_num: "Natanggap na Dami",
    CoinChainType_id: "Numero",
    Minus_user_phone: "Telepono",
    BetOrder_next_blockNumber: "Susunod na Block",
    No_depot_days: "Mga Araw na walang Posisyon",
    UserAccount_trx_account: "Mga Pondo ng TRX Account",
    AgentFlowLog_phone: "Telepono",
    Baseconfig_file_size: "Laki ng File ng Upload",
    MonthlyHistory_usdt_times: "Bilang ng Taya ng USDT",
    GxBeidanJC_bqc: "Bqc",
    OtcAccountInfo_id: "Numero",
    UserSimulate_remark: "Remarks",
    GXBasketballJc_lqSf: "LqSf",
    Baseconfig_withdraw_fee_way: "Mode ng Bayad sa Pag-withdraw",
    Recharge_audit_time: "Oras ng Pagkumpirma ng System",
    BetType_rule_1: "Iba pang Paglalarawan 1",
    User_type: "Uri",
    DailyHistory_partner_ref_code: "Referral Code ng Kasosyo",
    BetType_rule_2: "Iba pang Paglalarawan 2",
    Sys_name: "Espesyalista sa Customer Service",
    GxBeidanJcResult_home: "Pangalan ng Home Team",
    News_id: "Numero",
    BetType_rule_3: "Iba pang Paglalarawan 3",
    BetType_rule_pc_1: "Panuntunan_pc_1",
    BetType_rule_pc_2: "Panuntunan_pc_2",
    BetType_rule_pc_3: "Panuntunan_pc_3",
    LotteryResult_bet_win: "Halaga ng Panalo ng User",
    PowerInterest_cq_cxr: "Petsa ng Ex-dividend",
    LanguageField_extend: "Mga Extended Properties",
    GXBasketballJc_homeId: "Pangalan ng Home Team",
    CoinCurrency_user: "Gumagamit ng RPC",
    TimebaoAccount_lasttime: "Oras ng Pagkalkula ng Huling Interes",
    FlowLog_mold: "Uri 0: Magdagdag ng pera 1: Magbawas ng pera",
    SysConfig_report_task: "Iulat ang Gawain",
    Baseconfig_id: "Numero",
    OtcMerchant_update_time: "Oras ng pagbabago",
    RechargeMethod_min_amount: "Pinakamababang Halaga",
    Withdraw_status_Cancel: "Naghihintay ng Pag-apruba",
    Entrust_change: "Ilipat ang Buwis",
    AgentFlowLog_user_number: "Numero",
    OtcAccountHistory_currency: "Uri ng Pera",
    Baseconfig_lottery_task: "Mga Gawain sa Lottery",
    CoinAccount_withdraw_total: "Kabuuang Dami ng Pag-withdraw",
    DepotStop_update_time: "Oras ng Pagbabago",
    Plus_partner_name: "Pangalan ng Kasosyo",
    Capital_staff: "ID ng empleyado",
    CoinRechargeAddr_id: "Numero",
    VoucherCash_user_phone: "Numero ng Telepono",
    Agent_bank_account: "Account Number ng May-ari ng Account",
    AgentFlowType_name: "Uri ng Transaksyon",
    SMS_type: "Katayuan",
    GxBeidanJC_match_time: "Oras ng Pagtutugma",
    BetBalance_usdt_fee_amount: "Halaga ng Bayad sa USDT",
    Community_link: "Nauugnay",
    DepotSimulate_number: "Dami ng Stock",
    LotteryType_name_jp: "Hapon",
    GxBeidanJC_away: "umalis",
    TimebaoAccount_id: "Kontrata ng Diskarte",
    AgentFee_uid: "Numero",
    Max_net_recharge: "Customer Principal",
    TimebaoAccount_user_name: "palayaw",
    UserControl_user_real_name: "palayaw",
    UserCoupon_status: "Katayuan (0 - Hindi Na-cash, 1 - Na-cash)",
    Baseconfig_company_copyright: "Impormasyon sa Copyright",
    LotteryBetList_lottery_result_id: "Lottery Draw ID",
    Baseconfig_register_agent_type: "Uri ng Ahente",
    LotteryMaxResult_id: "Numero",
    UserControl_stock_type: "Restricted Stock Type",
    BetOrder_fee_amount: "Binawas ang Bayad",
    CoinRechargeAddr_partner_id: "Partner ID",
    TimebaoLogType_message_id: "Paglalarawan",
    I118_original_id: "Module ID",
    FlowLog_order: "Numero ng Order",
    AgentAccount_ref_code: "Referral Code",
    Recharge_status: "Katayuan ng Recharge",
    DepotStop_day: "Mga Araw ng Suspensyon",
    CoinCurrency_is_show:
      "Display Status (pangunahin sa personal na asset interface)",
    CoinRecharge_otc_ads_id: "OTC Advertisement ID",
    Capital_trade_fee: "Komisyon sa pangangalakal",
    AgentAccount_mother: "Inang Account ID",
    Baseconfig_default_agent: "Default na Ahente",
    CoinAccountDetail_id: "Numero",
    FriendCoupon_user_user_real_name: "Pangalan",
    DepotSimulate_delivery: "Dami ng Pamamahagi",
    TimebaoLog_uid: "Account ID",
    OtcOrder_closed_by: "Default na Halaga",
    CoinWithdraw_id: "Numero",
    MidokeMessage_partner_id: "Partner ID",
    SysConfig_trc20_refer_blockid: "Taas ng Reference Block",
    Withdraw_mother: "Exchange Rate",
    UserAccount_usdt_bet_today: "Kita/Pagkatalo ng USDT sa Pagtaya",
    CoinWithdraw_from_addr: "Address ng Pag-withdraw",
    LotteryResult_block_get_time: "Kumuha ng BLOCK Time",
    BetType_winning_pc_1: "Winning_pc_1",
    BetType_winning_pc_2: "Winning_pc_2",
    BetType_winning_pc_3: "Winning_pc_3",
    navigateToVerify: "I-verify ngayon",
    Depot_code: "Security Code",
    Mode_selection: "Pagpili ng Mode",
    Baseconfig_pc_banner3: "Larawan 3 ng PC Carousel",
    Baseconfig_pc_banner2: "Larawan 2 ng PC Carousel",
    Baseconfig_pc_banner1: "Larawan 1 ng PC Carousel",
    AgentReserve_recharge_label: "Mag-recharge",
    RechargeType_type: "Uri ng Recharge",
    AgentAccount_agent_phone: "Telepono",
    scrollDownToLoadMore: "Mag-scroll pababa para mag-load pa...",
    Capital_agent_real_name: "Pangalan ng Ahente",
    Baseconfig_filetype: "Uri ng File",
    FlowLog_to_address: "Pagtanggap ng Wallet Address",
    Baseconfig_pc_banner6: "Larawan 6 ng PC Carousel",
    GxBasketballJCResult_matchTime: "Oras ng Pagtutugma",
    Baseconfig_pc_banner5: "Larawan 5 ng PC Carousel",
    OtcAccountInfo_phone: "Telepono",
    Baseconfig_pc_banner4: "Larawan 4 ng PC Carousel",
    Agent_withdraw: "Pag-withdraw ng Ahente",
    Baseconfig_sys_isdefaultcreateagent: "Lumikha ng Ahente?",
    AgentDivide_agent: "ID ng Ahente",
    HomeConfig_column_count: "Bilang ng mga column",
    TimebaoAccount_last_capital: "Halaga ng Pagkalkula ng Huling Interes",
    AgentAccount_trx_commission_1: "TRX Iba Pang Komisyon",
    DepotSimulate_finish: "Nakumpletong Dami",
    CoinRecharge_otc_price: "Presyo ng OTC",
    Lottery_name_ch: "Tradisyunal na Tsino",
    AgentAccount_day_capital: "Pang-araw-araw na Pananalapi",
    AgentDivide_balance: "Balanse",
    Capital_warning: "Linya ng Babala",
    LotteryBetList_partner_name: "Pangalan ng Kasosyo",
    ActivityLog_activity_id: "ID ng Transaksyon",
    SysConfig_smsplannet_appKey: "smsplannet Application Key",
    RechargeMethod_image: "Imahe",
    CoinWithdraw_amount: "Halaga ng Pag-withdraw",
    Depot_create_time: "Oras ng Pagbubukas",
    Wallet_ref_code: "Reference Code",
    DepotSimulate_surplus_total: "Natitirang Halaga",
    Baseconfig_water_position: "Posisyon ng Watermark",
    CoinCurrency_currency_img: "Prefix ng query sa hash ng transaksyon",
    Activity_rule_ch: "Mga Panuntunan sa Tradisyunal na Aktibidad ng Tsino",
    TimebaoAccount_is_autoinout:
      "1 - Awtomatikong Paglipat In/Out, 0 - Manu-mano",
    PowerInterest_code: "Stock Code",
    AgentWithdraw_user_real_name: "Pangalan",
    VoucherManagement_ref: "Sanggunian",
    Recharge_partner_ref_code: "Referral Code ng Kasosyo",
    Withdraw_partner_refCode: "Reference Code ng Kasosyo",
    LotteryType_name_en: "Ingles",
    InterestLog_staff: "ID ng empleyado",
    TimebaoRate_days: "Mga araw",
    GxBasketballJCResult_basketballJC_ResultID: "Basketball JC_Result ID",
    PlusMinusType_activity_type: "Uri ng Aktibidad",
    AgentFlowLog_capital: "Sub-account ID",
    Withdraw_bank_id: "Bank ID",
    AgentAccount_trx_commission_month: "TRX Buwanang Komisyon",
    Agent_day: "Araw-araw na Pag-alis sa Pamamahagi",
    Wallet_name: "Paglalarawan",
    GxBeidanJC_sxp: "Sxp",
    VoucherCash_amount: "Halaga",
    Deal_cost: "Presyo ng Pagbebenta",
    Recharge_order: "Numero ng Order",
    OtcTrade_base_currency: "Base Currency",
    OtcOrder_done_volume: "Dami na Na-trade",
    UserAccount_trx_recharge_total: "TRX Kabuuang Deposito",
    AgentDeferred_capital: "ID ng financing",
    Lottery_id: "Numero",
    HomeConfig_sportgames_title_color: "Kulay ng Font ng Pamagat",
    LotteryBetList_bet_time: "Oras ng Pagtaya",
    Lottery_name_en: "Ingles",
    User_app_version: "Bersyon ng Application",
    Baseconfig_ios_download: "Apple Download",
    LotteryResult_order_id: "Numero ng Isyu",
    RechargeMethod_status: "Katayuan",
    WeekVoucherManagement_amount: "Halaga",
    I118_language_en: "Ingles",
    User_is_simulate: "Simulation",
    LotteryType_sample_rule_jp: "Simpleng Panuntunan ng Hapon",
    GxBasketballJCResult_homeId: "Home Team ID",
    Baseconfig_agent_default_reserve: "Template ng Ahente ng Miyembro",
    PowerInterest_cash_dividend: "Ratio ng Cash Dividend (%)",
    OtcTrade_quote_currency: "Valuation Currency",
    CoinCurrency_lock_release_percent:
      "Porsiyento ng Paglabas, 1 para sa 100%, 0.1 para sa 10%",
    lastMsgFile: "file",
    FoundWinners_classify: "Kategorya",
    LanguageField_type: "Uri",
    Job_status: "Katayuan",
    EntrustSimulate_number: "Dami ng Order",
    AgentReserve_partner_id: "Partner ID",
    JobLog_exception_info: "Impormasyon sa Pagbubukod",
    Baseconfig_activity_title: "Pamagat ng Recharge na Aktibidad",
    UserVip_discount: "VIP na Diskwento",
    Withdraw_partner_id: "Transaksyon HASH",
    AgentCommission_agent: "ID ng Ahente",
    verifyBeforeClaim:
      "Paki-verify ang iyong telepono para ma-claim ang reward",
    Lottery_code_list:
      "Listahan ng Opsyonal na Numero ng Lottery, na pinaghihiwalay ng mga kuwit",
    GxBeidanJcResult_homeScore: "Marka ng Koponan ng Tahanan",
    Help_count: "Basahin ang Bilang",
    TimebaoLogType_partner_id: "Partner ID",
    FirstVoucher_comment: "Paglalarawan",
    CoinRechargeAddr_currency: "Pera, tulad ng BTC",
    Job_module: "Modyul ng Pagpapatupad",
    Minus_partner_id: "Partner ID",
    Job_update_time: "Oras ng Pag-update",
    LotteryType_other1: "Iba 1",
    reachedEndOfList: "Katapusan ng listahan",
    PowerInterest_ycq_ts: "Mga Araw ng Ex-rights (Countdown) (Mga Araw)",
    LotteryType_other3: "Iba pa 3",
    MidokeMessage_other: "Iba pa",
    LotteryType_other2: "Iba pa 2",
    AgentAccount_fee_total: "Halaga ng Transaksyon",
    Baseconfig_timebao_agent_rate: "Real-Time na Treasure Rate ng Ahente",
    FlowLog_curreny: "Pera",
    BetType_name_jp: "Pangalan ng Hapon",
    Baseconfig_usdt_enabled: "Magrehistro ng Ahente",
    CapitalLog_code: "Stock Code",
    Baseconfig_ucpass_appid: "Yunxin Application ID",
    Recharge_auditor: "Operator",
    AgentFlowType_language_1: "Ibang Wika 1",
    TronExchange_from_token: "TOKEN",
    CoinWithdraw_currency_id: "Token ID",
    AgentFlowType_language_2: "Ibang Wika 2",
    "Baseconfig_site_logo\t": "Logo ng Site",
    AgentFlowType_language_3: "Ibang Wika 3",
    UserBank_user_real_name: "May hawak ng Account",
    CoinCurrency_c_min_recharge:
      "Pinakamababang Halaga ng Deposito, ang mga halagang mas mababa dito ay hindi kinikilala",
    LotteryBetList_lottery_number: "Mga Panalong Numero",
    GxBasketballJCResult_id: "Numero",
    AgentAccount_trade_stamp: "Trading Stamp Duty",
    Baseconfig_timebao_image: "Real-Time na Treasure Image",
    Capital_agent: "ID ng Ahente",
    LotteryResult_blockNumber: "Taas ng Block",
    LotteryMax_result: "Resulta",
    AgentDeferred_balance: "Balanse",
    FoundWinners_high_price: "Pinakamataas na Presyo",
    GxBeidanJcResult_sellStatus: "Katayuan ng Benta",
    UserCoupon_amount: "Halaga",
    DepotSimulate_transfer: "Dami ng Paglipat",
    AgentCommission_commission: "Kasalukuyang Komisyon",
    Minus_status: "Katayuan: 0 - Aplikasyon, 1 - Naaprubahan, 2 - Tinanggihan",
    AgentAccount_free_capital_total: "Pananalapi na walang interes",
    RechargeMethod_config: "Configuration",
    CapitalLog_number: "Dami",
    Deal_order: "Numero ng Order",
    Recharge_status_Cancelled: "Mali ang Kasalukuyang Password",
    Protocol_content: "Nilalaman",
    TimebaoLog_type: "Uri ng Operasyon",
    OtcChat_trade_id: "Order ID",
    Agent_phone: "Numero ng Mobile",
    LotteryType_name_ch: "Tradisyunal na Tsino",
    Baseconfig_smsplannet_appKey: "smsplannet_appKey",
    AgentDeferred_agent_real_name: "Pangalan ng Ahente",
    CoinRechargeAddr_check_flag: "Flag 0 - Huwag Suriin, 1 - Suriin",
    CoinRecharge_otc_money: "Halaga ng Matatanggap ng OTC",
    LotteryResult_result: "Mga Resulta ng Lottery",
    InterestLog_user_phone: "Numero ng Telepono",
    AgentAccount_create_time: "Oras",
    TronExchange_to_fee: "Singilin sa Pagkonsumo ng Gasolina ng System",
    OtcMerchant_uid: "User table primary key id",
    Activity_create_time: "Petsa ng Paglikha",
    Depot_surplus_total: "Natitirang Halaga",
    CoinCurrency_c_intro_en: "Maikling Paglalarawan (Ingles)",
    TimebaoAccount_phone: "Numero ng Telepono",
    AgentAccount_agent_name: "palayaw",
    TimebaoRate_partner_ref_code: "Referral Code ng Kasosyo",
    SysConfig_currency: "Pera.",
    TimebaoRate_partner_id: "Partner ID",
    Baseconfig_filesize: "Pag-upload ng Configuration",
    Entrust_complete_time: "Oras ng Pagkumpleto",
    Baseconfig_trx_enabled: "Buksan ang TRX",
    PowerInterest_allocation_plan: "Plano ng Pamamahagi",
    Baseconfig_file_type: "Uri ng File",
    Activity_content: "Mga tuntunin",
    OtcAccountDetail_currency: "Uri ng Pera",
    TimebaoBatchLog_id: "Numero",
    Closed_closed_time: "Mga Petsa ng Saradong Market",
    Plus_approved_by: "Approver",
    UserBank_uid: "User Code",
    Agent_uid: "User ID",
    AgentDivide_user_phone: "Numero ng Telepono ng Ahente",
    DailyHistory_usdt_result: "Tala ng Panalo/Pagkakatalo ng USDT",
    TimebaoLogType_language_3: "Wika_3",
    DepotStop_id: "Numero",
    Plus_currency: "Mag-recharge ng Pera",
    CoinCurrency_withdraw_open_time: "Oras ng Pagbubukas ng Withdrawal",
    HomeConfig_save: "I-save",
    Deal_type: "Uri 0: Bumili 1: Ibenta",
    Activity_rule_en: "Mga Panuntunan sa Aktibidad sa Ingles",
    JobLog_job_name: "Pangalan ng Gawain",
    TimebaoLogType_language_1: "Wika_1",
    TimebaoLogType_language_2: "Wika_2",
    UserControl_uid: "User ID",
    SMS_create_time: "Delay Log",
    GxBeidanJcResult_jq: "Mga Logro ng May Kapansanan",
    UserSimulate_create_time: "Oras ng Pagpaparehistro",
    DealSimulate_depot_mold: "Mode ng Posisyon 0: A Posisyon 1: B Posisyon",
    UserBank_service_provider_id: "Service_provider_id",
    AgentAccount_partner_name: "Pangalan ng Kasosyo",
    JobLog_status: "Katayuan ng Pagpapatupad",
    AgentFlowLog_partner_id: "Remarks",
    Withdraw_id: "Numero",
    FeeLog_capital: "Margin Trading ID",
    Deal_agent: "ID ng Ahente",
    HomeConfig_enter_content_heading: "Ipasok ang pamagat ng nilalaman",
    CoinCurrency_c_intro_cn: "Maikling Paglalarawan (Chinese)",
    DailyHistory_usdt_net_loss: "USDT Net Loss",
    Withdraw_txid: "Transaksyon HASH",
    FeeLog_price: "pangangalakal",
    LotteryType_name: "Paglalarawan",
    Language_id: "Numero",
    EMS_result: "Magpadala ng mga Resulta",
    GxBeidanJcResult_compId: "Itugma ang Group ID",
    LotteryResult_comment: "Tandaan",
    LotteryBetList_status: "Katayuan",
    LotteryBetList_bet_order_id: "Numero ng taya",
    EntrustSimulate_fee: "Kabuuang Bayarin",
    Withdraw_name: "Pangalan",
    Recharge_review_status: "Katayuan",
    SysConfig_smsplannet_secretkey: "Smsplannet_secretkey",
    AgentFlowType_partner_id: "Partner_id",
    Withdraw_token: "Uri ng TOKEN 1 - USDT, 0 - TRX",
    LotteryResult_partner_id: "Partner ID",
    UserAccount_usdt_win_month: "Buwanang Kita ng USDT",
    Activity_number: "Halaga ng Pananalapi",
    InterestLog_charge_time: "Oras ng Bayad",
    PowerInterest_earnings_perShare: "Mga Kita sa bawat Bahagi",
    RiskControl_user_real_name: "Tunay na Pangalan",
    Plus_fee: "Bayad sa Paghawak",
    Baseconfig_lottery_wait_second:
      "Mga Segundo ng Oras ng Pagpapanatili ng Taya",
    MonthlyHistory_usdt_extra_1: "USDT Reserve 1",
    VoucherCash_status: "Katayuan",
    DepotStop_agent: "ID ng Ahente",
    VoucherCash_ref: "Sanggunian",
    BetType_game_type: "Uri ng Laro",
    Agent_safety_password: "Pag-withdraw ng Password",
    UserAccount_trx_win_total: "TRX Kabuuang Kita",
    PowerInterest_time2: "Petsa ng Ex-dividend",
    OtcOrder_cancel_volume: "Nakansela ang dami",
    UserVip_comment: "Remarks",
    OtcTrade_pay_time: "Oras ng Pagbabayad",
    Recharge_balance: "Balanse ng Account",
    User_vip: "Antas ng VIP",
    LotteryBetList_bet_number: "Bilang ng mga Taya",
    RechargeMethod_hot: "Sikat na Laro: 1 - Mainit, 0 - Default",
    SysConfig_schedule_task: "Instant Treasure CRON",
    GXBasketballJc_matchId: "Itugma ang Item ID",
    Baseconfig_water_status: "Katayuan ng Watermark",
    BetOrder_amount: "Halaga ng Recharge",
    BetBalance_id: "Numero",
    lastMsgVideo: "Video",
    AgentReserve_create_time: "Petsa at Oras",
    InterestLog_status: "Katayuan",
    Baseconfig_recommend_stock: "Tuklasin ang Hot Stocks",
    Withdraw_remark: "Paliwanag sa Pagbabayad ng Platform",
    Baseconfig_sys_give_voucher_amount: "Halaga ng Voucher sa Pag-sign up",
    Protocol_status: "Katayuan",
    FlowLog_order_id: "Numero ng Order",
    Agent_partner_name: "Pangalan ng Kasosyo",
    BetBalance_bet_type: "Kategorya ng Laro",
    LotteryType_base_bidding: "Default na Halaga ng Taya",
    Plus_approve_time: "Oras ng Pag-apruba",
    Deal_purchase_price: "Presyo ng Pagbili",
    AgentCommission_uid: "User ID",
    ActivityLog_create_time: "Oras",
    MidokeMessage_sendername: "Pangalan ng Nagpadala",
    FriendCoupon_remark: "Remarks",
    DailyHistory_id: "Numero",
    AgentCommission_upagent: "Superior Agent ID",
    UserLevel_recharge_total_to: "Kabuuang Recharge Sa",
    UserSimulate_login_ip: "IP sa pag-login",
    Parameter_name: "Pangalan ng Parameter",
    HomeConfig_add_menu: "Magdagdag ng menu",
    Entrust_surplus: "Natitirang Dami",
    AgentWithdraw_user_number: "Account",
    Recharge_id: "Numero",
    DepotStop_order: "Numero ng Order",
    popular: "Uso",
    LotteryBetList_order_id: "Numero",
    Baseconfig_system_datasource: "Pinagmulan ng Data ng System",
    Lottery_bid_digits: "Bilang ng Mga Panalong Numero",
    User_code: "Referral Code",
    SysConfig_email_smtp_host: "Email smtp Host",
    Entrust_phone: "Numero ng Telepono",
    AgentDeferred_vouchers: "Voucher",
    InterestLog_number: "Halaga",
    RiskControl_uid: "User ID",
    AgentDivide_capital: "ID ng financing",
    DailyHistory_usdt_times: "Bilang ng Taya ng USDT",
    UserAccount_first_trans_red_total:
      "Kabuuang Natanggap na Mga Pulang Packet",
    OtcAccountHistory_frozen_balance: "Frozen Balanse",
    JobLog_job_message: "Impormasyon sa Log",
    Entrust_com_cost: "Gastos ng Komisyon",
    BetOrder_win_rate: "Ibalik ang Maramihan",
    BetType_name_ch: "Pinasimpleng Pangalan ng Tsino",
    Withdraw_user_phone: "Telepono",
    Activity_start_date: "Petsa ng Pagsisimula",
    HomeConfig_app_download_title: "Pamagat",
    SubUser_usdt_commission_total: "Kabuuang Komisyon ng USDT",
    LotteryBetList_loss_amount: "Halaga ng Pagkawala",
    Activity_app_image_1: "Iba pang 1 APP Images",
    User_partner_id: "Partner ID",
    FlowLog_from_address: "Nagpapadala ng Address ng Wallet",
    User_token: "Token",
    Capital_real_profit_loss: "Aktwal na Kita at Pagkalugi",
    OtcAccountInfo_real_name: "Tunay na Pangalan",
    LotteryType_rule_zh: "Panuntunang Tsino",
    GxBasketballJCResult_sellStatus: "Katayuan ng Benta",
    CategoryList_id: "Numero",
    Community_partner_name: "Pangalan ng Kasosyo",
    Deal_id: "Numero",
    FlowLog_fee: "Bayad",
    EntrustSimulate_complete_time: "Oras ng Pagkumpleto",
    Partners_refCode: "reference code",
    BetOrder_win_amount: "Halaga ng Napanalunan ng User",
    Activity_partner_name: "Pangalan ng Kasosyo",
    Withdraw_exchange: "Exchange Rate",
    TimebaoRate_id: "Numero",
    ExchangeRate_rate: "Exchange Rate",
    LotteryType_bet_minimum: "Pinakamababang Halaga ng Taya",
    UserVip_name: "Paliwanag",
    adminuser_status: "Katayuan",
    Activity_app_image_3: "Iba pang 3 APP Images",
    GXBasketballJc_lqSfc: "LqSfc",
    UserSimulate_team: "Kabuuang Mga Miyembro ng Koponan",
    AgentAccount_uid: "Numero",
    CoinRechargeAddr_create_time: "Oras ng Paglikha",
    Activity_app_image_2: "Iba pang 2 Larawan ng APP",
    SubUser_create_time: "Oras ng Pagpaparehistro",
    Depot_type: "Uri",
    TimebaoLog_balance: "Balanse",
    Withdraw_create_time: "Oras ng Paggawa ng Order",
    ExchangeRate_from_currency: "Impormasyon ng Pera",
    GxBeidanJcResult_createAt: "Nilikha noong",
    UserAccount_last_trans_date: "Multiplier ng Kita",
    GxBeidanJC_home: "Home",
    Entrust_capital_account: "Account",
    LotteryType_name_zh: "Paglalarawan ng Tsino",
    AgentAccount_total: "Kabuuang Halaga",
    Deal_deal: "Bilhin ang Presyo",
    AgentDivide_user_number: "Numero",
    TimebaoBatchLog_partner_partner_name: "Pangalan ng Kasosyo",
    CoinAccountDetail_balance: "Balanse ng Account Pagkatapos ng Transaksyon",
    BetType_name_en: "Pangalan sa Ingles",
    FriendCouponLog_user_real_name: "Pangalan",
    BetType_amount_pc_ch: "Halaga_pc_ch",
    Recharge_currency: "Pera",
    TronExchange_pay_time: "Oras ng Pagbabayad",
    FirstVoucher_operate_amount: "Bilhin ang Halaga",
    CapitalLog_name: "Pangalan ng Stock",
    Baseconfig_before_recharge: "Popup na Not-Recharge na Notification",
    GxBasketballJCResult_lqSf: "Panalo/Talo",
    Depot_interest: "Halaga ng Pamamahagi Pagkatapos ng Buwis",
    Holographic: "Comprehensive Mode",
    UserAccount_recharge_fee: "Bayad sa Deposito",
    MidokeMessage_sender: "Nagpadala",
    Baseconfig_coupon_web: "User Cash Coupon (PC)",
    Baseconfig_is_before_trading: "Non-Trading Popup Switch",
    Activity_voucher_type: "Voucher | 1, Bayad sa Pamamahala | 2",
    ActivityLog_uid: "User ID",
    LotteryGroup_name: "Paglalarawan",
    TimebaoLog_partner_partner_name: "Pangalan ng Kasosyo",
    OtcAccount_update_time: "Oras ng pagbabago",
    Capital_loss: "Bilang ng mga Sub-account na may Pagkawala",
    TimebaoAccount_next_capital: "Susunod na Valid Capital",
    UserSimulate_staff: "Empleyado",
    BetOrder_bet_result:
      "Resulta ng Laro: 0 - Pagkatalo, 1 - Panalo, 2 - Tie, 5 - Di-wastong Taya",
    AgentFlowLog_user_real_name: "Pangalan",
    DepotStop_frozen: "Frozen Dami",
    SysConfig_smsbao_account: "SMS Treasure Account",
    UserSimulate_certified: "Napatotohanan",
    Activity_sortid: "Numero ng Kategorya",
    CoinCurrency_num: "Address Pool Reserve Dami",
    AgentDeferred_uid: "User ID",
    UserAccount_first_date: "Unang Petsa ng Pag-recharge",
    Entrust_status:
      "Katayuan 0: Naisumite ang Aplikasyon 1: Matagumpay 2: Kinansela 3: Bahagyang Kinansela 4: Kanselahin ang Aplikasyon 5: Iniulat para sa Pagkansela",
    OtcAccount_user_name: "palayaw",
    GxBasketballJCResult_lqRf: "Panalo/Pagkatalo sa Handicap",
    DepotStop_finish: "Nakumpletong Dami",
    EntrustSimulate_mother: "Ina Account",
    AgentFlowLog_user_phone: "Numero ng Telepono",
    OtcTrade_id: "Numero",
    FlowLog_order_sn: "Numero ng Order",
    Baseconfig_email_smtp_port: "SMTP Port",
    AgentFlowLog_real_name: "Tunay na Pangalan",
    FriendCoupon_id: "Numero",
    Avg_total: "Average na Pang-araw-araw na Halaga ng Binili",
    OtcOrder_base_rate: "Base Exchange Rate Price sa Order Placement",
    Deal_surplus: "Natitirang Dami",
    Depot_day_number: "Posisyon Ngayon",
    EMS_id: "Numero",
    Entrust_entrust_time: "Oras ng Order",
    Agent_total: "Kita ng Ahente",
    User_email: "Email ng User",
    Agent_bank_card: "Bank Account Number",
    SysConfig_water_alpha: "Transparency ng Watermark",
    TimebaoAccount_interest_amount: "Kabuuang Interes",
    CoinAccount_fee_total: "Kabuuang Dami ng Bayad",
    EMS_ip: "IP",
    GxBasketballJCResult_homeScore: "Marka ng Koponan ng Tahanan",
    AgentDivide_agent_number: "Account ng Ahente",
    Refer_a_friend: "Magrekomenda ng mga Kaibigan",
    OtcMerchant_name: "palayaw",
    SysConfig_android_download: "Pag-download ng Android",
    Activity_end_date: "Petsa ng Pagtatapos",
    Activity_app_image_zh: "Pinasimpleng Chinese APP Images",
    Agent_reserve: "Template ng Komisyon ng Ahente",
    CoinCurrency_withdraw_fee_percent:
      "Tagapahiwatig ng Porsiyento ng Bayad sa Pag-withdraw: 0 para sa hindi, 1 para sa oo",
    Plus_id: "Numero",
    FeeLog_status: "Katayuan",
    commisionName: "Pangalan ng Komisyon",
    newPassword: "Bagong password",
    Closed_create_time: "Oras ng Paglikha",
    Depot_cost: "Gastos sa Posisyon",
    AgentAccount_server_total: "Kabuuang Bayarin sa Serbisyo",
    OtcOrder_price_type: "Uri ng Presyo",
    AgentReserve_status: "Katayuan",
    notEligible: "Hindi karapat-dapat para sa promosyon",
    BetOrder_create_time: "Petsa at Oras",
    Baseconfig_login_register_logo: "Logo ng Pag-login sa Pagrehistro",
    Deal_code: "Stock Code",
    Baseconfig_stock_prohibit_message: "Ipagbawal ang Impormasyon sa Trading",
    LotteryResult_estimate_time: "Naka-iskedyul na Oras ng Pag-block",
    SysConfig_email_smtp_ssl_protocols: "Email smtp SSL protocol",
    CapitalLog_deal: "Numero ng Deal",
    EntrustSimulate_entrust_id: "Numero ng Order",
    SysConfig_domain: "Bind Domain",
    AgentDeferred_agent_number: "Account ng Ahente",
    CoinAccount_currency: "Singilin sa Pagkonsumo ng Gasolina ng System",
    AgentAccount_week_capital: "Lingguhang Pananalapi",
    MidokeMessage_nickname: "palayaw",
    CoinCurrency_can_recharge: "Availability ng Deposito",
    FriendCouponLog_coupon: "Cash Coupon Code - 9-digit na natatanging numero",
    Agent_code: "Aking Rekomendasyon ID",
    Total_return_investment_ratio: "Kabuuang Pagbabalik ng Puhunan",
    Wallet_status: "Katayuan",
    Plus_user_phone: "Telepono",
    Withdraw_partner_ref_code: "Referral Code ng Kasosyo",
    Agent_divided: "Mutual Commission",
    CoinWithdraw_currency: "Token",
    Withdraw_total: "Aktwal na Halaga",
    User_core_set: "Template ng Bayad sa Gumagamit",
    Agent_real_day: "Tunay na Ratio",
    BetOrder_status:
      "Katayuan: 0 Pagbabayad ng User, 1 Nakabinbing Pagbabayad, 2 Nakumpleto",
    OperatorInformation_id: "Numero",
    TimebaoLogType_name: "Paglalarawan",
    BetType_exclude_address: "Huwag pansinin ang Address",
    Capital_profit_loss: "Settlement Profit at Loss",
    AgentDeferred_id: "Numero",
    OtcOrder_order_id: "Numero ng Order",
    GXBasketballJc_awayId: "Pangalan ng Away Team",
    FeeLog_change: "Ilipat ang Buwis",
    Baseconfig_ucpass_sid: "Yunxin User SID",
    Withdraw_refer_to: "Link",
    BetBalance_usdt_balance: "Halaga ng Balanse ng USDT",
    Baseconfig_is_trade_time_enabled: "Paganahin ang Trading Hours",
    OtcOrder_id: "Numero",
    AgentAccount_usdt_commission_month: "Buwanang Komisyon ng USDT",
    Capital_extra: "Pag-withdraw ng Kita",
    Baseconfig_domain: "Bind Domain Name",
    Baseconfig_home_logo: "Logo ng Bahay",
    HomeConfig_app_download_subtitle: "Subtitle",
    SMS_code: "Code",
    Baseconfig_recharge_hint: "Mag-recharge ng Warm Prompt",
    DealSimulate_order: "Numero ng Order",
    AgentCommission_create_time: "Petsa Oras",
    Withdraw_number: "Halaga",
    OtcChat_id: "Numero",
    LotteryType_sample_rule_zh: "Simpleng Panuntunang Tsino",
    HomeConfig_third_tab: "Pangatlong tab",
    Agent_md5_phone: "MD5 Encryption",
    TimebaoAccount_interest_this: "Interes Ngayong Buwan",
    OtcAccountInfo_payment_img: "Larawan ng Pagbabayad",
    Home_active_number: "Mga Aktibong Gumagamit",
    UserAccount_partner_name: "Pangalan ng Kasosyo",
    LotteryType_is_fix_rate: "Flag ng Fixed Odds",
    Baseconfig_timebao_task: "Time Treasure Tasks",
    Withdraw_card: "Numero ng Card",
    AgentManage_user_member_account: "Numero",
    TimebaoBatchLog_start_time: "Oras ng Pagsisimula ng Interes",
    MonthlyHistory_trx_net_loss: "TRX Net Profit/Los",
    Recharge_fee: "Bayad sa Paghawak",
    TimebaoAccount_create_time: "Oras",
    RiskControl_number: "Account",
    Depot_finish: "Nakumpletong Dami",
    nameAndEmailCannotbeEmpty:
      "Hindi maaaring walang laman ang Pangalan o Email",
    OtcOrder_user_real_name: "Tunay na Pangalan",
    SysConfig_tron_api_key1: "Tron_api_key1",
    Parameter_id: "ID",
    MidokeMessage_appdata: "Data ng Application",
    AgentDivide_number: "Dami ng Transaksyon",
    UserControl_status: "Katayuan",
    RechargeType_exchange_name: "Palitan ng Pangalan",
    Withdraw_reject_reason: "Dahilan ng Pagtanggi",
    LotteryType_name_3: "Iba pa 3",
    valuePlaceholder: "Halaga(10~50000)",
    Withdraw_auditor: "Handler Account, Administrator sa admin table",
    LotteryType_name_2: "Iba pa 2",
    AgentManage_agent_phone: "Advanced na Numero ng Telepono",
    Parameter_config_key: "Pangalan ng Parameter Key",
    LotteryType_name_1: "Iba 1",
    LanguageField_remark: "Remarks",
    User_google_secret: "Secret key ng Google verification code",
    BetBalance_bet_date: "Petsa",
    game: "Laro",
    Minus_partner_refCode: "Reference Code ng Kasosyo",
    CoinWithdraw_otc_oppsite_currency: "Counterparty Coin Type sa OTC",
    UserSimulate_mother: "ID ng Magulang na Account",
    WalletCollectHistory_id: "Numero",
    EntrustSimulate_remark: "Remarks",
    CoinRechargeAddr_withdraw_total: "Kabuuang Halaga ng Pag-withdraw",
    FlowLog_token: "TOKEN",
    remark: "Puna",
    UserAccount_increase_bond: "Karagdagang Margin",
    CoinWithdrawAddr_status: "Katayuan",
    UserSimulate_agent: "Ahente",
    OtcOrder_volume: "Dami",
    FirstVoucher_agent_cash: "Gantimpala ng Ahente",
    BetOrder_from_address: "Address ng Pinagmulan",
    FlowLog_agent: "ID ng Ahente",
    FoundWinners_stock_name: "Pangalan ng Stock",
    DepotSimulate_cq_cxr: "Petsa ng Ex-dividend",
    LotteryBetList_bet_total: "Kabuuang Halaga ng Taya",
    OtcChat_uid: "ID ng Miyembro",
    Agent_wit_pwd: "Pag-withdraw ng Password",
    CoinAccountDetail_opt_source: "Module ng Transaksyon",
    UserAccount_voucher_managetotal: "Kabuuang Bayad sa Pamamahala ng Gifted",
    FlowLog_amount: "Halaga",
    Recharge_version: "Bersyon",
    Recharge_number: "Halaga ng Recharge",
    Parameter_update_time: "Oras ng Pag-update",
    User_number: "Numero",
    SMS_id: "Numero",
    Capital_stamp: "Tungkulin ng Selyo",
    AgentReserve_name: "Paglalarawan",
    SMS_ip: "IP ng kliyente",
    OtcOrder_price_change_type: "Uri ng Pagbabago ng Presyo",
    Lottery_partner_ref_code: "Referral Code",
    CoinCurrency_partner_id: "Partner_id",
    AgentCommission_partner_name: "Pangalan ng Kasosyo",
    BetBalance_trx_balance: "Halaga ng Balanse ng TRX",
    UserSimulate_certified_synced: "Customer Service Sync",
    CoinRecharge_order_id: "Source Document ID",
    selectBankPlaceholder: "Pumili ng bangko",
    HomeConfig_news_label: "Listahan ng balita",
    User_certified: "Napatotohanan",
    CoinCurrency_tokenaddr: "Kontrata",
    SysConfig_smsbao_api_key: "SMS Treasure API Key",
    Agent_type: "Uri ng Ahente",
    Wallet_type: "Uri ng Wallet",
    GxBasketballJCResult_updateAt: "Na-update noong",
    CoinCurrency_port: "Port ng Server",
    EntrustSimulate_id: "Numero",
    Agent_capital: "Default na Pag-withdraw",
    "frozenAmount ": "Frozen na Halaga",
    UserAccount_uid: "Numero",
    GxBeidanJcResult_bqc: "Mga Logro ng Kalidad",
    FirstVoucher_name: "Antas",
    Baseconfig_team_all_data_level: "Hierarchy ng Koponan ng Ahente",
    Agent_partner_id: "Oras ng Pag-login",
    Depot_frozen: "Frozen Dami",
    Capital_number: "Halaga ng Pananalapi",
    SysConfig_timebao_task: "Time Treasure Task",
    VoucherCash_approved_by: "Approver",
    AgentReserve_umlBetting_label: "Pinagsama-samang Pagtaya",
    Baseconfig_before_trading: "Non-Trading Notification Popup",
    CoinRecharge_audit_time: "Oras ng Pagproseso",
    DealSimulate_number: "Dami ng Deal",
    Baseconfig_recharge_coupon:
      "I-prompt ang Mga Kaibigan na Makatanggap ng Cash Coupons (PC)",
    TimebaoLog_capital_rank2: "Tiered na Halaga 2",
    CoinRechargeAddr_private_key: "Pribadong Susi",
    TimebaoLog_capital_rank1: "Tiered na Halaga 1",
    Capital_uid: "User ID",
    TimebaoLog_capital_rank3: "Tiered na Halaga 3",
    Agent_login_time: "Oras ng Pag-login",
    Baseconfig_otc_default_currency: "Default na Pera",
    OtcAccount_available_balance: "Magagamit na balanse",
    UserLevel_id: "Numero",
    FlowLog_staff: "ID ng empleyado",
    BetType_game_img_home: "Game Homepage ng Larawan",
    Withdraw_user_name: "palayaw",
    DepotSimulate_day: "Mga Araw ng Suspensyon",
    Capital_order: "Numero ng Order",
    FeeLog_stamp: "Tungkulin ng Selyo",
    CoinRecharge_user_real_name: "Tunay na Pangalan",
    TimebaoBatchLog_starttime: "Oras ng Pagsisimula ng Interes",
    Baseconfig_hangqing_banner: "Larawan ng Pabalat ng Pahina ng Market",
    FirstVoucher_voucher_cache: "Halaga ng Voucher",
    Recharge_token: "Uri ng TOKEN",
    DepotSimulate_fee_total: "Kabuuang Bayarin",
    FeeLog_deal: "Deal Record ID",
    InterestLog_voucher: "Voucher",
    PowerInterest_name: "Pangalan ng Stock",
    DepotSimulate_give: "Dami ng Regalo",
    Job_concurrent: "Kasabay na Pagpapatupad",
    Withdraw_status:
      "Katayuan: 0 - Nakabinbin, 1 - Naaprubahan, 2 - Kinansela, 3 - Matagumpay na Pag-withdraw, 4 - Tinanggihan",
    DepotStop_create_time: "Oras ng Pagbubukas",
    Agent_grade: "Antas ng Ahente",
    GXBasketballJc_issueNum: "Oras ng Pagtutugma",
    Capital_agent_phone: "Ahente Mobile",
    Baseconfig_email_smtp_auth: "Awtorisasyon ng SMTP",
    Deal_uid: "User ID",
    Agent_remark: "Remarks",
    SubUser_member_count: "Bilang ng mga Miyembro",
    AgentWithdraw_create_time: "Oras",
    VoucherCash_user_name: "palayaw",
    AgentDeferred_user_real_name: "Pangalan",
    OtcChat_chat_type: "Uri ng Record",
    LotteryBetList_bet_data: "Panloob na Data ng Mga Pagpipilian sa Pagtaya",
    VoucherCash_id: "Numero",
    Capital_times: "Mga Awtomatikong Oras ng Pag-renew",
    Minus_user_real_name: "Pangalan",
    Baseconfig_data: "Data",
    JobLog_create_time: "Oras ng Paglikha",
    AgentManage_agent_id: "Superior Identity",
    Baseconfig_popup_mobile_switch: "Mobile Popup Switch",
    TimebaoAccount_interestlast: "Interes noong nakaraang buwan",
    DepotStop_price: "Presyo ng Gastos",
    HomeConfig_enter_app_download_title: "Ipasok ang pamagat",
    AgentFlowType_language_jp: "Hapon",
    SysConfig_name: "Pangalan",
    CapitalLog_price: "Presyo ng Deal",
    Language_status: "Katayuan",
    HomeConfig_stock_search_label: "Paghahanap ng stock",
    LotteryCategory_sort: "Pag-uuri",
    FoundWinners_stock_code: "Stock Code",
    Baseconfig_agent_default_type: "Uri ng Ahente ng Miyembro",
    PowerInterest_gx_rate: "Dividend Yield (%)",
    Agent_ratio: "Ratio ng Komisyon",
    LotteryGroup_name_jp: "Hapon",
    CoinCurrency_is_coin:
      "Kahit na isang Cryptocurrency (hindi kasama ang CNY)",
    LanguageField_tip: "Paglalarawan",
    CategoryList_game_type_id: "ID ng Uri ng Laro",
    AgentAccount_agent: "Superior ID",
    AgentManage_manage: "Bayad sa Pamamahala",
    Baseconfig_live_Chat_URL: "Real-time na URL ng Chat",
    DepotSimulate_cash: "Pamamahagi ng Dividend",
    PlusMinusType_id: "ID",
    OtcOrder_real_name: "Tunay na Pangalan",
    PowerInterest_mg_wfp_ly: "Hindi Naipamahagi na Kita sa bawat Share (Yuan)",
    Baseconfig_email_smtp_ssl_protocols: "SMTP_SSL Protocol",
    AgentAccount_rec_total: "Naipon na Recharge",
    LotteryType_bonus_rate: "Odds",
    FeeLog_agent: "ID ng Ahente",
    User_qq: "Impormasyon sa QQ",
    AgentFlowType_language_en: "Ingles",
    Deal_profit_loss: "Kita at Pagkalugi",
    Withdraw_from_addr: "Nagpapadala ng Address",
    Recharge_partner_partner_name: "Pangalan sa Login ng Kasosyo",
    AgentAccount_deferred_total: "Bayad sa Rollover",
    Parameter_title: "Pamagat ng Parameter",
    DepotStop_cancel: "Kinanselang Dami",
    Agent_ref_code: "Referral Code",
    Agent_real_name: "Pangalan ng Ahente",
    Closed_status: "Katayuan",
    Deal_mold: "Uri ng Operasyon 1: Bumili 2: Bumili sa Market",
    UserBank_bank: "Bank ID",
    TronExchange_partner_name: "Pangalan ng Kasosyo",
    ExchangeRate_effect_date: "Petsa ng Bisa",
    Wallet_usdt_fee: "USDT Exchange Fee",
    LotteryType_rule_jp: "Panuntunan ng Hapon",
    User_login_ip: "IP sa pag-login",
    Deal_name: "Pangalan ng Stock",
    CoinRechargeAddr_uid: "ID sa USER Table",
    TronExchange_to_amount: "Kabuuan ng Exchange",
    AgentFee_user_number: "Account",
    AgentAccount_agent_real_name: "Pangalan",
    LotteryType_max_count: "Pinakamataas na Bilang ng Mga Taya",
    LotteryType_example_zh: "Halimbawa sa Chinese",
    HomeConfig_copyrights_label: "Copyright",
    User_area_code: "Code ng bansa",
    SysConfig_otc_merchat_deposit_amount: "Deposito ng Merchant",
    AgentAccount_trx_commission_today: "TRX Daily Commission",
    TimebaoLog_user_name: "palayaw",
    User_email_status: "Katayuan ng email",
    GxBeidanJcResult_spf: "Mga Logro ng Panalo/Draw/Talo",
    GXBasketballJc_categoryId: "Numero ng Kategorya",
    DepotStop_surplus: "Nananatiling Available",
    EntrustSimulate_com_cost: "Gastos ng Komisyon",
    CoinWithdraw_fee: "Bayad",
    LotteryCategory_name_jp: "Hapon",
    DepotSimulate_capital: "ID ng financing",
    EntrustSimulate_status:
      "Katayuan 0: Naisumite ang Aplikasyon 1: Matagumpay 2: Kinansela 3: Bahagyang Kinansela 4: Kanselahin ang Aplikasyon 5: Iniulat para sa Pagkansela",
    AgentFlowLog_uid: "User ID",
    EMS_email: "Email",
    Wallet_min_amount: "Pinakamababang Halaga",
    AgentFee_user_real_name: "Pangalan ng Ahente",
    AgentFlowLog_id: "Numero",
    "Home_Recharge_amount_of_the_day ": "Halaga ng Recharge para sa Araw",
    Withdraw_status_Approved: "Naaprubahan",
    WalletCollectHistory_uid: "User ID",
    Plus_user_name: "palayaw",
    UserAccount_user_real_name: "Pangalan",
    FriendCoupon_effect_date: "Panahon ng Bisa",
    Capital_deferred: "Ipinagpaliban na Bayad",
    Recharge_from_amount: "Halaga ng Recharge",
    HomeConfig_font_color: "Kulay ng background",
    UserSimulate_real_name: "Tunay na Pangalan",
    CoinRechargeAddr_total: "Balanse ng coin chain na ito",
    AgentDivide_create_time: "Oras ng Transaksyon",
    adminuser_role_id: "Tungkulin",
    UserAccount_usdt_recharge_total: "Bayarin sa Pag-withdraw ng USDT",
    "Home_Fundraisers_count_day ":
      "Bilang ng Bagong Margin Trader para sa Araw",
    GXBasketballJc_createAt: "Lokal na Oras ng Paglikha",
    Recharge_user_name: "Palayaw ng User",
    DepotSimulate_name: "Pangalan ng Stock",
    User_encrypt_phone: "Naka-encrypt na Numero ng Telepono",
    UserBank_address: "Pangalan ng Sangay",
    AgentAccount_partner_id: "Partner ID",
    LotteryMaxResult_end_time: "Oras ng Pagtatapos",
    orderID: "Order ID",
    DepotSimulate_uid: "User ID",
    Lottery_name_zh: "Paglalarawan ng Tsino",
    EntrustSimulate_price: "Presyo ng Deal",
    InterestLog_user_fee: "Komisyon ng Gumagamit",
    LotteryResult_partner_name: "Pangalan ng Kasosyo",
    Withdraw_amount: "Halaga ng Pag-withdraw",
    I118_language_zh: "Pinasimpleng Chinese",
    UserCoupon_from_uid: "Friend ID ang ginamit",
    UserLevel_recharge_times: "Mga Oras ng Pag-recharge",
    "Home_Time_treasure ": "Real-time na Kayamanan",
    TimebaoBatchLog_end_time: "Oras ng Pagtatapos ng Interes",
    TimebaoRate_period: "Panahon",
    LotteryMax_lottery_id: "Numero ng Lottery",
    Baseconfig_mail_password: "Email Password",
    Withdraw_pay_order: "Numero ng Order ng Pagbabayad",
    CoinWithdrawAddr_currency_id: "Currency ID",
    Deal_depot_mold: "Mode ng Posisyon 0: A Posisyon 1: B Posisyon",
    DealSimulate_id: "Numero",
    Friend_coupon: "Voucher ng Kaibigan",
    AgentCommission_partner_id: "Partner ID",
    User_user_account_wit_total: "Kabuuang Halaga ng Pag-withdraw",
    Lottery_name_3: "Iba pa 3",
    LotteryResult_blocktime: "Block Time",
    AgentAccount_real_name: "Tunay na Pangalan",
    BetBalance_trx_fee_amount: "Halaga ng Pagbabalik ng USDT",
    Last_trans_date: "Petsa ng Huling Trading",
    Lottery_name_2: "Iba pa 2",
    Lottery_name_1: "Iba 1",
    TimebaoRate_partner_partner_name: "Pangalan ng Kasosyo",
    LotteryMax_partner_id: "Partner ID",
    adminuser_note: "Remarks",
    Activity_app_image_jp: "Mga Larawan ng Japanese APP",
    User_peizi_auth: "Authorization Code",
    TimebaoRate_coin_currency_id: "Digital Currency ID",
    LotteryType_bet_count_function: "Panalong Pagkalkula Function",
    turnOver: "Turnover",
    Deal_plus_fee: "Mga Karagdagang Singil",
    DepotStop_staff: "ID ng empleyado",
    LotteryGroup_name_en: "Ingles",
    UserSimulate_bindwechat: "Nakatali sa Public Account",
    OtcChat_opposite_trade_id: "Counterparty Order ID",
    UserAccount_total: "Kabuuang Halaga ng Pondo",
    CoinCurrency_auto_withdraw_up_limit:
      "Awtomatikong Withdrawal Upper Limit, 0 ay nangangahulugan na ang awtomatikong withdrawal ay hindi suportado",
    Minus_number: "Halaga ng Recharge",
    Holiday_amount: "Holiday Treasure",
    LotteryType_rule_en: "Panuntunan sa Ingles",
    Baseconfig_timebao_time_interval: "Real-Time Treasure Interval",
    CoinRechargeAddr_version: "VERSION",
    LotteryMax_estimate_time: "Tinatayang Oras",
    Recharge_mother: "ID ng Magulang na Account",
    AgentReserve_betting_label: "pagtaya",
    CoinFlowType_id: "Numero",
    AgentWithdraw_uid: "User ID",
    User_photo: "Larawan ng Authentication",
    UserControl_user_phone: "Numero ng Telepono",
    CoinCurrency_sortid: "Pag-uuri",
    Capital_capital_type: "Uri",
    Timebao_amount: "Real-time na Kayamanan",
    PowerInterest_sg_rate: "Ratio ng Isyu ng Bonus",
    Baseconfig_stock_limit_message: "Limitahan ang Impormasyon sa Trading",
    LotteryMaxResult_partner_name: "Pangalan ng Kasosyo",
    OtcAccount_user_real_name: "Tunay na pangalan",
    RechargeType_create_time: "Oras ng Paglikha",
    Baseconfig_popup_pc_content: "PC Popup",
    Depot_transfer: "Inilipat na Dami",
    LotteryMaxResult_ref_code: "Uri ng Pag-upload",
    Baseconfig_register_agent_template: "Template ng Pagbabahagi ng Kita",
    AgentDivide_user_real_name: "Pangalan",
    BetType_max_block_timestamp: "Pinakamataas na USDT Block Time",
    GxBeidanJC_comp: "Ikumpara",
    LanguageField_controller_name: "Module",
    RechargeMethod_max_amount: "Pinakamataas na Halaga",
    AgentFlowType_language_ch: "Tradisyunal na Tsino",
    CoinCurrency_c_cannot_withdraw_desc_en:
      "Paglalarawan Kapag Hindi Magagamit ang Pag-withdraw (Ingles)",
    UserAccount_trx_payback_total: "TRX Kabuuang Refund",
    Language_code: "Code ng wika",
    Recharge_pay_type: "Uri ng Pagbabayad",
    Deal_entrust: "Ipagkatiwala ang ID",
    CoinRechargeAddr_currency_chain_type: "Uri ng Currency Chain",
    LotteryGroup_name_ch: "Tradisyunal na Tsino",
    CoinCurrency_c_min_withdraw:
      "Pinakamababang Halaga ng Pag-withdraw; hindi pinapayagan ang mga withdrawal kung mas mababa sa halagang ito",
    Voucher_cash: "Trading Red Envelope",
    Information_create_time: "Oras ng Paglikha",
    OtcOrder_lock_amount: "Naka-lock na Halaga ng Trading",
    SysConfig_ucpass_sid: "ucpass sid",
    User_binwechat: "Bind Public Account",
    Entrust_code: "Stock Code",
    UserAccount_usdt_bet_month: "Mga Buwanang Taya ng USDT",
    PowerInterest_status: "Katayuan",
    UserAccount_trx_balance: "TRX Betting Profit/Los",
    SysConfig_description: "Paglalarawan ng Site",
    AgentFee_user_fee: "Komisyon ng Empleyado",
    SysConfig_upload_type: "Uri ng Pag-upload",
    UserCoupon_coupon: "Cash Coupon Code - 9-digit na natatanging numero",
    Plus_partner_refCode: "Reference Code ng Kasosyo",
    Entrust_create_time: "Oras ng Order",
    DailyHistory_trx_extra_1: "TRX Reserve 1",
    VoucherManagement_user_name: "palayaw",
    OtcChat_taker: "Nagpadala ng Mensahe",
    LotteryResult_close_start_time: "Oras ng Pagsisimula ng Settlement",
    LotteryGroup_ref_code: "Referral Code",
    hasPendingBets:
      "Mangyaring maghintay hanggang ang lahat ng mga nakabinbing taya ay naayos",
    User_simulate_uid: "Simulated Account",
    InterestLog_staff_fee: "Komisyon ng Empleyado",
    Recharge_coupon_amount: "Halaga ng Cash Coupon",
    DepotStop_number: "Dami ng Stock",
    MonthlyHistory_trx_result: "TRX Win/Los Record",
    Plus_user_caller: "Serbisyo sa Customer",
    UserControl_stock_value: "Halaga sa Pamilihan",
    Information_content: "Nilalaman",
    Baseconfig_report_task: "Time Treasure Tasks",
    Activity_rule_3: "Iba pang 3 Panuntunan sa Aktibidad",
    DepotStop_fee_total: "Kabuuang Bayarin",
    CoinCurrency_c_cannot_withdraw_desc_cn:
      "Paglalarawan Kapag Hindi Available ang Withdrawal (Chinese)",
    Recharge_coupon: "Numero ng Friend Cash Coupon",
    UserSimulate_type: "Uri ng User",
    DealSimulate_stamp_cost: "Halaga ng Stamp Duty",
    Withdraw_status_Reject: "Kanselahin",
    TimebaoLogType_language_jp: "Wika_jp",
    InterestLog_agent: "ID ng Ahente",
    AgentAccount_account: "Magagamit na Balanse",
    DailyHistory_trx_bet_total: "TRX Kabuuang Halaga ng Taya",
    MonthlyHistory_uid: "User ID",
    CoinWithdraw_coin_addr: "Coin Address ng User",
    User_team: "Kabuuang Mga Miyembro ng Koponan",
    level: "Mga antas",
    OtcTrade_uid: "Merchant ID",
    OtcTrade_price: "Presyo ng Pagpapatupad",
    OtcAccountHistory_record_date: "Naitala ang Oras ng Asset",
    AgentAccount_usdt_account: "Magagamit na Balanse ng USDT",
    AgentReserve_ref_code: "Referral Code",
    SysConfig_password_attempt: "Mga Pagsubok sa Password",
    VoucherCash_balance: "Balanse",
    bonusRedeemNotice:
      "Magdeposito ng ₱ {amount} at tumanggap ng ₱ {extraAmount} bilang regalo.",
    GxBeidanJcResult_sxp: "Mga Logro ng Layunin",
    CoinCurrency_c_precision: "Mga Desimal na Lugar",
    RsaKey_public_key: "Pampublikong Susi",
    TimebaoAccount_withdraw_amount: "Kabuuang Pag-withdraw",
    Information_aid: "Impormasyon ng Administrator",
    Capital_mother: "ID ng empleyado",
    "Home_Profit_loss_on_day ": "Paghahatid ng Kita at Pagkalugi para sa Araw",
    CoinRechargeAddr_recharge_total: "Kabuuang Halaga ng Deposito",
    LotteryType_status: "Katayuan",
    LotteryType_rule_ch: "Tradisyonal na Panuntunang Tsino",
    GxBeidanJC_createTime: "Nilikhang Oras",
    Entrust_uid: "User ID",
    CoinWithdrawAddr_addr: "Address",
    Lottery_partner_partner_name: "Pangalan ng Kasosyo",
    CoinWithdraw_auditor: "Account ng Processor",
    TimebaoRate_rank1: "Tiered na Halaga 1",
    CapitalLog_staff: "ID ng empleyado",
    TimebaoRate_rank3: "Tiered na Halaga 3",
    OtcAccountInfo_bank_or_img:
      "Bank Card Opening Bank o QR Code Image ng WeChat Pay/Alipay",
    TimebaoRate_rank2: "Tiered na Halaga 2",
    Parameter_create_by: "Tagapaglikha",
    UserAccount_trx_loss_total: "TRX Kabuuang Pagkalugi",
    Depot_cq_cxr: "Petsa ng Ex-dividend",
    OtcAccount_frozen_balance: "Frozen na balanse",
    FeeLog_code: "Stock Code",
    MonthlyHistory_usdt_bet_total: "USDT Kabuuang Halaga ng Taya",
    AgentFlowLog_token: "TOKEN",
    HomeConfig_should_display: "Pagpapakita",
    FeeLog_user_real_name: "Pangalan",
    Agent_core_set: "Template ng Bayad sa Gumagamit",
    BetOrder_next_blockID: "Susunod na Block Hash",
    RechargeType_exchange_rate: "Exchange Rate",
    LotteryResult_lottery_id: "Lottery ID",
    Deal_status: "Katayuan",
    VoucherManagement_mold: "Magdagdag o Magbawas",
    Plus_uid: "Impormasyon ng Gumagamit",
    UserCoupon_remark: "Remarks",
    Recharge_remark: "Remarks",
    VoucherCash_uid: "User ID",
    User_phone: "Numero ng Telepono",
    SysConfig_copyright: "Copyright ng Site",
    Activity_rule_1: "Iba pang 1 Mga Panuntunan sa Aktibidad",
    CoinCurrency_currency: "Currency Code, hal., CNY, BTC, LTC, atbp.",
    Activity_rule_2: "Iba pang 2 Panuntunan sa Aktibidad",
    BetBalance_usdt_paid_amount: "Halaga ng Pagbabalik ng USDT",
    AgentAccount_usdt_commission_year: "Taunang Komisyon ng USDT",
    Recharge_status_successfully: "Kinansela",
    Job_misfire_policy: "Diskarte sa Pagpapatupad ng Error",
    UserSimulate_extension_type: "Paraan ng Promosyon",
    Depot_version: "Bersyon",
    TronExchange_partner_refCode: "Reference Code ng Kasosyo",
    LotteryType_all_count: "Kabuuang Bilang ng Mga Pusta",
    Protocol_title: "Pangalan ng Kasunduan",
    Job_create_by: "Tagapaglikha",
    Capital_bond: "Margin",
    WeekVoucherManagement_remark: "Remarks",
    Withdraw_fee: "Bayad sa Paghawak",
    MidokeMessage_msgid: "ID ng Mensahe",
    Baseconfig_password_attempt: "Oras ng Pagtatangka ng Password",
    Withdraw_withdraw_type: "Uri ng Pag-withdraw",
    HomeConfig_sportgames_card_value_color: "Kulay ng Halaga ng Pindutan",
    Baseconfig_app_download_image: "I-download ang APP Bumalik",
    FoundWinners_status: "Katayuan",
    BetType_min_block_timestamp: "Minimum na USDT Block Time",
    I118_create_time: "Oras ng Paglikha",
    Baseconfig_tron_api_key1: "Tron_Api_key1",
    Help_source: "Pinagmulan",
    DailyHistory_trx_times: "Bilang ng Taya ng TRX",
    Lottery_image_jp: "Larawan sa Japanese",
    AgentAccount_trade_change: "Bayarin sa Paglipat",
    Baseconfig_sys_give_voucher: "Mag-sign up para sa Voucher",
    HomeConfig_custom_styles: "I-customize ang istilo",
    CoinWithdraw_otc_owner_name: "Pangalan ng Counterparty sa OTC",
    Parameter_rule: "Mga Panuntunan sa Pagpapatunay",
    MidokeMessage_partner_partner_name: "Pangalan sa Login ng Kasosyo",
    TimebaoBatchLog_partner_id: "Partner ID",
    RechargeMethod_exchange: "Exchange Rate",
    LanguageField_table_key: "Record ID",
    UserAccount_increase_capital: "Karagdagang Margin Trading",
    DailyHistory_trx_net_loss: "TRX Net Loss",
    Activity_app_image_ch: "Mga Tradisyunal na Chinese APP Images",
    adminuser_create_time: "Oras ng Paglikha",
    UserAccount_usdt_withdraw_total: "USDT Accumulated Withdrawals",
    UserAccount_trx_win_today: "TRX Araw-araw na Kita",
    BetOrder_confirmations: "Numero ng Kumpirmasyon",
    User_last_time: "Huling Oras ng Pag-log in",
    EntrustSimulate_surplus: "Natitirang Dami",
    InterestLog_loan: "Principal",
    TimebaoLogType_language_en: "Wika_en",
    User_last_token_time: "Huling TOKEN Time",
    OtcOrder_payment_time: "Deadline ng Pagbabayad",
    EntrustSimulate_stamp: "Tungkulin ng Selyo",
    Language_create_time: "Petsa at oras",
    CoinWithdraw_user_phone: "Numero ng Telepono",
    I118_id: "Numero",
    RiskControl_capital_order: "Utos",
    GxBasketballJCResult_createAt: "Nilikha noong",
    UserAccount_trx_fee_total: "Bayarin sa TRX",
    UserSimulate_number: "Numero",
    Deal_contract: "Numero ng Pagpopondo sa Kontrata",
    Withdraw_balance: "Balanse",
    FlowLog_net_recharge: "Net Recharge",
    Protocol_partner_id: "Partner ID.",
    GXBasketballJc_compId: "Itugma ang Pangalan ng Item",
    Agent_status: "Katayuan ng Ahente",
    LotteryCategory_status: "Katayuan",
    UserLevel_recharge_total_from: "Kabuuang Recharge Mula sa",
    FeeLog_name: "Pangalan ng Stock",
    DepotStop_day_number: "Posisyon Ngayon",
    LotteryBetList_partner_id: "Partner ID",
    UserSimulate_we_chat: "WeChat",
    RechargeType_app_version: "Bersyon ng App",
    BetOrder_loss_amount: "Dami ng Nawala ng User",
    CoinAccount_frozen_balance: "Frozen Balanse",
    CoinRecharge_from_address: "Paglipat ng Address",
    ActivityNotice_status: "Katayuan",
    DealSimulate_commission: "Komisyon sa pangangalakal",
    Language_country_code: "Code ng bansa",
    CategoryList_type_description: "Uri ng Paglalarawan",
    Activity_app_image_en: "English APP Images",
    CapitalLog_type: "Uri",
    Baseconfig_description: "Paglalarawan ng Site",
    GxBeidanJcResult_status: "Katayuan",
    OtcTrade_user_name: "palayaw",
    Withdraw_partner_partner_name: "Pangalan sa Login ng Kasosyo",
    UserAccount_usdt_win_today: "USDT Araw-araw na Kita",
    Capital_remark: "Remarks",
    AgentFlowLog_agent_phone: "Numero ng Telepono",
    SubUser_id: "Pagkakakilanlan ng Gumagamit",
    Capital_name: "Pangalan ng Pananalapi",
    TimebaoLogType_language_ch: "Wika_ch",
    AgentFlowType_language_zh: "Pinasimpleng Chinese",
    News_source: "Pinagmulan ng Balita",
    SysConfig_register_create_agent: "Magrehistro ng Ahente",
    AgentReserve_partner_name: "Pangalan ng Kasosyo",
    Depot_capital: "Margin Trading ID",
    ActivityNotice_name: "Pamagat",
    SMS_uid: "User ID",
    OperatorInformation_ip_address: "Operator",
    CoinWithdraw_reject_reason: "Dahilan ng Pagtanggi",
    User_create_time: "Oras ng Pagpaparehistro",
    Baseconfig_trc20_refer_blocktime: "Oras ng Pag-block ng Sanggunian",
    Distance_time: "Unang Halaga ng Recharge",
    CoinChainType_chain_type: "Uri ng Public Chain",
    Wallet_partner_id: "Partner ID",
    RechargeMethod_payment_provider: "Provider ng Pagbabayad",
    BetBalance_trx_bet_amount: "TRX Recharge Halaga",
    FeeLog_commission: "Komisyon",
    Baseconfig_site_title: "Pangalan ng Site",
    InterestLog_id: "Numero",
    FeeLog_create_time: "Oras ng Order",
    TimebaoAccount_update_time: "Oras ng Pag-update",
    OtcTrade_consuming_time: "Pagtanggap ng Account",
    UserCoupon_uid: "User ID",
    Capital_cash: "Halaga ng Dibidendo",
    WeekVoucherManagement_uid: "User ID",
    RiskControl_user_phone: "Numero ng Telepono",
    AgentAccount_trx_commission_year: "Taunang Komisyon ng TRX",
    DepotStop_status: "Katayuan ng Stock",
    CoinRecharge_hash: "Transaksyon ng Deposito",
    First_total: "Unang Halaga ng Recharge",
    News_create_time: "Oras ng Paglikha",
    DepotStop_surplus_total: "Natitirang Halaga",
    TurnOn: "Umiiral na ang Pangalan sa Login ng Kasosyo",
    AgentManage_capital: "ID ng financing",
    Withdraw_bank: "Pangalan ng Bangko",
    Recharge_partner_id: "Partner ID",
    Deal_sell_total: "Kabuuang Halaga ng Benta",
    DealSimulate_mother: "Inang Account ID",
    HomeConfig_enter_copyright_rules: "Maglagay ng mga panuntunan sa copyright",
    UserAccount_user_caller: "Espesyalista sa Customer Service",
    SysConfig_email_smtp_auth_starttls_enable:
      "Email SMTP Authentication StartTLS Enable",
    GxBeidanJC_status: "Katayuan",
    GxBeidanJC_sell_status: "Katayuan ng Benta",
    HomeConfig_banners_label: "Banner",
    UserAccount_usdt_withdraw_fee: "Bayarin sa Pag-withdraw ng USDT",
    AgentDeferred_agent: "ID ng Ahente",
    AgentCommission_balance: "Balanse ng Komisyon",
    Lottery_create_time: "Oras ng Paglikha",
    ActivityLog_partner_name: "Pangalan ng Kasosyo",
    AgentCommission_ref_code: "Referral Code",
    News_udpate_time: "Oras ng Pagbabago",
    AgentAccount_agent_server_total: "Bayad sa Serbisyo",
    Minus_remark: "Remarks",
    DailyHistory_usdt_extra_1: "USDT Reserve 1",
    HomeConfig_content: "Nilalaman",
    Lottery_name_jp: "Hapon",
    BetOrder_blockID: "I-block ang Hash",
    CoinCurrency_decimal: "Token Precision / Default 1e18",
    GxBasketballJCResult_lqSfc: "Panalong Margin",
    PlusMinusType_type: "Uri ng Recharge Deduction",
    User_extension_type: "Paraan ng Promosyon",
    OtcMerchant_deposit_currency: "Pera ng deposito",
    Sell_win: "Bilang ng Panalo sa Pagbebenta",
    User_push_team: "Direktang Referral Team",
    DailyHistory_partner_id: "Partner ID",
    TimebaoAccount_lastcapital: "Huling Halaga ng Interes",
    No_holding_days: "Mga araw na walang Pambili",
    LanguageField_table_column: "Pangalan ng Field",
    EntrustSimulate_staff: "ID ng empleyado",
    CoinRecharge_reject_reason: "Dahilan ng Pagtanggi",
    TimebaoRate_effect_date: "Petsa ng Bisa",
    DailyHistory_user_user_number: "Address ng Wallet",
    BetType_id: "Numero",
    AgentManage_agent_real_name: "Superior na Pangalan",
    RechargeType_comment: "Remarks",
    UserAccount_trx_extra_2: "TRX Spare Field 2",
    UserAccount_trx_extra_1: "TRX Spare Field 1",
    UserAccount_trx_extra_3: "TRX Win/Los Resulta",
    Recharge_md5info: "Pag-encrypt",
    Recharge_txid: "Transaksyon HASH",
    SysConfig_default_agent: "Default na Ahente",
    CoinWithdraw_coin_chain_type: "Uri ng Kadena ng Barya",
    I118_language_ja: "Language_ja",
    Capital_fee_rate: "Rate ng Komisyon ng Transaksyon",
    OtcTrade_trade_type: "Uri ng Order",
    MonthlyHistory_ref_code: "Referral Code ng Kasosyo",
    I118_type: "Uri ng mensahe",
    Capital_id: "Numero",
    RechargeType_channel: "Channel",
    BetOrder_token: "Uri ng TOKEN: 1 - USDT, 0 - TRX",
    Minus_uid: "Gumagamit",
    VoucherManagement_balance: "Balanse",
    CoinAccountDetail_user_real_name: "Tunay na Pangalan",
    DepotStop_mother: "ID ng Ina Warehouse",
    DealSimulate_fee: "Komisyon sa pangangalakal",
    Parameter_update_by: "Updater",
    RiskControl_detail: "Detalyadong Paglalarawan",
    Protocol_id: "Numero",
    RiskControl_status: "Katayuan",
    Activity_pc_image_2: "Iba pang 2 Mga Larawan ng PC",
    Activity_pc_image_3: "Iba pang 3 Mga Larawan ng PC",
    Activity_pc_image_1: "Iba pang 1 Mga Larawan ng PC",
    SysConfig_time_interval: "Instant Treasure Interval",
    UserCoupon_effect_date: "Petsa ng Bisa",
    TimebaoLog_interest_rank1: "Tiered Interes 1",
    Account: "Kabuuang Balanse ng Account",
    TimebaoLog_interest_rank2: "Tiered Interes 2",
    TimebaoAccount_modify_time:
      "1 - Awtomatikong Paglipat In/Out, 0 - Manu-mano",
    Lottery_image_ch: "Larawan sa Tradisyunal na Tsino",
    LotteryType_rule_3: "Iba pang Panuntunan 3",
    Deal_extra_fee3: "Mga Bayarin sa Platform",
    LotteryType_rule_2: "Iba pang Panuntunan 2",
    BetType_amount_pc_2: "Halaga_pc_2",
    JobLog_module: "Modyul ng Pagpapatupad",
    Deal_extra_fee2: "Mga Bayad sa Settlement",
    LotteryType_rule_1: "Iba pang Panuntunan 1",
    BetType_amount_pc_1: "Halaga_pc_1",
    Deal_extra_fee1: "Mga Bayarin sa Paghawak ng Produkto",
    CoinRecharge_auditor: "Account ng Processor",
    AgentAccount_name: "Pangalan",
    AgentFlowLog_total: "Kabuuang Halaga",
    BetType_amount_pc_3: "Halaga_pc_3",
    TimebaoLog_user_real_name: "Pangalan",
    OtcMerchant_deposit_volume: "Halaga ng deposito",
    EntrustSimulate_short: "Maikling Code ng Stock",
    UserAccount_trx_bet_year: "Mga Taunang Taya ng TRX",
    MonthlyHistory_trx_times: "Bilang ng Taya ng TRX",
    I118_use_way: "Lokasyon ng paggamit",
    WeekVoucherManagement_agent: "Ahente",
    Minus_token: "Token",
    AgentManage_remark: "Oras ng Transaksyon",
    Baseconfig_sys_checkinamount: "Mag-sign-in para sa Voucher",
    AgentFlowLog_partner_name: "Pangalan ng Kasosyo",
    FriendCouponLog_remark: "Remarks",
    Agent_mother: "Inang Account ID",
    Bond_total: "Margin sa Operasyon",
    LotteryResult_bet_money: "Kabuuang Halaga ng Taya",
    SMS_status: "Katayuan",
    FlowLog_partner_refCode: "Reference Code ng Kasosyo",
    TimebaoLog_interest_rank3: "Tiered Interes 3",
    CoinRecharge_address: "Address ng Deposito",
    DepotSimulate_create_time: "Oras ng Pagbubukas",
    Deal_capital: "ID ng financing",
    Capital_user_phone: "Numero ng Telepono",
    MidokeMessage_appkey: "Susi ng Application",
    HomeConfig_menus_label: "Menu",
    CoinWithdraw_oper_ip: "IP ng Operasyon ng User",
    Baseconfig_smsbao_url: "URL ng Pakete ng SMS",
    UserSimulate_code: "Referral Code",
    Baseconfig_default_agent_reserve: "Default na Proxy Template",
    Community_name: "Pangalan",
    Sell_loss: "Bilang ng Pagkalugi sa Pagbebenta",
    OtcMerchant_id: "Numero",
    Baseconfig_sms_password: "Password ng SMS",
    LotteryType_select_nums: "Bilang ng Mga Numero sa bawat Taya",
    UserSimulate_last_token_time: "Huling TOKEN Time",
    CoinRecharge_id: "Numero",
    SysConfig_code_required: "Nangangailangan ng Referral Code",
    FriendCouponLog_create_time: "Oras ng Paglikha",
    CoinWithdraw_partner_id: "Partner ID",
    Baseconfig_sms_account: "SMS Account",
    Baseconfig_downgrade_image: "I-downgrade ang Imahe",
    FeeLog_fee: "Komisyon sa pangangalakal",
    User_password: "Password",
    Baseconfig_trade_time: "Oras ng kalakalan",
    Baseconfig_trc20_task: "Mga Gawain sa TRC20",
    BetOrder_coin_address: "Recharge Address",
    BetType_name_zh: "Tradisyonal na Pangalan ng Tsino",
    LotteryBetList_user_phone: "Telepono",
    OtcTrade_create_time: "Oras ng Paglikha",
    Partners_logo: "Identifier",
    CoinRecharge_transaction_id: "ID ng Transaksyon",
    GxBeidanJcResult_halfAwayScore: "Half-Time Away na Marka ng Koponan",
    AgentAccount_usdt_commission_today: "Pang-araw-araw na Komisyon ng USDT",
    FlowLog_user_real_name: "Pangalan",
    Baseconfig_trading_popup_image_mob:
      "Larawan ng APP para sa Mga Detalye ng Notification na Non-Trading",
    Capital_manage: "Bayad sa Pamamahala",
    Baseconfig_company_qq1: "QQ Customer Service 1",
    FeeLog_staff: "ID ng empleyado",
    Baseconfig_company_qq2: "QQ Customer Service 2",
    HomeConfig_enter_route: "Ipasok ang path ng pag-click",
    WeekVoucherManagement_admin: "Operator",
    TimebaoLogType_partner_partner_name: "Pangalan ng Kasosyo",
    OtcOrder_create_time: "Oras ng Paglikha",
    Login_freeTrial: "Libreng Pagsubok",
    OtcPaymentType_type: "Uri",
    CoinAccountDetail_currency: "Uri ng Pera",
    WeekVoucherManagement_id: "Numero",
    First_trans_date: "Petsa ng Unang Pagbili",
    UserAccount_partner_refCode: "Reference Code ng Kasosyo",
    UserAccount_trx_recharge_fee: "Bayarin sa Deposito ng TRX",
    Depot_sell_total: "Kabuuang Halaga ng Pagbebenta",
    Agent_login_ip: "IP sa pag-login",
    Entrust_capital_order: "Kontrata ng Diskarte",
    SysConfig_lottery_task: "Gawain sa Lottery",
    I118_controller: "Source module",
    OtcChat_create_time: "Oras ng Paglikha",
    Lottery_image_en: "Larawan sa Ingles",
    Recharge_user_real_name: "Pangalan",
    PlusMinusType_partner_id: "Partner ID",
    data: "Data",
    TimebaoAccount_interest_last: "Interes Noong nakaraang Buwan",
    User_ip: "IP ng pagpaparehistro",
    CoinRecharge_create_time: "Oras ng Deposito",
    DepotStop_buy_total: "Kabuuang Halaga ng Mga Pagbili",
    AgentFee_balance: "Balanse",
    Withdraw_order: "Numero ng Order",
    Capital_renew_time: "Oras ng Pag-renew",
    PowerInterest_cq_cxr_h_ssr_zf:
      "Pagtaas ng Presyo pagkatapos ng 30 Araw na dating mga karapatan (%)",
    Activity_day_limit: "Limitasyon sa Pagbili",
    FriendCouponLog_amount: "Halaga",
    AgentDeferred_staff: "ID ng empleyado",
    Baseconfig_stock_limit_price: "Limitahan ang Presyo ng Trading",
    LotteryCategory_name_ch: "Tradisyunal na Tsino",
    CoinRechargeAddr_trx_total: "Kabuuang TRX",
    FlowLog_create_time: "Oras",
    CategoryList_status: "Katayuan",
    User_id: "User ID",
    WalletCollectHistory_from_address: "Address ng Wallet",
    LotteryGroup_name_zh: "Paglalarawan ng Tsino",
    Protocol_create_time: "Oras ng Paglikha",
    DailyHistory_user_user_name: "palayaw",
    DepotStop_short: "Maikling Code ng Stock",
    LotteryGroup_lottery_id: "Lottery ID",
    FeeLog_id: "Numero",
    CoinWithdrawAddr_currency_chain_type: "Partner ID",
    CapitalLog_num: "Dami ng Deal",
    BetOrder_paid_time: "Oras ng Pagbabalik",
    noPendingBets: "Walang nakabinbing taya",
    Baseconfig_popup_pc_switch: "PC Popup Switch",
    Recharge_from_address: "Account/Address ng Customer",
    DailyHistory_usdt_win_total: "Halaga ng Panalo ng USDT",
    BetType_max_trx_block_timestamp: "Pinakamataas na TRX Block Time",
    Parameter_remark: "Remarks",
    Entrust_capital: "ID ng financing",
    Recharge_user_phone: "Telepono",
    FirstVoucher_id: "Numero",
    LotteryMaxResult_blockNumber: "Taas ng Block",
    Baseconfig_is_before_recharge: "Non-Recharge Popup Switch",
    CoinCurrency_is_otc:
      "Paglalarawan Kapag Hindi Magagamit ang Pag-withdraw (Ingles)",
    AgentManage_staff: "ID ng empleyado",
    AgentFee_staff_fee: "Komisyon ng Empleyado",
    AgentManage_user_real_name: "Pangalan",
    here: "Dito",
    Baseconfig_transcan_block_url: "I-block ang Link ng Impormasyon",
    RechargeType_id: "Numero",
    Baseconfig_stock_prohibit_price:
      "Ipagbawal ang Pagbili/Pagbebenta ng Presyo",
    TronExchange_id: "Numero",
    EntrustSimulate_commission: "Komisyon",
    UserAccount_first_voucher_done: "Naipadala na",
    CoinRecharge_gas: "kung",
    LotteryCategory_name_en: "Ingles",
    OtcTrade_order_id: "Sariling Order ID",
    InterestLog_capital: "Margin Trading ID",
    Entrust_id: "Bersyon",
    TimebaoLog_coin_currency_id: "Digital Currency ID",
    DepotSimulate_surplus: "Nananatiling Available",
    updateKycDetails: "I-verify Ngayon",
    GxBeidanJcResult_updateAt: "Na-update noong",
    LotteryBetList_bet_times: "Multiplier ng Pagtaya",
    BetType_coin_address: "Recharge Address",
    "Home_Management_fee_income_day ":
      "Kita sa Bayad sa Pamamahala para sa Araw",
    Parameter_tip: "Paglalarawan ng Parameter",
    CapitalLog_remark: "Remarks",
    GxBeidanJC_beidanId: "North Dandan ID",
    LotteryMax_partner_name: "Pangalan ng Kasosyo",
    Entrust_type: "Uri 0: Bumili 1: Ibenta",
    Help_title: "Pamagat",
    Activity_status: "Katayuan | 1 Wasto, 0 Di-wasto",
    Job_update_by: "Updater",
    HomeConfig_app_download: "Prompt sa pag-download ng app",
    HomeConfig_content_heading: "Pamagat ng nilalaman",
    Activity_title_zh: "Pinasimpleng Pamagat ng Tsino",
    Activity_total: "Kabuuang Bahagi",
    OtcAccountDetail_before_info: "Nakaraang Impormasyon ng Account",
    GxBeidanJcResult_beidanJC_ResultID: "Numero",
    Parameter_value: "Susi ng Parameter",
    GxBeidanJcResult_issue: "Isyu",
  },
  phone: {
    codeRequired:
      "Ilagay ang verification code na kinakailangan para sa certification",
    incorrect: "Error sa verification code",
    notEqual: "Hindi mababago ang numero ng telepono",
    cannotEmpty: "Sports Live",
    required: "Magbigay ng numero ng telepono",
    Existing: "Nakarehistro na ang kasalukuyang numero ng telepono",
    verifyError: "Error sa Captcha",
  },
  refund: {
    system: "Rebate sa Aktibidad",
    manual: "Rebate sa Customer Service",
  },
  operateDay: {
    alertM:
      "Kapag ang kabuuang margin trading fund ay bumaba sa ilalim ng linya ng pagpuksa, inilalaan namin ang karapatang likidahin ang iyong mga stock. Upang maiwasan ang pagpuksa, pakitiyak na sapat ang iyong punong-guro sa lahat ng oras.",
  },
  otcAds: {
    unitPrice: "Presyo ng unit",
    buyOnline: "Bumili online",
    sellOnline: "Magbenta online",
    regDate: "Oras ng pagpaparehistro",
    dayTrans: "30-araw na order ng transaksyon",
    masterRate: "Kabuuang order ng transaksyon",
    operate: "Operasyon",
    payMethod: "Paraan ng pagbabayad",
    quota: "Limitahan",
    qty: "Dami",
    avgRate: "Average na paglabas",
    comRate: "30-araw na rate ng pagkumpleto",
    verify: "Pagpapatunay ng totoong pangalan",
    currency: "Pangkalakal na pera",
    merchDeposit: "margin ng mangangalakal",
  },
  login: {
    SignInBtn: "Mag-login",
    Account: "Account",
    registerkey: "Magrehistro na",
    forgetPassword: "Nakalimutan ang password?",
    passwordNotMatch: "Hindi tugma ang mga password",
    AddressError: "Nawala ang address ng pitaka",
    phoneNum: "Telepono",
    ForgotPasswordlink: "Nakalimutan ang iyong password?",
    signUp: "Magrehistro na",
    emailplaceholder: "I-email",
    password: "Password",
    logout: "Mag-logout",
    enterCaptcha: "Pakipasok ang code sa pag-verify ng larawan",
    AccountLogin: "Account",
    PasswordError: "Pakilagay ang password ng iyong account",
    onlineService: "Online Customer Service",
    resendVerifyCode: "Muling ipadala pagkatapos ng {title} segundo",
    sendVerifyCode: "Ipadala ang Verification Code",
    pleaseLogin: "Kumusta, mangyaring mag-log in",
    forgotPass: "Nakalimutan ang password?",
    isSimulate: "Libreng Pagsubok",
    resetPasswordBtn:
      "Kung naaalala mo ang iyong password, mangyaring mag-log in nang direkta",
    walletAdrNotExists: "Mali ang address ng pitaka o password, pakipasok muli",
    phoneLogin: "Telepono",
    AccountPlaceHolder: "Mga Numero at Titik Lamang",
    emailLogin: "I-email",
    accountNotExists: "Mali ang input ng account o password, pakisubukang muli",
    enterPhone: "Mangyaring ipasok ang numero ng mobile",
    passwordTip: "Ang password ay dapat na 6-15 alphanumeric na character",
    Login: "Mag-login",
    createAccount: "Lumikha ng Account",
    invalidLoginMethod: "Di-wastong paraan ng pag-log in, pakisuri muli",
    ForgotPassword: "Bago?",
    phoneNumber: "Numero ng Telepono",
    success: "Isang default na pera lang ang pinapayagan",
    phonePlaceholder: "Mangyaring ipasok ang iyong numero ng telepono",
    phoneFormatIncorrect: "Maling format ng numero ng telepono",
    passwordIncorrect: "Maling input ng password, pakisubukang muli",
    Greeting:
      "Kumusta, maligayang pagdating sa {company_name} trading platform!",
    WalletLogin: "Wallet",
    passwordPlaceholder: "Mag-login",
    loginkey: "Mag-login",
    login: "Mag-login",
    title: "Mag-login",
    emailValidate: "Mangyaring magpasok ng email",
    forgotPassword: "Nakalimutan ang Password?",
    UserNameError: "Mangyaring ipasok ang iyong palayaw sa account",
    lineThree: "Ikatlong Linya",
    captchaIncorrect: "Maling code sa pag-verify ng larawan",
    Home: "Home",
    email: "I-email",
    Password: "Password",
    newUserNotice: "Bagong LOTO365?",
    PasswordPlaceHolder: "Password",
    submitButton: "Mag-login",
    phoneNoNotExists: "Walang numero ng telepono",
    verifyCode: "Verification code",
    UserName: "Account",
    verifyCodeLogin: "OTP login",
    Wallet: "Wallet",
    invalidAreaCode: "Hindi Nagtutugma ang Code ng Bansa",
    dontHaveAccount: "Walang account?",
    invalidAccount: "Walang account",
    TouristLogin: "Maglaro nang walang pagpaparehistro",
    enterPassword: "Mangyaring ipasok ang password sa pag-login",
    emailNotExists: "Walang email",
    ConfirmPassword: "Bagong Password",
    userLogin: "Login ng user",
    WalletPlaceHolder: "Desentralisadong wallet (TRC-20 USDT)",
    Register: "Magrehistro",
    resend: "Muling ipadala",
    UserAccountDisable: "Hindi magagamit ang user account",
    SignIn: "Mag-log in <br /> Ang iyong account",
    loginError: "Mali ang account o password",
    passwordusernamenotmatch: "Kopyahin",
    phnplaceholder: "Mangyaring ipasok ang numero ng telepono",
    phoneValidate: "Mangyaring ipasok ang numero ng telepono",
    account: "Account",
    register: "Magrehistro",
    confirmLogout: "Sigurado ka bang gusto mong mag-logout?",
    logoutSuccess: "Pakipasok ang {title}",
  },
  moreTrendPC28: {
    specialPlay: "Espesyal na gameplay",
    guess: "Hulaan ang Numero",
    singleDouble: "Malaki Maliit Odd Even",
    Guessysum: "Hulaan ang Numero",
    GuessNum: "Espesyal na Numero",
  },
  popupthree: {
    set: "I-set up",
    ignore: "Huwag pansinin",
    content: "Kinakailangan ang pag-setup ng security code",
  },
  pcPProcess: {
    TabtwoColumntwo: "Website",
    TaboneHeading: "Magrehistro ng desentralisadong pitaka",
    TaboneColumnone: "Magrehistro ng desentralisadong pitaka",
    Heading: "Proseso ng pakikilahok",
    Tabthree: "Maglagay ng taya gamit ang isang desentralisadong pitaka",
    TabfourHeading2: "Pamagat 2",
    TabtwoColumnone: "Plataporma",
    Tabtwo: "Bumili ng USDT/TRX sa isang palitan",
    Tabone: "Magrehistro ng desentralisadong pitaka",
    TabtfourHeading: "Pamagat",
    TaboneColumnthree: "Tutorial",
    TabwoHeading: "Bumili ng USDT/TRX sa isang palitan",
    tabfour:
      "Ang premyo ay awtomatikong ibabalik nang mabilis pagkatapos manalo",
    TabthreeColumnthree: "Tutorial",
    Tabthreetitle: "Pamagat",
    TaboneColumntwo: "Website",
    TabthreeHeading: "Maglaro gamit ang isang desentralisadong pitaka",
    TabthreeHeading2: "Pamagat",
  },
  pkNewGames: {
    quickBets: "Mabilis na taya",
    betMultipler: "Multiplier ng taya",
    estGain: "Est Gain",
    lotteryImgBoxTitle: "Piliin ang iyong mga masuwerteng item",
    placeBet: "$ Ilagay ang taya",
    mainTitle: "Mga Huling Resulta",
    Selected: "Napili",
    inSertValue: "Ipasok ang Halaga",
    bets: "Taya",
    betValueRule: "Ang halaga ay dapat na higit sa 0",
  },
  profitdetail: {
    Profit: "Kita",
  },
  forgotPassword: {
    smsVerificationCode: "SMS verification code",
    getVerificationCode: "Kunin ang Verification Code",
    submitButton: "Kumpleto",
    newPasswordPlaceholder: "Pakipasok ang bagong password",
    confirmPasswordPlaceholder: "Kumpirmahin ang bagong password",
    back: "Bumalik",
    newPassword: "Bagong Password",
    title: "Nakalimutan ang Password",
    verificationCode: "Verification Code",
    verificationCodePlaceholder: "Pakilagay ang verification code",
    phoneFormatError: "Maling format ng numero ng telepono",
    phone: "Numero ng Telepono",
    phonePlaceholder: "Mangyaring ipasok ang iyong numero ng telepono",
    confirmPassword: "Kumpirmahin ang Bagong Password",
    smsCodePlaceholder: "Pakilagay ang SMS verification code",
  },
  navbar: {
    AppTitle: "365LOTO",
  },
  otcOrdrDtl: {
    selectBank: "Mangyaring pumili ng uri ng pagbabayad",
  },
  recharge: {
    rechargeRange: "Saklaw ng Pag-charge",
    CopyLink: "Kopyahin",
    Minimum: "Minimum na halaga ng recharge",
    Address: "Recharge Address",
    onlyDepositing:
      "*Sa pamamagitan lamang ng pagdeposito sa pamamagitan ng pop-up na ito ay madodoble ang bonus.",
    timeBonus: "TIMES ang bonus!",
    multipliedReward: "Maramihang Gantimpala",
    contToRecharge: "Ipagpatuloy ang bagong recharge",
    waitingForInformation: "Nakabinbing kumpirmasyon",
    SelectRechargeType: "Piliin ang Uri ng Recharge",
    Information: "Mag-recharge sa tinukoy na wallet address sa ibaba",
    multiplierReward: "Mga Multiplier na Gantimpala",
    RechargeAmount: "Halaga ng Recharge",
    amountGreater: "Ang halaga ng recharge ay dapat na higit sa 100 yuan.",
    checkedVerified: "Pakisuri ang na-verify na button.",
    Network: "Mainnet",
    RechargeName: "Pangalan ng Nagbabayad",
    enterAmount: "Pakilagay ang tamang halaga ng recharge.",
    continueClaiming: "Magpatuloy sa Pagtanggap",
    thirdPartyFailed: "Pagkabigo ng Ikatlong Partido",
    claim: "PARA MAKATANGGAP",
    enterName: "Pakilagay ang pangalan ng nagbabayad.",
    rechargeType: "Piliin ang Iyong Paraan ng Pag-recharge",
    win: "panalo",
    rechargeInstructions:
      "Kumuha ng real-time na deposit card nang mag-isa sa pamamagitan ng mobile/computer/bank transfer.",
    doMore: "Gumawa ng higit pa",
    multiple: "maramihan",
    Title: "Mag-load",
    enterType: "Pumili ng uri.",
    makeAnotherDeposit: "Gumawa ng isa pang deposito",
    submitAgain:
      "Nagsumite ka ng recharge ng parehong halaga na kasalukuyang sinusuri at pinoproseso. Mangyaring huwag muling isumite kung hindi ito bagong recharge.",
    statusCancelled: "Kabiguan",
    enterPassword: "Ipasok ang password.",
    depo: "deposito",
    cashback: "LIBRENG CASHBACK",
    statusSuccessful: "Tagumpay",
    Copy: "Kopyahin ang address",
    deposit: "Deposito",
    WalletTitle: "Mangyaring gamitin ang iyong desentralisadong wallet",
    noNewRecharge: "Hindi bagong recharge",
  },
  paymentMethods: {
    set: "Mga setting",
    update: "Nakatakda na",
    title: "Paraan ng pagbabayad",
  },
  pcaboutus: {
    LotResTitonecontent:
      "Ang block hash ay gumuhit nang random at hindi makontrol, patas, makatarungan, at transparent",
    WMoneyTitle2cont:
      "Ang mga withdrawal ay nangangailangan ng pagtatasa ng panganib, lahat ay kinokontrol ng platform",
    RegandRechTitle1cont:
      "Ang pagpaparehistro ay nangangailangan ng buong tunay na pangalan na pag-verify, kumpletong impormasyon ng bank card",
    LotteryResults: "Mga resulta ng lottery",
    LotResTitletwocont:
      "Tsansang pagmamanipula ng mga itim na platform sa mga panalong logro at resulta",
    PlatformStrength: "Lakas ng platform",
    WhyChooseUs: "Bakit tayo pipiliin",
    LotResTitletwo: "Mga tradisyunal na laro ng paghula",
    RegandRechTitletwo: "Mga tradisyunal na laro ng paghula",
    PStrengthTitle2cont:
      "Behind-the-scenes operations, limitadong prize pool, madaling ma-collapse, tumakas, at pagtanggi na magbayad.",
    PStrengthTitleone: "Hash guessing games",
    WithdrawMoney: "I-withdraw ang mga panalo",
    RegandRechTitleone: "Hash guessing games",
    WMoneyTitle1cont:
      "Awtomatikong tinutukoy ng sistema ng panalong ang mga settlement nang walang kontrol sa panganib, pagbabayad sa loob ng 10 segundo sa wallet",
    RegandRechTitle2cont:
      "Ang pagpaparehistro ay nangangailangan ng buong tunay na pangalan na pag-verify, kumpletong impormasyon sa bank card, madaling pagkaantala sa mga deposito, o kahit na malisyosong pag-iingat ng mga pondo",
    RegisterandRecharge: "Pagpaparehistro at mga deposito",
    PStrengthTitletwo: "Mga tradisyunal na laro ng paghula",
    WMoneyTitletwo: "Mga tradisyunal na laro ng paghula",
    LotResTitleone: "Hash guessing betting games",
    WMoneyTitleone: "Hash guessing betting games",
    PStrengthTitle1cont:
      "Patas, patas, transparent, multimillion-dollar na premyong pool, real-time na pamamahagi ng premyo",
  },
  member: {
    ChangePassword: "Itakda ang password sa pag-login",
    Email: "I-email",
    line: "Mga linya",
    SecuritySettings: "Mga Setting ng Seguridad",
    lineSwitch: "Paglipat ng linya",
    ChooseLanguage: "Piliin ang preset na wika",
    historyRecord: "Tala ng Kasaysayan",
    agentRight: "QR Code",
    CommissionDesc: "Komisyon ng ahente ng paglipat",
    TrcAddress: "Withdrawal wallet",
    sms: "Telepono",
    LanguageText: "Mga setting ng wika",
    SecurityText: "Password sa pag-login",
    lineSwitchPopCancel: "Kanselahin",
    TrcAddressTopic: "Address ng wallet sa pagtaya (TRC20 USDT)",
    betHistory: "Kasaysayan ng taya",
    Settings: "Mga setting",
    email: "E-mail",
    LogoutText: "Lumabas",
    SafetyPasswordInfo: "Baguhin ang password sa pag-login",
    coupon: "Tubusin",
    agentPromo: "Promo ng Ahente",
    CommissionText: "Komisyon ng ahente",
    BindWalletAddress: "Idagdag, itali ang address ng wallet sa pagtaya",
    realName: "Totoong Pangalan",
    LogoutApp: "Lumabas sa App",
    lineSwitchPopConfirm:
      "Ang pagpaparehistro ay nangangailangan ng buong tunay na pangalan na pag-verify, kumpletong impormasyon sa bank card, madaling pagkaantala sa mga deposito, o kahit na malisyosong pag-iingat ng mga pondo",
    instruction:
      "Kumpletuhin ang pag-verify ng account para protektahan ang iyong account at pataasin ang mga limitasyon sa transaksyon.",
    SMS: "SMS",
    OtherServer: "Iba pang mga pag-andar",
    SafetyPassword: "Password ng seguridad",
    username: "Account",
  },
  verify: {
    setUserName: "Pag-verify ng Username",
    ContactService2: "Mangyaring makipag-ugnayan sa customer service",
    ContactService1: "Di-wastong Captcha?",
    addUserName: "Isumite",
  },
  betHistory: {
    estPayout: "Tinantyang Pagbabayad",
    amount: "Halaga",
    winner: "Nagwagi",
    Payout: "Paggasta",
    settled: "Naayos na",
    myBets: "Mga Pusta ko",
    odds: "Odds",
    active: "Positibo",
    bets: "Taya",
    totalStake: "Kabuuang Equity",
    viewAll: "Tingnan Lahat",
    cashout: "Pag-withdraw",
  },
  reward: {
    depositUnavailable: "Mag-claim pagkatapos mag-recharge",
    dailyRewardPerPerson: "Kabuuang bilang ng mga reward bawat tao:",
    topBoxHeadingOne: "Kabuuang Halaga ng Premyo",
    perPerson: "tao bawat session ngayon",
    randomRewardTitle: "Random na masuwerteng premyo",
    congratulations: "Binabati kita..!!",
    dailyRewardPerDay: "Bilang ng mga reward bawat araw:",
    randomUnavailable: "Kasalukuyang hindi magagamit",
    validityPeriod: "Panahon ng Bisa:",
    todayRechageBlindBox: "Mga Gantimpala sa Blind Box:",
    todayRechRewardNum: "Kabuuang bilang ng mga reward:",
    couponAmount: "Halaga ng Kupon",
    dailySignInTitle: "Mga user na hindi na-recharge",
    todayRechageLevel: "Antas ng Recharge:",
    alreadyClaim: "Na-claim na",
    noReward: "Walang Gantimpala",
    claim: "I-click para i-claim",
    topBoxHeadingTwo: "Na-claim na",
    wonCoupon: "premyo! Nanalo ka a",
    popupHeading: "₱1000 na Bonus!",
    dailySignIn: "Araw-araw na premyo",
    topBoxSubOne: "1000",
    congratYouWon: "Congratulations.. nanalo ka sa",
    coupon: "kupon",
    unlimited: "Hindi available ang kupon! Subukan muli.",
    mystBoxReward: "Mga Gantimpala sa Mystery Box",
    surpriseRewards: "Mga Gantimpala ng Sorpresa",
    dailyRewardNum: "Kabuuang bilang ng mga reward:",
    claimAmount: "Na-claim na Halaga:",
    anytime: "Kahit kailan",
    cliclOnMysteryBox: "Mag-click sa Surprise Box",
    click: "I-click",
    missionRewards: "Mga Gantimpala sa Misyon",
    rechargeDailySignIn: "Araw-araw na premyo",
    nondepositUnavailable: "Mag-claim pagkatapos mag-recharge",
    dailyRewardTime: "Oras ng reward:",
    todayRechRewardTime: "Oras ng mga reward:",
    todayRechRewardPerDay: "limitado sa",
    todayUnavailable: "Mangyaring mag-claim pagkatapos mag-recharge ngayon",
    daily: "Araw-araw",
    alreadyClaimToday: "Nabigyan ng bonus. Subukan bukas.",
    randomReward: "Lucky mystery Box Random Rewards",
    todayRechargeTitle: "Mga recharged na user ngayon",
    todayRecharge:
      "Mga user na nagre-recharge ngayon, may reward ang mystery box",
    randomBlindBox: "premyo",
    rechargeDailySignInTitle: "Mga recharged na user",
    noTaskRewards: "Walang reward sa gawain sa ngayon",
  },
  coupon: {
    pleaseCopyToClaim: "Pakikopya ang redeem code para ma-claim.",
    instruct: "Pindutin nang matagal para i-paste.",
    Copy: "Kopyahin",
    exchangeReward: "MAGPALIT NG REWARD",
    claimCoupon: "Mag-claim ng Kupon",
    eneterPasteRedeem: "Ilagay/I-paste ang coupon redeem code",
    enterOrPaste: "Ilagay/Idikit...",
    paste: "Idikit",
    goToclaim: "Bisitahin ang pahina ng claim",
  },
  otcUser: {
    insuffAssert:
      "Hindi sapat ang kasalukuyang available na mga asset, mangyaring bumili/mag-recharge/maglipat muna",
  },
  menu: {
    LotteryMaxResult: "Pinakamataas na Resulta ng Lottery",
    CoreSet: "Mga Pamantayan sa Bayad",
    AgentDivide: "Bahagi ng Kita",
    FoundWinners: "Tuklasin ang Bull Stocks",
    Store: "Pamamahala ng mangangalakal",
    Activity: "Pamamahala ng aktibidad",
    AgentManage: "Hati ang Bayad sa Pamamahala",
    ChatGroupMessageLog: "Log ng mensahe ng grupo ng chat",
    TimebaoBatchLog: "Batch Processing Logs",
    UserSimulate: "Simulated User Management",
    Currency: "Pamamahala ng pera",
    OperLog: "Log ng Operasyon",
    AgentAccount: "Mga Account ng Ahente",
    MassageFolder: "Serbisyong pangkalusugan",
    WalletFolder: "Pamamahala ng wallet",
    TradeChannalLog: "Trade Channel Log",
    HomeCapital: "Pamamahala ng User",
    CapitalLogType: "Uri ng Capital Log",
    Minus: "Backend Deduction",
    Stock: "Pamamahala ng Stock",
    BetOrder: "Order ng Laro",
    UserVip: "User VIP Level",
    RiskControl: "Log ng Pagkontrol sa Panganib",
    Bank: "Bangko",
    PartnerAdmin: "Talahanayan ng Administrator ng Kasosyo",
    UserNotice: "Notification ng impormasyon",
    CapitalType: "Mga Uri ng Margin Trading",
    CoinFlowType: "Uri ng Transaksyon",
    CoinChainType: "Uri ng token chain",
    Protocol: "Iba pang Nilalaman",
    Sysconfig: "System Configuration",
    FriendCoupon: "Friend Cash Coupons",
    GxFootballJCResult: "Mga Resulta ng GX Football JC",
    Baseconfig: "Pangunahing Configuration",
    GxLeague: "Mga Liga ng GX",
    RsaKey: "Encryption key",
    ThirdPartyGames: "Mga Praktikal na Laro",
    Partners: "Kasosyo",
    Parameter: "Configuration ng Parameter",
    VoucherManagement: "Mga Voucher ng User",
    LotteryBetList: "Mga Order ng Taya",
    PragmaticGames: "Mga praktikal na laro",
    DepotStop: "Mga Nasuspinde na Posisyon",
    FlowLog: "Log ng transaksyon",
    CompanyAliPay: "Kumpanya Alipay",
    UserAddress: "Address ng gumagamit",
    AgentFlowLog: "Mga Transaksyon ng Ahente",
    AgentDailyDepot: "Ahente Daily Warehouse",
    Uploadconfig: "Thumbnail Configuration",
    InterestLog: "Margin na Pagbabayad ng Interes",
    Test: "Module ng Pagsubok",
    GXSportsGames: "GX Sports Games",
    ComplainType: "Uri ng Ulat",
    ActivityNotice: "Uri ng Produkto",
    OtcPaymentType: "Uri ng Pagbabayad",
    Evaluation: "Pagsusuri ng user",
    GxGameType: "Mga Uri ng Laro ng GX",
    EMS: "Pamamahala ng email",
    Deal: "Pamamahala ng Deal",
    ActivityFolder: "Mga Aktibidad sa Anunsyo",
    VoucherCash: "Mga Kupon sa Cash ng Gumagamit",
    Role: "Pamamahala ng Tungkulin",
    GxBetOrder: "Order ng GX Sports Bet",
    Bankaccountnumber: "Bank Account Number",
    OrderService: "Mga detalye ng serbisyo",
    TimebaoLogType: "Uri ng Log",
    GxBetList: "Listahan ng GX Bet",
    OtcOrder: "Merchant Advertisement",
    PartnerRole: "Talahanayan ng Tungkulin ng Kasosyo",
    AgentFolder: "Pamamahala ng Ahente",
    Action: "Pamamahala ng Pamamaraan",
    ExchangeRate: "Pamamahala ng Exchange Rate",
    FirstVoucher: "Mga Unang Recharge na Aktibidad",
    UserLevel: "Mga Antas ng Pag-recharge ng User",
    WeekVoucherManagement: "Pag-apruba ng mga Reward Voucher",
    System: "Pamamahala ng System",
    ChatHistoryData: "Data ng talaan ng chat",
    FeeLog: "Komisyon sa pangangalakal",
    UserControl: "User Risk Control",
    Field: "Pamamahala sa larangan",
    Language: "Pamamahala ng Wika",
    AgentFlowType: "Uri ng Daloy ng Ahente",
    News: "Pamamahala ng Balita",
    Home: "Home",
    Room: "Mga setting ng kwarto",
    Coupon: "Kupon ng diskwento",
    TimebaoLog: "Mga Log sa Pananalapi",
    Withdraw: "Pamamahala ng Withdrawal",
    DeferLog: "Delay Log",
    AgentDeferred: "Ipinagpaliban ang Hati sa Bayad",
    DailyHistory: "Pang-araw-araw na Istatistika",
    AboutUs: "Tungkol sa amin",
    GXBasketballJc: "Numero",
    ParameterFolder: "Mga Uri ng Margin Trading",
    Logininfor: "Log sa pag-login",
    OtcAccountHistory: "Kasaysayan ng OTC Trading Account",
    OtcMerchant: "Pamamahala ng mangangalakal",
    MidokeMessage: "Mensahe ng Midoke",
    MonthlyHistory: "Buwanang Istatistika",
    LotteryType: "Lottery Group",
    JobLog: "Log ng gawain",
    UserAccount: "User Account",
    OtcFolder: "Fiat kalakalan",
    Community: "Komunidad",
    StatisticFolder: "Data ng Istatistika",
    UserFolder: "Gumagamit",
    GxBasketballJCResult: "Resulta ng GX Basketball JC",
    RechargeType: "Uri ng recharge",
    AgentFee: "Hatiin ang Log",
    Recharge: "Pamamahala ng Recharge",
    I118: "Mensahe sa Wika",
    FinanceFolder: "Idle Money Manager",
    OtcAccountInfo: "Merchant Receiving Account",
    Complain: "Pamamahala ng Reklamo",
    CapitalTest: "Capital Test",
    LotteryCategory: "Lottery Group",
    Operations: "Operasyon",
    OtcAccountDetail: "Impormasyon ng Account",
    Agent: "Pamamahala ng Mga Account ng Ahente",
    ChatGroupMember: "Mga miyembro ng chat group",
    CoinWithdraw: "Pag-withdraw ng Token",
    UserBank: "Bangko ng Gumagamit",
    ActivityLog: "Mga Detalye ng Aktibidad ng User",
    CompanyBank: "Pagtanggap ng mga Account",
    QuickReply: "Mabilis na sagot",
    GxFootBallJC: "GX Football JC",
    Secrect: "App Secret Key",
    AgentReserve: "Template ng Komisyon",
    Sms: "Pamamahala ng SMS",
    SMS: "SMS",
    LotteryResult: "Pamamahala ng Lottery",
    TeamGX: "Mga Koponan ng GX",
    GxMatches: "GX Matches",
    Application: "Pamamahala ng App",
    Help: "Katulong sa pangangalakal",
    Discount: "Diskwento",
    RoomMessage: "Mga Mensahe sa Chat",
    ChatGroup: "Grupo ng chat",
    HomeProblem: "Pamamahala ng User",
    Promotion: "Promosyon",
    CapitalLog: "Mga Transaksyon sa Sub-Account",
    GameConfig: "Game Configuration",
    Mother: "Securities Account",
    FinanceAccount: "Financial Account",
    AgentWithdraw: "Pag-withdraw ng Ahente",
    PartnerMenu: "Talahanayan ng Menu ng Kasosyo",
    PlusMinusType: "Uri ng Transaksyon sa Backend",
    LotteryFolder: "Pamamahala ng Lottery",
    Menu: "Pamamahala ng Menu",
    SystemChat: "Magpadala ng broadcast",
    CapList: "Listahan",
    OperatorInformation: "Impormasyon ng Operator",
    Capital: "Mga Sub-Account",
    PeiziFolder: "Pamamahala ng Margin Trading",
    Entrust: "Pamamahala ng Order",
    BetType: "Uri ng Laro",
    WalletCollectHistory: "Kasaysayan ng koleksyon ng pitaka",
    Lottery: "Pag-upload ng Configuration",
    FlowType: "Uri ng transaksyon",
    GameManagement: "Pamamahala ng Laro",
    CustomerService: "Serbisyo sa Customer",
    OtcAccount: "Merchant token account",
    CoinRecharge: "Token Recharge",
    UserSuspect: "Hinala ng Gumagamit",
    DepotSimulate: "Mga Simulated na Posisyon",
    HomeConfig: "Home Configuration",
    TimebaoRate: "Setting ng Rate ng Interes",
    Formula: "Pamamahala ng Numero",
    OtcTrade: "Pamamahala ng Transaksyon",
    Notice: "Panloob na Abiso",
    TronExchange: "Pagpapalitan ng TOKEN",
    UserBankType: "Uri ng Account",
    WithdrawMethod: "Paraan ng pag-withdraw",
    Job: "Pamamahala ng gawain",
    Plus: "Backend Recharge",
    FriendCouponLog: "Mga Log ng Friend Cash Coupon",
    Tool: "Pamamahala ng Tool",
    Order: "Pamamahala ng order",
    SendSms: "Magpadala ng SMS",
    AgentCommission: "Mga detalye ng komisyon",
    CoinAccount: "Token Asset Account",
    TimebaoAccount: "Mga Financial Account",
    Cap: "Pagsubok",
    Adminuser: "Gumagamit ng Backend",
    RechargeMethod: "Mga Paraan ng Deposito",
    CoinCurrency: "Pera ng barya",
    CoinRechargeAddr: "Address ng token ng user",
    PowerInterest: "Ex-rights at Ex-dividend",
    NewCapitalTest: "Bagong Capital Test",
    User: "Gumagamit",
    DepotFolder: "Pamamahala ng pangangalakal",
    LanguageField: "Mga larangang multilingguwal",
    GxBeidanJC: "GX Football Single",
    Config: "Pamamahala ng Configuration",
    CoinAccountDetail: "Mga Detalye ng Token Fund",
    Information: "Iba pang Nilalaman",
    BetBalance: "Pang-araw-araw na Bill",
    UserCoupon: "Aking mga Voucher",
    CommentLabel: "Mga tag ng komento",
    LotteryMax: "Pinakamataas na Lottery",
    PragmaticGamesList: "Listahan ng praktikal na laro",
    Banksetting: "Mga Setting ng Bangko",
    RechargeBankLog: "Recharge Bank Log",
    HolidayAccount: "Holiday Account",
    DealSimulate: "Simulated Deal",
    AgentVoucher: "Voucher ng Ahente",
    SysConfig: "Pangunahing Configuration",
    Wallet: "Pamamahala ng wallet",
    OtcChat: "Chat ng Transaksyon",
    CoinWithdrawAddr: "Address ng pag-withdraw ng user",
    LotteryGroup: "Lottery Group",
    CategoryList: "GX Football Single",
    Closed: "Mga Piyesta Opisyal",
    EntrustSimulate: "Simulated Orders",
    Depot: "Pamamahala ng Posisyon",
    Api: "interface ng API",
    GxBeidanJcResult: "Resulta ng GX Biden JC",
  },
  flowLog: {
    type29: "Cancelar",
    type28: "Vender",
    type38: "Descongelar",
    type15: "Envelope Vermelho",
    type37: "Cancelar o Acordo",
    type36: "Desbloquear Restrição de Venda",
    type35: "Comerciante Rejeitado",
    type57: "Diminuição disponível para retirada",
    type12: "Comissão para Conta Principal",
    type34: "Solicitação de Comerciante",
    type56: "Aumento disponível para retirada",
    type11: "Comissão para Loteria",
    type33: "reclamação",
    type55: "Diminuir o volume de negócios",
    type32: "Adicionadas apostas esportivas GX",
    type54: "Aumentar o volume de negócios",
    type31: "Confirmar da outra parte",
    type53: "Saque bem-sucedido (não recarga)",
    type30: "Confirmado pela outra parte",
    type52: "Saque rejeitado (não recarga)",
    type51: "Solicitar saque (não recarga)",
    type50: "Saque bem-sucedido (normal)",
    type3: "Solicitar saque",
    type9: "Dedução do Admin",
    type7: "Recarga do Admin",
    type1: "Recarga",
    type19: "Dedução de Aposta",
    type18: "Ganhar para Loteria",
    type17: "Conta Principal para Conta Corrente",
    type39: "Cancelar Venda",
    type27: "comprar",
    type49: "Saque rejeitado (normal)",
    type26: "Moeda fiduciária da conta principal",
    type48: "Solicitar saque (normal)",
    type25: "Conta Principal para Conta OTC",
    type47: "Recompensa de Verificação de E-mail",
    type46: "Recompensa de Verificação de Celular",
    type45: "Recompensa de Configuração de Conta",
    type44: "Bônus da Caixa Surpresa",
    type21: "Prêmio da Loteria",
    type43: "Retorno de Metade da Aposta",
    type20: "Cancelamento de Aposta",
    type40: "Reembolso do Comerciante",
  },
  filter: {
    cancel: "Kanselahin",
    confirm: "Kumpirmahin",
    chooseDate: "Piliin ang Petsa",
  },
  help: {
    helpCenter: "Help Center",
  },
  appReset: {
    installInstructions:
      '<p>Para maipagpatuloy ang pag-update ng <strong>PK737</strong>, sundin lamang ang mga hakbang na ito:</p>\n<p>1. I-tap ang <strong>Pumunta sa Mga Setting</strong> sa ibaba para buksan ang mga setting.</p>\n<p>2. Sa susunod na screen, i-toggle ang <strong>Payagan mula sa pinagmulang ito</strong> sa <strong>ON</strong>.</p>\n<p><img style="display: block; margin-left: auto; margin-right: auto;" src="https://lotophilippians.s3.ap-east-1.amazonaws.com/20260722/6deacde7bd4c4fcf9f6df9ed1eed1e1cphoto_2026-07-22_14-54-53.jpg" alt="" width="201" height="39" /></p>\n<p>3. Bumalik para bumalik sa app.</p>',
    permissionNeeded: "Kinakailangan ang Pahintulot",
    downloading: "Nagda-download",
    pleaseWait: "Mangyaring Maghintay",
    contentApk:
      "Mayroon nang bagong bersyon. Para sa pinakamagandang karanasan at access sa mga bagong feature, piliin ang opsyon sa pag-update upang i-update ang iyong app.",
    goToSetting: "Pumunta sa Setting",
    ignore: "Balewalain",
    update: "I-update APP",
    content:
      "Mayroon nang bagong bersyon. Para masiguro ang pinakamahusay na karanasan at ma-access ang mga bagong tampok, pakipili ang opsyon sa pag-update para i-refresh ang iyong app. Kung gusto mo, maaari mong manu-manong i-clear ang iyong cache para mailapat ang mga pinakabagong update.",
  },
  chat: {
    messageEmpty: "Walang laman na mensahe",
    CustomerService: "Makipag-ugnayan sa customer service",
    system: "Mensahe ng system",
    SystemInfo: "Mensahe ng system",
    onlineService: "Online na serbisyo sa customer",
    EnterMessage: "Mangyaring magpasok ng impormasyon",
    exclusiveCust: "Eksklusibong serbisyo sa customer",
    System: "Online na serbisyo sa customer.",
  },
  report: {
    RefundAll: "Mga Makasaysayang Rebate",
    commision: "Komisyon",
    CommissionAll: "Komisyong Pangkasaysayan",
    commissionList: "Listahan ng Komisyon",
    lotteryList: "Listahan ng Lottery",
    RebateTodayMonth: "Rebate kahapon / Rebate ngayong buwan",
    WinTodayMonth: "Mga panalo ngayon / Mga panalo ngayong buwan",
    BetAll: "Makasaysayan",
    ProfitAll: "Makasaysayang Kita at Pagkalugi",
    otcReport: "Over-the-counter (OTC) na kalakalan",
    ProfitMonth: "Ang Kita at Pagkalugi ngayong Buwan",
    Records: "Mga detalye ng pondo",
    otc: "balanse ng C2C",
    transferOut: "Mag-withdraw",
    RefundMonth: "Mga Rebate ngayong Buwan",
    BetCount: "Ang halaga ng taya",
    totalAssest: "Kabuuang Mga Asset",
    PlayNow: "Ulat ng kita",
    transfer: "Paglipat",
    CommissionToday: "Komisyon ngayon",
    assetsList: "Listahan ng Asset",
    Balance: "Balanse ng Account",
    lotterySummery: "Ulat sa Lottery",
    SummeryReport: "Komprehensibong Ulat",
    Fund: "Mga Detalye ng Pondo",
    BetWeek: "Ngayong Linggo",
    WithdrawWeek: "Mga Withdrawal Ngayong Linggo",
    RefundToday: "Mga Rebate Ngayon",
    WithdrawReport: "Ulat sa Pag-alis",
    BetMonth: "Ngayong Buwan",
    WithdrawToday: "Mga Withdrawal Ngayon",
    WithdrawAll: "Mga Makasaysayang Pag-withdraw",
    otcWeek: "Linggo",
    total: "Loterya",
    current: "Kumita",
    CommonDetail: "Mga Detalye",
    otcMonth: "buwan",
    recharge: "Mag-load",
    BrokerageTodayMonth: "Komisyon ngayon / Kabuuang komisyon",
    CommissionMonth: "Komisyon ngayong Buwan",
    otcAll: "Lahat ng transaksyon",
    earnList: "Listahan ng Kumita",
    RefundReport: "Ulat ng Rebate",
    overview: "Buod",
    Withdraw: "Pag-withdraw ng pondo",
    withdrawal: "Labas",
    WithdrawMonth: "Mga Withdrawal ngayong Buwan",
    CommissionWeek: "Komisyon ngayong Linggo",
    CommissionReport: "Ulat ng Komisyon",
    ProfitReport: "Pahayag ng Kita",
    BetTodayMonth: "Ulat ng kita / Taya sa buwang ito",
    popupTitle: "Kinakailangan ang desentralisadong wallet setup",
    BetToday: "Ngayong araw",
    ProfitToday: "Ang Kita at Pagkalugi Ngayon",
    RefundWeek: "Mga Rebate Ngayong Linggo",
    BetReport: "Ulat sa Laro",
    transferIn: "Deposito",
    otcToday: "Araw",
    ProfitWeek: "Ang Kita at Pagkalugi ngayong Linggo",
  },
  otctrade: {
    typeSell: "Ibenta",
    typeBuy: "Bumili",
  },
  resetPassword: {
    OTPCode: "Captcha",
    ResetPasswordpNoPlaceHolder: "Numero ng Mobile",
    PageTopic: "I-reset ang Password",
    EnterNewPassword: "Nakalimutan ang Password?",
    Notice: "Nakabinbin",
    AccountResetPassword: "Account",
    PhoneResetPassword: "Telepono",
    CaptchaPlaceHolder: "CAPTCHA",
    EmailResetPassword: "E-mail",
  },
  auth: {
    welcomeNote: "Maligayang pagdating sa",
  },
  allNews: {
    back: "Bumalik",
    end: "Wala na",
    title: "Balita",
  },
  pcCustomerService: {
    Csone: "Chinese customer service",
    Heading: "Makipag-ugnayan sa customer service",
    Cstwo: "English customer service",
    Csthree: "Pamayanan ng eroplano",
  },
  timebao: {
    NoInterestInvestment: "Ang prinsipal ay hindi pa nakakakuha ng interes",
    Heading: 'Mga kita kahapon"',
    APR: "Taunang rate ng interes",
    historyProfit: "Mga makasaysayang kita",
    CurrentAsset: "Mga kasalukuyang asset",
    interestStarts:
      "Magsisimula ang interes sa susunod na araw, na may taunang rate ng interes na 30% hanggang 300%, na ina-update araw-araw",
    InterestPaymentDate: "Petsa ng pagbabayad ng interes",
    nextThirdDate:
      "Na-credit sa ikatlong araw sa 00:00 (UTC -3) pagkatapos ng paglipat",
    transferout: "Mag-withdraw",
    todayInterest: "Mga kita ngayon",
    TransferAnyTime: "Pamamahala sa pananalapi",
    ladder: "Mga tier",
    InterestInvested: "Ang prinsipal ay kumikita na ng interes",
    Example:
      "Halimbawa: Kung ang mga rate ng interes para sa mga tier ng 1-3 taon ay 20.00%, 6.00%, at 1.00% ayon sa pagkakabanggit, at namuhunan ka ng 30,000 USDT, ang taunang kita ay kakalkulahin tulad ng sumusunod:\n\n\n\nKita = 30,000 * (20.00% + 6.00% + 1.00%)\n\nKita = 30,000 * (0.20 + 0.06 + 0.01)\n\nKita = 30,000 * 0.27\n\nKita = 8,100 USDT",
    transferin: "Deposito",
    yesterdayProfit: "Mga Kita Kahapon",
    InterestStartDate: "Petsa ng pagsisimula ng interes",
    currentAPR: "Kasalukuyang taunang rate ng interes",
    nextDate:
      "Na-credit sa susunod na araw sa 00:05 (UTC -3) pagkatapos ng paglipat",
    "DailyReal-timeUpdates": "Pang-araw-araw na real-time na mga update",
  },
  sysetem: {
    captchaExpire: "Nag-expire na ang Captcha",
    captchaError: "Maling Captcha",
  },
  protocol: {
    back: "Bumalik",
    goBackLastPage: "Bumalik sa nakaraang pahina",
    riskDisclosure: "Pahayag ng pagsisiwalat ng panganib",
    title: "Pinakabagong Stock Pool",
    instructionsUseFCC: "Mga tuntunin ng paggamit ng cash voucher ng kaibigan",
  },
  download: {
    gift: "Pagsagip",
    downloadImmediately: "I-download Ngayon",
    macDesktop: "Bersyon ng MAC Desktop",
    clickAfterQRScan: 'I-scan ang QR code at i-click ang "Tingnan sa"',
    about: "Tungkol sa Google Play",
    casino: "Casino",
    explanation:
      "Tandaan: Ang TF ay kumakatawan sa TestFlight, na isang opisyal na mode ng pamamahagi ng Apple.",
    commentOne:
      "Napakagandang app na may magandang disenyo at maayos na navigation. Madali at diretso ang proseso ng pagtaya. Excited ako sa mga susunod na update. Magandang trabaho",
    tablet: "Tableta",
    commentDateThree: "Hunyo 9, 2025",
    stockAppleVersion: "Bersyon ng iOS ng Stock ng Hong Kong",
    appleversion: "Apple mobile na bersyon.",
    similarGame: "Mga katulad na laro",
    reviewCount: "1.91k mga review",
    terms: "Mga Tuntunin ng Serbisyo",
    appleClassic: "Klasikong Bersyon ng iOS",
    withinSec: "I-download sa loob ng 15 segundo",
    pwaDownloadInstructions: "I-tap ang Share sa Safari, pagkatapos piliin ang Add to Home Screen",
    helpFull: "Nakatulong ba ito sa iyo?",
    collectData:
      "Mga pagkakakilanlan ng Lokasyon, In-app na Aktibidad at Device at iba pa",
    playPass: "Pagsagip",
    commentDateTwo: "Disyembre 19, 2025",
    perFormUpdate: "Mga Gift Card",
    guide: "Gabay sa pamilya",
    app: "Mga app",
    newUpdate: "Narito ang isang bagong update:",
    helloFan: "Hello, PK737 fans!",
    dataSecurity: "Seguridad ng data",
    iPhoneUpgradeVersion: "iOS Non-Upgrade na Bersyon",
    appSecurity:
      "Ang iyong seguridad ay nagsisimula sa pag-unawa kung paano kinokolekta at ibinabahagi ng mga developer ang iyong data. Maaaring mag-iba ang mga kasanayan sa seguridad at privacy ng data batay sa paggamit, rehiyon, at edad. Ibinigay ng developer ang sumusunod na impormasyon, na maaaring ma-update sa paglipas ng panahon.",
    androidClassic: "Klasikong Bersyon ng Android",
    androidPro: "Propesyonal na Bersyon ng Android",
    telephone: "Telepono",
    film: "Mga pelikula",
    sharing: "Pagbabahaginan ng Pamilya",
    slotMach: "Mga puwang",
    appActivity:
      "Mga pagkakakilanlan ng Lokasyon, In-app na Aktibidad at Device at iba pa",
    dataEncrypt: "Naka-encrypt ang data sa pagpapadala",
    qrCodeTxt: "I-scan upang ipasok ang bersyon ng mobile web.",
    commentThree:
      "Talagang nag-eenjoy ako sa app na ito! Malinis at moderno ang itsura ng interface, at napakadali nitong gamitin. Mas nakakatuwa ang animal theme, at maayos ang takbo ng lahat. Magaling ang trabaho ng mga developer",
    commentDateOne: "Marso 5, 2026",
    desc: "Ang pinaka-maimpluwensyang blockchain lottery sa mundo",
    child: "Mga bata",
    aboutGame: "Tungkol sa larong ito",
    refund: "Patakaran sa Pag-refund",
    childFam: "Mga bata at pamilya",
    windowsDesktop: "Bersyon ng Windows Desktop",
    desktopVersion: "Bersyon ng Desktop",
    no: "Hindi",
    helpFullBy: "Ang pagsusuring ito ay minarkahan bilang kapaki-pakinabang ni",
    mobileweb: "Direktang pag-access.",
    android: "Android mobile na bersyon.",
    book: "Mga libro",
    enjoy: "Play Points",
    privacy: "Pagkapribado",
    appleTestFlight: "Apple TF",
    stockAndroidVersion: "Bersyon ng Android ng Stock ng Hong Kong",
    tfVersionForIPhone: "Bersyon ng Apple Mobile TF (Anti-Ban)",
    wishList: "Idagdag sa Wish List",
    datShareLearn:
      "Alamin ang higit pa tungkol sa kung paano idinedeklara ng mga developer ang pagbabahagi",
    reqDelete: "Maaari kang humiling ng pagtanggal ng data",
    clickStartTestStockIcon:
      'I-click ang "Start Testing" - "Accept" - "Install" button',
    viewInstallAndOpen:
      'I-click ang "View in" pagkatapos i-scan ang QR code, i-install at buksan',
    share: "Ibahagi",
    rescue: "Pagsagip",
    appDataContent:
      '<p>🌍Sa gitna ng matinding kompetisyon sa pandaigdigang merkado ng online entertainment, opisyal na inilunsad ng Flutter Entertainment ang *Animal Racing: Wild Sprint*, na pinapagana ng lakas ng mga tatak nitong Paddy Power at Betfair.</p>\n<p>Hindi lamang ito simpleng laro ng "cyber animals"; isa itong bagong uri ng produktong pang-aliw na pinagsasama ang high-definition 3D rendering, physics engine collisions, at mga mekanismo ng dynamic odds. Layunin nitong pag-ugnayin ang tradisyonal na karera ng kabayo at ang mga casual game na madaling laruin, gamit ang advanced na data processing ng Flutter upang makapaghatid ng isang immersive na karanasan sa pagtaya na mabilis ang takbo (tuwing ika-90 segundo), transparent, at lubos na interactive.</p>',
    againScanQRCode: "I-scan muli ang QR code",
    yes: "Oo",
    bottomNotice: "Pilipino (Filipino)",
    readyToUse: "Magagamit mo na ito ngayon",
    store: "Google Store",
    googlePlay: "Mga Gift Card",
    seeAllReview: "Play Points",
    allPrice: "Kasama sa lahat ng presyo ang Buwis.",
    flagMsg: "Mga Gift Card",
    commentTwo:
      "Napakadaling gamitin. Masaya ang pagpili ng mga hayop tulad ng Tiger, Dragon, Ox, Mouse, at Rabbit. Sana ay magkaroon pa ito ng mas maraming features sa mga susunod na update.",
    developer: "Mga developer",
    androidUpgradeVersion: "Bersyon ng Android Non-Upgrade",
    sport: "Mga laro",
    dataShare: "Hindi ibinabahagi ang data sa mga third party",
    playPoint: "Play Points",
    clickStartTest: 'I-click ang "Start Testing" - "Accept" - "Install" button',
  },
  timebaolog: {
    all: "Lahat",
    commissiontocurrent: "Komisyon ng account sa kasalukuyang account",
    Confirm: "Paglipat at subscription, mag-withdraw sa kalooban",
    Time: "Upang",
    Type: "Oras",
    mastertocurrent: "Kabuuang account sa kasalukuyang account",
    Details: "Salain",
    balance: "Balanse",
    Filter: "Uri",
    currenttomaster: "Kasalukuyang account sa kabuuang account",
    currency: "Pera",
    To: "I-reset",
    Reset: "Kumpirmahin",
    currentbill: "Kasalukuyang account statement",
  },
  lotteryRecords: {
    addBets: "Bilang ng mga Taya",
    Amount: "Halaga",
    Time: "Oras",
    result: "Gumuhit ng Numero",
    lostAmt: "Halaga ng Pagkawala",
    Game: "Laro",
    lostBets: "Mga Round ng Pagkatalo",
    State: "Manalo ng mga Round",
    blockNo: "I-block ang Hash",
    pleaseSelect: "Mangyaring pumili",
    returnAmt: "Ibalik ang Halaga",
    categories: "Uri",
    Topic: "Rekord ng Loterya",
    profit: "Halaga ng Kita at Pagkalugi",
  },
  logo: {
    test: "Teksto ng Logo",
  },
  funds: {
    WithdrawLog: "Mga detalye ng withdrawal",
    BalanceFlow: "Balanse",
    AmountWithdraw: "Halaga ng Pag-withdraw",
    FlowLog: "Lahat ng detalye",
    NoRecord: "Walang nakitang mga tala",
    StatusWithdraw: "Katayuan",
    BalanceRecharge: "Balanse",
    CreateTimeWithdraw: "Oras ng Paglikha",
    TypeFlow: "Uri",
    CreateTimeRecharge: "Oras ng Paglikha",
    TypeRecharge: "Uri",
    CoinAddrWithdraw: "Address ng Pera",
    FundDetails: "Mga detalye ng pondo",
    RechargeLog: "Recharge Record",
    ToAddressFlow: "Ilipat sa",
    AmountRecharge: "Halaga",
    AmountFlow: "Halaga ng Pag-withdraw",
    CreateTimeFlow: "Oras ng Paglikha",
  },
  otcaccountinfo: {
    typeBank: "Bank card",
    typeAlipay: "Pagbabayad ng Alipay",
    typeWxPay: "Pagbabayad sa WeChat",
  },
  logs: {
    amount: "Halaga",
    voucher: "Voucher",
    tabfinance: "Kumita ng Account",
    fullDetails: "Lahat ng detalye",
    type: "Uri",
    tabcommission: "Account ng Komisyon",
    financialIncome: "Kita sa pananalapi.",
    tabmaster: "Lottery Account",
    balance: "Balanse",
    mgtCosts: "Bayad sa pamamahala",
    loadDetails: "Mga detalye ng pautang",
    recharge: "Mag-recharge",
    fundingDetails: "Mga detalye ng pondo",
    commission: "Komisyon.",
    noData: "Walang mga tala",
    state: "Katayuan",
    time: "Oras",
    cashBack: "Cashback",
    withdraw: "Pag-withdraw",
    tabOTC: "C2C",
  },
  verification: {
    selectCountry: "Pumili",
  },
  fundDetails: {
    All: "Lahat",
    Heading: "Mga detalye ng bill",
    Withdraw: "Pag-withdraw",
    Amount: "Dami ng nangyari",
    Commission: "Komisyon",
    Time: "Oras",
    Month: "Ngayong buwan",
    Project: "item",
    Game: "item",
    AllData: "Lahat",
    Week: "Ngayong linggo",
    Day: "Ngayong araw",
    Balance: "Balanse",
  },
  homeTutorial: {
    ViewTutorial: "Tingnan",
    BetTab:
      "Mag-enjoy ng 1% na komisyon sa 1st level offline na turnover sa pagtaya\n\nTangkilikin ang 0.6% na komisyon sa 2nd level offline na turnover sa pagtaya\n\nTangkilikin ang 0.4% na komisyon sa ika-3 antas ng offline na turnover sa pagtaya\n\nAng hindi direktang 2nd level ay tumutukoy sa mga miyembro na direktang binuo mula sa 1st level",
    HeaderTutorial: "Tutorial",
    HeaderPlatform: "Plataporma",
    RegisterWallet: "Magrehistro ng wallet",
    TransferTips:
      "Matagumpay na nailipat sa sumusunod na account ng laro para sa agarang paglahok sa Lucky Hash",
    TabFourTopic:
      "Awtomatikong nakredito ang bonus ng mga panalo sa laro sa real time",
    TransferBet: "Ilipat ang pagtaya",
    QuestionTab: "Mga Madalas Itanong",
    GameTab: "Mga panuntunan sa laro",
    TabThreeTopic:
      "Lumipat sa platform ng paglalaro upang lumahok sa mga aktibidad sa paghula.<br/>Matagumpay na nailipat sa sumusunod na account ng laro para sa agarang paglahok sa Lucky Hash",
    TabTwoTopic:
      "Bumili ng USDT sa mga sumusunod na pangunahing cryptocurrency wallet",
    Introduction: "Panimula ng laro",
    Copy: "Kopyahin",
    AddressTopic: "Opisyal na address ng wallet",
    TabOneTopic:
      "Bumili ng USDT sa mga sumusunod na pangunahing cryptocurrency wallet",
    Rewards: "Remittance ng mga panalo",
    HeaderURL: "Website",
    VirtualCurrency: "I-trade ang virtual na pera",
  },
  timebaoLogType: {
    type4: "Comissão para Ganhos",
    type3: "Transferir conta corrente para conta geral",
    type2: "Retornos financeiros hash",
    type1: "Loteria para Ganhos",
  },
  operateday: {
    times: "beses",
    allocation: "Mga pondo sa margin trading",
    deposit: "Margin",
    dailyRate: "Araw-araw na rate ng interes",
  },
  historyOperate: {
    over: "Natapos na",
  },
  otcMerchant: {
    notMerchant: "Kailangang maging merchant bago mag-post ng mga ad",
    noWithdrawPassword: "Mangyaring itakda ang withdrawal password",
    notApproved: "Sinusuri ang account ng merchant",
    noPaymentMethosSet: "Itakda ang uri ng pagbabayad",
    existingMerchant: "Nakarehistrong mangangalakal",
    invalidMerchant: "Ang user ay hindi isang wastong merchant",
  },
  ecomInfo: {
    QRDownloaded: "Matagumpay na na-download",
  },
  " system": {
    dayStockLogSaveFailed: "Nabigong i-save ang kasalukuyang log ng imbentaryo",
    enterTheStockCode: "Error sa format ng presyo ng pagbebenta",
  },
  otcOrderDetails: {
    appCanComplete: "Matagumpay ang pagkansela",
  },
  friends: {
    WinningMonth: "Panalo ngayong buwan",
    LevelThree: "Ikatlong antas",
    NoFriends: "Walang kaibigan",
    LevelTwo: "Pangalawang antas",
    FriendList: "Mga miyembro ng pangkat",
    AccountBalance: "Balanse sa account",
    RegDate: "Petsa ng pagpaparehistro",
    WinToday: "Panalo ngayong araw",
    BetToday: "Tumaya ngayon",
    BettingMonth: "Pagtaya ngayong buwan",
    LevelOne: "Unang antas",
    Trc20Address: "Trc20 address",
  },
  lotteryType: {
    name511: "6º Regular 2 Maneiras",
    name512: "Combinação três completa",
    name510: "6º Regular Exato",
    name515: "Combinação dois com especial",
    name516: "Corrente especial combinada",
    name513: "Combinação três dois",
    name514: "Combinação dois completa",
    name519: "1 Zodíaco",
    name517: "Meia Onda Especial",
    name518: "Zodíaco Especial",
    name500: "1º Regular Exato",
    name501: "1º Regular 2 Maneiras",
    name504: "3º Regular Exato",
    name505: "3º Regular 2 Maneiras",
    name502: "2º Regular Exato",
    name503: "2º Regular 2 Maneiras",
    name508: "5º Regular Exato",
    name509: "5º Regular 2 Maneiras",
    name506: "4º Regular Exato",
    name507: "4º Regular 2 Maneiras",
    name530: "5 Não combina",
    name412: "1D",
    name533: "8 Não combina",
    name413: "1D",
    name534: "9 Não combina",
    name410: "Escolha 8 Acerte 5 (F+A)",
    name531: "6 Não combina",
    name411: "1D",
    name532: "7 Não combina",
    name416: "Especial 2 Maneiras",
    name537: "Posição Fixa",
    name417: "Regulares Opcional",
    name538: "Posição Fixa",
    name414: "1D",
    name535: "10 Não combina",
    name415: "Especial Exato",
    name536: "Posição Fixa",
    name418: "1º Regular Exato",
    name539: "Posição Fixa",
    name419: "1º Regular 2 Maneiras",
    name401: "Escolha 6 Acerte 5",
    name522: "Animal combinado não em",
    name402: "Escolha 7 Acerte 5",
    name523: "2 Zodíaco Vinculados",
    name520: "Zodíaco Regular",
    name400: "Escolha 5 Acerte 5",
    name521: "Zodíaco de Grupo",
    name405: "Escolha 3 Acerte 3 (F+A)",
    name526: "Cabeça e Cauda Especiais",
    name406: "Escolha 4 Acerte 4 (F+A)",
    name527: "Link de 2 Caudas",
    name403: "Escolha 8 Acerte 5",
    name524: "3 Zodíaco Vinculados",
    name404: "Escolha 2 Acerte 2 (F+A)",
    name525: "4 Zodíaco Vinculados",
    name409: "Escolha 7 Acerte 5 (F+A)",
    name407: "Escolha 5 Acerte 5 (F+A)",
    name528: "Link de 3 Caudas",
    name408: "Escolha 6 Acerte 5 (F+A)",
    name529: "Link de 4 Caudas",
    name19: "Os três primeiros singles de seleção direta",
    name18: "Os três primeiros compostos de seleção direta",
    name17: "Os dois últimos singles de seleção direta",
    name16: "Os dois últimos compostos de seleção direta",
    name15: "Os dois primeiros singles de seleção direta",
    name14: "Os dois primeiros compostos de seleção direta",
    name13: "Composto de uma estrela",
    name12: "Jogabilidade especial",
    name11: "Adivinhe o número",
    name10: "G/P & P/Í",
    name470: "Combinação três dois",
    name350: "Posição Fixa",
    name471: "Combinação dois completa",
    name111: "8 Não combina",
    name232: "Últimos três compostos de seleção direta",
    name353: "Escolha 2 Acerte 2",
    name474: "Meia Onda Especial",
    name112: "9 Não combina",
    name233: "Últimos três singles de seleção direta",
    name354: "Escolha 3 Acerte 3",
    name475: "Zodíaco Especial",
    name230: "Composto de seleção direta de três intermediários",
    name351: "Aposta Ímpar-Par",
    name472: "Combinação dois com especial",
    name110: "7 Não combina",
    name231: "Single de seleção direta de três intermediários",
    name352: "Escolha 1 Acerte 1",
    name473: "Corrente especial combinada",
    name115: "1 Dígito",
    name236: "Composto de seleção direta de cinco estrelas",
    name357: "Escolha 6 Acerte 5",
    name478: "Zodíaco de Grupo",
    name116: "2 Primeiros",
    name237: "Single de seleção direta de cinco estrelas",
    name358: "Escolha 7 Acerte 5",
    name479: "Animal combinado não em",
    name113: "10 Não combina",
    name234: "Composto de seleção direta de quatro estrelas",
    name355: "Escolha 4 Acerte 4",
    name476: "1 Zodíaco",
    name114: "Número ímpar",
    name235: "Single de seleção direta de quatro estrelas",
    name356: "Escolha 5 Acerte 5",
    name477: "Zodíaco Regular",
    name119: "Os dois últimos singles de seleção direta",
    name117: "Os dois primeiros singles de seleção direta",
    name238: "2 Primeiros G/P & P/Í",
    name359: "Escolha 8 Acerte 5",
    name118: "2 Últimos",
    name239: "2 Últimos G/P & P/Í",
    name460: "2º Regular 2 Maneiras",
    name100: "Animal combinado não em",
    name221: "Dragão vs Tigre",
    name342: "Escolha 6 Acerte 5 (F+A)",
    name463: "4º Regular Exato",
    name101: "2 Zodíaco Vinculados",
    name222: "5 Iguais",
    name343: "Escolha 7 Acerte 5 (F+A)",
    name464: "4º Regular 2 Maneiras",
    name340: "Escolha 4 Acerte 4 (F+A)",
    name461: "3º Regular Exato",
    name220: "2 Maneiras",
    name341: "Escolha 5 Acerte 5 (F+A)",
    name462: "3º Regular 2 Maneiras",
    name104: "Cabeça e Cauda Especiais",
    name225: "Os dois primeiros singles de seleção direta",
    name346: "Primeiros 2",
    name467: "6º Regular Exato",
    name105: "Link de 2 Caudas",
    name226: "Os dois últimos compostos de seleção direta",
    name347: "Os dois primeiros singles de seleção direta",
    name468: "6º Regular 2 Maneiras",
    name102: "3 Zodíaco Vinculados",
    name223: "Composto de uma estrela",
    name344: "Escolha 8 Acerte 5 (F+A)",
    name465: "5º Regular Exato",
    name103: "4 Zodíaco Vinculados",
    name224: "Os dois primeiros compostos de seleção direta",
    name345: "Primeiros 3",
    name466: "5º Regular 2 Maneiras",
    name108: "5 Não combina",
    name229: "Os três primeiros singles de seleção direta",
    name109: "6 Não combina",
    name106: "Link de 3 Caudas",
    name227: "Os dois últimos singles de seleção direta",
    name348: "Os três primeiros singles de seleção direta",
    name469: "Combinação três completa",
    name107: "Link de 4 Caudas",
    name228: "Os três primeiros compostos de seleção direta",
    name349: "Qualquer Posição",
    name6: "Composto de seleção direta de três estrelas",
    name5: "Os dois últimos singles de seleção direta",
    name4: "2 Últimos",
    name3: "2 Primeiros",
    name9: "Os dois últimos tamanhos ímpar-par",
    name8: "Os dois primeiros tamanhos ímpar-par",
    name7: "Single de seleção direta de três estrelas",
    name2: "2 Primeiros",
    name1: "1 Dígito",
    name250: "2 Diferentes",
    name371: "Qualquer Posição",
    name492: "10 Não combina",
    name130: "Single de seleção direta de três estrelas",
    name251: "Soma",
    name372: "Posição Fixa",
    name493: "Soma",
    name490: "8 Não combina",
    name370: "Os três primeiros singles de seleção direta",
    name491: "9 Não combina",
    name133: "1 Dígito",
    name254: "3 Diferentes",
    name375: "Escolha 2 Acerte 2",
    name496: "Soma",
    name134: "2 Primeiros",
    name255: "3 Consecutivos",
    name376: "Escolha 3 Acerte 3",
    name497: "Especial Exato",
    name131: "2 Primeiros G/P & P/Í",
    name252: "3 Iguais 1",
    name373: "Aposta Ímpar-Par",
    name494: "Soma",
    name132: "2 Últimos G/P & P/Í",
    name253: "3 Iguais 2",
    name374: "Escolha 1 Acerte 1",
    name495: "Soma",
    name137: "Os dois últimos singles de seleção direta",
    name258: "2 Diferentes",
    name379: "Escolha 6 Acerte 5",
    name138: "3 Dígito",
    name259: "Soma",
    name135: "Os dois primeiros singles de seleção direta",
    name256: "2 Iguais 1",
    name377: "Escolha 4 Acerte 4",
    name498: "Especial 2 Maneiras",
    name136: "2 Últimos",
    name257: "2 Iguais 2",
    name378: "Escolha 5 Acerte 5",
    name499: "Regulares Opcional",
    name139: "Single de seleção direta de três estrelas",
    name360: "Escolha 2 Acerte 2 (F+A)",
    name481: "3 Zodíaco Vinculados",
    name240: "2 Maneiras",
    name361: "Escolha 3 Acerte 3 (F+A)",
    name482: "4 Zodíaco Vinculados",
    name480: "2 Zodíaco Vinculados",
    name122: "2 Primeiros G/P & P/Í",
    name243: "Soma",
    name364: "Escolha 6 Acerte 5 (F+A)",
    name485: "Link de 3 Caudas",
    name123: "2 Últimos G/P & P/Í",
    name244: "3 Iguais 1",
    name365: "Escolha 7 Acerte 5 (F+A)",
    name486: "Link de 4 Caudas",
    name120: "3 Dígito",
    name241: "Luta de dragão e tigre",
    name362: "Escolha 4 Acerte 4 (F+A)",
    name483: "Cabeça e Cauda Especiais",
    name121: "Single de seleção direta de três estrelas",
    name242: "Adivinhe o leopardo",
    name363: "Escolha 5 Acerte 5 (F+A)",
    name484: "Link de 2 Caudas",
    name126: "Os dois primeiros singles de seleção direta",
    name247: "3 Consecutivos",
    name368: "Primeiros 2",
    name489: "7 Não combina",
    name127: "2 Últimos",
    name248: "2 Iguais 1",
    name369: "Os dois primeiros singles de seleção direta",
    name124: "1 Dígito",
    name245: "3 Iguais 2",
    name366: "Escolha 8 Acerte 5 (F+A)",
    name487: "5 Não combina",
    name125: "2 Primeiros",
    name246: "3 Diferentes",
    name367: "Primeiros 3",
    name488: "6 Não combina",
    name128: "Os dois últimos singles de seleção direta",
    name249: "2 Iguais 2",
    name129: "3 Dígito",
    name430: "Combinação três completa",
    name310: "Duas Vias",
    name431: "Combinação três dois",
    name550: "Posição Fixa",
    name313: "Os cinco primeiros singles de seleção direta",
    name434: "Corrente especial combinada",
    name314: "4 Primeiros",
    name435: "Meia Onda Especial",
    name311: "Posição Fixa",
    name432: "Combinação dois completa",
    name312: "5 Primeiros",
    name433: "Combinação dois com especial",
    name317: "Os três primeiros singles de seleção direta",
    name438: "Zodíaco Regular",
    name318: "2 Primeiros",
    name439: "Zodíaco de Grupo",
    name315: "Os quatro primeiros singles de seleção direta",
    name436: "Zodíaco Especial",
    name316: "3 Primeiros",
    name437: "1 Zodíaco",
    name319: "Os dois primeiros singles de seleção direta",
    name540: "Posição Fixa",
    name420: "2º Regular Exato",
    name541: "Posição Fixa",
    name302: "4 Primeiros",
    name423: "3º Regular 2 Maneiras",
    name544: "Posição Fixa",
    name303: "Os quatro primeiros singles de seleção direta",
    name424: "4º Regular Exato",
    name545: "Posição Fixa",
    name300: "5 Primeiros",
    name421: "2º Regular 2 Maneiras",
    name542: "Posição Fixa",
    name301: "Os cinco primeiros singles de seleção direta",
    name422: "3º Regular Exato",
    name543: "Posição Fixa",
    name306: "2 Primeiros",
    name427: "5º Regular 2 Maneiras",
    name548: "Posição Fixa",
    name307: "Os dois primeiros singles de seleção direta",
    name428: "6º Regular Exato",
    name549: "Posição Fixa",
    name304: "3 Primeiros",
    name425: "4º Regular 2 Maneiras",
    name546: "Posição Fixa",
    name305: "Os três primeiros singles de seleção direta",
    name426: "5º Regular Exato",
    name547: "Posição Fixa",
    name308: "1 Primeiros",
    name429: "6º Regular 2 Maneiras",
    name309: "No. 1 + No. 2",
    name210: "3 do Meio",
    name331: "Escolha 2 Acerte 2",
    name452: "9 Não combina",
    name211: "Single de seleção direta de três intermediários",
    name332: "Escolha 3 Acerte 3",
    name453: "10 Não combina",
    name450: "7 Não combina",
    name330: "Escolha 1 Acerte 1",
    name451: "8 Não combina",
    name214: "4 Digito",
    name335: "Escolha 6 Acerte 5",
    name456: "Regulares Opcional",
    name215: "Single de seleção direta de quatro estrelas",
    name336: "Escolha 7 Acerte 5",
    name457: "1º Regular Exato",
    name212: "3 Últimos",
    name333: "Escolha 4 Acerte 4",
    name454: "Especial Exato",
    name213: "Últimos três singles de seleção direta",
    name334: "Escolha 5 Acerte 5",
    name455: "Especial 2 Maneiras",
    name218: "2 Primeiros G/P & P/Í",
    name339: "Escolha 3 Acerte 3 (F+A)",
    name219: "2 Últimos G/P & P/Í",
    name216: "5 Digito",
    name337: "Escolha 8 Acerte 5",
    name458: "1º Regular 2 Maneiras",
    name217: "Single de seleção direta de cinco estrelas",
    name338: "Escolha 2 Acerte 2 (F+A)",
    name459: "2º Regular Exato",
    name320: "1 Primeiros",
    name441: "2 Zodíaco Vinculados",
    name200: "2 Maneiras",
    name321: "No. 1 + No. 2",
    name442: "3 Zodíaco Vinculados",
    name440: "Animal combinado não em",
    name203: "1 Digito",
    name324: "Primeiros 2",
    name445: "Link de 2 Caudas",
    name204: "2 Primeiros",
    name325: "Os dois primeiros singles de seleção direta",
    name446: "Link de 3 Caudas",
    name201: "Grande vs Pequeno",
    name322: "Duas Vias",
    name443: "4 Zodíaco Vinculados",
    name202: "5 Iguais",
    name323: "Primeiros 3",
    name444: "Cabeça e Cauda Especiais",
    name207: "Os dois últimos singles de seleção direta",
    name328: "Posição Fixa",
    name449: "6 Não combina",
    name208: "3 Primeiros",
    name329: "Aposta Ímpar-Par",
    name205: "Os dois primeiros singles de seleção direta",
    name326: "Os três primeiros singles de seleção direta",
    name447: "Link de 4 Caudas",
    name206: "2 Últimos",
    name327: "Qualquer Posição",
    name448: "5 Não combina",
    name209: "Os três primeiros singles de seleção direta",
    name195: "Single de seleção direta de quatro estrelas",
    name196: "5 Digito",
    name193: "Últimos três singles de seleção direta",
    name194: "4 Digito",
    name199: "2 Últimos G/P & P/Í",
    name197: "Single de seleção direta de cinco estrelas",
    name198: "2 Primeiros G/P & P/Í",
    name184: "2 Primeiros",
    name185: "Os dois primeiros singles de seleção direta",
    name182: "5 Iguais",
    name183: "1 Digito",
    name188: "3 Primeiros",
    name189: "Os três primeiros singles de seleção direta",
    name186: "2 Últimos",
    name187: "Os dois últimos singles de seleção direta",
    name191: "Single de seleção direta de três intermediários",
    name192: "3 Últimos",
    name190: "3 do Meio",
    name151: "G/P & P/Í",
    name272: "2 Iguais 1",
    name393: "Qualquer Posição",
    name152: "Adivinha Número",
    name273: "2 Iguais 2",
    name394: "Posição Fixa",
    name270: "3 Diferentes",
    name391: "Os dois primeiros singles de seleção direta",
    name150: "2 Últimos G/P & P/Í",
    name271: "3 Consecutivos",
    name392: "Os três primeiros singles de seleção direta",
    name155: "Adivinha Número",
    name276: "5 Primeiros",
    name397: "Escolha 2 Acerte 2",
    name156: "Jogo Especial",
    name277: "Os cinco primeiros singles de seleção direta",
    name398: "Escolha 3 Acerte 3",
    name153: "Jogo Especial",
    name274: "2 Diferentes",
    name395: "Aposta Ímpar-Par",
    name154: "G/P & P/Í",
    name275: "Posição Fixa",
    name396: "Escolha 1 Acerte 1",
    name159: "Jogo Especial",
    name157: "G/P & P/Í",
    name278: "4 Primeiros",
    name399: "Escolha 4 Acerte 4",
    name158: "Adivinha Número",
    name279: "Os quatro primeiros singles de seleção direta",
    name280: "3 Primeiros",
    name140: "2 Primeiros G/P & P/Í",
    name261: "3 Iguais 2",
    name382: "Escolha 2 Acerte 2 (F+A)",
    name141: "2 Últimos G/P & P/Í",
    name262: "3 Diferentes",
    name383: "Escolha 3 Acerte 3 (F+A)",
    name380: "Escolha 7 Acerte 5",
    name260: "3 Iguais 1",
    name381: "Escolha 8 Acerte 5",
    name144: "Os dois primeiros singles de seleção direta",
    name265: "2 Iguais 2",
    name386: "Escolha 6 Acerte 5 (F+A)",
    name145: "2 Últimos",
    name266: "2 Diferentes",
    name387: "Escolha 7 Acerte 5 (F+A)",
    name142: "1 Dígito",
    name263: "3 Consecutivos",
    name384: "Escolha 4 Acerte 4 (F+A)",
    name143: "2 Primeiros",
    name264: "2 Iguais 1",
    name385: "Escolha 5 Acerte 5 (F+A)",
    name148: "Single de seleção direta de três estrelas",
    name269: "3 Iguais 2",
    name149: "2 Primeiros G/P & P/Í",
    name146: "Os dois últimos singles de seleção direta",
    name267: "Soma",
    name388: "Escolha 8 Acerte 5 (F+A)",
    name147: "3 Dígito",
    name268: "3 Iguais 1",
    name389: "Primeiros 3",
    name390: "Primeiros 2 ",
    name173: "Últimos três singles de seleção direta",
    name294: "2 Primeiros",
    name174: "4 Digito",
    name295: "Os dois primeiros singles de seleção direta",
    name171: "Single de seleção direta de três intermediários",
    name292: "3 Primeiros",
    name172: "3 Últimos",
    name293: "Os três primeiros singles de seleção direta",
    name177: "Single de seleção direta de cinco estrelas",
    name298: "Duas Vias",
    name178: "2 Primeiros G/P & P/Í",
    name299: "Posição Fixa",
    name175: "Single de seleção direta de quatro estrelas",
    name296: "1 Primeiros",
    name176: "5 Digito",
    name297: "No. 1 + No. 2",
    name179: "2 Últimos G/P & P/Í",
    name180: "2 Maneiras",
    name181: "Grande vs Pequeno",
    name162: "Jogo Especial",
    name283: "Os dois primeiros singles de seleção direta",
    name163: "1 Digito",
    name284: "1 Primeiros",
    name160: "G/P & P/Í",
    name281: "Os três primeiros singles de seleção direta",
    name161: "Adivinha Número",
    name282: "2 Primeiros",
    name166: "2 Últimos",
    name287: "Posição Fixa",
    name167: "Os dois últimos singles de seleção direta",
    name288: "5 Primeiros",
    name164: "2 Primeiros",
    name285: "No. 1 + No. 2",
    name165: "Os dois primeiros singles de seleção direta",
    name286: "Duas Vias",
    name168: "3 Primeiros",
    name289: "Os cinco primeiros singles de seleção direta",
    name169: "Os três primeiros singles de seleção direta",
    name290: "4 Primeiros",
    name170: "3 do Meio",
    name291: "Os quatro primeiros singles de seleção direta",
    name39: "Dois números iguais singles",
    name38: "Dois números iguais compostos",
    name37: "Três números consecutivos selecionar todos",
    name36: "Três números diferentes",
    name35: "Três números iguais selecionar single",
    name34: "Três números iguais selecionar todos",
    name33: "Soma",
    name32: "Adivinhe o leopardo",
    name31: "Luta de dragão e tigre",
    name30: "Dois lados",
    name29: "Os dois últimos tamanhos ímpar-par",
    name28: "Os dois primeiros tamanhos ímpar-par",
    name27: "Single de seleção direta de cinco estrelas",
    name26: "Composto de seleção direta de cinco estrelas",
    name25: "Single de seleção direta de quatro estrelas",
    name24: "Composto de seleção direta de quatro estrelas",
    name23: "Últimos três singles de seleção direta",
    name22: "Últimos três compostos de seleção direta",
    name21: "Single de seleção direta de três intermediários",
    name20: "Composto de seleção direta de três intermediários",
    name59: "Single e duplo interessantes",
    name58: "Aposta posicional",
    name57: "Os três primeiros um código sem posicionamento",
    name56: "Os três primeiros singles de seleção direta",
    name55: "Os dois primeiros singles de seleção direta",
    name54: "Os dois primeiros compostos de seleção direta",
    name53: "Os três primeiros compostos de seleção direta",
    name52: "Painel frente e verso",
    name51: "Vice-campeão",
    name50: "Adivinhe o campeão",
    name49: "Os dois primeiros singles de seleção direta",
    name48: "Os dois primeiros compostos de seleção direta",
    name47: "Os três primeiros singles de seleção direta",
    name46: "Os três primeiros compostos de seleção direta",
    name45: "Os quatro primeiros singles de seleção direta",
    name44: "Os quatro primeiros compostos de seleção direta",
    name43: "Os cinco primeiros singles de seleção direta",
    name42: "Os cinco primeiros compostos de seleção direta",
    name41: "Aposta posicional",
    name40: "Dois números diferentes",
    name79: "1º Regular 2 Maneiras",
    name78: "1º Regular Exato",
    name77: "Regulares Opcional",
    name76: "Especial 2 Maneiras",
    name75: "Especial Exato",
    name74: "Oito em cinco opcional com suporte",
    name73: "Sete em cinco opcional com suporte",
    name72: "Seis em cinco opcional com suporte",
    name71: "Cinco em cinco opcional com suporte",
    name70: "Quatro em quatro opcional com suporte",
    name69: "Três em três opcional com suporte",
    name68: "Dois em dois opcional com suporte",
    name67: "Composto oito em cinco opcional",
    name66: "Composto sete em cinco opcional",
    name65: "Composto seis em cinco opcional",
    name64: "Composto cinco em cinco opcional",
    name63: "Composto quatro em quatro opcional",
    name62: "Composto três em três opcional",
    name61: "Composto dois em dois opcional",
    name60: "Composto um em um opcional",
    name99: "Zodíaco de Grupo",
    name98: "Zodíaco Regular",
    name97: "1 Zodíaco",
    name96: "Zodíaco Especial",
    name95: "Meia Onda Especial",
    name94: "Corrente especial combinada",
    name93: "Combinação dois com especial",
    name92: "Combinação dois completa",
    name91: "Combinação três dois",
    name90: "Combinação três completa",
    name89: "6º Regular 2 Maneiras",
    name88: "6º Regular Exato",
    name87: "5º Regular 2 Maneiras",
    name86: "5º Regular Exato",
    name85: "4º Regular 2 Maneiras",
    name84: "4º Regular Exato",
    name83: "3º Regular 2 Maneiras",
    name82: "3º Regular Exato",
    name81: "2º Regular 2 Maneiras",
    name80: "2º Regular Exato",
  },
  beidan: {
    overOdd: "Over Odd",
    underOdd: "Sa ilalim ng Odd",
    clicktoSelectScore: "I-click upang pumili ng puntos",
    underEven: "Ibaba Kahit",
    OverUnderOddEven: "Over/Under at Odd/Even",
    overEven: "Draw Over",
    clicktoSelectHalfFull: "I-click upang piliin ang Half/Full Time",
  },
  transfer: {
    all: "Lahat",
    EnterAmount: "Pinakamababang 0.01",
    selectAFromAccount: "Pumili ng Mula sa Account",
    quantity: "Dami",
    Title: "Paglipat",
    Confirm: "Paglipat",
    From: "Mula sa",
    master: "Lottery Account",
    cantSwitch: "Hindi makapagpalit",
    comission: "Account ng Komisyon",
    currency: "Pera",
    To: "Upang",
    savings: "Kasalukuyang account",
    finance: "Kumita ng Account",
    otc: "C2C account",
  },
  setsms: {
    ActiveSms: "SMS",
    Intro:
      "Ang pag-verify ng SMS ay nagdaragdag ng karagdagang layer ng seguridad sa iyong mga withdrawal at account",
    Topic: "SMS",
    ChangePhone: "Baguhin ang pag-verify ng SMS",
  },
  refundDetail: {
    All: "Lahat",
    Type: "Uri",
    Note: "Remarks",
    Amount: "Halaga",
    Manual: "Rebate sa Customer Service",
    Topic: "Mga Detalye ng Refund",
    System: "Rebate sa Aktibidad",
  },
  prediction: {
    headerSubText: "Sistema Profissional de Previsão",
    nextDraw: "Próximo Sorteio",
    historyRecords: "Histórico",
    winsIn: "Acerto em",
    trendAnalysis: "Análise de Tendências",
    loss: "Derrota",
    currentDraw: "Sorteio Atual",
    aiPredictionMenu: "Previsão de AI",
    homeTitle: "ANÁLISE PK SORTEIO",
    draws: "Sorteios",
    roadMapAnalysis: "Análise de Roadmap",
    predictedWin: "Predicted Win",
    win: "Vitória",
    results: "Resultado",
    latest: "Últimos",
    last: "Últimas",
    winStreak: "Vitórias Seg",
    forecast: "Previsão",
    predictedLoss: "Derrota Prevista",
    analysis: "Análise de Recursos",
    lossStreak: "Derrotas Seg.",
    dataStatsTitle: "Estatísticas",
    historyForecast: "Histórico de Previsões",
    lossessIn: "Acertos em",
    bettingStrategy: "Estratégia de Apostas",
    position: "Lugar",
    winRate: "Taxa de Vitória",
    predictionProb: "Prob. de Previsão",
  },
  forgetpass: {
    pleaseEnterYourCard: "Pakilagay ang iyong card",
    pleaseEnterNewPasswordAgain: "Pakipasok muli ang bagong password",
    identificationNumber: "ID number:",
    pleaseEnterYourRealName: "Pakilagay ang iyong tunay na pangalan",
    enterNewPasswordAgain: "Maglagay muli ng bagong password",
  },
  header: {
    userCenter: "Ang aking account",
    fundAcc: "Margin trading account",
    frontPage: "Home",
    dainuOfficialWebsite: "Opisyal na Website ng Hong Kong Stock",
    appDownload: "Pag-download ng APP",
    marketCenter: "palengke",
    applyFunding: "Mag-apply para sa margin trading",
    bullStocks: "Mainit na stock",
    login: "Mag-login",
    signUp: "Mag-sign Up",
    activityArea: "Sone ng aktibidad",
    firmOffer: "Tunay na pangangalakal",
    signIn: "Mag-log In",
    quit: "Mag-logout",
    myAccount: "Ang aking account",
    register: "Magrehistro",
  },
  foundwinner: {
    loginreadable: "Mag-login para magbasa",
    sure: "Kumpirmahin",
    laststock: "Pinakabagong stock pool",
  },
  pcgameinfo: {
    titleone: "Maglipat, tumaya, agarang pagbabayad",
    Copy: "Kopyahin ang address",
    qrdetail:
      "Mangyaring gamitin ang iyong wallet upang i-scan ang QR code para sa paglalagay ng mga taya",
    bettingAddress: "Address ng pagtaya",
    titletwo:
      "Mangyaring gamitin ang iyong desentralisadong pitaka upang ilipat sa tinukoy na TRON wallet address sa ibaba",
  },
  historyrecord: {
    all: "Lahat",
    tabtransfer: "Balanse",
    process: "Isinasagawa",
    tabwithdraw: "Pag-withdraw",
    tabrecharge: "Mag-recharge",
    financial: "Pananalapi",
    type: "Uri",
    title: "Mga tala sa kasaysayan",
    master: "Pangunahing Account",
    filter: "Salain",
    confirm: "Kasalukuyang Tala",
    fail: "Kabiguan",
    balance: "Balanse",
    success: "Tagumpay",
    reset: "Kumpirmahin",
    commission: "Komisyon",
    currency: "Pera",
    state: "Katayuan",
    time: "Oras",
    to: "I-reset",
  },
  aboutUs: {
    sectionAboutUs: "Tungkol sa Amin",
    sectionTradingRules: "Mga Panuntunan sa pangangalakal",
    sectionCompanyQualification: "Mga Kwalipikasyon ng Kumpanya",
    sectionRegistrationAgreement: "Kasunduan sa Pagpaparehistro",
    sectionContactUs: "Makipag-ugnayan sa Amin",
    back: "Bumalik",
    sectionHelpCenter: "Help Center",
    sectionFundAllocation: "Gabay sa Margin Trading",
    sectionBeginner: "Gabay sa Baguhan",
  },
  game: {
    BettingData: "Data ng pagtaya",
    friendName: "Palayaw ng kaibigan",
    GameType: "Kategorya ng Laro",
    ViewDetails: "Tingnan ang mga detalye",
    result: "Resulta ng Laro",
    Betting: "Taya",
    WinToday: "Mga panalo ngayon",
    GameResult5: "Di-wasto",
    AcceptUSDTRX: "TRC20-USDT lang ang tinatanggap",
    GameResult2: "At",
    GameResult1: "manalo",
    GameResult0: "Pagkawala",
    HowToPlay: "Panimula ng laro",
    Odds: "Odds",
    Title: "Laro - Desentralisadong Pagtaya sa Wallet",
    BettingMonth: "Mga taya ngayong buwan",
    PlayNow: "Maglagay ng taya ngayon",
    WinnerMonth: "Panalo ngayong buwan",
    betAmount: "Halaga ng taya",
    Introduction: "Panimula ng Laro",
    comission: "Kasalukuyang Komisyon",
    GrandTotal: "Mga panalo sa kasaysayan",
    BetToday: "Mga taya ngayon",
    time: "Petsa at Oras",
    tokenType: "Uri ng TOKEN",
  },
  pcquestion: {
    topic: "Mga Madalas Itanong",
  },
  code: {
    incorrect: "Maling verification code",
  },
  footer: {
    aboutUs: "Tungkol sa Amin",
    copyright: "Copyright Â©",
    serviceLine: "Numero ng telepono ng serbisyo",
    noviceGuide: "Gabay ng nagsisimula",
    Fund: "Mga pondo",
    promoteToMakeMoney: "Mag-promote at kumita ng pera",
    companyQuali: "Mga Kwalipikasyon ng Kumpanya",
    InviteFriend: "Mag-imbita",
    DailyCash: "Bonus",
    helpCenter: "Help Center",
    monthlyAllo: "Buwanang Margin Trading",
    Console: "Console",
    Chat: "Suporta",
    regAgree: "Kasunduan sa Pagpaparehistro",
    companyProfile: "Profile ng Kumpanya",
    Member: "Miyembro",
    Home: "Index",
    otc: "C2C",
    allocateFunds: "Mag-apply para sa Margin Trading",
    contactUs: "Makipag-ugnayan sa Amin",
    Report: "Mga ulat",
    appDownload: "Pag-download ng APP",
    Promote: "Promosyon",
    legalHoliday: "Mga legal na pista opisyal",
    opHours: "Oras ng trabaho",
    interestFree: "Walang Interes na Margin Trading",
    Game: "Mga laro",
    fundingByDay: "Pang-araw-araw na Margin Trading",
    Lottery: "Lottery",
    commonProb: "Mga Madalas Itanong",
    fundByWeek: "Lingguhang Margin Trading",
    sport: "Palakasan",
    allRightsReserved: "Copyright Â©",
  },
  otcdetail: {
    available: "Nagyelo",
    estimated: "Katumbas",
    frozen: "Nagyelo",
    otcTopic: "Mga detalye ng C2C",
  },
  lotteryPC28: {
    PageTopTitlte: "Malaki Maliit Odd Even",
    emptyAll: "Maaliwalas",
    RandomSelect: "Random na Pagpili",
    Loader: "Ang pagiging Iginuhit",
  },
  lotteryDetails: {
    MyBet: "Mga taya ko",
    CancelPopup:
      "Hindi maibabalik ang pagkansela, sigurado ka bang gusto mong kanselahin?",
    Cencellation: "Kanselahin",
  },
  error: {
    webViewError:
      "Ang mga pag-download ng APK ay hindi sinusuportahan sa loob ng web view",
    downloadFailed: "Nabigo ang Pag-download, pakisubukang muli",
  },
  timer: {
    timerContent: "Ok",
    timerTitle: "Natitirang",
  },
  console: {
    AboutUsDescTwo: "Propesyonal na branded na serbisyo",
    PromoData: "Data ng promosyon",
    BettingData: "Data ng pagtaya",
    Downline: "Bilang ng downline",
    InviteFriends: "Mag-imbita ng mga kaibigan",
    Deadline: "Instant lottery",
    AboutUs: "Tungkol sa amin",
    DownlineBet: "Mga downline na taya",
    InviteBet:
      "Anyayahan ang mga kaibigan na lumahok sa pagtaya at makatanggap ng mga magagandang gantimpala",
    ViewDetails: "Tingnan ang mga detalye",
    DownlineProfit: "Mga kita sa downline",
    More: "Magbasa pa",
    Betting: "Taya",
    DownlineWin: "Mga panalo sa downline",
    ValidBet: "Instant na taya",
    GrandTotal: "Mga panalo sa kasaysayan",
    AboutUsDescOne:
      "Itinutuloy namin ang kaunting proseso at mabilis na mga payout",
    Winning: "Panalo",
    AboutUsDetail:
      "Isang desentralisadong digital wallet lang, lumahok kaagad sa lottery. Walang mga paghihigpit sa gameplay, diskarte, o device, anumang oras, kahit saan, sa sarili mong bilis! Awtomatikong na-kredito sa loob ng 10 segundo ng pagkapanalo, walang patid na paglalaro, kapana-panabik na karanasan.",
  },
  soccer: {
    AwayWithScore: "Panalo ang Away sa Anumang Score",
    goal: "Layunin",
    handicap: "May kapansanan",
    totalGoal: "Kabuuang Mga Layunin",
    liveStream: "Mabuhay",
    halfFullTime: "Half Time / Full Time",
    second: "Pangalawa",
    score: "Puntos",
    DrawWithScore: "Gumuhit ng Iskor",
    HomeWinScore: "Nanalo ang Home sa Anumang Score",
    scoreboard: "Scoreboard",
    Final: "Pangwakas",
    first: "Una",
  },
  " moreTrendPC28": {
    Special: "Espesyal na gameplay",
  },
  sidePannel: {
    Agent: "Data ng Ahente",
    TimeBao: "Kumita",
    Withdraw: "Pag-withdraw",
    Report: "Mga ulat",
    Promote: "Data ng promosyon",
    DailyCash: "Pang-araw-araw na Pera",
    Flow: "Mga Detalye ng Pondo",
    NotLogin: "Hindi naka-log in",
    Game: "Mga detalye ng laro",
    Register: "Rehistro",
    Lottery: "Lottery",
    popupTitle: "Kinakailangan ang desentralisadong wallet setup",
    AccountBalance: "Balanse sa account",
    Assets: "Mga asset",
    Logout: "Mag-logout",
    SignIn: "Mag-login",
    Console: "Console",
    OnlineService: "Online na Serbisyo",
    Home: "Home",
    Settings: "Mga setting",
  },
  safetyPopup: {
    cancel: "Kanselahin",
    confirm: "Kumpirmahin",
    popupTitle: "Mangyaring magtakda ng password sa seguridad",
  },
  changePassword: {
    CaptchaError: "Pakipasok ang verification code",
    NewPassword: "Magtakda ng bagong password",
    Captcha: "Verification code",
    RePassword: "I-verify ang bagong password",
    PasswordError: "Hindi tugma ang mga password!",
    captchaNotMatch: "Maling verification code",
    CurrentPassword: "Ipasok ang kasalukuyang password",
    UpdatePassword: "Baguhin ang password sa pag-login",
    Update: "Update ngayon",
    Security: "Mga setting ng seguridad",
    validation:
      "Ang password ay dapat na hindi bababa sa 6 na character, walang mga puwang.",
  },
  systemNotification: {
    read: "Basahin",
    unread: "Hindi pa nababasa",
    title: "Mga abiso",
  },
  gxpay: {
    buycoins: "Bumili ng mga barya",
    myOrder: "Aking Mga Order",
    loginAccount: "Account sa Pag-login sa Platform",
    GxPayAccount: "Account",
    balance: "Balanse",
    kindTips: "Friendly na Paalala",
    sellcoins: "Magbenta ng mga barya",
    GxPayTitle: "Madaling Pagbabayad",
    GxPayOr: "o",
  },
  agencyComponent: {
    amount: "Halaga:",
    noMore: "Wala na",
    balance: "Balanse:",
    account: "Account:",
  },
  pcmian: {
    FairSubSub: "Eksklusibong Logro",
    PublicSubSub: "hindi nababago",
    SafeSub: "Hindi na kailangan ng totoong pangalan",
    Fair: "Pagkamakatarungan",
    TopHeading: "Hash guessing betting platform",
    SafeSubSub: "Pigilan ang pagyeyelo ng mga card",
    PublicSub: "Generation ng hash",
    Safe: "Seguridad",
    FairSub: "Eksklusibong posibilidad",
    Public: "Transparency",
  },
  strategy: {
    trendFollowingStrategy:
      "Sundin ang kasalukuyang sikat na trend kapag naglalagay ng taya. Kapag ang isang tiyak na numero o pattern ay lumitaw nang paulit-ulit, patuloy na tumaya sa parehong direksyon. Ang diskarte na ito ay angkop para sa mga panahon na may malinaw na mga uso at nagdadala ng medyo mas mababang panganib.",
    ontrarianStrategy:
      "Ang klasikong diskarte sa Martingale, kung saan dinoble ang stake pagkatapos ng bawat pagkatalo hanggang sa magkaroon ng panalo. Sa teorya, ginagarantiyahan nito ang tubo, ngunit nangangailangan ito ng sapat na kapital upang mapanatili ang diskarte.",
    martingaleStrategy:
      "Ang klasikong diskarte sa Martingale, kung saan dinoble ang stake pagkatapos ng bawat pagkatalo hanggang sa magkaroon ng panalo. Sa teorya, ginagarantiyahan nito ang tubo, ngunit nangangailangan ito ng sapat na kapital upang mapanatili ang diskarte.",
    trendFollowing: "Diskarte sa Pagsunod sa Trend",
    flatBetting: "Flat Betting Strategy",
    martingale: "Diskarte sa Martingale",
    flatBettingStrategy:
      "Isang fixed-stake na diskarte sa pagtaya kung saan ang halaga ng taya ay nananatiling pareho para sa bawat taya. Ang panganib ay nakokontrol, ginagawa itong angkop para sa mga konserbatibong mamumuhunan, na may medyo matatag na pangmatagalang pagbabalik.",
    swingBetting: "Diskarte sa Pagtaya sa Swing",
    swingBettingStrategy:
      "Isang diskarte sa pagtaya na nagsasaayos ng laki ng stake at dalas ng pagtaya batay sa mga pagbabago sa merkado. Taasan ang mga taya sa mga mababa at bawasan ang mga taya sa mga matataas upang makuha ang mga pagbabalik batay sa swing.",
    ontrarian: "Kontrarian Strategy",
  },
  user: {
    confirmNewPassword: "Kumpirmahin ang Bagong Password",
    topUp: "Mobile Top-Up",
    passwordPlaceholder: "Ipasok ang Password",
    notSet: "Hindi Nakatakda",
    login: "Matagumpay ang Pag-login",
    phnNo: "Numero ng Telepono",
    signUp: "Magrehistro Dito",
    forgotPassword: "Nakalimutan ang Password?",
    bank: "Bangko",
    alreadyHaveAccount: "Mayroon ka nang account?",
    changePhone: "Bagong Numero ng Telepono",
    payPass: "Password sa Pagbabayad",
    me: "Aking",
    loginPass: "Login Password",
    copy: "Kopyahin",
    resetPass: "I-reset ang Iyong Password",
    email: "I-email",
    settings: "Mga setting",
    address: "Address ng Wallet",
    welcomeMessage: "Hello",
    otpCode: "OTP Code",
    otp: "OTP",
    transactions: "Mga transaksyon",
    userId: "User ID",
    currentPassword: "Kasalukuyang Password",
    changeName: "Palitan ang Iyong Pangalan",
    confPass: "Kumpirmahin ang Password",
    phonePlaceholder: "Ipasok ang Numero ng Telepono",
    enterCode: "Ipasok ang code",
    signIn: "Mag-log In",
    name: "Pangalan",
    noAccount: "Walang Account?",
    newEmail: "Bagong Email",
    accountBalance: "Balanse ng Account",
    jcaptcha: "Maling verification code",
    refCode: "Reference Code",
    collect: "Bookmark",
  },
  sport: {
    noticetext2: "Deposit Bonus",
    lobby: "Lobby",
    noticetext1: "Mabilis at Madaling Panimula sa 300% Deposit Bonus",
    string1: "Accumulator 1",
    liveEvent: "Mga Live na Kaganapan",
    noticebtn: "Deposito Ngayon",
    Bets: "Taya",
  },
  memberDetailedLog: {
    cashBack: "Rebate ng pera",
  },
  addressEdit: {
    UpdateBank: "Mga Setting ng Bangko",
    Address: "Address ng pitaka (TRC20)",
    WarningText:
      "Tandaan: Napakahalaga ng tamang address ng wallet sa pagtaya, ito ang iyong account sa pagtaya at gayundin ang iyong itinalagang withdrawal wallet, at maaaring makabuo ng mga ulat para malinaw mong maunawaan ang sitwasyon ng pagtaya.",
    UpdateAddress: "I-edit ang address ng wallet",
    UpdateWithdraw: "Impormasyon sa pag-withdraw",
    Update: "Update ngayon",
    Password: "Mangyaring ipasok ang password sa seguridad",
  },
  customer: {
    chat: "Chat",
    contactService: "Makipag-ugnayan sa Serbisyo",
  },
};
